angular.module('stwo.maps', ["stwo.core"]).config(function ($stateProvider, $urlRouterProvider, $translateProvider, moduleStoreProvider) {

    // registering itself as a menu at the top
    moduleStoreProvider.registerModule({
        name: "map",
        links: [{
            name: "MAP",
            category: "ASSETS",
            sref: "secure.content.map",
            icon: "map",
            color: "info",
            access: moduleStoreProvider.access("stwo.maps", ["asset", "get"]),
            sort: 16,
            controllers: ["MapController"]
        }]
    });

    $stateProvider.state("secure.content.map", {
        url: "/map/{ids}",
        templateUrl: "modules/maps/maps.html",
        controller: "MapController",
        titleName: 'MAP',
        titleIcon: "map",
        bodyclass: 'homepage'
    });
});

angular.module('stwo.maps').controller('MapController', function ($scope, $state, $filter, $controller, $timeout, $stateParams, pushService, smarttrackerService, mapService, leafletData, googlemapsService, $translate, IPSService) {

    $controller('BaseListContentController', {
        $scope: $scope
    });

    // check navigation start
    if ((window.location.href + "").match(/startNavigation/gi) !== null) {

        return $state.go("secure.content.navigate");

    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.alarmCenter = smarttrackerService.isAlarmCenter();
        $scope.CID = smarttrackerService.getCustomerId();
        leafletData.getMap("mapMap").then(function (otherMap) {
            map = otherMap;
            mapService.loadOverlays(map);
        });
    });
    var map = false;

    $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE"])
        .then(function (data) {
            $scope.translations = {
                hour: data['XGUARD_HOUR'],
                hours: data['XGUARD_HOURS'],
                minute: data['XGUARD_MINUTE'],
                minutes: data['XGUARD_MINUTES'],
                timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE']
            };
        });

    if ($stateParams.ids && $stateParams.ids.length > 0) {
        $scope.filterUrlString = "&id:equals=" + $stateParams.ids;
        $scope.filterMessage = "SELECTED_ITEMS";
        $scope.filterMessage2 = "";
    }

    $scope.mapMode = {
        indoor: stwoGlobal.mapDefaultView === 'indoor',
        deduced: false
    };
    if (localStorage["mapDefaultState"] === "indoor") {
        $scope.mapMode.indoor = true;
    } else if (localStorage["mapDefaultState"] === "outdoor") {
        $scope.mapMode.indoor = false;
    }

    $scope.popupItem = null;
    $scope.itemsInsideViewport = {};

    $scope.mapSidebar = {
        'visible': false
    };
    $scope.addressSearchVisible = {
        toggle: (window.location.href + "").match(/startNavigation/gi) !== null
    };
    $scope.awaitingNavigation = {
        toggle: (window.location.href + "").match(/startNavigation/gi) !== null
    }
    $scope.currentAddressData = {};
    $scope.markers = {};
    $scope.paths = {
        popupPath: {
            color: '#FF0000',
            weight: 4,
            latlngs: []
        }
    };
    $scope.indoorViewer = {
        state: {
            selected: null
        },
        location: null,
        markers: {},
        changeCounter: 0
    };

    mapService.basicMapDesign($scope, leafletData, "mapMap");

    $scope.super({
        clazz: 'asset',
        pagination: {
            max: 200
        },
        downloadUrl: '/asset?select=owner+name+type+groups+tracked+properties+image+lastValidPosition+lastPosition+positionProvider&sort=name&order=asc'
    });

    $scope.downloadAll = function () {
        var total = $scope.pagination.total;
        //$scope.clearItems();

        $scope.super({
            pagination: {
                max: total
            },
            clazz: 'asset',
            downloadUrl: '/asset?select=owner+name+type+groups+tracked+properties+image+lastValidPosition+lastPosition+positionProvider&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    };

    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 8
        },
        defaults: {
            dragging: true,
            maxZoom: 21
        }
    };

    $scope.events = {
        marker: {
            enable: ['click'],
            logic: 'emit'
        },
        map: {
            enable: ['moveend'],
            logic: 'emit'
        }
    };

    $scope.$on('leafletDirectiveMap.moveend', function (event, attrs) {
        $scope.calculateItemsInsideViewport();
    });

    // takes argument a center object
    $scope.setCenter = function (newCenter) {
        $scope.mapData.center.lat = newCenter.lat;
        $scope.mapData.center.lng = newCenter.lng;
        if (newCenter.zoom) {
            $scope.mapData.center.zoom = newCenter.zoom;
        }
    };

    $scope.showOnlyItemsInView = false;

    $scope.$watch("mapMode.indoor", function () {
        setTimeout(function () {
            //window.dispatchEvent(new Event('resize'));
        }, 100);
    });

    $scope.$watch("mapSidebar.visible", function () {
        setTimeout(function () {
            //window.dispatchEvent(new Event('resize'));
        }, 100);
    });

    $scope.calculateItemsInsideViewport = function () {
        $timeout(function () {

            //setting all to false, thus keeping the same object
            for (var k in $scope.itemsInsideViewport) {
                $scope.itemsInsideViewport[k] = false;
            }

            var bounds = map.getBounds();

            for (var n = 0; n < $scope.items.length; n++) {
                var item = $scope.items[n];
                if (item && item.lastValidPosition && item.lastValidPosition.valid) {
                    var point = new L.latLng(item.lastValidPosition.latitude, item.lastValidPosition.longitude);
                    $scope.itemsInsideViewport[item.id] = bounds.contains(new L.latLngBounds(point, point));
                }
            }
        }, 100);
    };

    /** Centers the map on the provided address data. */
    $scope.centerOnAddress = function (data) {
        map.setView({
            'lat': data.point.lat,
            'lng': data.point.lng
        }, 16);

        $scope.currentAddressData = data;

        if ($scope.awaitingNavigation.toggle === true) {

            $scope.startNavigation();
            $scope.awaitingNavigation.toggle = false;

        }
    }

    $scope.startNavigation = function () {

        return $state.go("secure.content.navigate");

    }

    // $scope.startNavigation = function () {

    //     // check if address string is there
    //     if (typeof $scope.currentAddressData.TCAString !== 'undefined') {

    //         if (confirm('Wil je de navigatie starten naar:\n\n' + $scope.currentAddressData.TCAString)) {

    //             // create new IPS point
    //             IPSService.newIPSPoint($scope.currentAddressData, map, 0).then(function (response) {

    //                 // open maps
    //                 console.log('Start maps', googlemapsService.googleMaps(null, null, $scope.currentAddressData.TCAString));

    //                 // reset position at next tick
    //                 $timeout(function () {

    //                     $scope.currentAddressData = {};

    //                 }, 500)


    //             }, function (rejection) {

    //                 //alert('Rejected');
    //                 console.log('rejection', rejection)

    //             });

    //         } else {

    //             console.log('2 confirmation cancelled')

    //             $timeout(function () {

    //                 $scope.currentAddressData = {};
    //                 $scope.addressSearchVisible.toggle = true;
    //                 $scope.awaitingNavigation.toggle = true;

    //             }, 100)
    //         }

    //     } else {

    //         console.log('1 Address data missing')
    //         $scope.currentAddressData = {};
    //         $scope.addressSearchVisible.toggle = true;
    //         $scope.awaitingNavigation.toggle = true;

    //     }

    // }


    $scope.centerOnAllItems = function () {
        var activeMarkersPoints = [];
        // console.log($scope.items);
        for (var n = 0; n < $scope.items.length; n++) {
            if ($scope.items[n] && $scope.items[n].lastValidPosition && $scope.items[n].lastValidPosition.valid) {
                activeMarkersPoints.push(new L.latLng($scope.items[n].lastValidPosition.latitude, $scope.items[n].lastValidPosition.longitude));
            }
        }
        var bounds = new L.latLngBounds(activeMarkersPoints);

        $timeout(function () {

            map.fitBounds(bounds);
            /*map.zoomOut(1);*/
        }, 150);
    };

    $scope.startTrackingItem = function (item) {

        if ($scope.trackItem) {
            $scope.trackItem = null;
        } else {
            $scope.centerOnItem(item);
            $scope.trackItem = item;
        }
    };

    $scope.centerOnItem = function (item) {
        if (item && item.lastValidPosition && item.lastValidPosition.location && item.lastValidPosition.location.locationId) {
            $scope.mapMode.indoor = true;
            $scope.indoorViewer.centerOnLocationId(item.lastValidPosition.location.locationId);
        } else if (item && item.lastValidPosition && item.lastValidPosition.valid) {
            $scope.mapMode.indoor = false;
            var newcenter = {
                lat: item.lastValidPosition.latitude,
                lng: item.lastValidPosition.longitude
            };

            $scope.setCenter(newcenter, 18);
        }
    };

    $scope.goToItemDetails = function (item) {
        $state.go("secure.content.asset.detail", {
            'id': item.id
        });
    };

    $scope.toggleHistoryExpanded = function () {
        $scope.historyExpanded = !$scope.historyExpanded;
    }

    $scope.itemClicked = function (item, centerOnItem) {

        $scope.historyExpanded = false;
        $scope.trackItem = false;

        $scope.scrollToElement(item);

        setTimeout(function () {
            $scope.scrollToElement(item);
        }, 100);

        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }

        $scope.popupExpand = false;

        if (!item || ($scope.popupItem && item && $scope.popupItem.id === item.id)) {
            $scope.popupItem = null;

        } else {
            $scope.popupItem = item;
            $scope.mapSidebar.visible = true;

            if (item && item.lastValidPosition && item.lastValidPosition.valid) {
                var newcenter = {
                    lat: item.lastValidPosition.latitude,
                    lng: item.lastValidPosition.longitude
                };
                $scope.setCenter(newcenter);


                map.setView(newcenter, 18);
            }
        }

        $scope.indoorViewer.state.selected = $scope.popupItem;

        if (item && centerOnItem) {
            $scope.centerOnItem(item);
        }
    };



    var oms = false;
    var addMarker = function (item) {
        var markerID = "marker" + item.id;

        // we only add markers for positions newer than 3 hours
        var tooOld = true;
        if(item.lastValidPosition){

            var secondsSincePosition =  (new Date().getTime() - moment.tz(item.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate().getTime()) / 1000;
            tooOld = secondsSincePosition >= (60 * 60 * 3);

        }

        if (!oms) { // Create Spiderfier layer
            oms = new OverlappingMarkerSpiderfier(map);
            oms.addListener("click", function (marker) {
                $scope.itemClicked(marker.item);
            });
            $scope.slInit = true;
        }
        if (item && item.lastValidPosition && item.lastValidPosition.valid) {
            var marker = $scope.markers[markerID];
            var loc = new L.LatLng(item.lastValidPosition.latitude, item.lastValidPosition.longitude);
            if (marker) {
                oms.unspiderfy();
                marker.setLatLng(loc);
            } else {
                var defaultColor = [(tooOld ? "rgba(200, 200, 200, 0.5)" : "#22b573"), (tooOld ? "rgba(200, 200, 200, 0.5)" : "#1c925d")];
                marker = new L.Marker(loc, {
                    icon: mapService.makeNamedIcon(item.name, defaultColor[0], "mdi mdi-map-marker", defaultColor),
                    riseOnHover: true
                });
                marker.defaultColor = defaultColor;
                marker.item = item;
                $scope.markers[markerID] = marker;
                map.addLayer(marker);
                oms.addMarker(marker);

                // Keep the old code until we know there are no breaks
                // $scope.markers["marker" + item.id] = {
                //     id: "marker" + item.id,
                //     lat: item.lastValidPosition.latitude,
                //     lng: item.lastValidPosition.longitude,
                //     icon: mapService.makeNamedIcon(item.name),
                //     //message : "message",
                //     focus: false, //just add them on the map. not in focus
                //     draggable: false,
                //     'item': item
                // };
            }
        }
        if ($scope.indoorViewer["markers"][item.id]) {
            $scope.indoorViewer["markers"][item.id] = item;
            $scope.indoorViewer.changeCounter++;
        }
    };

    $scope.historyMode = {
        current: null,
        available: ["LAST_10", "LAST_HOUR", "LAST_24H"]
    };
    $scope.historyMode.current = $scope.historyMode.available[0];

    $scope.downloadHistoryForPopupItem = function () {
        if ($scope.popupItem && $scope.popupItem.lastValidPosition) {

            var historyFilterString = "";
            var to = moment((new Date()).getTime()).tz('utc').format('YYYY-MM-DDTHH:mm:ss.SSS');
            if ($scope.historyMode.current === "LAST_10") {
                var from = moment((new Date()).getTime() - 180 * 24 * 3600000).tz('utc').format('YYYY-MM-DDTHH:mm:ss.SSS');
                historyFilterString += "&timestamp:greater=" + from;
                historyFilterString += "&timestamp:less=" + to + "&max=10";
            } else if ($scope.historyMode.current === "LAST_HOUR") {
                var from = moment((new Date()).getTime() - 3600000).tz('utc').format('YYYY-MM-DDTHH:mm:ss.SSS');
                historyFilterString += "&timestamp:greater=" + from;
                historyFilterString += "&timestamp:less=" + to + "&max=1000";
            }
            if ($scope.historyMode.current === "LAST_24H") {
                var from = moment((new Date()).getTime() - 24 * 3600000).tz('utc').format('YYYY-MM-DDTHH:mm:ss.SSS');
                historyFilterString += "&timestamp:greater=" + from;
                historyFilterString += "&timestamp:less=" + to + "&max=1000";
            }
            var target = $scope.popupItem;

            target.history = [];

            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/assetHistory?asset:equals=' + $scope.popupItem.id + '&sort=timestamp&order=desc&select=position+subEvent+event+data+timestamp' + ($scope.alarmCenter ? '&crossAccount=true' : '') + historyFilterString, { onErrorDoNotRedirect: true }).then(function (response) {
                if (response && response.data && typeof response.data.result === 'object') {
                    $scope.paths["popupPath"].latlngs.splice(0, $scope.paths["popupPath"].latlngs.length)
                    target.history = response.data.result;
                    if (response.data.result.length > 1) {
                        for (var n = 0; n < response.data.result.length; n++) {
                            var r = response.data.result[n];
                            if (r.data && r.data.length === 1 && r.data[0].type === "observation" && r.data[0].info.valid) {
                                $scope.paths["popupPath"]["latlngs"].push({
                                    lat: r.data[0].info.latitude,
                                    lng: r.data[0].info.longitude
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    $scope.$watch("historyMode.current", function (newVal, oldVal) {
        $scope.downloadHistoryForPopupItem();
    });

    $scope.$watch("popupItem.id", function (newVal, oldVal) {
        for (var marker in $scope.markers) { //give default color
            $scope.markers[marker].setIcon(mapService.makeNamedIcon($scope.markers[marker].item.name, $scope.markers[marker].defaultColor[0], "mdi mdi-map-marker", $scope.markers[marker].defaultColor[1]));
        }
        if (newVal && $scope.markers["marker" + newVal]) {
            $scope.markers["marker" + newVal].setIcon(mapService.makeNamedIcon($scope.popupItem.name));
            $scope.downloadHistoryForPopupItem();
        }
    });

    $scope.initialCenterSet = false;





    $scope.$watch("itemsChanged", function (newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.indoorViewer["markers"] = {};
            $scope.indoorViewer.changeCounter++;

            var oldPopupExists = false;

            var indoorRatio = 0;
            var ratioCount = 0;
            getTimeStrings();

            var allIds = [];
            angular.forEach($scope.items, function (item) {
                allIds.push(item.id);
            });
            angular.forEach($scope.markers, function (marker, id) {
                if (!marker.item || !marker.item.id || allIds.indexOf(marker.item.id) < 0) {
                    map.removeLayer(marker);
                    oms.removeMarker(marker);
                    delete $scope.markers[id];
                }
            })

            //use the ids of the assets as the ids of the markers as well
            if ($scope.items.length > 0) {
                for (var i = 0; i < $scope.items.length; i++) {
                    addMarker($scope.items[i]);
                    if ($scope.popupItem && $scope.popupItem.id === $scope.items[i].id) {
                        $scope.popupItem = $scope.items[i];
                        oldPopupExists = true;
                    }

                    if ($scope.items[i] && $scope.items[i].lastValidPosition && $scope.items[i].lastValidPosition.location && $scope.items[i].lastValidPosition.location.locationId) {
                        indoorRatio++;
                        ratioCount++;
                    } else if ($scope.items[i] && $scope.items[i].lastValidPosition && $scope.items[i].lastValidPosition.valid) {
                        indoorRatio--;
                        ratioCount++;
                    }
                }

                if ($scope.filterUrlString && $scope.filterUrlString != '') {
                    $scope.centerOnAllItems();

                    if ($scope.items.length === 1) {
                        $scope.itemClicked($scope.items[0]);
                    }
                } else {
                    if (!$scope.initialCenterSet) {
                        $scope.setCenter($scope.savedCenters.osloCenter);
                        $scope.initialCenterSet = true;
                    }
                }

                $scope.calculateItemsInsideViewport();

            }

            if (!oldPopupExists) {
                $scope.popupItem = null;
            }

            if (!$scope.mapMode.deduced) {
                console.log("Indoor ratio", indoorRatio, ratioCount)
                $scope.mapMode.deduced = true;

                if (!localStorage["mapDefaultState"] || localStorage["mapDefaultState"] === "auto") {
                    if (indoorRatio > 0 && ratioCount > 0) {
                        $scope.mapMode.indoor = true;
                    } else if (indoorRatio < 0 && ratioCount > 0) {
                        $scope.mapMode.indoor = false;
                        setTimeout(function () {
                            $scope.centerOnAllItems();
                            //window.dispatchEvent(new Event('resize'));
                        }, 100);
                    }
                } else if (localStorage["mapDefaultState"] === "indoor") {
                    $scope.mapMode.indoor = true;
                } else if (localStorage["mapDefaultState"] === "outdoor") {
                    $scope.mapMode.indoor = false;
                }
            }

        }


    });


    $scope.pushChanged = pushService.changed();

    $scope.$watch("mapMode.indoor", function () {
        setTimeout(function () {
            //$scope.centerOnAllItems();
            //window.dispatchEvent(new Event('resize'));
        }, 100);
    });

    $scope.$watch("pushChanged.counter", function () {
        pushService.process(function (data, util) {
            if (data.object && data.object.type === "asset") {
                if (data.type === "observation" || data.type === "update") {
                    for (var n = 0; n < $scope.items.length; n++) {
                        if (data.object.info.id === $scope.items[n].id) {
                            util.mergePosition($scope.items[n], data);
                            $scope.items[n].properties = data.object.info.properties;
                            break;
                        }
                    }
                    for (var k in $scope.markers) {
                        var m = $scope.markers[k];
                        if (m && m.item && m.item.id && data.object.info.id === m.item.id) {
                            util.mergePosition(m.item, data);
                            if (m.item.lastValidPosition && m.item.lastValidPosition.valid) {
                                if (m.lat !== m.item.lastValidPosition.latitude || m.lng !== m.item.lastValidPosition.longitude) {
                                    if ($scope.popupItem && $scope.popupItem.id === m.item.id && $scope.paths["popupPath"] && $scope.paths["popupPath"].latlngs) {
                                        $scope.paths["popupPath"].latlngs.unshift({
                                            lat: m.item.lastValidPosition.latitude,
                                            lng: m.item.lastValidPosition.longitude
                                        });
                                    }
                                }
                                // m.lat = m.item.lastValidPosition.latitude;
                                // m.lng = m.item.lastValidPosition.longitude;
                                addMarker(m.item); // Will update position
                            }
                        }
                    }
                    $scope.calculateItemsInsideViewport();
                }
                $scope.indoorViewer.changeCounter++;
                getTimeStrings();
                if ($scope.trackItem && $scope.trackItem.id) {
                    $scope.centerOnItem($scope.trackItem);
                }
            }
        });
    });




    //ALL THE CODE BELOW CUSTOM MADE BY X-GUARD


    var clearMarkers = function () {
        angular.forEach($scope.markers, function (value, key) {
            try {
                value.remove();
                oms.removeMarker(value);
            } catch (e) {
                console.error(e);
            }
        });
        $scope.markers = {};
    }

    $scope.textInput = {
        nameSearchValue: "",
        externalIdSearchValue: "",
        assetIdSearchValue: ""
    };
    var searchInProgress = false;
    $scope.applyNameSearch = function ($event) {
        if (!$scope.textInput.nameSearchValue || $scope.textInput.nameSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            searchInProgress = true;
            clearMarkers();
            $scope.filterValues = {
                "name": $scope.textInput.nameSearchValue
            };
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue + ($scope.alarmCenter ? "&crossAccount=true" : "");
            $scope.textInput = {
                nameSearchValue: "",
                externalIdSearchValue: "",
                assetIdSearchValue: ""
            };
        }
    };

    $scope.applyExternalIdSearch = function ($event) {
        if (!$scope.textInput.externalIdSearchValue || $scope.textInput.externalIdSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            searchInProgress = true;
            clearMarkers();
            $scope.filterValues = {
                "externalId": $scope.textInput.externalIdSearchValue
            };
            $scope.filterUrlString = "&externalId:equals=" + $scope.textInput.externalIdSearchValue + ($scope.alarmCenter ? "&crossAccount=true" : "");
            $scope.textInput = {
                nameSearchValue: "",
                externalIdSearchValue: "",
                assetIdSearchValue: ""
            };
        }
    }

    $scope.applyIdSearch = function ($event) {
        if (!$scope.textInput.assetIdSearchValue || $scope.textInput.assetIdSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            searchInProgress = true;
            clearMarkers();
            $scope.filterValues = {
                "id": $scope.textInput.assetIdSearchValue
            };
            $scope.filterUrlString = "&id:equals=" + $scope.textInput.assetIdSearchValue + ($scope.alarmCenter ? "&crossAccount=true" : "");
            $scope.textInput = {
                nameSearchValue: "",
                externalIdSearchValue: "",
                assetIdSearchValue: ""
            };
        }
    }

    $scope.$watch("timers.sixty", function () {
        getTimeStrings();
    });


    var getTimeStrings = function () {
        if ($scope.items.length > 0 && $scope.translations) {
            angular.forEach($scope.items, function (asset, key) {
                if (asset.lastValidPosition && asset.lastValidPosition.timestamp) {
                    var time = moment.tz(asset.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
                    var diff = Math.floor((new Date() - time) / 1000);
                    if (diff < 86400) {
                        var hours = Math.floor(diff / 3600);
                        diff = diff = Math.floor(diff % 3600);
                        var minutes = Math.floor(diff / 60);

                        asset.timeString = $scope.translations.timeTemplate.toString().replace("<HOURS>", hours > 0 ? hours + (hours > 1 ? " " + $scope.translations.hours + " " : " " + $scope.translations.hour + " ") : "")
                            .replace("<MINUTES>", minutes >= 0 ? (minutes + (minutes == 1 ? " " + $scope.translations.minute + " " : " " + $scope.translations.minutes + " ")) : "");
                    } else {
                        asset.timeString = asset.lastValidPosition.timestampFormatted;
                    }
                }
            });
        }
    }

    $scope.getTimeColor = function (item) {
        var clazz = 'text-danger';
        if (item) {
            var alarmDate = moment.tz(item.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
            var now = new Date();
            var diff = now - alarmDate;
            if (diff < 901 * 1000) {
                clazz = 'text-success';
            } else if (diff < 3900 * 1000) {
                clazz = 'text-warning';
            }
        }
        return clazz;
    }

    var copyProperty = function (property) {
        var copy = property.constructor();
        for (var attr in property) {
            if (property.hasOwnProperty(attr)) copy[attr] = property[attr];
        }
        return copy;
    };

    $scope.toggleProperty = function (asset, prop, action) {
        prop.working = true;
        console.log(prop.value + " != " + action);
        if (prop.value == action) {
            prop.working = false;
            return; // No need to bother smarttracker
        }
        property = copyProperty(prop);
        if (property.value == action) return;
        property.value = action;
        var json = {
            "properties": [property]
        }

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + asset.id, json)
            .then(function (response) {
                prop.working = false;
                asset.properties = response.data.result[0].properties;
            });
    };

    $scope.scrollContainer = document.getElementById('scroll-container');

    $scope.scrollToElement = function (item) {
        if (item != null) {
            var anchorscroll = angular.element(document.getElementById(item.id));
            var container = angular.element(document.getElementById('scroll-container'));

            setTimeout(function () {
                container.scrollTo(anchorscroll, 15, 500);
            }, 10);
        }
    };

    $scope.toggleFilters = function () {
        if ($scope.showFilters) {
            TweenLite.to("#sidebarFilters", 0.5, {
                height: "0px",
                ease: "Quart.easeInOut"
            });
            $scope.showFilters = false;
        } else {
            TweenLite.set("#sidebarFilters", {
                height: "auto"
            });
            TweenLite.from("#sidebarFilters", 0.5, {
                height: "0px",
                ease: "Quart.easeInOut"
            });
            $scope.showFilters = true;
        }
    };

    $scope.popupExpand = false;

    $scope.togglePopup = function () {
        if ($scope.popupExpand) {
            TweenLite.to("#mapPopup", 0.5, {
                height: "10px",
                ease: "Quart.easeInOut"
            });
            $scope.popupExpand = false
        } else {
            TweenLite.set("#mapPopup", {
                height: "auto"
            });
            TweenLite.from("#mapPopup", 0.5, {
                height: "10px",
                ease: "Quart.easeInOut"
            });
            $scope.popupExpand = true;
        }
    };

    $scope.goToItemEdit = function (item) {
        $state.go("secure.content.management-asset", {
            'ids': item.id
        });
    };

    $scope.scrollToPopupItem = function () {
        $scope.scrollToElement($scope.popupItem);
    };

    $scope.Screensize = function () {
        if ($(window).width() > 991) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
        $scope.popupExpand = false;
    };

    $scope.localFavorites = (localStorage["Favorites"] === "true");

    if ($scope.localFavorites) {
        $scope.showFavorites();
    }

    $scope.localCollapseMap = (localStorage["CollapseMap"] === "true");
    $scope.toggleCollapseMap = function () {
        $scope.localCollapseMap = !$scope.localCollapseMap;
        localStorage["CollapseMap"] = $scope.localCollapseMap;
    };

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    $scope.isIndoor = function (item) {
        if (item.lastValidPosition == null) {
            return false
        } else if (item.lastValidPosition.source.type == "beacon") {
            return true
        } else {
            return false
        }
    };

    $scope.getIconColor = function (item) {
        var clazz = 'text-danger';

        if (item.lastPosition === null) {
            clazz = 'text-danger';
        } else if (item.lastValidPosition === null) {
            clazz = 'text-danger';
        } else if (item.lastValidPosition.accuracy > 0 && item.lastValidPosition.accuracy <= 15) {
            clazz = 'text-success';
        } else if (item.lastValidPosition.accuracy > 15 && item.lastValidPosition.accuracy <= 40) {
            clazz = 'text-warning';
        }
        return clazz
    };

    $scope.googleMaps = function (item) {
        var lat = item.lastValidPosition.latitude;
        var lng = item.lastValidPosition.longitude;

        return googlemapsService.googleMaps(lat, lng);
    };

    $scope.ZoomIn = function () {
        map.zoomIn();
    };

    $scope.ZoomOut = function () {
        map.zoomOut();
    };

    $scope.searchOnMap = function () {
        $scope.searchOverlay = !$scope.searchOverlay;
    };

    /** Level selection for overlays functionality*/
    $scope.levelOptions = [];
    for (var i = 5; i >= -1; i--) {
        $scope.levelOptions.push(i + "");
    }
    $scope.selectedOverlayLevel = mapService.selectedOverlayLevel();
    $scope.selectOverlayLevel = function (level) {
        mapService.loadOverlays(map, level);
        $scope.selectedOverlayLevel = level;
    }
    /** End Level selection*/

});
angular.module('stwo.asset', ["stwo.core"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider, $translateProvider) {

    var pollingForData = false;
    var lastPollCustomerId = -1;
    var lastPollMillis = 0;

    var assetLinks = [{
        name: "XGUARD_ASSETS_NAV",
        category: "navigation",
        icon: "apple",
        sref: "secure.content.asset",
        categoryDependency: "ASSETS",
        sort: 10,
        color: "info",
        controllers: ["AssetListController", "AssetDetailController", "AssetPropertyController"]
    },
        {
            name: "ASSETS_ALL",
            category: "= filter",
            // category: "ASSETS",
            sref: "secure.content.asset",
            access: moduleStoreProvider.access("stwo.asset", ["asset", "get"]),
            icon: "account-multiple",
            color: "info",
            controllers: ["AssetListController", "AssetDetailController", "AssetPropertyController"],
            sort: 11
        }
        // , {
        //     name: "FAVORITES",
        //     category: "ASSETS",
        //     sref: "secure.content.asset({filter: 'favorites'})",
        //     access: moduleStoreProvider.access("stwo.asset", ["asset", "get"]),
        //     stateParams: {filter: 'favorites'},
        //     icon: "star",
        //     color: "info",
        //     sort: 30
        // }
        ];

    moduleStoreProvider.registerModule({
        name: "asset",
        categories: [{
            name: "ASSETS",
            icon: "account",
            color: "info",
            sort: 11
        }
            // ,{
            //         name : "ASSET_TYPES",
            //         icon : "fa fa-pie-chart",
            //         color: "info",
            //         sort : 12
            // }
            //     {
            //         name : "ASSET_GROUPS",
            //         icon : "fa fa-circle-o",
            //         color: "info",
            //         sort : 13
            // }
        ],
        links: assetLinks,

        notificationHandlers: {
            poll: function () {
                var sts = moduleStoreProvider.serviceRepository()["smarttrackerService"];
                if (pollingForData) {
                    return;
                }
                if (!sts.getCustomerId() || sts.getCustomerId() !== lastPollCustomerId) {
                    for (var n = moduleStoreProvider.links().length - 1; n >= 0; n--) {
                        if (moduleStoreProvider.links()[n]._assetLinkType === "type") {
                            moduleStoreProvider.removeLink(n);
                        }
                    }
                    for (var n = moduleStoreProvider.links().length - 1; n >= 0; n--) {
                        if (moduleStoreProvider.links()[n]._assetLinkType === "group") {
                            moduleStoreProvider.removeLink(n);
                        }
                    }
                    if (!sts.getCustomerId()) {
                        return;
                    }
                }

                var now = (new Date()).getTime();

                if ((now - lastPollMillis) > 15 * 60 * 1000 || lastPollCustomerId !== sts.getCustomerId()) {
                    lastPollMillis = now;
                    lastPollCustomerId = sts.getCustomerId();
                } else {
                    return;
                }

                pollingForData = true;
                sts.authGet(sts.getCustomerId() + '/type?select=name&sort=name&order=asc&max=15', {onErrorDoNotRedirect: true}).then(function (response) {


                    if (response && response.data) {
                        for (var n = moduleStoreProvider.links().length - 1; n >= 0; n--) {
                            if (moduleStoreProvider.links()[n]._assetLinkType === "type") {
                                moduleStoreProvider.removeLink(n);
                            }
                        }


                        for (var n = 0; n < response.data.result.length; n++) {
                            moduleStoreProvider.registerLink({
                                name: response.data.result[n].name,
                                module: "asset",
                                category: "ASSET_TYPES",
                                sref: "secure.content.asset({filter: 'ASSET_TYPE_IS~type.id:equals~" + response.data.result[n].name + "~" + response.data.result[n].id + "'})",
                                access: moduleStoreProvider.access("stwo.asset", ["asset", "get"]),
                                stateParams: {filter: "ASSET_TYPE_IS~type.id:equals~" + response.data.result[n].name + "~" + response.data.result[n].id},
                                icon: "fa fa-pie-chart",
                                color: "primary",
                                sort: 40,
                                '_assetLinkType': "type"
                            });
                        }
                        if (response.data.result.length) {
                            moduleStoreProvider.registerLink({
                                name: "ASSET_TYPE_NO_TYPE",
                                module: "asset",
                                category: "ASSET_TYPES",
                                sref: "secure.content.asset({filter: 'ASSET_TYPE_IS~type:null~ASSET_TYPE_NULL~true'})",
                                access: moduleStoreProvider.access("stwo.asset", ["asset", "get"]),
                                stateParams: {filter: 'ASSET_TYPE_IS~type:null~ASSET_TYPE_NULL~true'},
                                icon: "fa fa-pie-chart",
                                color: "primary",
                                sort: 40,
                                '_assetLinkType': "type"
                            });
                        }
                    } else {
                        console.log("Empty response from smarttracker", response)
                    }
                    sts.authGet(sts.getCustomerId() + '/group?select=name&sort=name&order=asc&max=15', {onErrorDoNotRedirect: true}).then(function (response) {

                        if (response && response.data) {
                            for (var n = moduleStoreProvider.links().length - 1; n >= 0; n--) {
                                if (moduleStoreProvider.links()[n]._assetLinkType === "group") {
                                    moduleStoreProvider.removeLink(n);
                                }
                            }

                            for (var n = 0; n < response.data.result.length; n++) {
                                moduleStoreProvider.registerLink({
                                    name: response.data.result[n].name,
                                    module: "asset",
                                    category: "ASSET_GROUPS",
                                    sref: "secure.content.asset({filter: 'ASSET_MEMBER_OF~groups:equals~" + response.data.result[n].name + "~" + response.data.result[n].id + "'})",
                                    access: moduleStoreProvider.access("stwo.asset", ["asset", "get"]),
                                    stateParams: {filter: "ASSET_MEMBER_OF~groups:equals~" + response.data.result[n].name + "~" + response.data.result[n].id},
                                    icon: "fa fa-circle-o",
                                    controllers: ["AssetListController"],
                                    color: "default",
                                    sort: 50,
                                    '_assetLinkType': "group"
                                });
                            }
                        } else {
                            console.log("Empty response from smarttracker", response)
                        }
                        pollingForData = false;
                    }, function () {
                        pollingForData = false;
                    });
                }, function () {
                    pollingForData = false;
                });
            }
        }
    });

    $stateProvider.state("secure.content.asset", {
        url: "/asset:filter",
        templateUrl: "modules/asset/list.html",
        controller: "AssetListController",
        titleName: 'ASSETS_TITLE',
        titleIcon: "account-multiple-outline"

    }).state("secure.content.asset.detail", {
        url: "/asset-detail/:id",
        templateUrl: "modules/asset/detail.html",
        controller: "AssetDetailController",
        titleName: 'ASSETS_DETAILS',
        titleIcon: "account-multiple-outline"
    }).state("secure.content.asset.detail.property", {
        url: "/asset-property/:id/:typePropertyIdentifier",
        templateUrl: "modules/asset/property.html",
        controller: "AssetPropertyController"
    }).state("secure.content.asset.map", {
        url: "/asset-map/:id",
        templateUrl: "modules/asset/map.html",
        controller: "AssetMapController",
        titleName: 'MAP',
        titleIcon: "map"
    });

    moduleStoreProvider.addPossibleFilter("asset", {
        id: "name",
        label: "ASSETS_FILTER_NAME",
        type: "string",
        field: "name",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("asset", {
        id: "description",
        label: "ASSETS_FILTER_DESCRIPTION",
        type: "string",
        field: "description",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("asset", {
        id: "tags",
        label: "ASSETS_FILTER_TAG",
        type: "string",
        field: "tags",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("asset", {
        id: "typename",
        label: "ASSETS_FILTER_TYPE",
        type: "string",
        field: "type.name",
        comparator: "contains"
    });

    moduleStoreProvider.addPossibleFilter("type", {
        id: "name",
        label: "ASSETS_TYPE_FILTER_NAME",
        type: "string",
        field: "name",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("type", {
        id: "description",
        label: "ASSETS_TYPE_FILTER_DESCRIPTION",
        type: "string",
        field: "description",
        comparator: "contains"
    });

    moduleStoreProvider.addPossibleFilter("device", {
        id: "name",
        label: "NAME",
        type: "string",
        field: "name",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("device", {
        id: "uuid",
        label: "DEVICE_ID",
        type: "string",
        field: "uuid",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("device", {
        id: 'primaryProperties',
        label: "PRIMARY_PROPERTIES",
        type: "string",
        field: "primaryPropertiesString",
        comparator: "contains"
    });
    moduleStoreProvider.addPossibleFilter("device", {
        id: "active",
        label: "ACTIVE",
        comparator: "equals",
        type: "list",
        list: [{label: "-", value: ""}, {label: "Active", value: "true"}, {label: "Inactive", value: "false"}],
        field: "active"
    });
    moduleStoreProvider.addPossibleFilter("device", {
        id: "lastSeen",
        label: "LAST_SEEN",
        comparator: "older",
        type: "list",
        list: [{label: "-", value: ""}, {label: "LAST_SEEN_1_DAY", value: "86400000"}, {
            label: "LAST_SEEN_3_DAY",
            value: "259200000"
        }],
        field: "lastSeen"
    });
});

angular.module('stwo.asset').controller('AssetListController', function ($scope, $state, $controller, pushService, decorationService, smarttrackerService, moduleStore) {
    $controller('BaseListContentController', {$scope: $scope});

    $scope.super({
        clazz: 'asset',
        downloadUrl: '/asset?select=name+tags+type+tracked+image+icon+properties+lastValidPosition+devices&sort=name&order=asc'
    });

    $scope.assetClicked = function (asset) {
        $state.go("secure.content.asset.detail", {id: asset.id});
    }

    $scope.openSelectedAssetsInMap = function () {
        if ($scope.selectedItems.length > 0) {
            var idsList = [];

            for (var i = 0; i < $scope.selectedItems.length; i++) {
                idsList.push($scope.selectedItems[i].id);
            }

            $state.go("secure.content.map", {ids: idsList.join("%2B")});
        }
    };


    $scope.pushChanged = pushService.changed();
    $scope.$watch("itemsChanged", function () {
        for (var n = 0; n < $scope.items.length; n++) {
            $scope.items[n]._decoration = decorationService.find("asset", $scope.items[n], "property");
            if ($scope.items[n].tags) {
                for (var nt = 0; nt < $scope.items[n].tags.length; nt++) {
                    $scope.items[n].tags[nt]._decoration = decorationService.find("asset", $scope.items[n], "tag", $scope.items[n].tags[nt].name);
                }
            }
        }
    });
    $scope.$watch("pushChanged.counter", function () {
        pushService.process(function (data, util) {
            for (var n = 0; n < $scope.items.length; n++) {
                $scope.items[n]._decoration = decorationService.find("asset", $scope.items[n]);
                if (data.type === "observation" && data.object && data.object.type === "asset" && data.object.info.id === $scope.items[n].id) {
                    util.mergePosition($scope.items[n], data);
                }
            }
        });
    })

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.stateDependentLinks = moduleStore.stateDependentLinks($scope.getCurrentState(), $scope);
    });

});

angular.module('stwo.asset').controller('AssetDetailController', function ($state, $scope, $modal, $translate, $controller, $stateParams, moduleStore, smarttrackerService, decorationService, pushService, contentCacheService, leafletData, mapService) {

    $controller('BaseDetailContentController', {$scope: $scope});

    $scope.sentCommands = null;

    $scope.indoorViewer = {location: null, markers: {}, changeCounter: 0};
    $scope.markers = {};
    $scope.paths = {};
    $scope.mapData = {
        center: {
            lat: 0,
            lng: 0,
            zoom: 1
        }
    };
    mapService.basicMapDesign($scope, leafletData);

    $scope.openInMap = function (asset) {
        if ($scope.modules["map"]) {
            $state.go("secure.content.map", {ids: asset.id});
        } else {
            $state.go("secure.content.asset.map", {id: asset.id});
        }
    };

    $scope.displayItemInMap = function (item) {
        if (item && item.lastValidPosition && item.lastValidPosition.valid) {
            $scope.markers["marker"] = {
                id: "marker",
                lat: item.lastValidPosition.latitude,
                lng: item.lastValidPosition.longitude,
                icon: mapService.makeNamedIcon(item.name),
                focus: false,
                draggable: false
            };
            $scope.paths["marker"] = {
                id: "marker",
                latlngs: {lat: item.lastValidPosition.latitude, lng: item.lastValidPosition.longitude},
                color: "#ff8800",
                weight: 2,
                type: "circle",
                radius: item.lastValidPosition.accuracy ? item.lastValidPosition.accuracy : 1
            };
            // center on the marker
            $scope.mapData.center.lat = item.lastValidPosition.latitude;
            $scope.mapData.center.lng = item.lastValidPosition.longitude;
            $scope.mapData.center.zoom = 14;
        }
    };

    $scope.asset = contentCacheService.get("asset", $stateParams.id);
    $scope.displayItemInMap($scope.asset);


    $scope.sendCommand = function (asset, command) {
        if (smarttrackerService.getAccessRights()["deviceCommand"]["post"]) {
            var modalInstance = $modal.open({
                templateUrl: 'core/html/send_command_modal.html',
                controller: stwoCommonSendCommandModalController,
                size: "lg",
                resolve: {
                    sendCommandConfiguration: function () {
                        return {asset: asset, command: command}
                    }
                }
            });

            modalInstance.result.then(function (newFilterData) {
                $scope.downloadSentCommandsForAsset(asset);
            }, function () {

            });
        }
    }

    $scope.downloadSentCommandsForAsset = function (asset) {
        if (smarttrackerService.getAccessRights()["deviceCommand"]["get"]) {
            $scope.sentCommands = null;
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/deviceCommand?select=command+commandFormatted+sent+status+statusCode&asset:equals=' + asset.id)
                .then(function (response) {
                    if (response && response.data && response.data.result) {
                        $scope.sentCommands = response.data.result;
                    }
                });
        }
    };

    $scope.downloadAsset = function () {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $stateParams.id + '?select=*').then(function (response) {
            $scope.asset = response.data.result[0];
            if ($scope.asset) {
                contentCacheService.put("asset", $scope.asset.id, $scope.asset);
            }
            $scope.displayItemInMap($scope.asset);
            $scope.downloadSentCommandsForAsset($scope.asset);
            $scope.indoorViewer["markers"][$scope.asset.id] = $scope.asset;
            $scope.indoorViewer.changeCounter++;

            $scope.stateDependentLinks = moduleStore.stateDependentLinks($scope.getCurrentState(), $scope);
        });
    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.downloadAsset();

        $scope.pushChanged = pushService.changed();

        $scope.$watch("pushChanged.counter", function () {
            pushService.process(function (data, util) {
                if (data.type === "observation" && $scope.asset && data.object && data.object.type === "asset" && data.object.info.id === $scope.asset.id) {
                    util.mergePosition($scope.asset, data);
                    $scope.displayItemInMap($scope.asset);
                    $scope.indoorViewer["markers"][$scope.asset.id] = $scope.asset;
                    $scope.indoorViewer.changeCounter++;
                }
            });
        })
    });

    $scope.addPin = function () {
        var possiblePins = {
            "tags": [],
            "properties": [],
            "position": []
        }

        $translate(['ASSETS_TAGS', 'ASSETS_TAGS']).then(function (translations) {
            possiblePins["tags"].push({
                templateUrl: "modules/asset/widget/tags-widget.html",
                title: $scope.asset.name + ": " + translations.ASSETS_TAGS,
                shortTitle: translations.ASSETS_TAGS,
                sourceType: "asset",
                sourceId: $scope.asset.id,
                link: {sref: "secure.content.asset.detail", stateParams: {id: $scope.asset.id}},
                theme: "warning",
                select: ["tags"],
                filter: [],
                extraData: {},
                height: "3"
            });
        });

        $translate(['ASSETS_TAGS', 'ASSETS_WHERE']).then(function (translations) {
            possiblePins["position"].push({
                templateUrl: "modules/asset/widget/position-widget.html",
                title: $scope.asset.name + ": " + translations.ASSETS_WHERE,
                shortTitle: translations.ASSETS_WHERE,
                sourceType: "asset",
                sourceId: $scope.asset.id,
                link: {sref: "secure.content.asset.detail", stateParams: {id: $scope.asset.id}},
                theme: "success",
                select: ["lastValidPosition"],
                filter: [],
                extraData: {},
                height: "4"
            });
        });

        if ($scope.asset.properties) {
            for (var n = 0; n < $scope.asset.properties.length; n++) {
                possiblePins["properties"].push({
                    templateUrl: "modules/asset/widget/property-widget.html",
                    title: $scope.asset.name + ": " + $scope.asset.properties[n].name,
                    shortTitle: $scope.asset.properties[n].name,
                    sourceType: "asset",
                    sourceId: $scope.asset.id,
                    link: {sref: "secure.content.asset.detail", stateParams: {id: $scope.asset.id}},
                    theme: "info",
                    select: ["properties"],
                    filter: [],
                    extraData: {typePropertyIdentifier: $scope.asset.properties[n].typePropertyIdentifier},
                    height: "2"
                });
            }
        }


        $modal.open({
            templateUrl: 'glue/pinboard/pin_add_modal.html',
            controller: stwoGluePinboardAddNewPinModalController,
            size: "lg",
            resolve: {
                possiblePins: function () {
                    return possiblePins
                }
            }
        });
    }

    $scope.super({clazz: 'asset'});
});

angular.module('stwo.asset').controller('AssetMapController', function ($state, $scope, $modal, $controller, $stateParams, smarttrackerService, pushService, contentCacheService, leafletData, mapService) {

    $controller('BaseDetailContentController', {$scope: $scope});

    $scope.markers = {};
    $scope.paths = {};
    $scope.mapData = {
        center: {
            lat: 0,
            lng: 0,
            zoom: 1
        }
    };
    mapService.basicMapDesign($scope, leafletData);

    $scope.displayItemInMap = function (item) {
        if (item && item.lastValidPosition && item.lastValidPosition.valid) {
            $scope.markers["marker"] = {
                id: "marker",
                lat: item.lastValidPosition.latitude,
                lng: item.lastValidPosition.longitude,
                icon: mapService.makeNamedIcon(item.name),
                focus: false,
                draggable: false
            };
            $scope.paths["marker"] = {
                id: "marker",
                latlngs: {lat: item.lastValidPosition.latitude, lng: item.lastValidPosition.longitude},
                color: "#ff8800",
                weight: 2,
                type: "circle",
                radius: item.lastValidPosition.accuracy ? item.lastValidPosition.accuracy : 1
            };
            // center on the marker
            $scope.mapData.center.lat = item.lastValidPosition.latitude;
            $scope.mapData.center.lng = item.lastValidPosition.longitude;
            $scope.mapData.center.zoom = 14;
        }
    };

    $scope.asset = contentCacheService.get("asset", $stateParams.id);
    $scope.displayItemInMap($scope.asset);

    $scope.downloadAsset = function () {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $stateParams.id + '?select=*').then(function (response) {
            $scope.asset = response.data.result[0];
            if ($scope.asset) {
                contentCacheService.put("asset", $scope.asset.id, $scope.asset);
            }
            $scope.displayItemInMap($scope.asset);
        });
    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.downloadAsset();


        $scope.pushChanged = pushService.changed();

        $scope.$watch("pushChanged.counter", function () {
            pushService.process(function (data, util) {
                if (data.type === "observation" && $scope.asset && data.object && data.object.type === "asset" && data.object.info.id === $scope.asset.id) {
                    util.mergePosition($scope.asset, data);
                    $scope.displayItemInMap($scope.asset);
                }
            });
        })
    });

    $scope.super({clazz: 'asset'});
});

angular.module('stwo.asset').controller('AssetPropertyController', function ($scope, $http, $stateParams, smarttrackerService) {

    var oldestHistoryItem = "2030-01-01T00:00:00.503";
    var dataReady = false;
    var alreadyDownloadedItems = {};
    $scope.propertyHistory = []
    $scope.historyDownloadState = {showHistory: false, downloading: false, moreExist: true};

    $scope.graphData = []

    $scope.$watch("asset", function (newVal) {
        if (newVal && newVal.properties) {
            for (var n = 0; n < newVal.properties.length; n++) {
                if (newVal.properties[n].typePropertyIdentifier === $stateParams.typePropertyIdentifier) {
                    $scope.property = newVal.properties[n];
                    if ($scope.property.unit && $scope.property.unit !== "none") {
                        $scope.unitToFormat = $scope.property.unit.replace("/", "p").replace("\\", "p").toUpperCase();
                    }

                    $scope.graphOptions = {
                        axes: {
                            x: {
                                type: "date"
                            }
                        },
                        series: [
                            {
                                y: "val_0",
                                label: $scope.property.name,
                                color: "#9467bd"
                            }
                        ],
                        tooltip: {
                            mode: "scrubber"
                        }
                    };

                    if (!dataReady) {
                        dataReady = true;
                        $scope.downloadMoreHistory();
                    }
                    break;
                }
            }
        }
    }, true);

    $scope.downloadMoreHistory = function () {
        $scope.historyDownloadState.downloading = true;
        var max = 10;
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/property?select=*&asset:equals=" + $scope.asset.id +
            "&typePropertyIdentifier:equals=" + $scope.property.typePropertyIdentifier +
            "&timestamp:greater=2010-01-01T00:00:00.503&timestamp:less=" + oldestHistoryItem +
            "&max=" + max + "&order=desc&sort=timestamp")
            .then(function (response) {
                $scope.historyDownloadState.downloading = false;
                if (response.data.result.length < max) {
                    $scope.historyDownloadState.moreExist = false;
                }
                if (response.data.result.length > 0) {
                    oldestHistoryItem = response.data.result[response.data.result.length - 1].timestamp;
                    for (var n = 0; n < response.data.result.length; n++) {
                        if (!alreadyDownloadedItems[response.data.result[n].timestamp + response.data.result[n].textValue]) {
                            alreadyDownloadedItems[response.data.result[n].timestamp + response.data.result[n].textValue] = true;
                            $scope.propertyHistory.push(response.data.result[n]);
                            if ($scope.property.valueType === "numeric") {
                                $scope.graphData.push({
                                    x: new Date(response.data.result[n].timestamp),
                                    val_0: response.data.result[n].numberValue
                                });
                            }

                        }
                    }
                }

            }, function (response) {
                $scope.historyDownloadState.downloading = false;
            });
    }
    smarttrackerService.isLoggedInDelayed().then(function () {

    });

});
angular.module('stwo.asset').directive('assetPropertyWidget', function($http, $state, decorationService) {
    return {
        restrict: 'AE',
        scope: {
            data: '=widgetData',
            extraData: '=widgetExtraData',
            theme: '=widgetTheme'
        },
        template:   '<div class="alert no-padding text-center height-100 grid-max-height property-box clickable"  ng-click="go(\'secure.content.asset.detail.property\', {id: asset.id, typePropertyIdentifier: property.typePropertyIdentifier})"' +
                        'ng-class="(property._decoration.image ? \'property-with-decorative-image \' : \'\') + \'alert-\' + theme + \' decorative-color decorative-color-\' + property._decoration.color">' +
                    '<div class="property-decoration-image" ng-if="property._decoration.image" ng-style="{\'background-image\': \'url(\' + property._decoration.image + \')\'}"></div>' + 
                    '<div class="property-data property-data-image" ng-if="property.valueType === \'image\'" ng-style="{\'background-image\': \'url(\' + property.value + \')\'}"></div>' + 
                    '<div class="h3 no-margin property-data" ng-if="property.valueType !== \'image\'">{{formattedPropertyValue}}<span ng-if="unitToFormat" class="h5">&nbsp;<span translate="">{{\'UNIT_\' + unitToFormat}}</span></span></div>' + 
                    '<div class="h5 no-margin property-name" ng-class="\'property-name-\' + property.valueType">{{property.name}}</div>' +
                    '</div>',
        link: function(scope, element, attrs) {
            scope.$watch("property", function() {
                if (scope.property) {
                    scope.property._decoration = decorationService.find("asset", scope.asset, "property", scope.property);
                }
            }, true);
                
            scope.go = $state.go;
            scope.asset = scope.data;
            if (scope.asset && scope.asset.properties) {
                for (var n = 0; n < scope.asset.properties.length; n++) {
                    if (scope.extraData && scope.asset.properties[n].typePropertyIdentifier === scope.extraData.typePropertyIdentifier) {
                        scope.property = scope.asset.properties[n];
                        break;
                    }
                }
            }
            
            if (scope.property) {
                if (scope.property.valueType === "numeric") {
                    if (!scope.property.value && scope.property.value !== 0) {
                        scope.formattedPropertyValue = "-";
                    } else {
                        scope.formattedPropertyValue = scope.property.value; //round down?
                        
                        if (scope.property.unit && scope.property.unit !== "none") {
                            scope.unitToFormat = scope.property.unit.replace("/", "p").replace("\\", "p").toUpperCase();
                        }
                    }
                } else {
                    scope.formattedPropertyValue = scope.property.value;
                }
            }
        }
    };
});

angular.module('stwo.asset').directive('assetTagsWidget', function($http, decorationService) {
    return {
        restrict: 'AE',
        scope: {
            data: '=widgetData',
            theme: '=widgetTheme'
        },
        template:   '<div ng-repeat="tag in asset.tags" class="grid-float-5m">' + 
                    '<span class="label label-lg" ng-class="\'label-\' + theme + \' decorative-color decorative-color-\' + tag._decoration.color"><i class="fa fa-tag"></i>&nbsp;{{tag.name}}</span>' + 
                    '</div>',
        link: function(scope, element, attrs) {
            scope.$watch("asset.tags", function() {
                if (scope.asset.tags) {
                    for (var n = 0; n < scope.asset.tags.length; n++) {
                        scope.asset.tags[n]._decoration = decorationService.find("asset", scope.asset, "tag", scope.asset.tags[n].name);
                    }
                }
            }, true)
            scope.asset = scope.data;
        }
    };
});

angular.module('stwo.asset').directive('assetPositionWidget', function(mapService, leafletData) {
    return {
        restrict: 'AE',
        scope: {
            data: '=widgetData',
            theme: '=widgetTheme'
        },
        template:   '<div class="grid-max-height alert no-padding" ng-class="\'alert-\' + theme">' +
                    '<div ng-click="mapExpanded = !mapExpanded" class="tight-padding clickable">' + 
                    '<p>{{ asset.lastValidPosition.timestamp | amDateFormat:\'YYYY-DD-MM, HH:mm:ss\' }}</p>' +
                    '<div class="h4"><i class="fa" ng-class="positionIcon"></i>&nbsp;{{textualPosition}}</div></div>' + 
                    '<div ng-if="asset.lastValidPosition.insideZones.length"><span translate="">ASSETS_INSIDE_ZONES</span>: {{ _.pluck(asset.lastValidPosition.insideZones, \'name\').join(\', \')}}</div>' +
                    '<span ng-if="asset.lastValidPosition.accuracy > 0"><span translate="">ASSETS_ACCURACY</span>: {{asset.lastValidPosition.accuracy}} <span translate="">METERS</span></span>' +
                    '<div ng-if="mapExpanded && mapType === \'outdoor\'"><br /><leaflet class="leaflet-map-details height-400" center="mapData.center" markers="markers" paths="paths" layers="layers" ></leaflet></div>' +
                    '<div ng-if="mapExpanded && mapType === \'indoor\'"><br /><div class="indoor-location-viewer-box" indoor-location-viewer data="indoorViewer"></div></div>' +
                    '</div>',
        link: function(scope, element, attrs) {
            scope["_"] = _;
            scope.asset = scope.data;
            scope.mapExpanded = false;
            
            scope.textualPosition = "";
            scope.positionIcon = "fa-ban";
            if (scope.asset && scope.asset.lastValidPosition) {
                if (scope.asset.lastValidPosition.valid) {
                    var t  = scope.asset.lastValidPosition.address;
                    if (scope.asset.lastValidPosition.textual) {
                        if (t) {
                            t = scope.asset.lastValidPosition.textual + ", " + t;
                        } else {
                            t  = scope.asset.lastValidPosition.textual;
                        }
                    }
                    scope.positionIcon = "fa-globe";
                    if (t) {
                        scope.textualPosition = t;
                    }
                }
                if (scope.asset.lastValidPosition.location && scope.asset.lastValidPosition.location.locationId) {
                    scope.textualPosition = scope.asset.lastValidPosition.location.path;
                    scope.positionIcon = "fa-building-o";
                }
            }
            
    
            scope.indoorViewer = {location: null, markers: {}, changeCounter: 0};
            scope.markers = {};
            scope.paths = {};
            scope.mapData = {
                    center : {
                            lat : 0,
                            lng : 0,
                zoom : 1			
                    }
            };
            mapService.basicMapDesign(scope, leafletData);
            
            
            if (scope.asset && scope.asset.lastValidPosition && scope.asset.lastValidPosition.location && scope.asset.lastValidPosition.location.locationId) {
                scope.mapType = "indoor";
                
                scope.indoorViewer["markers"][scope.asset.id] = scope.asset;
                scope.indoorViewer.changeCounter++;
            } else if (scope.asset && scope.asset.lastValidPosition && scope.asset.lastValidPosition.valid) {
                scope.mapType = "outdoor";
                scope.markers["marker"] = {
                    id : "marker",
                    lat : scope.asset.lastValidPosition.latitude,
                    lng : scope.asset.lastValidPosition.longitude,
                    icon: mapService.makeNamedIcon(scope.asset.name),
                    focus : false,
                    draggable : false
                };
                scope.paths["marker"] = {
                    id : "marker",
                    latlngs : {lat: scope.asset.lastValidPosition.latitude, lng : scope.asset.lastValidPosition.longitude},
                    color : "#ff8800",
                    weight : 2,
                    type: "circle",
                    radius: scope.asset.lastValidPosition.accuracy ? scope.asset.lastValidPosition.accuracy : 1
                };
                // center on the marker
                scope.mapData.center.lat = scope.asset.lastValidPosition.latitude;
                scope.mapData.center.lng = scope.asset.lastValidPosition.longitude;
                scope.mapData.center.zoom = 14;
            }
        }
    };
});
angular.module('stwo.management', ["stwo.core"])
	.config(function($stateProvider, moduleStoreProvider, $translateProvider) {
		
		moduleStoreProvider.registerModule({name: "management",
            categories : [{
                    name : "MANAGEMENT",
                    icon : "fa fa-gears",
                    color: "warning",
                    sort : 81
            }],
            links: [{
                    name:"MANAGEMENT",
                    category: "navigation",
                    icon: "fa fa-gears",
                    sref: "secure.content.management",
                    categoryDependency: "MANAGEMENT",
                    sort: 10,
                    color: "success",
                    controllers: ["ManagementDashboardController"]
                }]});
		
        $stateProvider
			.state("secure.content.management",
				{
					url: "/management",
					templateUrl: "modules/management/dashboard.html",
					controller: "ManagementDashboardController"
				})
	});
	
	
angular.module('stwo.management').controller('ManagementDashboardController', function ($scope, $state, moduleStore) {
    
	$scope.allLinks = moduleStore.links();
    
    $scope.linkClicked = function(link) {
        if (link.stateParams) {
            $state.go(link.sref.split("(")[0], link.stateParams);
        } else {
            $state.go(link.sref);
        }
    }
});
angular.module('stwo.management-subscription', ["stwo.management"])
	.config(function($stateProvider, moduleStoreProvider, $translateProvider) {
		
		moduleStoreProvider.registerModule({name: "subscription-management", links: [
                {
                    name:"SUBSCRIPTION",
                    category: "= filter" ,
                    sref: "secure.content.subscription",
                    access: ["asset", "put"],
                    icon: "playlist-check",
                    color: "warning",
                    controllers: ["SubscriptionListController", "SubscriptionMessageListController"],
                    sort: 81,
                    navigation: true
                }
            ]});
		
        $stateProvider
			.state("secure.content.subscription",
				{
					url: "/subscription",
					templateUrl: "modules/management-subscription/list.html",
					controller: "SubscriptionListController",
                    titleName: 'MANAGEMENT_SUBSCRIPTIONS_TITLE',
                    titleIcon: "playlist-check"
				}).state("secure.content.subscription-message", {
                    url : "/subscription-message/:subscriptionId",
                    templateUrl : "modules/management-subscription/messages.html",
                    controller : "SubscriptionMessageListController",
                    titleName: 'MANAGEMENT_SUBSCRIPTIONS_TITLE',
                    titleIcon: "playlist-check"
            })
	});
	
	
angular.module('stwo.management-subscription').controller('SubscriptionListController', function ($scope, $modal, $http, dialogService, smarttrackerService) {
    $scope.pagination = {offset: 0, max: 20};
    $scope.items = [];
    $scope.showRawJson = {};
    $scope.JSON = JSON;
    $scope.refresh = function() {
        $scope.download();
    }
    $scope.download = function() {
    
        $http.get(stwoGlobal.smarttrackerSubscriptionUrl + "manage/" + smarttrackerService.getCustomerId() + "?max=" + $scope.pagination.max + "&offset=" + $scope.pagination.offset, {
                headers : {
                    "X-Auth-Token" : smarttrackerService.getAuthToken()
                }
            }).then(function(response) {
                $scope.items = response.data.sort(function(a, b) {
                    return a.id < b.id ? 1 : -1;
                });
            });
    }
    
    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.download();
        
        $scope.$watch("pagination.offset + pagination.max", function() {
           $scope.download(); 
        });
    });
    
    
    $scope.create = function() {
        var modalInstance = $modal.open({
            templateUrl: 'modules/management-subscription/subscription-modal.html',
            controller: stwoManagementSubscriptionModifyModalController,
            size: "lg",
            resolve: {
                subscription: function() { return null }
            }
        });
        
        modalInstance.result.then(function (newFilterData) {
            console.log("new subscription", newFilterData.subscription);
            
            $http.post(stwoGlobal.smarttrackerSubscriptionUrl + "manage/" + smarttrackerService.getCustomerId(), newFilterData.subscription, {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.download();
                });
            
        }, function() {
            
        });
    }
    
    $scope.remove = function(subscription) {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_DELETE_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_DELETE_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_DELETE_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {

            $http["delete"](stwoGlobal.smarttrackerSubscriptionUrl + "manage/" + smarttrackerService.getCustomerId() + "/" + subscription.id, {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.download();
                });

        });
    }
    
    $scope.update = function(subscription) {
        var modalInstance = $modal.open({
            templateUrl: 'modules/management-subscription/subscription-modal.html',
            controller: stwoManagementSubscriptionModifyModalController,
            size: "lg",
            resolve: {
                subscription: function() { return angular.fromJson(angular.toJson(subscription)) }
            }
        });
        
        modalInstance.result.then(function (newFilterData) {
            console.log("update subscription", newFilterData.subscription);
            
            $http.put(stwoGlobal.smarttrackerSubscriptionUrl + "manage/" + smarttrackerService.getCustomerId() + "/" + newFilterData.subscription.id, newFilterData.subscription, {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.download();
                });
        }, function() {
            
        });
    }
});
	
var stwoManagementSubscriptionModifyModalController = function ($scope, $modalInstance, subscription) {
    
    $scope.subscription = subscription ? subscription : {active: true, object:{type: "asset", ids: []}, select:["*"], filter:[""], timeToLive: 3600, format:{type: "json-tellu"}, protocol:{type:"ws-server", repeatQueue: "false"}};
    
    if ($scope.subscription && !$scope.subscription.protocol) {
        $scope.subscription.protocol = {};
    }
    if (!$scope.subscription.protocol.repeatQueue) {
        $scope.subscription.protocol.repeatQueue = "false"
    }
    
    $scope.existingSubscription = subscription ? angular.fromJson(angular.toJson(subscription)) : null;
    
    $scope.subscription.select = $scope.subscription.select ? $scope.subscription.select.join("\n") : "";
    $scope.subscription.filter = $scope.subscription.filter ? $scope.subscription.filter.join("\n") : "";
    $scope.subscription.object.ids = $scope.subscription.object.ids ? $scope.subscription.object.ids.join("\n") : "";
    
    $scope.ok = function () {
        $scope.subscription.select = $scope.subscription.select.split("\n");
        $scope.subscription.filter = $scope.subscription.filter.split("\n");
        $scope.subscription.object.ids = $scope.subscription.object.ids.split("\n");
        
        $modalInstance.close({subscription: $scope.subscription});
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};

angular.module('stwo.management-subscription').filter('subscriptionMessageFilter', function () {
        return function (arr, filter) {
            var outArr = [];
            for (var n = 0; n < arr.length; n++) {
                var anyFilter = false;
                var anyFilterMatch = false;
                
                if (!anyFilterMatch && filter.free && filter.free != "") {
                    anyFilter = true;
                    anyFilterMatch = angular.toJson(arr[n]).toLowerCase().indexOf(filter.free.toLowerCase()) !== - 1;
                }
                
                if (!anyFilter || anyFilterMatch) {
                    outArr.push(arr[n]);
                }
            }
            return outArr;
        };
    });
    
    
angular.module('stwo.management-subscription').controller('SubscriptionMessageListController', function ($scope, $stateParams, $http, dialogService, smarttrackerService) {
    $scope.pagination = {downloading: false, mode: "undelivered", offset: 0, nomore: false, sort:"created", order: "asc"};
    $scope.items = [];
    $scope.showRawJson = {};
    $scope.filter = {free: ''};
    
    $scope.setFilterMode = function(mode) {
        if ($scope.pagination.mode === mode) {
            $scope.pagination.mode = "undelivered";
        } else {
            $scope.pagination.mode = mode;
            $scope.refresh();
        }
    }
    
    $scope.setOrder = function(order) {
        $scope.pagination.order = order;
        $scope.refresh();
    }
    
    $scope.refresh = function() {
        $scope.pagination.offset = 0;
        $scope.pagination.nomore = false;
        $scope.items = [];
        $scope.download();
    }
    
    $scope.download = function() {
        $scope.pagination.downloading = true;
        
        var max = 100;
        var filter = "";
        if ($scope.pagination.mode === "undelivered") {
            
        } else if ($scope.pagination.mode === "delivered") {
            filter = "&delivered:equals=true";
        } else if ($scope.pagination.mode === "failed") {
            filter = "&failed:equals=true";
        }
        
        var sort = "&sort=" + $scope.pagination.sort && "&order=" + $scope.pagination.order;
        
        
        $http.get(stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "?max=" + max + "&offset=" + $scope.pagination.offset + filter + sort, {
                headers : {
                    "X-Auth-Token" : smarttrackerService.getAuthToken()
                }
            }).then(function(response) {
                $scope.pagination.downloading = false;
                
                $scope.pagination.offset += max;
                
                if (response.data) {
                    for (var n = 0; n < response.data.length; n++) {
                        var d = response.data[n];

                        var exists = false;
                        for (var m = $scope.items.length - 1; m >= 0; m--) {
                            if ($scope.items[m].id === d.id) {
                                exists = true;
                            }
                        }

                        if (!exists) {
                            if (d.contentType.indexOf("json") > 0) {
                                //$scope.items[n]._prettyContent = $scope.items[n].content;
                                d._prettyContent = JSON.stringify(angular.fromJson(d.content), null, " ");
                            } else {
                                d._prettyContent = d.content;
                            }
                            $scope.items.push(d);
                        }
                    }
                    
                    if (response.data.length < max) {
                        $scope.pagination.nomore = true;
                    }
                }
                
            }, function(response) {
                $scope.pagination.downloading = false;
            });
    }
    
    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.download();
    });
    
    
    
    $scope.remove = function(message) {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["delete"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "/" + message.id, {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {

                        for (var n = $scope.items.length - 1; n >= 0; n--) {
                            if ($scope.items[n].id === message.id) {
                                $scope.items.splice(n, 1);
                            }
                        }
                });

        });
    }
    
    $scope.removeAll = function() {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_ALL_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_ALL_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_ACK_ALL_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["delete"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId, {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.refresh();
                });

        });
    }
    
    $scope.redeliver = function(message) {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["put"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "/" + message.id + "?operation=redeliver", {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {

                        for (var n = $scope.items.length - 1; n >= 0; n--) {
                            if ($scope.items[n].id === message.id) {
                                $scope.items.splice(n, 1);
                            }
                        }
                });

        });
    }
    
    $scope.redeliverAll = function() {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_ALL_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_ALL_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_REDELIVER_ALL_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["put"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "?operation=redeliver", {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.refresh();
                });

        });
    }
    
    $scope.retry = function(message) {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["put"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "/" + message.id + "?operation=retry", {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {

                        for (var n = $scope.items.length - 1; n >= 0; n--) {
                            if ($scope.items[n].id === message.id) {
                                $scope.items.splice(n, 1);
                            }
                        }
                });

        });
    }
    
    $scope.retryAll = function() {
        
        var promise = dialogService.prompt("MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_ALL_TITLE",
                            "MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_ALL_TEXT",
                            {
                                okButtonText: "MANAGEMENT_SUBSCRIPTION_MESSAGE_RETRY_ALL_OK",
                                disablePromptText: true
                            });
                            
        promise.then(function(data) {
            $http["put"](stwoGlobal.smarttrackerSubscriptionUrl + "message/" + $stateParams.subscriptionId + "?operation=retry", {
                    headers : {
                        "X-Auth-Token" : smarttrackerService.getAuthToken()
                    }
                    }).then(function(response) {
                        $scope.refresh();
                });

        });
    }
});
angular.module('stwo.management-asset', ["stwo.management", "angularTrix", "dndLists"]).config(function($stateProvider, moduleStoreProvider) {

	moduleStoreProvider.registerModule({
            name : "asset-management",
            links : [{
                    name : "XGUARD_MANAGEMENT_ASSETS",
                    category : "MANAGEMENT",
                    sref : "secure.content.management-asset",
                    access : ["asset", "put"],
                    sort : 10,
                    icon : "account-settings-variant",
                    color: "info",
                    controllers: ['AssetManagementListController', 'AssetManagementDetailController']
            }]
	});

   moduleStoreProvider.addPossibleFilter("asset", {
    id: "externalId",
    label: "MANAGEMENT_ASSET_EXTERNAL_ID_FILTER",
    type: "string",
    field: "externalId",
    comparator: "contains"
});

   moduleStoreProvider.addPossibleFilter("asset", {
    id: "id",
    label: "MANAGEMENT_ASSET_ID_FILTER",
    type: "string",
    field: "id",
    comparator: "equals"
});

   moduleStoreProvider.addPossibleFilter("device", {
    id: "assets",
    label: "MANAGEMENT_ASSET_DEVICE_UNBOUND_FILTER",
    type: "string",
    field: "assets",
    comparator: "empty=true"
});

	$stateProvider.state("secure.content.management-asset", {
		url : "/asset-management/:ids",
		templateUrl : "modules/management-asset/asset-management.html",
		controller : "AssetManagementListController",
        titleName: 'XGUARD_MANAGEMENT_ASSET_TITLE',
        titleIcon: "account-settings-variant"
	}).state("secure.content.management-asset.detail", {
		url : "/asset-management-detail/:id",
		templateUrl : "modules/management-asset/detail.html",
		controller : "AssetManagementDetailController",
        titleName: 'MANAGEMENT_ASSET_DETAIL',
        titleIcon: "account-settings-variant"
	});
});

angular.module('stwo.management-asset').controller('AssetManagementListController', function($scope, $translate, $timeout, $stateParams, $state, $modal, $controller, smarttrackerService, dialogService, contentCacheService, utilService) {
    $controller('BaseListContentController', {$scope: $scope});

    $scope.assetUpdateInProgress = {};
    $scope.assetExpanded = {};
    $scope.assetEditState = {};
    $scope.propertiesEditable = {};
    $scope.temporaryPropertyValues = {};

    $scope.trackingEditable = {};
    $scope.temporaryTrackingValues = {};

    $scope.sentCommandsPerAsset = {};

    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.alarmCenter = smarttrackerService.isAlarmCenter();
        $translate(['MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_ALERT',
            'MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_WARNING',
            'MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_NOTIFICATION', 'MANAGEMENT_ASSET_USER_IS_NOT_CONNECTED', 'MANAGEMENT_ASSET_USER_IS_CONNECTED'])
            .then(function (data) {
                $scope.translations = {
                    green:data['MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_NOTIFICATION'],
                    orange:data['MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_WARNING'],
                    red:data['MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_ALERT'],
                    userConnected:data['MANAGEMENT_ASSET_USER_IS_CONNECTED'],
                    userNotConnected:data['MANAGEMENT_ASSET_USER_IS_NOT_CONNECTED']
                };
        });
    });

    $scope.assetClicked = function (asset) {
        if(!asset)return;
        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }
        asset.connectedUser = {'name':$scope.translations.userNotConnected};
        if(asset.connectedTo){
            for(var i = 0; i < asset.connectedTo.length;i++) {
                if(asset.connectedTo[i].to.type == "user") {
                    asset.connectedUser = asset.connectedTo[i].to;
                    asset.connectedUser.name = $scope.translations.userConnected;
                    break;
                }
            }
        }
        if($scope.access['customerUser']['get']&&asset.connectedTo&&asset.connectedTo.length>0) {
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/customerUser/?select=user&user:equals=" + asset.connectedUser.id).then(function (response){
                if(response.data.result && response.data.result.length>0) {
                    asset.connectedUser.name = response.data.result[0].user.name;
                    console.log(asset.connectedUser);
                }
            });
        }
        $scope.currentAsset = asset;
        $scope.setAssetEditState(asset, 'general');
        $scope.scrollToElement(asset);
        $scope.currentAssetID = asset.id;
        $scope.currentAsset.editableDescription = $scope.currentAsset.description;
        $scope.updateTemporaryStateValues(asset);
    };

    $scope.updateTemporaryStateValues = function(asset) {
        if (asset.trackMode === "always") {
            $scope.temporaryTrackingValues[asset.id] = "always";
        } else if (asset.trackMode === "never") {
            $scope.temporaryTrackingValues[asset.id] = "never";
        } else if (asset.trackMode === "manual") {
            if (asset.tracked) {
                $scope.temporaryTrackingValues[asset.id] = "manual_yes";
            } else {
                $scope.temporaryTrackingValues[asset.id] = "manual_no";
            }
        }

        $scope.temporaryPropertyValues[asset.id] = {};
        if (asset.properties) {
            for (var n = 0; n < asset.properties.length; n++) {
                $scope.temporaryPropertyValues[asset.id][asset.properties[n].typePropertyIdentifier] = asset.properties[n].value;
            }
        }
    }

    $scope.downloadSentCommandsForAsset = function(asset) {
        $scope.sentCommandsPerAsset[asset.id] = null;
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/deviceCommand?select=command+commandFormatted+sent+status+statusCode&asset:equals=' + asset.id)
            .then(function(response) {
                $scope.sentCommandsPerAsset[asset.id] = response.data.result;
        });
    };

    $scope.setAssetEditState = function(asset, state) {

        $scope.assetEditState[asset.id] = state;

        if ($scope.assetEditState[asset.id]) {
            $scope.assetExpanded[asset.id] = true;
        }
        if ($scope.assetEditState[asset.id] && $scope.assetEditState[asset.id] === "commands" && !$scope.sentCommandsPerAsset[asset.id]) {
            $scope.downloadSentCommandsForAsset(asset);
        }

        $scope.updateTemporaryStateValues(asset);
    };

    $scope.super({
        clazz: 'asset',
        pagination: {max: 50},
        downloadUrl: '/asset?select=name+description+tags+type+groups+trackMode+tracked+properties+image+icon+devices+externalId+labels+positionIsFixed+lastValidPosition+connectedTo&sort=name&order=asc'
    });

    $scope.sendCommand = function(asset) {
        var modalInstance = $modal.open({
            templateUrl: 'core/html/send_command_modal.html',
            controller: stwoCommonSendCommandModalController,
            size: "lg",
            resolve: {
                sendCommandConfiguration: function() { return {asset: asset} }
            }
        });

        modalInstance.result.then(function (newFilterData) {
            $scope.downloadSentCommandsForAsset(asset);
        }, function() {

        });
    };

    $scope.trackingValueChanged = function(asset) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }
        $scope.assetUpdateInProgress[asset.id] = true;


        var newAssetObj = {id: asset.id};
        if ($scope.temporaryTrackingValues[asset.id] === "always") {
            newAssetObj["trackMode"] = $scope.temporaryTrackingValues[asset.id];
        } else if ($scope.temporaryTrackingValues[asset.id] === "never") {
            newAssetObj["trackMode"] = $scope.temporaryTrackingValues[asset.id];
        } else if ($scope.temporaryTrackingValues[asset.id] === "manual_yes") {
            newAssetObj["trackMode"] = "manual";
            newAssetObj["tracked"] = true;
        } else if ($scope.temporaryTrackingValues[asset.id] === "manual_no") {
            newAssetObj["trackMode"] = "manual";
            newAssetObj["tracked"] = false;
        }

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                        [newAssetObj])
            .then(function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
                for (var n = 0; n < $scope.items.length; n++) {
                    if ($scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].trackMode = response.data.result[0].trackMode;
                        $scope.items[n].tracked = response.data.result[0].tracked;
                        $scope.updateTemporaryStateValues($scope.items[n]);
                    }
                }
            }, function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
                $scope.updateTemporaryStateValues($scope.items[n]);
            });
    };

    $scope.changeExternalIdOfAsset = function(asset) {
        if(asset.externalId == asset.orignalExternalId)
            return;
        var externalId = asset.externalId;
        $scope.assetExtIdWorking = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id, [{'externalId':externalId}]).then(function (response){
            $scope.assetExtIdWorking = false;
            prepareCustomProperties(asset);
        });
    }

    $scope.changeNameOfAsset = function(asset) {
        if(asset.name == asset.originalName) {
            return; // no need to bother SmartTracker
        }
        var newAssetName = asset.name;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id, [{id: asset.id, name: newAssetName}])
        .then(function (response) {
            prepareCustomProperties(asset);
        })
    };

    $scope.changeDescriptionOfAsset = function(asset) {
        if(asset.description === asset.editableDescription) {
            return; // no need to bother SmartTracker
        }
        var newAssetDesc = asset.editableDescription;
        $scope.assetDescWorking = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id, [{id: asset.id, description: newAssetDesc }])
        .then(function (response) {
            asset.description = asset.editableDescription;
            $scope.assetDescWorking = false;
            prepareCustomProperties(asset);
        });
    };

    $scope.cancelEditDescription = function() {
        $scope.currentAsset.editableDescription = $scope.currentAsset.description;
    }


    $scope.addAsset = function() {
        var promise = dialogService.prompt("MANAGEMENT_ASSET_ADD_TITLE", "MANAGEMENT_ASSET_ADD_TEXT", {
                okButtonText: "MANAGEMENT_ASSET_ADD_OK"
                //promptText: nameProposal ? nameProposal : ""
            });

        promise.then(function (data) {
            var newAssetName = data.promptText;
            if (newAssetName && newAssetName !== "") {

                smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset?name:equals=' + newAssetName)
                    .then(function (response) {
                        if (response.data.total > 0) {
                            var promise = dialogService.prompt("MANAGEMENT_ASSET_ADD_FAILURE_TITLE",
                                                "MANAGEMENT_ASSET_ADD_FAILURE_NAME_TAKEN",
                                                {
                                                    okButtonText: "MANAGEMENT_ASSET_ADD_TRY_AGAIN",
                                                    disablePromptText: true
                                                });

                            promise.then(function(data) {
                                $scope.addAsset(newAssetName);
                            });
                        } else {
                            var template = stwoGlobal.templates["asset"] ? JSON.parse(JSON.stringify(stwoGlobal.templates["asset"])) : {};
                            template["name"] = newAssetName;
                            template["tracked"] = true;
                            template["trackMode"] = "always";
                            smarttrackerService.authPost(smarttrackerService.getCustomerId() + '/asset', [template]).then(function(response) {
                                $scope.filterUrlString = "&id:equals=" + response.data.result[0].id;
                                $scope.filterMessage = "NEW_ASSET";
                                $scope.filterMessage2 = "";

                                $scope.changeTypeOfAsset(response.data.result[0], true);
                            })
                        }
                    });

            }
        });
    };

    $scope.duplicateAsset = function() {
        var promise = dialogService.prompt(
                "MANAGEMENT_ASSET_DUPLICATE_ASSET_TITLE","MANAGEMENT_ASSET_DUPLICATE_ASSET_CONTENT",
                {
                    okButtonText: "MANAGEMENT_ASSET_DUPLICATE_ASSET_OK_BUTTON",
                    placeHolder: "MANAGEMENT_ASSET_DUPLICATE_ASSET_NAME_PLACEHOLDER",
                    emptyRestricted:true
                })
                .then(function (data) {

                        var a = $scope.currentAsset;
                        var text = data.promptText;
                        if(!text||text=="")return;
                        var body = {
                            name:text, 
                            description:a.description,
                            labels:a.labels,
                            groups:a.groups, 
                            type:a.type, 
                            properties:a.properties, 
                            externalId: a.externalId,
                            tracked: a.tracked,
                            trackMode: a.trackMode,
                        };
                        smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/asset/", body).then( function (response){
                            $scope.filterUrlString = "&id:equals=" + response.data.result[0].id;
                            $scope.filterMessage = "NEW_ASSET";
                            $scope.filterMessage2 = "";
                        })
                    },
                    function (data) {
                        //Cancelled
                    });
    }

    $scope.deleteConfirmation = function(asset) {
        var promise = dialogService.prompt("MANAGEMENT_ASSET_DELETE_TITLE", "MANAGEMENT_ASSET_DELETE_WARNING",
            {
                warningButtonText: "MANAGEMENT_ASSET_DELETE_OK",
                promptText: "",
                disablePromptText: true,
                deleteButton: true
            });
        promise.then(function(data) {
            $scope.deleteAsset(asset)
        });
    };

    $scope.deleteAsset = function(asset) {
        smarttrackerService.authDelete(smarttrackerService.getCustomerId() + '/asset/' + asset.id)
            .then(function(response) {
                for (var n = $scope.items.length - 1; n >= 0; n--) {
                    if ($scope.items[n].id === asset.id) {
                        $scope.items.splice(n, 1)
                    }
                }
            }, function(response) {
                alert("Error occurred while attempting to delete asset. Technical information:\n\n" + JSON.stringify(response));
            });
    };

    $scope.saveEditedProperties = function(asset) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }
        if (!asset.properties || asset.properties.length === 0) {
            return;
        }


        $scope.propertiesEditable[asset.id] = false;

        var newPropertyList = [];

        for (var n = 0; n < asset.properties.length; n++) {
            if (asset.properties[n].type !== "device" && $scope.temporaryPropertyValues[asset.id][asset.properties[n].typePropertyIdentifier]) {
                newPropertyList.push({typePropertyIdentifier: asset.properties[n].typePropertyIdentifier, value: $scope.temporaryPropertyValues[asset.id][asset.properties[n].typePropertyIdentifier]})
            }
        }


        $scope.assetUpdateInProgress[asset.id] = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                        [{id: asset.id, properties: newPropertyList}])
            .then(function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
                for (var n = 0; n < $scope.items.length; n++) {
                    if ($scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].properties = response.data.result[0].properties;
                    }
                }
            }, function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
            });
    }

    $scope.textInput = {nameSearchValue: "", externalIdSearchValue: "", assetIdSearchValue: ""};
    $scope.applyNameSearch = function($event) {
        if(!$scope.textInput.nameSearchValue||$scope.textInput.nameSearchValue=='')
            return;
        var keyCode = $event.which || $event.keyCode;
        if(keyCode === 13){
            $scope.filterValues = {"name":$scope.textInput.nameSearchValue};
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue + ($scope.alarmCenter?"&crossAccount=true":"");
            $scope.textInput = {nameSearchValue: "", externalIdSearchValue: "", assetIdSearchValue: ""};
        }
    }

    $scope.applyExternalIdSearch = function($event) {
        if(!$scope.textInput.externalIdSearchValue||$scope.textInput.externalIdSearchValue=='')
            return;
        var keyCode = $event.which || $event.keyCode;
        if(keyCode === 13){
            $scope.filterValues = {"externalId":$scope.textInput.externalIdSearchValue};
            $scope.filterUrlString = "&externalId:equals=" + $scope.textInput.externalIdSearchValue + ($scope.alarmCenter?"&crossAccount=true":"");
            $scope.textInput = {nameSearchValue: "", externalIdSearchValue: "", assetIdSearchValue: ""};
        }
    }

    $scope.applyIdSearch = function($event) {
        if(!$scope.textInput.assetIdSearchValue||$scope.textInput.assetIdSearchValue=='')
            return;
        var keyCode = $event.which || $event.keyCode;
        if(keyCode === 13){
            $scope.filterValues = {"id":$scope.textInput.assetIdSearchValue};
            $scope.filterUrlString = "&id:equals=" + $scope.textInput.assetIdSearchValue + ($scope.alarmCenter?"&crossAccount=true":"");
            $scope.textInput = {nameSearchValue: "", externalIdSearchValue: "", assetIdSearchValue: ""};
        }
    }

    $scope.changeTypeOfAsset = function(asset, value) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-type.html',
            controller: stwoCommonPickerModalController,
            size: "md",
            resolve: {
                pickerConfiguration: function() { return {
                    title: "MANAGEMENT_ASSET_TYPE_TITLE",
                    clazz: "type",
                    data: asset, fieldsToShow: ["name"],
                    nullAllowed: false,
                    cancelDisallowed: value,
                    nullButtonText: "MANAGEMENT_ASSET_REMOVE_TYPE",
                    downloadUrl: '/type?select=name&sort=name&order=asc'} }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            var asset = pickerResult.data;
            if (pickerResult.selectedItems.length > 0) {
                $scope.assetUpdateInProgress[asset.id] = true;

                var a = {id: asset.id};
                if (pickerResult.selectedItems[0]) {
                    a["type"] = {id: pickerResult.selectedItems[0].id};
                } else {
                    a["type"] = null;
                }
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                                [a])
                    .then(function(response) {
                        $scope.assetUpdateInProgress[asset.id] = false;
                        for (var n = 0; n < $scope.items.length; n++) {
                            if ($scope.items[n].id === response.data.result[0].id) {
                                $scope.items[n] = response.data.result[0];
                                //$scope.items[n].properties = response.data.result[0].properties;
                                $scope.propertiesEditable[response.data.result[0].id] = false;
                                prepareCustomProperties($scope.items[n]);
                                $scope.assetClicked($scope.items[n]);

                                break;
                            }
                        }
                    }, function(response) {
                        $scope.assetUpdateInProgress[asset.id] = false;
                    });
            }
        }, function() {

        });
    }

    $scope.changeImageOfAsset = function(asset) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }


        var promise = dialogService.prompt("MANAGEMENT_ASSET_CHANGE_IMAGE_TITLE",
                            "MANAGEMENT_ASSET_CHANGE_IMAGE_TEXT",
                            {
                                nullAllowed: true && asset.image,
                                nullButtonText: "MANAGEMENT_ASSET_CHANGE_IMAGE_NULL",
                                okButtonText: "MANAGEMENT_ASSET_CHANGE_IMAGE_OK",
                                promptText: asset.image ? asset.image : ""
                            });

        promise.then(function(data) {
            $scope.assetUpdateInProgress[asset.id] = true;

            var a = {id: asset.id, image: data.promptText};

            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                            [a])
                .then(function(response) {
                    $scope.assetUpdateInProgress[asset.id] = false;
                    for (var n = 0; n < $scope.items.length; n++) {
                        if ($scope.items[n].id === response.data.result[0].id) {
                            $scope.items[n].image = response.data.result[0].image;
                        }
                    }
                }, function(response) {
                    $scope.assetUpdateInProgress[asset.id] = false;
                });
        });
    }

    $scope.addTagToAsset = function(asset) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }


        var promise = dialogService.prompt("MANAGEMENT_ASSET_TAG_ADD_TITLE",
                            "MANAGEMENT_ASSET_TAG_ADD_TEXT",
                            {
                                okButtonText: "MANAGEMENT_ASSET_TAG_ADD_OK",
                                promptText: ""
                            });

        promise.then(function(data) {
            if (data.promptText && data.promptText != "") {
                var newTag = data.promptText;
                var newTagList = [];
                var newTagListMap = {};

                for (var n = 0; n < asset.tags.length; n++) {
                    newTagList.push({name: asset.tags[n].name});
                    newTagListMap[asset.tags[n].name] = true;
                }


                if (!newTagListMap[newTag]) {
                    newTagList.push({name: newTag});


                    $scope.assetUpdateInProgress[asset.id] = true;
                    smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                                    [{id: asset.id, tags: newTagList}])
                        .then(function(response) {
                            $scope.assetUpdateInProgress[asset.id] = false;
                            for (var n = 0; n < $scope.items.length; n++) {
                                if ($scope.items[n].id === response.data.result[0].id) {
                                    $scope.items[n].tags = response.data.result[0].tags;
                                }
                            }
                        }, function(response) {
                            $scope.assetUpdateInProgress[asset.id] = false;
                        });
                }
            }
        });
    }

    $scope.removeTagFromAsset = function(asset, tag) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }
        $scope.assetUpdateInProgress[asset.id] = true;

        var newTagList = [];
        for (var n = 0; n < asset.tags.length; n++) {
            if (asset.tags[n].name !== tag.name) {
                newTagList.push({name: asset.tags[n].name});
            }
        }

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                        [{id: asset.id, tags: newTagList}])
            .then(function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
                for (var n = 0; n < $scope.items.length; n++) {
                    if ($scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].tags = response.data.result[0].tags;
                    }
                }
            }, function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
            });
    }

    $scope.removeDeviceFromAsset = function(asset, device) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }
        $scope.assetUpdateInProgress[asset.id] = true;

        var newDeviceList = [];
        for (var n = 0; n < asset.devices.length; n++) {
            if (asset.devices[n].device.id !== device.device.id) {
                newDeviceList.push({device: {id: asset.devices[n].device.id}});
            }
        }

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id,
                        [{id: asset.id, devices: newDeviceList}])
            .then(function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
                for (var n = 0; n < $scope.items.length; n++) {
                    if ($scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].devices = response.data.result[0].devices;
                    }
                }
            }, function(response) {
                $scope.assetUpdateInProgress[asset.id] = false;
            });
    }

    $scope.addGroupsToAsset = function() {
        var asset = $scope.currentAsset;
        if($scope.assetUpdateInProgress[asset.id]){
            return;
        }

        var disabledIDs = [];
        angular.forEach(asset.groups, function (group) {
            disabledIDs.push(group.id);
        });

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-group.html',
            controller: stwoCommonPickerModalController,
            size: "md",
            resolve: {
                pickerConfiguration: function () {
                    return {
                        title: "MANAGEMENT_ASSET_GROUP_CHOOSE_TITLE",
                        clazz: "group",
                        fieldsToShow: ["name", "assets"],
                        multiple: true,
                        disabledIDs: disabledIDs,
                        downloadUrl: '/group?select=name%2Bassets&sort=name&order=asc'
                    }
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            console.log("DATA FROM GROUP PICKER" , pickerResult);

            var groups = utilService.clone(asset.groups);
            if(pickerResult.selectedItems.length < 0) return;
            angular.forEach(pickerResult.selectedItems, function (group){
                groups.push(group);
            });


                smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id, {'groups':groups}).then(function (response){
                    asset.groups = response.data.result[0].groups;
                }, function(){
                    alert("Something went wrong when adding the Person to the groups. Please contact your system administrator.");
                });

        });
    }

    $scope.removeGroupFromAsset = function(group){
        var asset = $scope.currentAsset;
        var index = asset.groups.indexOf(group);
        if(index > -1){
            var groups = utilService.clone(asset.groups);
            groups.splice(index,1);
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + asset.id, {'groups':groups}).then(function (response){
                asset.groups = response.data.result[0].groups;
            }, function(){
                alert("Something went wrong when removing the asset, please contact your system administrator.");
            });
        }

    }

    $scope.pickFixedPosition = function() {
        var position = $scope.currentAsset.lastValidPosition;
        var asset = $scope.currentAsset;
            $translate(['MANAGEMENT_ASSET_FIXED_POSITION_DIALOG_TITLE', 'MANAGEMENT_ASSET_FIXED_POSITION_DIALOG_CONTENT']).then(function (data){
                var position = asset.lastValidPosition;
                var modalInstance = dialogService.getPosition(data['MANAGEMENT_ASSET_FIXED_POSITION_DIALOG_TITLE'], data['MANAGEMENT_ASSET_FIXED_POSITION_DIALOG_CONTENT'], {position:position});
                modalInstance.result.then(function (positionResult) {
                    asset.chosenPosition = positionResult.data;
                });
            });
    }

    $scope.toggleFixedPosition = function() {
        var asset = $scope.currentAsset;
        if(!asset.lastValidPosition&&!asset.chosenPosition)return;

        console.log(smarttrackerService.getUserData());
        asset.fixedPositionWorking = true;
        if(asset.positionIsFixed) {
            doFixedPositionUpdate({'lastValidPosition':null}, asset);
        } else {
            var body = {
                lastValidPosition: {
                    latitude:asset.chosenPosition?asset.chosenPosition.position.lat:asset.lastValidPosition.latitude, 
                    longitude:asset.chosenPosition?asset.chosenPosition.position.lng:asset.lastValidPosition.longitude, 
                    valid: true,
                    textual:asset.chosenPosition?asset.chosenPosition.address:asset.lastValidPosition.address
                }
            }
            doFixedPositionUpdate(body, asset);
        }
    }

    var doFixedPositionUpdate = function(body, asset) {
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + asset.id, body).then(function (response){
                    console.log(response);
                    asset.fixedPositionWorking = false;
                    console.log("Settting position is fixed", asset.positionIsFixed);
                    asset.positionIsFixed = response.data.result[0].positionIsFixed;
                    asset.lastValidPosition = response.data.result[0].lastValidPosition;
                    console.log(asset.positionIsFixed, response.data.result[0].positionIsFixed);
        });
    }

    $scope.addDeviceToAsset = function(asset) {
        if ($scope.assetUpdateInProgress[asset.id]) {
            return;
        }

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-device.html',
            controller: stwoCommonPickerModalController,
            size: "lg",
            resolve: {
                pickerConfiguration: function() { return {
                        title: "MANAGEMENT_ASSET_DEVICE_CHOOSE_TITLE",
                        clazz: "device", data: asset,
                        fieldsToShow: ["name", "sensorDeviceType", "uuid", "assets"],
                        downloadUrl: '/device?select=name%2BsensorDeviceType%2Buuid%2Bassets&sort=name&order=asc',
                        filters: {activeAssets:{id:'assets', value:'assets:empty=true'}}
                    }
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            console.log("DATA FROM PICKER", pickerResult);

            var asset = pickerResult.data;

            $scope.assetUpdateInProgress[asset.id] = true;

            var device = pickerResult.selectedItems[0]; // Only one object
            var assets = device.assets.split(",");
            var colisionFound = false;
            angular.forEach(assets, function (assetName) {
                if(assetName == asset.name) return; // Already connected
                else if(assetName != "") {
                    // Do the prompt
                    colisionFound = true;
                }
            });
            if(colisionFound) {
                $translate(['MANAGEMENT_ASSET_ADD_DEVICE_COLISION_WARNING', 'MANAGEMENT_ASSET_COLISION_DIALOG_PROCEED', 'MANAGEMENT_ASSET_COLISION_DIALOG_TITLE'], {'assets':device.assets}).then(function (data){

                    var promise = dialogService.prompt(data.MANAGEMENT_ASSET_COLISION_DIALOG_TITLE, 
                    data.MANAGEMENT_ASSET_ADD_DEVICE_COLISION_WARNING,
                    {
                        promptText: "",
                        disablePromptText: true,
                        okButtonText: data.MANAGEMENT_ASSET_COLISION_DIALOG_PROCEED
                    });
                    promise.then(function(data) {
                        updateAssetsDevice(device, asset);
                    }, function () {
                        $scope.assetUpdateInProgress[asset.id] = false;
                    });

                });
            } else {
                updateAssetsDevice(device, asset);
            }
        }, function() {
            $scope.assetUpdateInProgress[asset.id] = false;
        });
    };

    var updateAssetsDevice = function(device, asset) { // in its own method for synchronization purposes. 
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/device/" + device.id, {'assets':[{'id':asset.id}]}).then(function (response){
                var otherAssets = device.assets.split(",");
                var oaIDs = otherAssets[0];
                for(var i = 1; i < otherAssets.length;i++) {
                    oaIDs += "%2B" + otherAssets[i];
                }
                oaIDs += (otherAssets.length>0&&device.assets!=""?"%2B":"") + asset.name;
                smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/?select=devices&name:equals=' + oaIDs).then(function (assetResponse) {
                    angular.forEach(assetResponse.data.result, function (currAsset) {
                        for(var i = 0; i < $scope.items.length;i++) {
                            if($scope.items[i].id === currAsset.id) {
                                $scope.items[i].devices = currAsset.devices;
                                break;
                            }
                        }
                    });
                    $scope.assetUpdateInProgress[asset.id] = false;
                })
            }, function (error){
                console.error("Something went wrong when adding device to asset", error);
                alert("Something went wrong when adding device to asset");
            });
    }





    //ALL THE CODE BELOW CUSTOM MADE BY X-GUARD




    $scope.currentAssetID = false;

    if($stateParams.ids){
        $scope.filterUrlString = "&id:equals=" + $stateParams.ids;
        $scope.filterMessage = "SELECTED_ITEMS";
        $scope.filterMessage2 = "";

        $scope.currentAssetID = $stateParams.ids;
        $scope.setAssetEditState({id: $stateParams.ids}, "general");
    }

    $scope.scrollToElement = function (item) {
        var anchorscroll = angular.element(document.getElementById(item.id));
        var container = angular.element(document.getElementById('scroll-container'));

        setTimeout(function () {
            container.scrollTo(anchorscroll, 15, 500);
        }, 10);

    };

    $scope.scrollContainer = document.getElementById('scroll-container');

    $scope.localFavorites = (localStorage["Favorites"] === "true");

    if ($scope.localFavorites){
        $scope.showFavorites();
    }

    $scope.toggleFavorites = function (value) {
        if($stateParams.ids) {
            $state.go("secure.content.management-asset", {'ids':''});
        } else if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    $scope.localCollapseAsset = (localStorage["CollapseAsset"] === "true");
    $scope.toggleCollapseAsset = function () {
        $scope.localCollapseAsset = !$scope.localCollapseAsset;
        localStorage["CollapseAsset"] = $scope.localCollapseAsset;
    };

    $scope.Screensize = function () {
        if ($(window).width() > 991) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
    };


    var codes = ["email", "phone", "sms", "allowContact", "allowContactNQR", "allowEmergencyContact", "allowNQR", "userLogin", "duration", "subscription", "sim", "notifications", "servicedesk"];

    var prepareCustomProperties = function(asset) {
        asset.originalName = asset.name;
        asset.editableDescription = asset.description;
        asset.originalExternalId = asset.externalId;
        for(var j in asset.properties) {
            var prop = asset.properties[j];
            if(codes.indexOf(prop.code) > -1) {
                prop.originalValue = prop.value;
                asset[prop.code] = prop;
            }
        }
        console.log(asset.name + ": ", asset);
    }

    $scope.$watch("itemsChanged", function(){
        for (var i in $scope.items) {

            var asset = $scope.items[i];
            prepareCustomProperties(asset);
            if($stateParams.ids&&$stateParams.ids == $scope.items[i].id) {
                $scope.assetClicked($scope.items[i]);   
            }
        }
        if($scope.filterUrlString.indexOf("id:equals=")>0&&$scope.items.length==1){
            $scope.assetClicked($scope.items[0]);
        }
        // if($scope.items && $scope.items.length>0&&$scope.items[0]) {
        //     $scope.assetClicked($scope.items[0]);
        // }
    });

    $scope.workhoursData = {
        days: {'All days':['MON','TUE','WED', 'THU', 'FRI', 'SAT', 'SUN'], 'Monday to Friday':['MON', 'TUE', 'WED', 'THU', 'FRI'], 'Monday':['MON'], 'Tuesday':['TUE'], 'Wednesday':['WED'],
            'Thursday':['THU'], 'Friday':['FRI'], 'Saturday':['SAT'], 'Sunday':['SUN']},
        fromHours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        fromMinutes: ['00', '15', '30', '45'],
        toHours: ['00','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
        toMinutes: ['00', '15', '30', '45'],
        errors: {'inconsistent':'End-time has to be after start-time', 'noday':'Please select a day'}
    };

    $scope.downloadAll = function() {
        var total = $scope.pagination.total;
        /*$scope.clearItems();*/

        $scope.super({
            pagination: {max: total },
            clazz: 'asset',
            downloadUrl: '/asset?select=name+tags+type+groups+trackMode+tracked+properties+image+icon+devices+positionIsFixed&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    };

    $scope.changeDropDownProp = function(asset, property, prop) {
        if(property.value == prop) return;
        property.value = prop;

        property.working = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + asset.id, {"properties":[property]})
            .then(function (response) {
                property.working = false;
            })
    };

    $scope.saveStringProp = function (asset, prop) {

        /*if(prop.value == prop.originalValue) {
            return; // Value has not been changed. No neede to bother SmartTracker
        }*/
        prop.working = true;

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + asset.id, {"properties":[prop]})
            .then(function (response) {
                prop.working = false;
                prepareCustomProperties(asset);
                // set the property on the asset
            })
    };

    $scope.raiseAlarm = function(asset) {
        dialogService.raiseAlarm("Alarm maken",
                "RAISE_ALARM_DIALOG_CONTENT",
                {
                    okButtonText: "XGUARD_SEND_MAIL_DIALOG_BUTTONS_OK",
                    multiline: true,
                    placeHolder: "MANAGEMENT_ASSET_DEFAULT_ALARM_NAME_ALERT"
                }).then(function (data) {


                    console.log(data);
                     var dialog = dialogService.wait("RAISE_ALARM_SPLASH_TITLE",
                    "RAISE_ALARM_SPLASH_CONTENT",
                    {});
                    
                    var alarmText = data.promptText;

                    if(!alarmText||alarmText=="") {
                        switch(parseInt(data.alarmType)) {
                            case 0:     alarmText = $scope.translations.red;break;
                            case -5:    alarmText = $scope.translations.orange;break;
                            case -20:   alarmText = $scope.translations.green;break;
                        }
                     }

                    var procedure;
                    switch(parseInt(data.alarmType)) {
                        case 0:     procedure = '<strong>1. NIET SPREKEN!</strong><br />2. Wanneer jij wordt aangesproken wel terug spreken.<br />3. Bij geverifieerd alarm, klik op "Help"<br />4. Bij twijfel, klik op "Verificatie"<br />5. Volg belvolgorde hieronder.';break;
                        case -5:    procedure = '<strong>1. DIRECT MELDEN!</strong> “Meldkamer, waarmee kan ik u van dienst zijn?”<br />2. Indien melding escaleert, klik op "Help"<br />3. Anders of bij twijfel, klik op "Verificatie"<br />4. Volg belvolgorde hieronder.';break;
                        case -20:   procedure = '1. De gebruiker heeft een systeem testmelding verstuurd waarvoor geen verdere actie nodig is.<br />2. Gebruiker dient commentaarveld in webportaal in te (laten) vullen.';break;
                    }

                    var alarmBody = {"name":alarmText, "procedure": procedure, "logLevel":parseInt(data.alarmType), "ackNeeded":true, "asset":{"id":asset.id}};
                    smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/alarm/", alarmBody).then(
                        function (response) {
                            dialog.close();
                        },
                        function() {
                            dialog.close();
                            alert("Failed to create alarm");
                        });
                    console.log("Alarm body");
                    console.log(alarmBody);
                    console.log($scope.translations);
                },
                function(){}
            );
    };

    var copyProperty = function(property) {
        var copy = property.constructor();
        for (var attr in property) {
            if (property.hasOwnProperty(attr)) copy[attr] = property[attr];
        }
        return copy;
    };

    $scope.toggleProperty = function(asset, prop, action){
        console.log(prop.value + " != " + action);
        if(prop.value == action){
            prop.working = false;
            return; // No need to bother smarttracker
        }
        prop.working = true;
        var property = copyProperty(prop);
        if(property.value == action)return;
        property.value = action;
        var json = {"properties":[property]};

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + asset.id, json)
            .then(function (response) {
                prop.working = false;
                asset.properties = response.data.result[0].properties;
                prepareCustomProperties(asset);
            });
    }

    var phoneFieldChanged = function(field) {
        var properties = $scope.currentAsset.properties;
        var prop = false;
        for(var i in properties) {
            if(properties[i].code == field){
                prop = properties[i];
                prop.value = $scope.currentAsset[field].value;
            }
        }
        if(prop && prop.originalValue!=prop.value)
            $scope.saveStringProp($scope.currentAsset, prop);
        else if(!prop) {
            console.error("Unable to find property with code '" + field + "' to update phone number");
        }
    }

    $scope.smsNbrChanged = function() {
        phoneFieldChanged("sms");
    }

    $scope.phoneNbrChanged = function() {
        phoneFieldChanged("phone");
    }

    $scope.toggleFilters = function () {
        if ($scope.showFilters) {
            TweenLite.to("#sidebarFilters", 0.5, {height: "0px", ease: "Quart.easeInOut"});
            $scope.showFilters = false;
        } else {
            TweenLite.set("#sidebarFilters", {height: "auto"});
            TweenLite.from("#sidebarFilters", 0.5, {height: "0px", ease: "Quart.easeInOut"});
            $scope.showFilters = true;
        }
    };

    $scope.linkUser = function() {
        if(!$scope.access['asset']['put'])return;
        var modalInstance = $modal.open({
            templateUrl: 'core/html/picker.html',
            controller: stwoCommonPickerModalController,
            size: "md",
            resolve: {
                pickerConfiguration: function() { return {
                    title: "MANAGEMENT_ASSET_TYPE_TITLE",
                    clazz: "type",
                    fieldsToShow: ["user.name", "user.username"],
                    nullAllowed: false,
                    downloadUrl: '/customerUser?select=user'} }
            }
        });

        modalInstance.result.then(function (data) {

            var selectedUser = data.selectedItems[0];
            var a = $scope.currentAsset;
            console.log(a);
            var c = a.connectedTo;
            if(c&&c.length>0) {
                angular.forEach(c, function (conn){
                    if(conn.to.type == "user" && a.connectedUser.id == conn.to.id) {
                        conn.to.id = selectedUser.user.id;
                    }
                });
            } else {
                c = [{from:{id:a.id, type:'asset'}, to:{id:selectedUser.user.id, type:'user'}}];
            }
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + a.id, {'connectedTo':c}).then(function (response) {
                a.connectedTo = c;
                if($scope.currentAsset == a) {
                    $timeout(function() {$scope.assetClicked(a);}, 100);
                }
            });
            console.log(data);
        }, function(){/** CANCEL */});
    }

    $scope.clearLinkedUser = function() {
        if(!$scope.access['asset']['put']) return;
        dialogService.alert('MANAGEMENT_ASSET_CLEAR_LINKED_USER_TITLE', 'MANAGEMENT_ASSET_CLEAR_LINKED_USER_CONTENT' , {'cancelButton':true}).then( function (success){
            var a = $scope.currentAsset;
            var i = -1;
            angular.forEach(a.connectedTo, function (conn, index) {
                if(conn.to.id == a.connectedUser.id) {
                    i = index;
                }
            });
            if(i >=0) {
                a.connectedTo.splice(i, 1);
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/asset/' + a.id, {'connectedTo':a.connectedTo}).then(function (response){
                    if($scope.currentAsset == a) {
                        $timeout(function() {$scope.assetClicked(a);}, 100);
                    }     
                });
            }
        }, function (){
            /** CANCEL */
        });
    }

});

angular.module('stwo.management-asset').controller('AssetManagementDetailController', function($state, $scope, $stateParams, smarttrackerService, contentCacheService) {

    $scope.asset = contentCacheService.get("asset", $stateParams.id);

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $stateParams.id + '?select=@').then(function(response) {
        $scope.asset = response.data.result[0];
        if ($scope.asset) {
            contentCacheService.put("asset", $scope.asset.id, $scope.asset);
        }
    });
});


angular.module('stwo.management-rule', ["stwo.management"])
    .config(function ($stateProvider, moduleStoreProvider) {

        moduleStoreProvider.registerModule({
            name: "rule-management", links: [
                {
                    name: "MANAGEMENT_RULES",
                    category: "= filter",
                    // category: "MANAGEMENT",
                    sref: "secure.content.management-rule",
                    access: ["rule", "get"],
                    icon: 'clipboard-text',
                    color: 'success',
                    sort: 23,
                    navigation: true,
                    controllers: ['RuleManagementListController', 'RuleManagementDetailController']
                }
            ]
        });

        $stateProvider
            .state("secure.content.management-rule",
                {
                    url: "/rule/:filter",
                    templateUrl: "modules/management-rule/list.html",
                    controller: "RuleManagementListController",
                    titleName: 'MANAGEMENT_RULES',
                    titleIcon: "clipboard-text"
                })
            .state("secure.content.management-rule.detail",
                {
                    url: "/rule-detail/:id",
                    templateUrl: "modules/management-rule/detail.html",
                    controller: "RuleManagementDetailController",
                    titleName: 'MANAGEMENT_RULES_DETAIL',
                    titleIcon: "clipboard-text"
                })

    });


angular.module('stwo.management-rule').controller('RuleManagementListController', function ($scope, $controller, $state, $modal, smarttrackerService) {

    $controller('BaseListContentController', {$scope: $scope});

    $scope.possibleRuleStatus = [{status: "active", color: "success", icon: "glyphicon glyphicon-ok"},
        {status: "inactive", color: "warning", icon: "glyphicon glyphicon-remove"},
        {status: "unknown", color: "danger", icon: "glyphicon glyphicon-warning-sign"},
        {status: "stopped", color: "warning", icon: "glyphicon glyphicon-remove"},
        {status: "failed", color: "danger", icon: "glyphicon glyphicon-fire"},
        {status: "requiresConfiguration", color: "warning", icon: "glyphicon glyphicon-certificate"}]
    $scope.possibleRuleStatusMap = {};
    for (var n = 0; n < $scope.possibleRuleStatus.length; n++) {
        $scope.possibleRuleStatusMap[$scope.possibleRuleStatus[n].status] = $scope.possibleRuleStatus[n];
    }

    $scope.addAvailableFilter("1", {label: "NAME", type: "string", field: "name", comparator: "contains"});

    $scope.super({clazz: 'rule', downloadUrl: '/rule?select=@&sort=name&order=asc'});

    $scope.ruleClicked = function (alarm) {
        $state.go("secure.content.management-rule.detail", {id: alarm.id});
    }
})

angular.module('stwo.management-rule').filter('orderRules', function () {
    return function (input, possibleRuleStatus) {
        if (!input) {
            return [];
        }
        if (!possibleRuleStatus) {
            return input;
        }
        var newItems = [];
        for (var i = 0; i < possibleRuleStatus.length; i++) {
            for (var j = 0; j < input.length; j++) {
                if (input[j].status == possibleRuleStatus[i].status) {
                    newItems.push(input[j]);
                }
            }
        }
        return newItems;
    };
});

angular.module('stwo.management-rule').controller('RuleManagementDetailController', function ($scope, $controller, $state, $stateParams, smarttrackerService, contentCacheService) {

    $controller('BaseDetailContentController', {$scope: $scope});

    $scope.rule = contentCacheService.get("rule", $stateParams.id);
    $scope.waitingForToggleResponse = false;
    $scope.ruleActivationErrorShown = false;

    $scope.constraints = {
        "days": []
    };


    $scope.isObjectEmpty = function (value) {
        return !(Boolean(value) && typeof value == 'object' && Object.keys(value).length > 0);
    };

    $scope.ruleToggle = function () {
        if ($scope.waitingForToggleResponse) {
            return;
        }

        var data = [{
            id: $scope.rule.id,
            status: $scope.rule.status == "active" ? "inactive" : "active"
        }];
        $scope.waitingForToggleResponse = true;

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/rule/' + $scope.rule.id, data).then(function (response) {
            $scope.waitingForToggleResponse = false;
            $scope.rule.status = response.data.result[0].status;
        }, function () {
            $scope.waitingForToggleResponse = false;
            $scope.ruleActivationErrorShown = true;
        });

    };


    smarttrackerService.isLoggedInDelayed().then(function () {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/rule/' + $stateParams.id + '?select=*').then(function (response) {
            $scope.rule = response.data.result[0];

            if ($scope.rule.constraints.week) {
                var days = ["DAYS_MONDAY", "DAYS_TUESDAY", "DAYS_WEDNESDAY", "DAYS_THURSDAY", "DAYS_FRIDAY", "DAYS_SATURDAY", "DAYS_SUNDAY"];
                var week = $scope.rule.constraints.week.split("");
                for (var i = 0; i < week.length; i++) {
                    if (week[i] == 't') {
                        $scope.constraints.days.push(days[i]);
                    }
                }
            }
        });
    });

    $scope.super({clazz: 'rule'});
});
angular.module('stwo.management-group', ["stwo.management", "angularTrix", "dndLists"]).config(function($stateProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
            name : "group-management",
            links : [{
                    name : "XGUARD_MANAGEMENT_GROUPS",
                    category : "MANAGEMENT",
                    sref : "secure.content.management-group",
                    access : ["group", "put"],
                    sort : 10,
                    icon : "account-multiple",
                    color: "info",
                    controllers: ['GroupManagementListController', 'GroupManagementDetailController']
            }]
    });

    $stateProvider.state("secure.content.management-group", {
        url : "/group-management/:ids",
        templateUrl : "modules/management-group/list.html",
        controller : "GroupManagementListController",
        titleName: 'XGUARD_MANAGEMENT_GROUP_TITLE',
        titleIcon: "account-multiple"
    }).state("secure.content.management-group.detail", {
        url : "/group-management-detail/:id",
        templateUrl : "modules/management-group/detail.html",
        controller : "GroupManagementDetailController",
        titleName: 'MANAGEMENT_ASSET_DETAIL',
        titleIcon: "account-multiple"
    });
});

angular.module('stwo.management-group').controller('GroupManagementListController', function($scope, $translate, $timeout, $stateParams, utilService, $state, $modal, $controller, smarttrackerService, dialogService, contentCacheService) {
    $controller('BaseListContentController', {$scope: $scope});

    $scope.groupUpdateInProgress = {};
        
    smarttrackerService.isLoggedInDelayed().then(function () {
        contentCacheService.download(smarttrackerService.getCustomerId() + '/contactList', {timeToLive: 5 * 60 * 1000 /**Five minutes*/}).then(function(listOfContactLists) {
            $scope.contactLists = listOfContactLists;
        });
    });

    
    $scope.groupClicked = function (group) {
        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }

        group.originalName = group.name;
        group.originalDescription = group.description;
        $scope.currentGroup = group;
        $scope.scrollToElement(group);
        $scope.currentGroupID = group.id;
        console.log(group.contactLists);
    };

    $scope.super({
        clazz: 'group',
        downloadUrl: '/group?select=name+description+assets+labels&sort=name&order=asc'
    });
    
    $scope.deleteGroup = function(group) {
        smarttrackerService.authDelete(smarttrackerService.getCustomerId() + '/group/' + group.id)
            .then(function(response) {
                for (var n = $scope.items.length - 1; n >= 0; n--) {
                    if ($scope.items[n].id === group.id) {
                        $scope.items.splice(n, 1)
                    }
                }
            }, function (response) {
                alert("Error occurred while attempting to delete asset. Technical information:\n\n" + JSON.stringify(response));
            });
    };

    $scope.changeGroupName = function(){
        if($scope.currentGroup.name != $scope.currentGroup.originalName) {
            var g = $scope.currentGroup;
            $scope.groupUpdateInProgress[g.id] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/group/' + g.id, {'name':g.name}).then(function (response){
                $scope.groupUpdateInProgress[g.id] = false;
                g.originalName = g.name;
            });
        }
    };

    $scope.changeGroupDescription = function() {
        var g = $scope.currentGroup;
        if(g.description != g.originalDescription) {
            $scope.groupUpdateInProgress[g.id] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + g.id, {'description':g.description}).then(function (response){
                $scope.groupUpdateInProgress[g.id] = false;
                g.originalDescription = g.description;
            });
        }
    };

    $scope.removeAssetFromGroup = function (asset) {
        var g = $scope.currentGroup;
        var index = -1;
        for(var i = 0; i < g.assets.length;i++) {
            if(g.assets[i].id == asset.id) {
                index = i;
                break;
            }
        }
        if(index > -1) {
        g.assets.splice(index, 1);
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + g.id, {"assets":g.assets}).then(function (response){

        });
        }
    };

    $scope.addAssetsToGroup = function( ){

        var disabledIDs = [];
        angular.forEach($scope.currentGroup.assets, function (asset){
            disabledIDs.push(asset.id);
        });

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-asset-to-group.html',
            controller: stwoCommonPickerModalController,
            size: "lg",
            resolve: {
                pickerConfiguration: function() { return {
                    title: "MANAGEMENT_GROUP_ADD_ASSET_TITLE",
                    clazz: "asset",
                    fieldsToShow: ["name", "groups"],
                    multiple: true,
                    nullAllowed: false,
                    disabledIDs:disabledIDs,
                    downloadUrl: '/asset?select=name+groups&sort=name&order=asc'}
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            var asset = pickerResult.data;
            if (pickerResult.selectedItems.length > 0) {
                console.log(pickerResult);
                if(pickerResult.selectedItems.length>0){
                    var g = $scope.currentGroup;
                    var a = g.assets;
                    angular.forEach(pickerResult.selectedItems, function (val) {
                        a.push(val);
                    });
                    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + g.id, {'assets':a}).then(function (response){
                        $scope.currentGroup.assets = response.data.result[0].assets;
                    }, function() {
                        alert("Something went wrong when adding assets. Please contact system administrator.");
                    });
                }
            }
        });
    }

    var prepareContactListsFor = function (group) {
        var l = group.labels; 
        group.contactLists = [];
        angular.forEach(l, function (label, name) {
            if(label.code == 'ACR_CL') {
                try{
                    var json = JSON.parse(label.value);
                    json.index = json.name; 
                    group.contactLists.push(json);
                } catch(e) {
                    console.err("Error when parsing contact list " + e);
                }
            }
        });
        if($scope.contactLists && $scope.contactLists.length>0) {
            var updateLabels = utilService.clone(group.labels);
            var changes = false;
            angular.forEach(group.contactLists, function (list) {
                var found = false;
                for(var i = 0; i < $scope.contactLists.length;i++) {
                    if($scope.contactLists[i].id == list.id){
                        found = true;
                        if($scope.contactLists[i].name != list.name) {
                            list.name = $scope.contactLists[i].name;
                            delete updateLabels[list.index];
                            updateLabels[$scope.contactLists[i].name] = {'code':'ACR_CL', 'value':JSON.stringify({'name':$scope.contactLists[i].name, 'id':$scope.contactLists[i].id})};
                            changes = true;
                            break;
                        }
                    }
                }
                if(!found) {
                    // The list is not there. Just remove it. It has to be deleted. 
                    delete updateLabels[list.index];
                    group.contactLists.splice(group.contactLists.indexOf(list), 1);
                    changes = true;
                }
            });
            if(changes && $scope.access['group']['put']){
                console.log("Labels did change", updateLabels, group.labels);
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + group.id, {'labels':updateLabels}).then(function (response) {
                    group.labels = response.data.result[0].labels;
                    prepareContactListsFor(group);
                });
            } else {
                console.log("Labels did not change", updateLabels, group.labels);
            }
        }
    }



    $scope.removeContactListFromGroup = function (cl) {
        var g = $scope.currentGroup;
        var labels = utilService.clone(g.labels);
        delete labels[cl.index];
       
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + g.id, {'labels':labels}).then(function (response){
            // All done
            angular.forEach($scope.items, function (value) {
                if(value.id == g.id) {
                    value.labels = response.data.result[0].labels;
                    prepareContactListsFor(value);
                }
            })
        });
    }

    $scope.addContactListToGroup = function() {
        var g = $scope.currentGroup; 
        console.log(g);
        var disabledIDs = [];
        angular.forEach(g.labels, function (value, key) {
            if(value.code == 'ACR_CL') {
                try{
                    var json = JSON.parse(value.value);
                    disabledIDs.push(json.id);
                } catch(e) {
                    console.err("Something went wrong parsing label " + e);
                }
            }
        });


        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-contactlist.html',
            controller: stwoCommonPickerModalController, 
            size:'lg',
            resolve:{
                pickerConfiguration: function() {
                    return {
                        title: "MANGEMENT_GROUP_SET_CONTACT_LIST_TITLE",
                        clazz: "contactList",
                        fieldsToShow: ["name"],
                        multiple: true,
                        nullAllowed: false,
                        disabledIDs:disabledIDs,
                        nullButtonText: "MANAGEMENT_GROUP_REMOVE_CONTACT_LIST",
                        downloadUrl: "/contactList?select=name&sort=name&order=asc"}
                }
            }
        });

        modalInstance.result.then(function (pickerResult){
            console.log(pickerResult);

            var cl = pickerResult.selectedItems[0];
            angular.forEach(pickerResult.selectedItems, function (cl){
                g.labels[cl.name] = {'code':'ACR_CL', 'value':JSON.stringify({'id':cl.id, 'name':cl.name})};
            }) ;
             
             var index = -1;
             
             console.log("Checking", cl, index);
           
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/group/" + g.id, {'labels':g.labels}).then(function (response){
                    prepareContactListsFor(g);
            });
        });
    }

    $scope.createGroup = function() {
         var promise = dialogService.prompt("MANAGEMENT_GROUP_ADD_TITLE",
                            "MANAGEMENT_GROUP_ADD_TEXT",
                            {
                                okButtonText: "MANAGEMENT_GROUP_ADD_OK",
                                promptText: ""
                            });
                            
        promise.then(function(data) {
            var newGroupName = data.promptText;
            if(newGroupName&&newGroupName!=""){
                smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/group/", {"name":newGroupName}).then(function (response){
                   $scope.filterUrlString = "&id:equals=" + response.data.result[0].id;
                   $scope.filterMessage = "NEW_GROUP";
                   $scope.filterMessage2 = "";
                   $scope.groupClicked(response.data.result[0]);

                });
            }
        });
    }

    $scope.deleteGroup = function() {
        smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/group/" + $scope.currentGroup.id).then(function (response) {
            var index = -1;
            for(var i = 0; i < $scope.items.length;i++){
                if($scope.items[i].id == $scope.currentGroup.id){
                    index = i;break;
                }
            }
            if(index > -1) {
                $scope.items.splice(index, 1);
                if($scope.items.length>0){
                    $scope.groupClicked($scope.items[0]);
                }
            }
        });
    }

        
    $scope.currentGroupID = false;

    if($stateParams.ids){
        $scope.filterUrlString = "&id:equals=" + $stateParams.ids;
        $scope.filterMessage = "SELECTED_ITEMS";
        $scope.filterMessage2 = "";
        $scope.currentGroupID = $stateParams.ids;
        

    }

    $scope.scrollToElement = function (item) {
        var anchorscroll = angular.element(document.getElementById(item.id));
        var container = angular.element(document.getElementById('scroll-container'));

        setTimeout(function () {
            container.scrollTo(anchorscroll, 15, 500);
        }, 10);

    };

    $scope.scrollContainer = document.getElementById('scroll-container');

    $scope.localFavorites = (localStorage["Favorites"] === "true");

    if ($scope.localFavorites){
        $scope.showFavorites();
    }

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    $scope.localCollapseAsset = (localStorage["CollapseAsset"] === "true");
    $scope.toggleCollapseAsset = function () {
        $scope.localCollapseAsset = !$scope.localCollapseAsset;
        localStorage["CollapseAsset"] = $scope.localCollapseAsset;
    };

    $scope.$watch("itemsChanged", function(){
        angular.forEach($scope.items, function (group){
            prepareContactListsFor(group);
        });
    });


    $scope.downloadAll = function() {
        var total = $scope.pagination.total;
        /*$scope.clearItems();*/
        
        $scope.super({
            pagination: {max: total },
            clazz: 'group',  
            downloadUrl: '/group?select=name+description+assets&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    }

    $scope.deleteConfirmation = function() {
        var promise = dialogService.prompt("MANAGEMENT_GROUP_DELETE_TITLE", "MANAGEMENT_GROUP_DELETE_WARNING",
            {
                warningButtonText: "MANAGEMENT_ASSET_DELETE_OK",
                promptText: "",
                disablePromptText: true,
                deleteButton: true
            });
        promise.then(function() {
            $scope.deleteGroup()
        });
    };

    $scope.Screensize = function () {
        if ($(window).width() > 991) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
    };
});
    

angular.module('stwo.management-group').controller('GroupManagementDetailController', function($state, $scope, $stateParams, smarttrackerService, contentCacheService) {
    
    $scope.group = contentCacheService.get("group", $stateParams.id);

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/group/' + $stateParams.id + '?select=@').then(function(response) {
        $scope.group = response.data.result[0];
        if ($scope.group) {
            contentCacheService.put("group", $scope.group.id, $scope.group);
        }
    });
});


angular.module('stwo.management-contact-list', ["stwo.management", "angularTrix", "dndLists"]).config(function($stateProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
            name : "contactList-management",
            links : [{
                    name : "XGUARD_MANAGEMENT_CONTACT_LIST",
                    category : "MANAGEMENT",
                    sref : "secure.content.management-contact-list",
                    access : ["contactList", "put"],
                    sort : 10,
                    icon : "phone-log",
                    color: "info",
                    controllers: ['ContactListManagementListController']
            }]
    });

    $stateProvider.state("secure.content.management-contact-list", {
        url : "/contactlist-management/:ids",
        templateUrl : "modules/management-contact-list/management-contact-list.html",
        controller : "ContactListManagementListController",
        titleName: 'XGUARD_MANAGEMENT_CONTACT_LIST_TITLE',
        titleIcon: "phone-log"
    });
});

angular.module('stwo.management-contact-list').controller('ContactListManagementListController', function($scope, $translate, $timeout, $stateParams, $state, $modal, $controller, smarttrackerService, dialogService, contentCacheService, utilService) {
    $controller('BaseListContentController', {$scope: $scope});

    $scope.contactListUpdateInProgress = {};

    $scope.selected = {
        value: null
    };

    $scope.editContact = function(index){
        $scope.animateEditor(index);
    };

    $scope.animateEditor = function (index){

        if ($scope.selected.value == index){
            TweenLite.set("#editor-" + index, {overflow: "hidden"});
            TweenLite.to("#editor-" + index, 0.5, {height: "0px", opacity: 0, ease: "Quart.easeInOut" });
            TweenLite.set("#editor-" + index, {overflow: "hidden", delay: 0.5});
            $scope.selected.value = null;
        } else {
            setTimeout(function () {
                TweenLite.set("#editor-" + index, {height: "auto", opacity: 1});
                TweenLite.from("#editor-" + index, 0.5, {height: "0px", opacity: 0, ease: "Quart.easeInOut" });
                TweenLite.set("#editor-" + index, {overflow: "visible", delay: 0.5});
            }, 20);
            $scope.selected.value = index;
        }
        if ($scope.selected.value != $scope.previous && !null){
            TweenLite.set("#editor-" + $scope.previous, {overflow: "hidden"});
            TweenLite.to("#editor-" + $scope.previous, 0.5, {height: "0px", opacity: 0, ease: "Quart.easeInOut" });
            TweenLite.set("#editor-" + $scope.previous, {overflow: "hidden", delay: 0.5});
        }
        $scope.previous = $scope.selected.value;

    };

    $scope.contactListClicked = function (cl) {
        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }
        console.log("Clicked contactlist", cl);

        cl.originalName = cl.name;
        cl.originalDescription = cl.description;
        // angular.forEach(group.labels, function (lbl) {
        //     if(lbl.code == 'ACR_CL') {
        //         try{
        //             var json = JSON.parse(lbl.value);
        //             group.contactList = json.name;
        //             console.log(json);
        //         } catch (e) {
        //             console.err(e);
        //         }
        //     }
        // });
        
        $scope.currentCL = cl;
        $scope.currentCLID = cl.id;
        $scope.scrollToElement(cl);
    };

    $scope.super({
        clazz: 'contactList',
        downloadUrl: '/contactList?select=contacts+name+labels+description&sort=name&order=asc'
    });
    
    $scope.deleteContactList = function() {
        var cl = $scope.currentCL;
        smarttrackerService.authDelete(smarttrackerService.getCustomerId() + '/contactList/' + cl.id)
            .then(function(response) {
                for (var n = $scope.items.length - 1; n >= 0; n--) {
                    if ($scope.items[n].id === cl.id) {
                        $scope.items.splice(n, 1)
                    }
                    $scope.currentCL = false;
                    $scope.currentCLID = false;
                    if($scope.items.length > 0) {
                        $scope.contactListClicked($scope.items[0]);
                    }
                }
                contentCacheService.invalidate(smarttrackerService.getCustomerId() + "/contactList");
            }, function (response) {
                alert("Error occurred while attempting to delete contactList. Technical information:\n\n" + JSON.stringify(response));
            });
    };

    $scope.changeContactListName = function(){
        var cl = $scope.currentCL;
        if(cl.name != cl.originalName && cl.name != "") {
            $scope.contactListUpdateInProgress[cl.id] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/contactList/' + cl.id, {'name':cl.name}).then(function (response){
                $scope.contactListUpdateInProgress[cl.id] = false;
                cl.originalName = cl.name;
                contentCacheService.invalidate(smarttrackerService.getCustomerId() + "/contactList");
            });
        }
    }

    $scope.changeContactListDescription = function() {
        var cl = $scope.currentCL;
        if(cl.description != cl.originalDescription && cl.description != "") {
            $scope.contactListUpdateInProgress[cl.id] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/contactList/" + cl.id, {'description':cl.description}).then(function (response){
                $scope.contactListUpdateInProgress[cl.id] = false;
                cl.originalDescription = cl.description;
            });
        }
    }

  


    $scope.createContactList = function() {
         var promise = dialogService.prompt("MANAGEMENT_CONTACT_LIST_ADD_TITLE",
                            "MANAGEMENT_CONTACT_LIST_ADD_TEXT",
                            {
                                okButtonText: "MANAGEMENT_CONTACT_LIST_ADD_OK",
                                promptText: ""
                            });
                            
        promise.then(function(data) {
            var newCLName = data.promptText;
            if(newCLName&&newCLName!=""){
                smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/contactList/", {"name":newCLName}).then(function (response){
                    $scope.filterUrlString = "&id:equals=" + response.data.result[0].id;
                    $scope.filterMessage = "NEW_LIST";
                    $scope.filterMessage2 = "";
                    $scope.contactListClicked(response.data.result[0]);
                    $scope.currentCL.originalContacts = []; 
            
                    contentCacheService.invalidate(smarttrackerService.getCustomerId() + "/contactList");
                }); 
            } else {
                dialogService.alert("MANAGEMENT_CONTACT_LIST_NAME_EMPTY_DIALOG_TITLE", "MANAGEMENT_CONTACT_LIST_NAME_EMPTY_DIALOG_CONTENT").then(
                    function (data) {
                        $scope.createContactList();
                    });
                }
        });
    }

    $scope.cancelContact = function (contact, index2) {
        var cl = $scope.currentCL;
        var index = cl.contacts.indexOf(contact);

        if(contact.new) {
            cl.contacts.splice(index, 1);
            $scope.selected.value = null;
            return;
        }
      
        if(index > -1) { 
            var c = utilService.clone(cl.originalContacts[index]);
            c.phoneNumber = '+' + c.phoneNumber;
            cl.contacts[index] = c;
        }
        $scope.animateEditor(index2);
        $scope.selected.value = null;

    };

    $scope.saveContact = function (contact, index2) {
        if(!$scope.access["contactList"]["put"]) {
            console.log("user does not have sufficient rights, ignoring save request. This will be rejected by SmartTracker");
            return;
        }
        contact.firstSave = true;
        $scope.validateContact(contact).then(function (success) {
            if(!success)return;

        var cl = $scope.currentCL;
        var index = cl.contacts.indexOf(contact);
        var contacts = cl.originalContacts ? utilService.clone(cl.originalContacts) : [];
        var updateContact = utilService.clone(contact);    
        updateContact.phoneNumber = contact.phoneNumber.replace("+", "");
        if(index < 0)return;
         
        if(contact.new) {
            updateContact.new = false;
            contacts.push(updateContact);
            $scope.animateEditor(index2);
            $scope.selected.value = null
        } else {
            contacts[index] = updateContact;
            $scope.animateEditor(index2);
            $scope.selected.value = null
        }
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/contactList/" + cl.id, {'contacts':contacts}).then(function (response){
                contact.dirty = false;
                contact.new = false;
                cl.originalContacts[index] = {'email':contact.email, 'name':contact.name, 'phoneNumber':contact.phoneNumber.replace("+", "")};
                console.log(cl)
        }, function (){
            alert("Something went wrong when trying to save contacts. Please contact System administration.");
        });
        });
    }

    $scope.validateContact = function(contact, update) {
        var cl = $scope.currentCL;
        var index = cl.contacts.indexOf(contact);
        if(index > -1) { 
            var original = cl.originalContacts[index];
            //console.log("contact.dirty = " + index+">="+cl.originalContacts.length+"||!("+contact.name+"=="+original.name+"&&"+contact.phoneNumber.replace('+', '')+"=="+original.phoneNumber.replace('+', '')+"&&"+contact.email+"=="+original.email+")");
            contact.dirty = index>=cl.originalContacts.length||!(contact.name==original.name&&contact.phoneNumber.replace('+', '')==(original.phoneNumber.replace('+', ''))&&contact.email==original.email);
        }

        if(!contact.firstSave)return false;
        var promise = new Promise(function (validate) {
        $translate(['MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_NAME_EMPTY', 'MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_MAIL_NUMBER_EMPTY', 'MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_MAIL_INVALID', 
            'MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_NUMBER_INVALID'], contact).then(function (data){
            //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},? ?)+$/;

            if(contact.name == '') {
                contact.error = data['MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_NAME_EMPTY'];
            } else if(contact.phoneNumber == '' && contact.email == '') {
                contact.error = data['MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_MAIL_NUMBER_EMPTY'];
            } else if(contact.email!=''&&!re.test(contact.email)) {
                contact.error = data['MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_MAIL_INVALID'];
            } else if(contact.phoneNumber != ''&&!(/^\+?[0-9 ]{5,}/).test(contact.phoneNumber)) {
                contact.error = data['MANAGEMENT_CONTACT_LIST_CONTACT_ERROR_NUMBER_INVALID'];
            } else {
                contact.error = false;
            }
            console.log(contact.error, contact.error==false);
            //return contact.error==false;
            validate(contact.error == false);
        });
        });
        return promise;
    }

    $scope.toggleAdminStatus = function() {
        var cl = $scope.currentCL;
        if(!cl.isAdminListWorking){
            cl.isAdminListWorking = true;
            var wl = utilService.clone(cl.labels);
            var pl = utilService.clone(cl.labels);
            if(cl.isAdminList) {
                angular.forEach(wl, function(label, key){
                    if(label.code == 'ACR_ANL') 
                        delete pl[key];
                });
            } else {
                pl["meta"] = {code:'ACR_ANL', value:"This list will be contacted when alarm is acked"}
            }
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/contactList/" + cl.id, {'labels':pl}).then(function (response){
                cl.isAdminList = !cl.isAdminList;
                cl.labels = response.data.result[0].labels;
                cl.isAdminListWorking = false;
            })
        }
    }

    $scope.removeContact = function (contact) {
        var cl = $scope.currentCL;
        var index = cl.contacts.indexOf(contact);
        if(contact.new) { // it is not saved, remove it from the list
            cl.contacts.splice(index, 1);
            $scope.selected.value = null;
            return;
        }
       // if(contact.confirmRemove) {
            var contacts = utilService.clone(cl.originalContacts);
            contacts.splice(index, 1);
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/contactList/" + cl.id, {"contacts":contacts}).then(function (response){
                cl.originalContacts = utilService.clone(contacts);
                cl.contacts.splice(index, 1);
            }, function() {
                alert("Something went wrong when removing contact. ");
            });
        // } else {
        //     cl.contacts[index].confirmRemove = true;
        // }
    };

    $scope.createContact = function() {
        $scope.currentCL.contacts.push({
            "name":"",
            "phoneNumber":"",
            "email":"",
            new:true,
            dirty:true
        });
        $scope.editContact($scope.currentCL.contacts.length-1);
    };




    if($stateParams.ids){
        $scope.filterUrlString = "&id:equals=" + $stateParams.ids;
        $scope.filterMessage = "SELECTED_ITEMS";
        $scope.filterMessage2 = "";
        $scope.currentGroupID = $stateParams.ids;
    }

    $scope.scrollToElement = function (item) {
        var anchorscroll = angular.element(document.getElementById(item.id));
        var container = angular.element(document.getElementById('scroll-container'));
        setTimeout(function () {
            container.scrollTo(anchorscroll, 15, 500);
        }, 10);
    };

    $scope.scrollContainer = document.getElementById('scroll-container');

    $scope.localFavorites = (localStorage["Favorites"] === "true");

    if ($scope.localFavorites){
        $scope.showFavorites();
    }

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    $scope.localCollapseAsset = (localStorage["CollapseAsset"] === "true");
    $scope.toggleCollapseAsset = function () {
        $scope.localCollapseAsset = !$scope.localCollapseAsset;
        localStorage["CollapseAsset"] = $scope.localCollapseAsset;
    };

    $scope.$watch("itemsChanged", function(){
        angular.forEach($scope.items, function (cl, index) {
            cl.originalContacts = []; 
            angular.forEach(cl.contacts, function (contact) {
            cl.originalContacts.push(utilService.clone(contact));
            contact.phoneNumber = contact.phoneNumber.indexOf('+') == 0 ? contact.phoneNumber : "+" + contact.phoneNumber;
            angular.forEach(cl.labels, function (label, key){
                if(label.code == 'ACR_ANL') {
                    cl.isAdminList = true;
                }
            });
        })
        });
    });


    $scope.downloadAll = function() {
        var total = $scope.pagination.total;
        /*$scope.clearItems();*/
        
        $scope.super({
            pagination: {max: total },
            clazz: 'contactList',  
            downloadUrl: '/contactList?select=name+description+contacts+labels&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    };

    $scope.deleteContactConfirmation = function(contact) {
        var promise = dialogService.prompt("MANAGEMENT_ASSET_DELETE_TITLE", "MANAGEMENT_ASSET_DELETE_WARNING",
            {
                warningButtonText: "MANAGEMENT_ASSET_DELETE_OK",
                promptText: "",
                disablePromptText: true,
                deleteButton: true
            });
        promise.then(function(data) {
            $scope.removeContact(contact)
        });
    };

    $scope.deleteConfirmation = function() {
        var promise = dialogService.prompt("MANAGEMENT_CONTACT_LIST_DELETE_TITLE", "MANAGEMENT_CONTACT_LIST_DELETE_WARNING",
            {
                warningButtonText: "MANAGEMENT_ASSET_DELETE_OK",
                promptText: "",
                disablePromptText: true,
                deleteButton: true
            });
        promise.then(function() {
            $scope.deleteContactList()
        });
    };

    $scope.Screensize = function () {
        if ($(window).width() > 991) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
    };

});
    

angular.module('stwo.alarm', ["stwo.core"]).config(function($stateProvider, $urlRouterProvider, moduleStoreProvider) {
    var pollingForAlarms = false;
    var max = 100;

    var pollSmarttrackerForAlarms = function() {

        var sts = moduleStoreProvider.serviceRepository()["smarttrackerService"];
        if (!pollingForAlarms && sts && sts.getCustomerId() && sts.getAccessRights()["alarm"] && sts.getAccessRights()["alarm"]["get"]) {
            pollingForAlarms = true;
            sts.authGet(sts.getCustomerId() + '/alarm?select=lastUpdated+logLevel+name+asset.name+ackedBy+ackNeeded&ackNeeded:equals=true&ackedBy:null=true&sort=lastUpdated&order=desc&max=' + max, {onErrorDoNotRedirect: true}).then(function(response) {
                
                if (response && response.data) {
                    if(response.data.total>max){
                        max = response.data.total;
                        pollingForAlarms = false;
                        pollSmarttrackerForAlarms();
                        return;
                    }
                    var ns = moduleStoreProvider.serviceRepository()["notificationService"];

                    var notificationIdsSeen = {};
                    for (var n = 0; n < response.data.result.length; n++) {
                        notificationIdsSeen["alarm-" + response.data.result[n].id] = true;
                        ns.add({
                            id : "alarm-" + response.data.result[n].id,
                            time : response.data.result[n].lastUpdated,
                            level :  (response.data.result[n].logLevelFormatted === "warning" ? 'warning' :  (response.data.result[n].logLevelFormatted === "notification" ? 'success' :  "danger")), //success, info, warning, danger
                            name : response.data.result[n].name,
                            module: "alarm",
                            dismissable: true,
                            dismissed: false,
                            access : ["alarm", "put"],
                            alarmId: response.data.result[n].id
                        });
                    }

                    var nss = ns.list();
                    for (var nn = 0; nn < nss.length; nn++) {
                        if (nss[nn].module === "alarm" && !notificationIdsSeen[nss[nn].id]) {
                            ns.silentDismiss(nss[nn].id);
                        }
                    }
                } else {
                    console.log("Empty response from smarttracker", response)
                }

                pollingForAlarms = false;
            }, function() {
                pollingForAlarms = false;
            });
        }
    }

	moduleStoreProvider.registerModule({
		name : "alarm",
        categories : [{
            name : "ALARMS",
            icon : "map",
            color: "info",
            sort : 5
        }],
		links : [{
            name:"ALARMS_NAV",
            category: "navigation",
            icon: "map",
            sref: "secure.content.alarm",
            access: moduleStoreProvider.access("stwo.alarm", ["alarm", "get"]),
            sort: 9,
            color: "danger",
            badge: "notificationCount",
            controllers: ["AlarmListController", "AlarmDetailController"]
        }
        // ,{
			// name : "ALARMS_ALL",
			// category : "ALARMS",
			// sref : "secure.content.alarm",
        //     access : ["alarm", "get"],
			// icon : "format-list-bulleted",
        //     controllers: ["AlarmListController", "AlarmDetailController"],
        //     color: "danger",
        //     badge: "notificationCount",
			// sort : 25
        // }
        // ,{
		// 	name : "ALARMS_UNACK",
		// 	category : "ALARMS",
		// 	sref : "secure.content.alarm({filter: 'unacked'})",
         //    access : ["alarm", "get"],
		// 	stateParams : {
		// 		filter : 'unacked'
		// 	},
         //    color: "danger",
		// 	icon : "alert",
		// 	sort : 20
		// }
		],
    
        notificationHandlers: {
            view: function(notification) {
                moduleStoreProvider.serviceRepository()["$state"].go("secure.content.alarm.detail", {id:notification.alarmId});
            },
            push: function(data, util) {
                if (data && data.type === "alarm") {
                    pollSmarttrackerForAlarms();
                }
            },
            poll: function() {
                pollSmarttrackerForAlarms();
            },
            dismiss: function(notification, dismissFn) {
                var m = moduleStoreProvider.serviceRepository()["$modal"];
                

                var modalInstance = m.open({
                    templateUrl: 'modules/alarm/ack_modal.html',
                    controller: stwoAlarmAcknowledgeModalController,
                    size: "lg",
                    resolve: {
                        alarm: function() { return null },
                        notification: function() { return notification }
                    }
                });

                modalInstance.result.then(function (newFilterData) {
                    dismissFn();
                }, function() {

                });
            }
        }
	});

	$stateProvider.state("secure.content.alarm", {
		url : "/alarm/:filter",
		templateUrl : "modules/alarm/list.html",
		controller : "AlarmListController",
        titleName: 'ALARM_LIST',
        titleIcon: "format-list-bulleted"
	}).state("secure.content.alarm.detail", {
		url : "/alarm-detail/:id",
		templateUrl : "modules/alarm/detail.html",
		controller : "AlarmDetailController",
        titleName: 'ALARM_DETAIL',
        titleIcon: "identification-card"
	});
    
    
    moduleStoreProvider.addPossibleFilter("alarm", {id: "name", label: "ALARMS_FILTER_NAME", type: "string", field: "name", comparator: "contains"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "asset", label: "ALARMS_FILTER_ASSET", type: "string", field: "asset.name", comparator: "contains"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "ack_needed", label: "ALARMS_FILTER_ACK_NEEDED", comparator: "equals", type: "list", list: [{label: "-", value: ""}, {label: "ALARMS_FILTER_ACK_NEEDED_TRUE", value: "true"}, {label: "ALARMS_FILTER_ACK_NEEDED_FALSE", value: "false"}], field: "ackNeeded"});
    moduleStoreProvider.addPossibleFilter("alarm", {id: "acked_by", label: "ALARMS_FILTER_ACKED", comparator: "null", type: "list", list: [{label: "-", value: ""}, {label: "ALARMS_FILTER_ACKED_FALSE", value: "false"}, {label: "ALARMS_FILTER_ACKED_TRUE", value: "true"}], field: "ackedBy"});
    
});

angular.module('stwo.alarm').controller('AlarmListController', function($scope, $controller, $state, $modal, smarttrackerService, notificationService) {
    $controller('BaseListContentController', {$scope: $scope});
    
    $scope.alarmWarning = {newAlarms: false};
    notificationService.audio.snoozed = true;
    
    $scope.addPredefinedFilter("unacked", [{filterId: "ack_needed", label: "ALARMS_FILTER_ACK_NEEDED", value: "true"},{filterId: "acked_by", label: "ALARMS_FILTER_ACKED", value: "true"}], "&ackNeeded:equals=true&ackedBy:null=true");
  
    $scope.super({clazz: 'alarm', downloadUrl: '/alarm?select=dateCreated+lastUpdated+rule+logLevel+name+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc'});
    
    $scope.notificationsChanged = notificationService.changed;
    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.updated + notificationsChanged.removed", function() {
        var notifications = notificationService.list();
        
        for (var n = 0; n < notifications.length; n++) {
            for (var m = 0; m < $scope.items.length; m++) {
                var not = notifications[n];
                var alm = $scope.items[m];
                if (not.alarmId && alm.id && not.alarmId === alm.id) {
                    if (not.dismissed && alm.ackNeeded && !alm.ackedBy) {
                        alm.ackedBy = {id: -1, name: "..."};
                    }
                }
            }
        }
    })
    
    
    $scope.$watch("items.length", function() {
       if ($scope.items.length === 0) {
           $scope.alarmWarning.newAlarms = false;
       } 
    });
    $scope.$watch("notificationsChanged.added", function() {
       if ($scope.items.length > 0) {
           $scope.alarmWarning.newAlarms = true;
       } 
    });
    
    $scope.alarmClicked = function(alarm) {
        $state.go("secure.content.alarm-screen-xguard-detail", {id:alarm.id});
    }
    
    $scope.ackAlarm = function(alarm) {

        var modalInstance = $modal.open({
            templateUrl: 'modules/alarm/ack_modal.html',
            controller: stwoAlarmAcknowledgeModalController,
            size: "lg",
            resolve: {
                alarm: function() { return alarm },
                notification: function() { return null }
            }
        });

        modalInstance.result.then(function (data) {
            
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarm.id + '?select=ackedBy+comment').then(function(response) {
                for (var n = 0; n < $scope.items.length; n++) {
                    if (response.data.result.length > 0 && $scope.items[n].id === response.data.result[0].id) {
                        $scope.items[n].ackedBy = response.data.result[0].ackedBy;
                        $scope.items[n].comment = response.data.result[0].comment;
                    }
                }
            });
        }, function() {

        });
    }
});

angular.module('stwo.alarm').controller('AlarmDetailController', function($scope, $controller, $stateParams, $modal, $window, smarttrackerService, contentCacheService, notificationService, mapService, leafletData, pushService) {
	
    $controller('BaseDetailContentController', {$scope: $scope});
    
    $scope.indoorViewer = {location: null, markers: {}, changeCounter: 0};
    $scope.alarm = contentCacheService.get("alarm", $stateParams.id);


    mapService.basicMapDesign($scope, leafletData);
    $scope.markers = {};

    $scope.mapData = {
        center : {
                lat : 0,
                lng : 0,
                zoom : 1			
        },
        defaults : {'dragging': true}
    };


    $scope.events = {
        marker : {enable: ['click'],
        logic :'emit'}
    };

    $scope.updateMarkers = function(fitToBounds) {
        if (!$scope.alarm) {
            return;
        }

        var boundsMarkerArray = [];
        $scope.markerCount = 0;

        
        $scope.indoorViewer.markers["alarm"] = $scope.alarm;
        $scope.indoorViewer.markers["alarm"].markerStrokeColor = ($scope.alarm.logLevelFormatted === 'notification' ? 'rgba(0, 255, 0, 1)' : ($scope.alarm.logLevelFormatted === 'warning' ? 'rgba(255, 128, 0, 1)' : 'rgba(255, 0, 0, 1)' ) );
        
        if ($scope.alarm.position && $scope.alarm.position.location && $scope.alarm.position.location.locationId) {
            $scope.indoorViewer.location = $scope.alarm.position.location.locationId;
        }
        
        $scope.indoorViewer.markers["asset"] = $scope.alarm.asset;
        
        if ($scope.alarm.position && $scope.alarm.position.valid) {
            boundsMarkerArray.push(new L.latLng($scope.alarm.position.latitude, $scope.alarm.position.longitude));
            $scope.markers["alarm"] = {
                id : "alarm",
                lat : $scope.alarm.position.latitude,
                lng : $scope.alarm.position.longitude,
                icon: mapService.makeNamedIcon($scope.alarm.name, "danger"),
                focus : false, //just add them on the map. not in focus
                draggable : false
            }
            $scope.markerCount++;
            
        }
        
        if ($scope.alarm.asset && $scope.alarm.asset.lastValidPosition && $scope.alarm.asset.lastValidPosition.valid) {
            boundsMarkerArray.push(new L.latLng($scope.alarm.asset.lastValidPosition.latitude, $scope.alarm.asset.lastValidPosition.longitude));
            $scope.markers["asset"] = {
                id : "asset",
                lat : $scope.alarm.asset.lastValidPosition.latitude,
                lng : $scope.alarm.asset.lastValidPosition.longitude,
                icon: mapService.makeNamedIcon($scope.alarm.asset.name),
                //message : "message",
                focus : false, //just add them on the map. not in focus
                draggable : false
            }
            $scope.markerCount++;
        }

        delete $scope.markers["merged"];
        if ($scope.markers["alarm"] && $scope.markers["asset"]) {
            var distanceBetweenTheMarkers = Math.sqrt(Math.pow($scope.markers["asset"].lat - $scope.markers["alarm"].lat, 2) + Math.pow($scope.markers["asset"].lng - $scope.markers["alarm"].lng, 2))
            if (distanceBetweenTheMarkers < 0.0005) { //magic number, decrease if group occurs prematurely
                delete $scope.markers["asset"];
                delete $scope.markers["alarm"];

                $scope.markers["merged"] = {
                    id : "merged",
                    lat : $scope.alarm.asset.lastValidPosition.latitude,
                    lng : $scope.alarm.asset.lastValidPosition.longitude,
                    icon: mapService.makeNamedIcon($scope.alarm.name + ", " + $scope.alarm.asset.name, "danger"),
                    //message : "message",
                    focus : false, //just add them on the map. not in focus
                    draggable : false
                }
                $scope.markerCount = 1;
            }
        }

        if (fitToBounds && boundsMarkerArray.length > 0) {
            var bounds = new L.latLngBounds(boundsMarkerArray);

            leafletData.getMap().then(function(map) {
                map.fitBounds(bounds);
                map.zoomOut(1);
            });
        }
        
        
        $scope.indoorViewer.changeCounter++;
    }

    $scope.updateMarkers(true);
    
    $scope.notificationsChanged = notificationService.changed;
    
    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.updated + notificationsChanged.removed", function() {
        var notifications = notificationService.list();
        
        for (var n = 0; n < notifications.length; n++) {
            var not = notifications[n];
            var alm = $scope.alarm;
            if (alm && not.alarmId && alm.id && not.alarmId === alm.id) {
                if (not.dismissed && alm.ackNeeded && !alm.ackedBy) {
                    $scope.downloadAlarm();
                }
            }
        }
    })
    
    $scope.downloadAlarm = function() {
        return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + $stateParams.id + '?select=*').then(function(response) {
            $scope.alarm = response.data.result[0];
            if ($scope.alarm) {
                contentCacheService.put("alarm", $scope.alarm.id, $scope.alarm);
            }
            $scope.updateMarkers(true);
        });
    }
	
	$scope.googleMaps = function(alarm) {
		$window.open('http://maps.google.com/maps?q='+alarm.position.latitude+','+alarm.position.longitude);		 		 
    }

    $scope.ackAlarm = function(alarm) {

        var modalInstance = $modal.open({
            templateUrl: 'modules/alarm/ack_modal.html',
            controller: stwoAlarmAcknowledgeModalController,
            size: "lg",
            resolve: {
                alarm: function() { return alarm },
                notification: function() { return null }
            }
        });

        modalInstance.result.then(function (data) {
            $scope.downloadAlarm().then(function() {
                // Iterates over parent scope data. Not very elegant, and makes assumptions about parent controller's data structure. Redo if possible. Magnus.
                if ($scope.items) {
                    for (var n = 0; n < $scope.items.length; n++) {
                        if ($scope.alarm && $scope.items[n].id === $scope.alarm.id) {
                            $scope.items[n].ackedBy = $scope.alarm.ackedBy;
                            $scope.items[n].comment = $scope.alarm.comment;
                        }
                    }
                }
            });
        });
    }
        
    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.downloadAlarm();
        
        $scope.pushChanged = pushService.changed();
        
        $scope.$watch("pushChanged.counter", function() {
            pushService.process(function(data, util) {
                if (data.type === "observation" && $scope.alarm && $scope.alarm.asset && data.object && data.object.type === "asset" && data.object.info.id === $scope.alarm.asset.id) {
                    util.mergePosition($scope.alarm.asset, data);
                    $scope.updateMarkers();
                    $scope.indoorViewer["markers"]["asset"] = $scope.alarm.asset;
                    $scope.indoorViewer.changeCounter++;
                }
            });
        });
    });
    
    $scope.super({clazz: 'alarm'});
    
});


var stwoAlarmAcknowledgeModalController = function ($scope, $modalInstance, contentCacheService, notificationService, smarttrackerService, alarm, notification) {

    $scope.impossibleToAck = true;
    $scope.downloadingAlarm = true;
    $scope.data = {comment: ""};
    var setAlarm = function(alarm) {
        $scope.alarm = alarm;
        $scope.downloadingAlarm = false;
        $scope.impossibleToAck = (alarm.alarmCenter && alarm.alarmCenter.id !== alarm.owner.id) || !smarttrackerService.getAccessRights()["alarm"]["put"];
    }
    if (alarm) {
        $scope.alarm = contentCacheService.get("alarm", alarm.id);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarm.id + '?select=*').then(function(response) {
            setAlarm(response.data.result[0]);
        });
    } else {
        $scope.alarm = contentCacheService.get("alarm", notification.alarmId);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + notification.alarmId + '?select=*').then(function(response) {
            setAlarm(response.data.result[0]);
        });
    }

    $scope.ok = function () {
        
        var user = smarttrackerService.getLoggedInUser();
        
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/alarm/' + $scope.alarm.id,
                        [{id: $scope.alarm.id, comment: $scope.data.comment, ackedBy: {id: user.user.id}}]
                                )
        .then(  function(response) {
            notificationService.silentDismiss("alarm-" + $scope.alarm.id)
            $modalInstance.close({});
        },      function(response) {
            alert("Error while acking");
        });
        
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};
angular.module('stwo.changelog', ["stwo.core"]).config(function ($stateProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
        name: "changelog",
        links: [{
            name: "XGUARD_APP_CHANGELOG",
            category: "",
            sref: "secure.content.changelog",
            sort: 10,
            icon: "playlist-check",
            color: "info",
            controllers: ['ChangelogController']
        }]
    });

    $stateProvider.state("secure.content.changelog", {
        url: "/changelog/",
        templateUrl: "modules/changelog/changelog.html",
        controller: "ChangelogController",
        titleName: 'XGUARD_APP_CHANGELOG',
        titleIcon: "playlist-check"
    });

});

angular.module('stwo.changelog').controller('ChangelogController', function ($scope, smarttrackerService) {

    $scope.showMore = 2;
    $scope.increaseBy = function (num) {
        $scope.showMore += num;
    };

    $scope.language = smarttrackerService.language();
    $scope.language = $scope.language ? $scope.language : 'en';

    $scope.items = {};

    $scope.items['1.6.3'] =  {
        beta: false,
        update: false,
        date: '18 februari 2021',
        module: [
            {
                name: {
                    'nl': 'Alarmweergave',
                    'en': 'Alarm details',
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Dubbel geplaatste comments',
                            'en': 'Comments appearing twice'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij mogelijk het geplaatste commentaar twee keer (of vaker) werd geplaatst.',
                            'en': 'A problem was resolved where it was possible that a placed comment appeared more than once.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.2'] =  {
        beta: false,
        update: false,
        date: '27 augustus 2020',
        module: [
            {
                name: {
                    'nl': 'Telefoongesprekken (groene box)',
                    'en': 'Calls (green box)',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Automatisch gedempte lijn bij paniekalarmen',
                            'en': 'Automatically muted phone calls for panic alarms'
                        },
                        subtext: {
                            'nl': 'Bij een paniekalarm is de lijn nu automatisch gedempt. Via de gemakkelijke interface kunt u uzelf dempen of ontdempen.',
                            'en': 'The phone calls are now automatically muted for pany alarms. You can easily mute or unmute yourself through the user interface.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.1'] =  {
        beta: false,
        update: false,
        date: '17 maart 2020',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'SMS- en e-mailberichten',
                            'en': 'Texts and e-mails'
                        },
                        subtext: {
                            'nl': 'Het versturen van een sms- of e-mailbericht is nu overzichtelijker. Daarnaast is de e-mail, die binnenkomt bij de ontvangende partij nu opgemaakt en overzichtlijk.',
                            'en': 'Sending an text or e-mail has been improved. The e-mail containing information about an alarm is now well-designed.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.6.0'] =  {
        beta: false,
        update: false,
        date: '6 februari 2020',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Volgorde opvolging',
                            'en': 'Response order'
                        },
                        subtext: {
                            'nl': 'De volgorde van de opvolging is aangepast. Een surveillant die de X-Guard Alarm-app gebruikt krijgt een hogere prioriteit dan beveiligingsbedrijven zonder X-Guard Alarm.',
                            'en': 'The response order has been changed to give more priority to professional X-Guard Alarm responders.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Inkomende gesprekken',
                            'en': 'Incoming calls'
                        },
                        subtext: {
                            'nl': 'Voor alarmen waarbij een aanbelcode beschikbaar is hebben we kleine visuele veranderingen doorgevoerd.',
                            'en': 'We made smal visual changes for alarms where an incoming call is available to pick up.'
                        }
                    },,
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Adressen',
                            'en': 'Addresses'
                        },
                        subtext: {
                            'nl': 'Klik op een adres om deze op te zoeken in Google Maps',
                            'en': 'You can now click an address to open it on Google Maps'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.7, 1.5.8'] =  {
        beta: false,
        update: false,
        date: '6 december 2019',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Het nieuwe bellen is nu mogelijk via de Alarm Manager',
                            'en': 'The new calling method is now available in the alarm manager.'
                        },
                        subtext: {
                            'nl': 'U kunt vanaf nu telefoongesprekken oppakken via de Alarm Manager. Dit is alleen actief voor klanten en meldkamers waarbij dit met de meldkamer is besproken.',
                            'en': 'You are now able to get the phone call dynamically. This only has been activated for Alarm Centers who have been trained to use this feature.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.6'] =  {
        beta: false,
        update: false,
        date: '26 juli 2019',
        module: [
            {
                name: {
                    'nl': 'Alarmen',
                    'en': 'Alarms',
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Afmelden van alarmen zonder geldige positie',
                            'en': 'Acknowledging alarms without a valid position'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij het niet mogelijk was om een alarm af te melden wanneer er geen positie werd meegestuurd met het alarm.',
                            'en': 'A problem with acknowledging alarms which do not have a valid position has been resolved.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.5'] =  {
        beta: false,
        update: false,
        date: '7 juni 2019',
        module: [
            {
                name: {
                    'nl': 'SMS-berichten verzenden',
                    'en': 'Sending SMS messages'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Toevoeging van sjablonen aan SMS-berichten',
                            'en': 'Added templates to SMS messages'
                        },
                        subtext: {
                            'nl': 'Je kan bij het verzenden van een SMS nu een door ons vooraf geselecteerd bericht versturen.',
                            'en': 'It is now possible to select predefined messages for SMS messages'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.4'] =  {
        beta: false,
        update: false,
        date: '24 mei 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Logteksten op alfabetische volgorde',
                            'en': 'Log templates are now sorted'
                        },
                        subtext: {
                            'nl': 'Op verzoek staan nu alle logteksten op alfabetische volgorde.',
                            'en': 'All log templates are now sorted alphabetically.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Verbeterde ingangen voor meldkamers',
                            'en': 'Improved Alarm Center setup'
                        },
                        subtext: {
                            'nl': 'Technische verbetering voor specifieke alarmcentrale setup waarbij een alarm geopend wordt vanuit externe software.',
                            'en': 'Technical improvement in how alarms are opened from external software.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.3'] =  {
        beta: false,
        update: false,
        date: '18 februari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmweergave',
                            'en': 'Alarm overview'
                        },
                        subtext: {
                            'nl': 'De tijd van een alarm wordt nu altijd weergegeven met tijdsaanduiding naast de standaard "x minuten geleden" weergave.',
                            'en': 'The alarm time is now always displayed with the actual date and time, on top of the already shown "x minutes ago" message.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Het is nu mogeljik aan te geven dat de vraag of een klant tevreden is "n.v.t" is. In dit geval worden de afmeldingsvragen overgslagen.',
                            'en': 'It is now possible to answer "n/a" to the question if the customer is satisfied. In that case, the acknowledgement survey will be skipped.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Vaste posities',
                            'en': 'Fixed positions'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost met het tonen van vaste posities.',
                            'en': 'We solved a problem with showing fixed positions.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.2'] =  {
        beta: false,
        update: false,
        date: '23 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost met het invoeren van commentaar door de centralist.',
                            'en': 'We solved a problem with adding alarm acknowledgement comments by alarm center personnel.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.1'] =  {
        beta: false,
        update: false,
        date: '16 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'In aanvulling op de vragen die gesteld worden aan een centralist bij het afmelden van een alarm, wordt nu ook een significant verbeterde e-mail verstuurd naar de eindgebruiker.',
                            'en': 'In additition to the questions asked to the alarm center personnel, we also made an effort to hugely improve the emails which are sent when an alarm is acknowledged.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.5.0'] =  {
        beta: false,
        update: false,
        date: '15 januari 2019',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Afmelden alarmen',
                            'en': 'Acknowledging alarms'
                        },
                        subtext: {
                            'nl': 'Wanneer je een alarm wil afmelden vraagt het systeem nu naar de kwaliteit van het alarm. Deze informatie wordt gebruikt om onze dienstverlening te verbeteren en het gemakkelijker te maken voor centralisten om een alarm met zo veel mogelijk informatie af te melden.',
                            'en': 'When acknowledging alarms the system will now guide you through a short quality control survey.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Commentaarsjablonen',
                            'en': 'Comment templates'
                        },
                        subtext: {
                            'nl': 'Veelvoorkomend commentaar kan nu worden geselecteerd uit een handige sjabloonbox.',
                            'en': 'Frequently used comments for alarms are now selectable as comment templates.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.3'] =  {
        beta: false,
        update: false,
        date: '10 december 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Vaste objecten kunnen nu videobeelden tonen.',
                            'en': 'Objects are now able to refer to video cameras.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.2'] = {
        beta: false,
        update: false,
        date: '12 november 2018',
        module: [
            {
                name: {
                    'nl': 'Personen',
                    'en': 'Assets'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmen maken',
                            'en': 'Raising alarms'
                        },
                        subtext: {
                            'nl': 'De functie om een alarm te maken via de X-Guard Alarm Manager is bijgewerkt om de meldkamerprocedure mee te sturen.',
                            'en': 'The raise alarm functionality is updated to also send the alarm centre procedure with an alarm.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.1'] = {
        beta: false,
        update: false,
        date: '5 november 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Er is een probleem opgelost waarbij Objecten niet verschenen in de alarmweergave voor meldkamers.',
                            'en': 'We solved a problem where Objects in some cases were not shown to alarm centres.'
                        }
                    },
                ]
            },
        ]
    };

    $scope.items['1.4.0'] = {
        beta: false,
        update: false,
        date: '1 november 2018',
        module: [
            {
                name: {
                    'nl': 'Menu',
                    'en': 'Menu'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarmmeldingen',
                            'en': 'Alarm notifications'
                        },
                        subtext: {
                            'nl': 'De schakelaar voor het ontvangen van alarmmeldingen staat nu ook in het menu.',
                            'en': 'The toggle to enable alarm notifications is now also available in the menu.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Quick Response',
                            'en': 'Quick Response'
                        },
                        subtext: {
                            'nl': 'Bij "Quick Response" staat nu aangegeven hoe oud de positie van een Quick Responder is.',
                            'en': 'The location age is now displayed in the "Quick Response" information for a Quick Responder.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Objecten',
                            'en': 'Objects'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om vaste objecten op te nemen in het "Quick Response"-protocol.',
                            'en': 'It is now possible to show fixed objects in the "Quick Response" follow up protocol.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarmen zonder afmelding',
                            'en': 'Alarms without acknowledgements'
                        },
                        subtext: {
                            'nl': 'Voor klanten die gebruik maken van alarmen die niet afgemeld hoeven te worden zijn een aantal verbeteringen doorgevoerd. Het is nu duidelijk zichtbaar dat een alarm automatisch is afgemeld door het systeem.',
                            'en': 'Alarms which do not need acknowledgements do now have an improved alarm overview. It is now clearly visible the alarm has been acknowledged automatically.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'iOS-probleem opgelost',
                            'en': 'iOS specific problem solved'
                        },
                        subtext: {
                            'nl': 'Een probleem waarbij Maps niet wou starten bij het gebruik van Beveiligde Navigatie op iOS is verholpen.',
                            'en': 'We solved a problem where Maps was not opening after using Secure Navigation on iOS devices.'
                        }
                    }
                ]
            },
        ]
    };

    $scope.items['1.3.1'] = {
        beta: false,
        update: false,
        date: '17 september 2018',
        module: [
            {
                name: {
                    'nl': 'Stabiliteitsupdates',
                    'en': 'Stability improvements'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Snelheid systeem',
                            'en': 'Speed of system'
                        },
                        subtext: {
                            'nl': 'Verschillende functies hebben verbeterde snelheden.',
                            'en': 'Various functions now have improved speeds.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Klantnaam zichtbaar voor alarmcentrales',
                            'en': 'Customer name now visible for alarm centers.'
                        },
                        subtext: {
                            'nl': 'Alarmcentrales zien nu vanuit welke klant een melding komt, naast de standaardinformatie over een persoon.',
                            'en': 'Alarm Centers now see information about the customer on top of the asset information already available.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.3.0'] = {
        beta: false,
        update: false,
        date: '21 juni 2018',
        module: [
            {
                name: {
                    'nl': 'Nieuwe cloudomgeving aangesloten',
                    'en': 'Connected new Cloud environment'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Onderhoudsupdate',
                            'en': 'Maintenance update'
                        },
                        subtext: {
                            'nl': 'In deze versie is de Alarm Manager opnieuw geconfigureerd om te werken met de nieuwe cloudomgeving.',
                            'en': 'In this update the Alarm Manager has been updated to work with the new Cloud environment'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.2.0'] = {
        beta: false,
        update: false,
        date: '12 juni 2018',
        module: [
            {
                name: {
                    'nl': 'SMS- en email-voorbeelden',
                    'en': 'SMS and e-mail previews'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Nieuwe functionaliteit',
                            'en': 'New functionality'
                        },
                        subtext: {
                            'nl': 'Het is vanaf vandaag mogelijk om bij het verzenden van een SMS of e-mail naar een persoon in de opvolginslijst deze e-mail eerst te zien en/of aan te passen.',
                            'en': 'It is now possible to preview and/or edit any text messages or e-mails to people in the response follow up list.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.8'] = {
        beta: false,
        update: false,
        date: '1 mei 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Probleem opgelost',
                            'en': 'Resolved minor problem'
                        },
                        subtext: {
                            'nl': 'Probleem opgelost waarbij op iPhones de kaart niet juist opende',
                            'en': 'Resolved problem where the map sometimes did not open'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.6, 1.1.7'] = {
        beta: false,
        update: false,
        date: '10 april 2018',
        module: [
            {
                name: {
                    'nl': 'Wachtwoord Vergeten',
                    'en': 'Password Reset'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Heractivatie functionaliteit',
                            'en': 'Reactivation of functionality'
                        },
                        subtext: {
                            'nl': 'We zijn verheugd te melden dat vanaf heden de Wachtwoord Vergeten-functionaliteit weer naar behoren werkt. ',
                            'en': 'We are happy to announce the Password Reset functionality is now fully workign again.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.4, 1.1.5'] = {
        beta: false,
        update: false,
        date: '29 maart 2018',
        module: [
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Maps'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Inactieve locaties',
                            'en': 'Inactive locations'
                        },
                        subtext: {
                            'nl': 'Locaties die ouder zijn dan 3 uur worden nu grijs weergegeven op de kaart.',
                            'en': 'Locations older than 3 minutes are now shown grey on the map.'
                        }
                    }
                ]        
            },
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Huisnummercheck',
                            'en': 'House number check'
                        },
                        subtext: {
                            'nl': 'Beveiligde Navigatie controleerd nu of u navigeert naar een adres met huisnummer.',
                            'en': 'Secure Navigation now checks if you are navigating to an address with a house number.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Bekende X-Guard locatie',
                            'en': 'Known X-Guard location'
                        },
                        subtext: {
                            'nl': 'Adressen die eerder gebruikt zijn tijdens het gebruik van Beveiligde Navigatie worden nu groen gemarkeerd.',
                            'en': 'Addresses which have been entered before in Secure Navigation are now marked green.'
                        }
                    },
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Betere adresweergave',
                            'en': 'Improved display of addresses'
                        },
                        subtext: {
                            'nl': 'Adressen worden nu inclusief de naam van een gebouw of bedrijf weergegeven, indien deze is ingevoerd.',
                            'en': 'Adresses are now shown including the name of a building or business, when entered.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Verschillende kleine stabiliteitsupdates',
                            'en': 'Various small stability improvements'
                        },
                        subtext: {
                            'nl': 'Er zijn verschillende kleine aanpassingen gedaan om de stabiliteit van Beveiligde Navigatie te verbeteren.',
                            'en': 'We have done various small updates to improve the stability of Secure Navigation.'
                        }
                    }
                ]        
            }
        ]
    };

    $scope.items['1.1.3'] = {
        beta: false,
        update: false,
        date: '1 maart 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Stabiliteit Beveiligde Navigatie',
                            'en': 'Stability of Secure Navigation'
                        },
                        subtext: {
                            'nl': 'Voor de werking van Beveiligde Navigatie maken we gebruik van een API van Google. Helaas is deze vandaag gestopt met werken. Deze update wijzigt de werking van Beveiligde Navigatie zodanig dat we geen gebruik meer maken van deze API.',
                            'en': 'The Secure Navigation functionality uses a Google API to enable searching for addresses. Unfortunately this API stopped working this morning. This updates changes the Secure Navigation functionality so we do not rely on this API.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.1, 1.1.2'] = {
        beta: false,
        update: false,
        date: '22 februari 2018',
        module: [
            {
                name: {
                    'nl': 'Nieuwe stijl',
                    'en': 'New styling'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Uitrol van het nieuwe X-Guard',
                            'en': 'Deployment of the new X-Guard'
                        },
                        subtext: {
                            'nl': 'X-Guard is continu bezig met vernieuwen. Bij een nieuwe website hoort een nieuw logo. Met trots presenteren wij u <a href="https://x-guard.nl" target="_blank">de nieuwe website</a>.',
                            'en': 'X-Guard focuses on continous improvement. With a new website comes a new logo. We proudly present you <a href="https://x-guard.nl" target="_blank">the new X-Guard website</a>'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.1.0'] = {
        beta: false,
        update: false,
        date: '19 februari 2018',
        module: [
            {
                name: {
                    'nl': 'Beveiligde Navigatie',
                    'en': 'Secure Navigation'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Beveiligd Navigeren',
                            'en': 'Secure Navigation'
                        },
                        subtext: {
                            'nl': 'Vanaf heden kunt u via de knop Beveiligde Navigatie uw route naar thuisadressen plannen. Uw eindbestemming wordt opgeslagen als binnenlocatie voor het nauwkeurig vaststellen van uw locatie.',
                            'en': 'You can now start Secure Navigation to navigate to home addresses securely. Your destination will be saved as an indoor position to make sure your location is correct on arrival.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['1.0.0'] = {
        beta: false,
        update: false,
        date: '23 januari 2018',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Notificaties sturen naar Quick Response',
                            'en': 'Send notifications to Quick Response'
                        },
                        subtext: {
                            'nl': 'Tijdens een alarm kan er een notificatie gestuurd worden naar de dichtsbijzijnde Quick Responders.',
                            'en': 'During an alarm, a notification can be sent to the nearest Quick Responders.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Notificatiecentrum',
                    'en': 'Notification center'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Notificaties in de statusbalk',
                            'en': 'Notifications in the status bar'
                        },
                        subtext: {
                            'nl': 'Nieuwe notificatie worden getoond in de statusbalk. Vanaf hier kunnen notificaties bekeken en gewist worden.',
                            'en': 'New notifications will be shown in the status bar. From here notifications can be viewed and deleted.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Zones',
                    'en': 'Zones'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verdieping toevoegen',
                            'en': 'Add floorlevel'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om de verdieping van een zone aan te geven.',
                            'en': 'It is now possible to add the floorlevel of the zone.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Modules die een kaart tonen',
                    'en': 'Modules that show a map'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Zoek een adres op de kaart',
                            'en': 'Search address on the map'
                        },
                        subtext: {
                            'nl': 'Alle modules waar een kaart wordt getoond, bevat nu een zoekknop om snel naar een adres naar keuze te navigeren. De meest recente zoekopdrachten worden opgeslagen zodat deze snel getoond kunnen worden.',
                            'en': 'All modules where a map is shown, now contain a search button to quickly navigate to an address of your choice. The most recent searches are saved so that they can be displayed quickly.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe Response check module',
                    'en': 'New Response check module'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Bekijk de huidige situatie voor uw response',
                            'en': 'View the current situation for your response'
                        },
                        subtext: {
                            'nl': 'Deze module toont u een situatie overzicht van de huidige response om u heen.',
                            'en': 'This module shows you a situation overview of the current response around you.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe tekeningen module',
                    'en': 'New Drawings module'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Toevoegen van tekeningen aan de kaart',
                            'en': 'Adding drawings to the map'
                        },
                        subtext: {
                            'nl': 'Met deze module is het mogelijk om afbeeldingen aan het Alarm Manager kaartsysteem toe te voegen per verdieping. Deze kaarten zijn zichtbaar voor u en de alarmcentrale.',
                            'en': 'With this module you can add image overlays to the Alarm Manager map for multiple levels. These drawings are visibile for u and the monitoring center'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.11'] = {
        beta: false,
        update: false,
        date: '28 november 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Problemen na laatste update',
                            'en': 'Problems after last update'
                        },
                        subtext: {
                            'nl': 'De afgelopen update bracht voor specifieke gebruikers enkele problemen met zich mee. Deze zijn verholpen. Dit is onder andere het tonen van de ingelogde gebruiker in de bovenbalk en het niet kunnen aanpassen van de taal en geluidsnotificatie instellingen.',
                            'en': 'The last update caused some problems for specific users. These have been solved. This includes displaying the logged-in user in the notification bar and not being able to change the language and sound notification settings.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Alarm filters',
                            'en': 'Alarm filters'
                        },
                        subtext: {
                            'nl': 'Filters worden nu correct toegepast als de pagina vernieuwd wordt of wanneer je terugkeert naar de overzichtspagina van de alarmen.',
                            'en': 'Filters are now correctly applied when the page is refreshed or when you return to the overview page of the alarms.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Crash naar inlogscherm',
                            'en': 'Crash to login screen'
                        },
                        subtext: {
                            'nl': 'In uitzonderlijke gevallen kon het voorkomen dat de alarm pagina werd afgesloten en je terug werd gebracht naar de inlogpagina. Dit is verholpen.',
                            'en': 'In exceptional cases it could happen that the alarm page was closed and you were taken back to the login page. This has been solved.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': "Zoeken op pagina's",
                    'en': 'Searching on pages'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Fout in zoekbanner',
                            'en': 'Error in search banner'
                        },
                        subtext: {
                            'nl': 'De gele zoekbanner wordt nu correct bijgewerkt als er vaker achter elkaar gezocht wordt.',
                            'en': 'The yellow search banner is now correctly updated if you do multiple searches.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Personen bewerken',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Niet kunnen openen van persoonlijke contacten',
                            'en': 'Unable to open the personal contacts'
                        },
                        subtext: {
                            'nl': 'Het kwam voor dat een persoonlijk contact soms niet geopend kon worden. Dit is opgelost.',
                            'en': 'It sometimes happened that a personal contact could not be opened. This has been resolved.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Nieuwe personen aanmaken',
                            'en': 'Creating new person'
                        },
                        subtext: {
                            'nl': 'Alle velden zijn nu direct actief als er een nieuw persoon aangemaakt wordt. Voorheen moest dan vaak de persoon eerst opnieuw geladen worden.',
                            'en': 'All fields are now immediately active when a new person is created. Previously, the person often had to be reloaded first.'
                        }
                    }
                ]
            }
        ]
    };


    $scope.items['2017.10'] = {
        beta: false,
        update: false,
        date: '16 november 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager Android',
                    'en': 'Alarm Manager Android'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarm notificaties',
                            'en': 'Alarm notifications'
                        },
                        subtext: {
                            'nl': 'Indien u push notificaties heeft geactiveerd zal tijdens een alarm een popup verschijnen met daarin meer informatie omtrent het alarm.',
                            'en': 'If you have activated push notifications, a pop-up will appear during an alarm with more information about the alarm.'
                        }
                    }
                ]
            }
        ]
    };


    $scope.items['2017.9'] = {
        beta: false,
        update: false,
        date: '25 september 2017',
        module: [
            {
                name: {
                    'nl': 'Verbeterde layout',
                    'en': 'Improved layout'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verbeterde layout safari',
                            'en': 'Improved safari layout'
                        },
                        subtext: {
                            'nl': 'De layout voor de safari browser (Apple) is verbeterd en geoptimaliseerd. Met name de mobiele versie voor iPhones gebruikers.',
                            'en': 'The layout for the safari browser (Apple) has been improved and optimized. Especially the mobile version for iPhone users.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Zone beheer',
                    'en': 'Zone management'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Kaart centreren op locatie',
                            'en': 'Center map on location'
                        },
                        subtext: {
                            'nl': 'De zone bewerk tools geven nu de mogelijkheid om de kaart automatisch op een adres te centreren.',
                            'en': 'The zone editing tools now allow you to automatically center the map on an address.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Filteren op tijdsduur',
                            'en': 'Filter on timespan'
                        },
                        subtext: {
                            'nl': 'In enkele gevallen was het niet mogelijk om op tijdsduur te filteren. Dit is opgelost.',
                            'en': 'In some cases, it was not possible to filter for a certain timespan. This is solved.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Dubbele alarmen',
                            'en': 'Doule alarms'
                        },
                        subtext: {
                            'nl': "Actieve alarmen werden tevens weergegeven onder het kopje 'afgemelde alarmen'. Dit is verholpen.",
                            'en': "Active alarms were also displayed under the heading  'Acknowledged alarms'. This has been fixed."
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Bewerkt personen',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Persoon kopieëren',
                            'en': 'Duplicate person'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om een persoon te kopieëren. Zo kan er eenvoudig een persoon ingericht worden met bijvoorbeeld contacturen en groep instellingen die vervolgens gekopieërd kan worden voor de verder in te richten personen.',
                            'en': 'It is now possible to duplicate a person. For example, a person can easily be configured with, for example, contact hours and group settings that can then be copied for the other persons that need to be added.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Inloggen',
                    'en': 'Logging in'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Inlog token verlopen',
                            'en': 'Login token expired'
                        },
                        subtext: {
                            'nl': 'De functie dat een inlog token kan verlopen is voorlopig uitgeschakeld. Deze toevoeging geeft nog te veel problemen.',
                            'en': 'The function that a login token can expire has been temporarily disabled. This addition still gives too many problems.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Instellingen pagina',
                    'en': 'Settings page'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verbeterde layout',
                            'en': 'Improved layout'
                        },
                        subtext: {
                            'nl': 'De instellingen pagina is nu duidelijker en beter geoptimaliseerd voor mobiele apparaten.',
                            'en': 'The settings page is now more clear and better optimized for mobile devices.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Wat is er nieuw?',
                    'en': "What's new?"
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Nu ook Engels',
                            'en': 'Now including English'
                        },
                        subtext: {
                            'nl': 'Deze lijst met wijzigingen en verbeteringen is nu ook in het Engels beschikbaar',
                            'en': 'This list with additions and improvement is now also available in English.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.8'] = {
        beta: false,
        update: false,
        date: '20 juli 2017',
        module: [{
            name: {
                'en': 'Settings',
                'nl': 'Instellingen'
            },
            fixes: [
                {
                    title: {
                        'en': 'Notification Sounds',
                        'nl': 'Notificatie geluiden'
                    },
                    subtext: {
                        'en': 'The 4 type notification sounds can now be set to the desired settings on the settings page. <strong> Note: These sounds only work in the web application and are not yet available for the Android and iOS apps. </strong>',
                        'nl': 'De 4 type notificatie geluiden kunnen nu naar eigen wens ingesteld worden op de instellingen pagina. <strong>Let op: Deze geluiden werken nu alleen nog in de web applicatie en zijn nog niet beschikbaar voor de Android en iOS apps.</strong>'
                    },
                    icon: "star"
                },
                {
                    icon: 'check',
                    title: {
                        'nl': 'Snooze is verwijderd',
                        'en': 'Snooze is removed'
                    },
                    subtext: {
                        'nl': 'Vanwege onduidelijkheid is de snooze optie weggehaald. In plaats daarvan is het beheren van de afzonderlijke geluiden verbeterd.',
                        'en': 'Due to ambiguity, the snooze option has been removed. Instead, the management of the individual sounds has been improved.'
                    }
                }
            ]
        },
            {
                name: {
                    'nl': 'Bewerk personen',
                    'en': 'Edit persons'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Beschrijving annuleren',
                            'en': 'Cancel the description edit'
                        },
                        subtext: {
                            'nl': 'Indien u een beschrijving hebt bewerkt maar deze toch niet op wilt slaan, bestaat er nu de mogelijkheid de wijzigingen te annuleren.',
                            'en': 'If you have edited a description but do not want to save it, there is now the possibility to cancel the changes.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Map'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'ln': 'Apparaat status en geschiedenis',
                            'en': 'Device status and history'
                        },
                        subtext: {
                            'nl': 'De laatste status en recente geschiedenis van het apparaat kan worden getoond op de kaart onder de persoon. Het hangt af van uw rechten of deze functie zichtbaar is.',
                            'en': 'The latest status and recent history of the device can be displayed on the map below the person. It depends on your rights or this feature is visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Favorieten',
                    'en': 'Favorites'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Favorieten onverwachts geactiveerd',
                            'en': 'Favorites unexpectedly activated'
                        },
                        subtext: {
                            'nl': 'Het kon voorkomen dat de favorieten onverwachts werden geactiveerd. Dit is verholpen.',
                            'en': 'The favorites may be activated unexpectedly. This has been fixed.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Fout in layout',
                            'en': 'Error in layout'
                        },
                        subtext: {
                            'nl': 'Een fout in de layout van het gebeurtenissenlogboek is opgelost.',
                            'en': 'An error in the event log layout has been resolved.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Wereldkaart',
                    'en': 'World map'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Verder inzoomen mogelijk',
                            'en': 'Further zooming possible'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om tot 2x verder in te zoomen op de kaart. Het kan voorkomen dat de kaart onscherper oogt op het diepste zoomniveau. Dit is beschikbaar gemaakt voor alle modules waar een kaart getoond wordt.',
                            'en': 'It is now possible to zoom in to 2x further on the map. The map may appear unsharp at the deepest zoom level. This is made available to all modules where a map is displayed.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.7'] = {
        date: '27 juni 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Alarmen filteren en zoeken',
                            'en': 'Filtering and searching alarms'
                        },
                        subtext: {
                            'nl': 'Het is nu mogelijk om alarmen te filteren en zoeken op bijvoorbeeld naam en binnen een bepaalde periode.',
                            'en': 'It is now possible to filter alarms and search alarms depending on for example the name or within a specified period.'
                        }
                    },
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Tijd van afmelden',
                            'en': 'Time of acknowledgement'
                        },
                        subtext: {
                            'nl': 'De tijd en datum waarop het alarm is afgemeld wordt nu getoond op de alarm pagina.',
                            'en': 'The time and date of the alarm acknowledgement is now displayed on the alarm page.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart',
                    'en': 'Map'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Zoeken op de kaart',
                            'en': 'Searching on the map'
                        },
                        subtext: {
                            'nl': 'Als er gezocht wordt naar bepaalde personen op de kaart, dan zullen nu ook alleen deze personen zichtbaar zijn op de kaart. Voorheen bleven alle personen zichtbaar.',
                            'en': 'When looking for certain people on the map, now only those people will be visible on the map. Previously all persons remained visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Kaart en bewerk personen',
                    'en': 'Map and edit persons'
                },
                fixes: [
                    {
                        icon: 'star',
                        title: {
                            'nl': 'Zoeken op ID',
                            'en': 'Search on ID'
                        },
                        subtext: {
                            'nl': 'Er kan nu ook gezocht worden op het ID en het externe ID van de personen. Dit kan door op het kleine pijltje naast de zoekbalk te klikken.',
                            'en': 'You can now also search for the ID and external ID of the people. This can be done by clicking the small arrow next to the search bar.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Nieuwe binnenposities',
                    'en': 'New indoor positions'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Kaart symbolen',
                            'en': 'Map symbols'
                        },
                        subtext: {
                            'nl': 'De symbolen op de kaart zijn weer hersteld. Door een bug waren deze niet zichtbaar.',
                            'en': 'The symbols on the map are restored. Due to a bug these were not visible.'
                        }
                    }
                ]
            },
            {
                name: {
                    'nl': 'Algemeen',
                    'en': 'Global'
                },
                fixes: [
                    {
                        icon: 'check',
                        title: {
                            'nl': 'Gesplitste notificaties',
                            'en': 'Splitted notifications'
                        },
                        subtext: {
                            'nl': 'De verschillende alarmen worden nu gescheiden in de notificatiebalk getoond (Rood, oranje en groen). Tevens opent de knop direct het alarm als er maar één alarm open staat. Nieuwe binnenposities worden nu blauw weergegeven.',
                            'en': 'The different alarms are now separated in the notification bar (Red, Orange, and Green). The button also opens the alarm immediately when there is only one alarm open. New indoor positions will now appear blue.'
                        }
                    },
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Favorieten',
                            'en': 'Favorites'
                        },
                        subtext: {
                            'nl': 'In bepaalde situaties kon het voorkomen dat de favorieten knop niet naar behoren werkte, dit is opgelost.',
                            'en': 'In certain situations, the favorites button did not work properly, this is resolved.'
                        }
                    }
                ]
            }
        ]
    };

    $scope.items['2017.6'] = {
        date: '23 mei 2017',
        module: [
            {
                name: {
                    'nl': 'Alarm Manager',
                    'en': 'Alarm Manager'
                },
                fixes: [
                    {
                        icon: 'bug',
                        title: {
                            'nl': 'Alarm kan niet geopend worden',
                            'en': 'Alarm cannot be opened'
                        },
                        subtext: {
                            'nl': 'In bepaalde situaties ontstond de fout dat het alarm niet geopend kon worden. Er werd alleen een grijs scherm getoond. Dit is nu verholpen.',
                            'en': 'In some situations, the error occurred that the alarm could not be opened. Only a gray screen was shown. This is now fixed.'
                        }
                    }
                ]
            }
        ]
    };

    // $scope.items = [
    //
    //     {
    //         date: '23 mei 2017',
    //         version: '2017.6',
    //         module: [
    //             {
    //                 name: 'Alarm Manager',
    //                 fixes: [
    //                     {
    //                         icon: 'bug',
    //                         title: 'Alarm kan niet geopend worden',
    //                         subtext: 'In bepaalde situaties ontstond de fout dat het alarm niet geopend kon worden. Er werd alleen een grijs scherm getoond. Dit is nu verholpen.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '10 mei 2017',
    //         version: '2017.5',
    //         module: [
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Contacten toevoegen',
    //                         subtext: 'Persoonlijke contacten kunnen nu toegevoegd en bewerkt worden. Ook kan de prioriteit aangepast worden.'
    //                     },
    //                     {
    //                         icon: 'star',
    //                         title: 'Groep(en) koppelen',
    //                         subtext: 'Vanuit de Alarm Manager kan er nu een groep of meerdere groepen aan een persoon gekoppeld worden.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Alarm Manager en Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Overlappende personen',
    //                         subtext: 'Als er op de overlappende personen op de kaart geklikt wordt, zullen deze uitwaaien in een spiraal.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: '<strong>Nieuwe module:</strong> Contactenlijsten beheren',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Contactenlijst aanmaken en beheren',
    //                         subtext: 'In deze nieuwe module kunnen contactenlijsten gemaakt en beheerd worden. Deze kunnen vervolgens gekoppeld worden aan een groep in de nieuwe groepen module.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: '<strong>Nieuwe module:</strong> Groepen beheren',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Groepen aanmaken en beheren',
    //                         subtext: 'In deze nieuwe module kunnen groepen gemaakt en beheerd worden. Personen kunnen snel toegevoegd of verwijderd worden en een contactenlijst kan gekoppeld worden.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '6 april 2017',
    //         version: '2017.4',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Een persoon zichtbaar',
    //                         subtext: 'Als er maar één persoon zichtbaar is, zullen enkele overbodige knoppen verdwijnen.'
    //                     },
    //                     {
    //                         icon: 'bug',
    //                         title: 'Automatische update',
    //                         subtext: 'Als een persoon op de kaart geupdate wordt zal alle nodige informatie bijgewerkt worden. Voorheen was dit alleen de positie van de persoon.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Personen toevoegen',
    //                         subtext: 'Er kunnen nu, indien u deze rechten heeft, nieuwe personen toegevoegd worden vanuit de app.'
    //                     },
    //                     {
    //                         icon: 'check',
    //                         title: 'Telefoonnummers bewerken',
    //                         subtext: 'Bij het bewerken van telefoonnummers moet nu een landcode geselecteerd worden om fouten te voorkomen.'
    //                     },
    //                     {
    //                         icon: 'check',
    //                         title: 'Kiezen van type en toestel',
    //                         subtext: 'Indien u hier toegang tot hebt, is het kiezen van een type en een toestel nu duidelijker.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '15 maart 2017',
    //         version: '2017.3',
    //         module: [
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Beschrijving',
    //                         subtext: 'Het is nu mogelijk een beschrijving aan een persoon toe te voegen. Deze beschrijving zal zichtbaar zijn tijdens een alarm.'
    //                     },
    //                     {
    //                         icon: '',
    //                         title: 'Extern ID',
    //                         subtext: 'Het externe ID van een persoon wordt nu, indien beschikbaar, onder de naam getoond.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Alarm Manager',
    //                 fixes: [
    //                     {
    //                         icon: 'check',
    //                         title: 'Snellere laadtijden',
    //                         subtext: 'Het openen van een alarm zal nu aanzienlijk sneller gaan.'
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Wat is er nieuw?',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: "'Wat is er nieuw?' pagina",
    //                         subtext: "De 'Wat is er nieuw?' pagina is toegevoegd aan de X-Guard Alarm Manager. Deze pagina laat alle recente wijzigingen zien omtrent de verschillende pagina's."
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '17 februari 2017',
    //         version: '2017.2',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'bug',
    //                         title: 'Juiste kleurcodering',
    //                         subtext: 'De positietijden geven nu de juiste kleurcodering weer.'
    //                     }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         date: '31 januari 2017',
    //         version: '2017.1',
    //         module: [
    //             {
    //                 name: 'Kaart',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Download alles',
    //                         subtext: "Een 'download alles' knop is toegoevoegd om alle resterende items in één keer te downloaden."
    //                     }
    //                 ]
    //             },
    //             {
    //                 name: 'Bewerk personen',
    //                 fixes: [
    //                     {
    //                         icon: 'star',
    //                         title: 'Download alles',
    //                         subtext: "Een 'download alles' knop is toegoevoegd om alle resterende items in één keer te downloaden."
    //                     }
    //                 ]
    //             }
    //         ]
    //     }
    // ]

});


angular.module("stwo.alarm-screen-xguard", ["stwo.core", "ui.bootstrap.datetimepicker"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider) {

  moduleStoreProvider.registerModule({
    name: "alarm-screen-xguard",
    links: [{
        name: "XGUARD_ALARMMANAGER_TITLE",
        category: "navigation",
        icon: "alert",
        sref: "secure.content.alarm-screen-xguard",
        categoryDependency: "ALARMS",
        sort: 5,
        color: "info",
        controllers: ["AlarmScreenXGuardController"]
      }, {
        name: "XGUARD_ALARMMANAGER_TITLE",
        category: "ALARMS",
        sref: "secure.content.alarm-screen-xguard",
        access: ["alarm", "get"],
        icon: "alert",
        controllers: "AlarmScreenXGuardController",
        color: "danger",
        sort: 5
      }
      /*, {
       name: "ALARMS_UNACK",
       category: "ALARMS",
       sref: "secure.content.alarm-screen-xguard({filter: 'unacked'})",
       access: ["alarm", "get"],
       stateParams: {
       filter: 'unacked'
       },
       color: "danger",
       icon: "alert",
       sort: 20
       }*/
    ]
  });

  $stateProvider.state("secure.content.alarm-screen-xguard", {
    url: "/alarm-manager/:filter",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard.html",
    controller: "AlarmScreenXGuardController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"


  }).state("secure.content.alarm-screen-xguard-detail", {
    url: "/alarm-manager-detail/:id",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-detail.html",
    controller: "AlarmScreenXGuardDetailController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"

  }).state("secure.content.alarm-screen-xguard-asset", {
    url: "/alarm-manager-asset/:assetID",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-asset.html",
    controller: "AlarmScreenXGuardAssetController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  }).state("secure.content.alarm-screen-xguard-externalid", {
    url: "/alarm-manager-extern/:externalId",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-externalid.html",
    controller: "AlarmScreenXGuardExternalIdController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  }).state("secure.content.alarm-screen-xguard-alert", {
    url: "/alarm-manager-alert/:assetID",
    templateUrl: "modules/alarm-screen-xguard/alarm-screen-xguard-alert.html",
    controller: "AlarmScreenXGuardAlertController",
    titleName: 'XGUARD_ALARMMANAGER_TITLE',
    titleIcon: "alert"
  });

  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "name",
    label: "ALARMS_FILTER_NAME",
    type: "string",
    field: "name",
    comparator: "contains"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "asset",
    label: "ALARMS_FILTER_ASSET",
    type: "string",
    field: "asset.name",
    comparator: "contains"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "ack_needed",
    label: "ALARMS_FILTER_ACK_NEEDED",
    comparator: "equals",
    type: "list",
    list: [{
      label: "-",
      value: ""
    }, {
      label: "ALARMS_FILTER_ACK_NEEDED_TRUE",
      value: "true"
    }, {
      label: "ALARMS_FILTER_ACK_NEEDED_FALSE",
      value: "false"
    }],
    field: "ackNeeded"
  });
  moduleStoreProvider.addPossibleFilter("alarm", {
    id: "acked_by",
    label: "ALARMS_FILTER_ACKED",
    comparator: "null",
    type: "list",
    list: [{
      label: "-",
      value: ""
    }, {
      label: "ALARMS_FILTER_ACKED_FALSE",
      value: "false"
    }, {
      label: "ALARMS_FILTER_ACKED_TRUE",
      value: "true"
    }],
    field: "ackedBy"
  });


}).filter('commentsWithLabelKey', function () {
  return function (arr, key) {
    var out = [];
    if (arr) {
      angular.forEach(arr, function (comment) {
        if (comment.labels && comment.labels[key]) {
          out.push(comment);
        }
      });
      return out;
    }
  }
}).filter('contactWithUserId', function () {
  return function (arr, id) {
    angular.forEach(arr, function (contact) {
      if (contact.connectedTo) {
        angular.forEach(contact.connectedTo, function (conn) {
          if (conn.type == "user" && conn.to.id == id) {
            return contact;
          }
        });
      }
    });
    return false;
  }
});; // End Module definition

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardController', function ($scope, $controller, $state, $modal, smarttrackerService, notificationService, $interval, pushService, $filter) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  //$scope.addPredefinedFilter("unacknowledged", [{
  //    filterId: "ack_needed",
  //    label: "ALARMS_FILTER_ACK_NEEDED",
  //    value: "true"
  //}, {
  //    filterId: "acked_by",
  //    label: "ALARMS_FILTER_ACKED",
  //    value: "true"
  //}], "&ackNeeded:equals=true&ackedBy:null=true");

  $scope.super({
    clazz: 'alarm',
    downloadUrl: '/alarm?select=asset.owner+dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=dateCreated&order=desc&active:false=true'

  });

  /**FILTERS*/
  var acfKey = "AlarmCenterFilter";

  $scope.endDateBeforeRender = endDateBeforeRender
  $scope.endDateOnSetTime = endDateOnSetTime
  $scope.startDateBeforeRender = startDateBeforeRender
  $scope.startDateOnSetTime = startDateOnSetTime
  var map = false;

  function startDateOnSetTime() {
    $scope.$broadcast('start-date-changed');
  }

  function endDateOnSetTime() {
    $scope.$broadcast('end-date-changed');
  }

  function startDateBeforeRender($dates) {
    if ($scope.filters.dateRange.end) {
      var activeDate = moment($scope.filters.dateRange.end);

      $dates.filter(function (date) {
        return date.localDateValue() >= activeDate.valueOf()
      }).forEach(function (date) {
        date.selectable = false;
      });
      $scope.applyFilter();
    }
  }

  function endDateBeforeRender($view, $dates) {
    if ($scope.filters.dateRange.start) {
      var ts = moment($scope.filters.dateRange.start).format("YYYY-MM-DDThh:mm:ss.SSS");
      console.log(ts);
      var activeDate = moment($scope.filters.dateRange.start).subtract(1, $view).add(1, 'minute');

      $dates.filter(function (date) {
        return date.localDateValue() <= activeDate.valueOf()
      }).forEach(function (date) {
        date.selectable = false;
      });
      $scope.applyFilter();
    }
  }

  $scope.clearFilters = function (refresh) {
    $scope.filters = {
      'externalId': {
        'value': '',
        'list': []
      },
      'triggeringAsset': {
        'value': '',
        'list': []
      },
      'logLevel': {
        'list': {
          'RED_ALERT': {
            selected: true
          },
          "WARNING": {
            selected: true
          },
          "NOTIFICATION": {
            selected: true
          }
        },
        'allSelected': true
      },
      'resolution': {
        'acked': true,
        'active': true
      },
      'dateRange': {
        'start': '',
        'end': ''
      }
    }
    if (refresh) {
      $scope.filterUrlString = '';
      $scope.applyFilter();
    }
  }
  $scope.clearFilters(false);

  $scope.changeAlarmTypeFilter = function (val) {
    $scope.filters.logLevel.value = val;
    $scope.applyFilter();
  }
  $scope.addExternalIdFilter = function ($event) {
    if ($event && ($event.which || $event.keyCode) && ($event.which != 13 && $event.keyCode != 13)) {
      return;
    }
    var o = $scope.filters.externalId;
    if (o.value != '' && o.list.indexOf(o.value) < 0) {
      o.list.push(o.value);
    }
    o.value = '';
    $scope.applyFilter();
  }

  $scope.addTriggeringAsset = function ($event) {
    if ($event && ($event.which || $event.keyCode) && ($event.which != 13 && $event.keyCode != 13)) {
      return;
    }
    var o = $scope.filters.triggeringAsset;
    if (o.value != '' && o.list.indexOf(o.value) < 0) {
      o.list.push(o.value);
    }
    o.value = '';
    $scope.applyFilter();
  }

  $scope.removeFilter = function (field, value) {
    switch (field) {
    case 'externalId':
    case 'triggeringAsset':
      $scope.filters[field].list.splice($scope.filters[field].list.indexOf(value), 1);
      $scope.applyFilter();
      break;
    case 'logLevel':
      angular.forEach($scope.filters.logLevel.list, function (value, key) {
        value.selected = true;
      });
      $scope.filters.logLevel.allSelected = true;
      $scope.applyFilter();
      break;
    case 'dateRange':
      $scope.filters[field][value] = '';
      $scope.applyFilter();
      break;
    }
  }

  $scope.applyFilter = function () {
    var filterString = "";
    angular.forEach($scope.filters.externalId.list, function (value) {
      filterString += "&asset.externalId:equals=" + value;
    });
    angular.forEach($scope.filters.triggeringAsset.list, function (value) {
      filterString += "&asset.name:contains=" + value;
    });
    var o = $scope.filters.logLevel.list;
    var llFilters = (o.RED_ALERT.selected ? '1' : '0') + (o.WARNING.selected ? '1' : '0') + (o.NOTIFICATION.selected ? '1' : '0');
    switch (llFilters) {
    case '111':
      break;
    case '110':
      filterString += "&logLevel:greater=-10";
      break;
    case '101':
      filterString += "&logLevel:equals=0&logLevel:equals=-15&logLevel:equals=-20";
      break;
    case '100':
      filterString += "&logLevel:equals=0";
      break;
    case '011':
      filterString += "&logLevel:less=0";
      break;
    case '001':
      filterString += "&logLevel:less=-9";
      break;
    case '010':
      filterString += "&logLevel:less=0&logLevel:greater=-10";
      break;
    }
    $scope.filters.logLevel.allSelected = (o.RED_ALERT.selected && o.WARNING.selected && o.NOTIFICATION.selected);
    // if(!(o.RED_ALERT.selected&&o.WARNING.selected&&o.NOTIFICATION.selected)) {
    //     angular.forEach(o, function (value, key){
    //         if(value.selected) {
    //             filterString += value.value;
    //         }
    //     });
    // }

    if ($scope.filters.dateRange.end != '') {
      filterString += "&dateCreated:less=" + moment($scope.filters.dateRange.end).utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    }
    if ($scope.filters.dateRange.start != '') {
      filterString += "&dateCreated:greater=" + moment($scope.filters.dateRange.start).utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    }

    // if(!($scope.filters.resolution.active&&$scope.filters.resolution.acked)) {
    //     filterString += "&ackedBy:null=" + ($scope.filters.resolution.active?'true':'false');
    // }

    console.log($scope.filters);
    downloadActiveAlarms(filterString);
    $scope.filterUrlString = filterString;
    if (filterString == "") {
      $scope.refresh();
    }
    // store filter
    localStorage[acfKey] = JSON.stringify($scope.filters);


  }

  var performUpdate = false;
  $scope.$watch("downloadProgress.active", function () {
    if (performUpdate && $scope.downloadProgress.active == false) {
      $scope.refresh();
      performUpdate = false;
    }
  });
  /**END Filters*/
  var ninit = 0;
  $scope.$watch("(notifications | notificationFromModule : 'alarm').length", function (val, val2) {
    console.log("Notification changed", val, val2, ninit);

    if (ninit++ > 2) { // initially it will be undefined and length,0. Ignore these.
      console.log("Notification triggered");
      $scope.applyFilter();
      //     console.log("Notification triggered");
      // var filterString = $scope.filterUrlString + ($scope.activeAlarms&&$scope.activeAlarms.length>0?'&dateCreated:less=' + $scope.activeAlarms[0].dateCreated:'');
      // var downloadUrl = '/alarm?select=dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc&ackedBy:null=true&&ackNeeded:equals=true' + (filterString?filterString:'');
      //     smarttrackerService.authGet(smarttrackerService.getCustomerId() + downloadUrl).then(function (response){
      //         for(var i = response.data.result.length-1;i >=0;i--) {
      //             $scope.activeAlarms.unshift(response.data.result[i]);
      //         }
      //         $scope.nbrActiveAlarms = $scope.activeAlarms.length;
      //     });
    }
  })
  //     $scope.pushChanged = pushService.changed();
  //     $scope.$watch("pushChanged.counter", function () {
  //         console.log("Push triggered");
  //         pushService.process(function (data, util) {
  //             console.log("Push message", data, util);
  //             if (data.type === "alarm") {
  //                 //$scope.items.unshift(data);
  //                 // smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm?select=dateCreated+lastUpdated+rule+logLevel+name+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=lastUpdated&order=desc&ackedBy:null=true').then(function (response) {
  //                 //     for (var i in response.data.result) {
  //                 //         var alarm = response.data.result[i];
  //                 //         var list = alarm.ackNeeded?$scope.activeAlarms:$scope.items;
  //                 //         var found = false;
  //                 //         angular.forEach(list, function (val, key){
  //                 //             if(val.id == alarm.id) found = true;
  //                 //         })
  //                 //         if(found)break;
  //                 //         list.unshift(alarm);
  //                 //         if(alarm.ackNeeded)$scope.nbrActiveAlarms++;
  //                 //     }
  //                 // });
  // $scope.refresh();
  //             }
  //         });
  //     });

  $scope.nbrActiveAlarms = 0;
  $scope.nbrAckedAlarms = 0;

  $scope.toggleFilters = function (scroll) {
    if ($scope.filterExpanded) {
      $scope.filterExpanded = false;
      TweenLite.set("#filters", {
        overflow: "hidden"
      });
      TweenLite.to("#filters", 0.5, {
        height: "45px",
        ease: "Quart.easeInOut"
      });
      TweenLite.set("#filters", {
        overflow: "hidden",
        delay: 0.5
      });
      if (scroll) {
        TweenLite.to("#view", 0.5, {
          scrollTo: "#scrollAnchor",
          ease: "Quart.easeInOut"
        });
      }
    } else {
      $scope.filterExpanded = true;
      TweenLite.set("#filters", {
        height: "auto"
      });
      TweenLite.from("#filters", 0.5, {
        height: "45px",
        ease: "Quart.easeInOut"
      });
      TweenLite.set("#filters", {
        overflow: "visible",
        delay: 0.5
      });
    }
  };

  $scope.showFilters = function () {
    if ($(window).width() > 768) {
      $scope.filterExpanded = true;
      TweenLite.set("#filters", {
        height: "auto",
        overflow: "visible"
      });
    }
  };

  $(window).width(function () {
    $scope.showFilters();
  });

  $(window).resize(function () {
    $scope.showFilters();
  });

  $scope.$watch("itemsChanged", function () {
    if ($scope.itemsChanged > 0) {
      $scope.nbrAckedAlarms = 0;
    }
  });

  $scope.activeAlarms = [];
  $scope.downloadActiveInProgress = true;

  function downloadActiveAlarms(filterString, offset) {
    if (!offset) offset = 0;
    if (offset == 0) {
      $scope.activeAlarms = [];
      $scope.nbrActiveAlarms = 0;
      $scope.downloadActiveInProgress = true;
    }
    var downloadUrl = '/alarm?select=asset.owner+dateCreated+lastUpdated+positionProvider+rule+logLevel+name+zone+asset.name+asset.image+asset.properties+asset.tags+ackedBy+ackNeeded+comment&sort=dateCreated&order=desc&ackedBy:null=true&&ackNeeded:equals=true&offset=' + offset + "" + (filterString ? filterString : '');
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + downloadUrl).then(function (response) {
      $scope.activeAlarms = $scope.activeAlarms.concat(response.data.result);
      $scope.nbrActiveAlarms = response.data.total;
      if (response.data.max + offset < response.data.total) {
        downloadActiveAlarms(filterString, offset + response.data.max);
      } else {
        $scope.downloadActiveInProgress = false
      }
    });
  }

  smarttrackerService.isLoggedInDelayed().then(function () {
    if (localStorage.getItem(acfKey)) {
      try {
        $scope.filters = JSON.parse(localStorage.getItem(acfKey));
      } catch (error) {
        console.error("error when parsing stored filter. ", error);
        $scope.clearFilters(false);
      }
    } else {
      $scope.clearFilters(false);
    }
    //downloadActiveAlarms();
    $scope.applyFilter();
    performUpdate = $scope.downloadProgress.active && $scope.filterUrlString != "";

    notificationService.poll();
  });

  $scope.alarmClicked = function (alarm) {
    $state.go("secure.content.alarm-screen-xguard-detail", {
      id: alarm.id
    });
  }
}); // End Module alarm-screen

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardDetailController', function ($http, $scope, deploymentApiService, $controller, $stateParams, $translate, socketioService, $timeout, $state, timerService, $modal, smarttrackerService, mapService, leafletData, notificationService, contentCacheService, $location, dialogService, $filter, utilService, $window) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  var PageOpenedDate = new Date().toISOString();
  var debugMode = false;

  var translations = [];
  $scope.responseAreas = [];

  $scope.handleCameraClick = function ($event, url) {

    if (url && url.indexOf('localhost:10283') !== -1) {

      // stop
      $event.stopPropagation();
      $event.preventDefault();

      // call xhr instead
      $http.get(url).then(function (result) {



      });

    }

  }

 // $translate('XGUARD_ASSETS_NAV', null, null, "nl", "nl").then(function (data){
  //     alert(data);
  // })

  $scope.commentTemplateList = [];
  $translate(["COMMENT_TEMPLATE_NO_VOICE_INITIATED",
      "COMMENT_TEMPLATE_NO_VOICE_AUDIO",
      "COMMENT_TEMPLATE_NO_VOICE_RESPONSE",
      "COMMENT_TEMPLATE_NO_VOICE_ONE_WAY",
      "COMMENT_TEMPLATE_VOICE_CORRECT",
      "COMMENT_TEMPLATE_OUTGOING_CALL_INITIATED",
      "COMMENT_TEMPLATE_OUTGOING_CALL_BUSY",
      "COMMENT_TEMPLATE_OUTGOING_CALL_VOICEMAIL",
      "COMMENT_TEMPLATE_OUTGOING_CALL_NO_VOICEMAIL",
      "COMMENT_TEMPLATE_RESPONDER_NOT_AVAILABLE",
      "COMMENT_TEMPLATE_OUTCOME_ALL_OK",
      "COMMENT_TEMPLATE_OUTCOME_EMERGENCY",
      "COMMENT_TEMPLATE_OUTCOME_TEST_OK",
      "COMMENT_TEMPLATE_OUTCOME_TEST_NOK",
      "COMMENT_TEMPLATE_RESPONSE_ONSITE_SECURITY",
      "COMMENT_TEMPLATE_RESPONSE_PRIVATE_SECURITY",
      "COMMENT_TEMPLATE_POLICE_NEEDED",
      "COMMENT_TEMPLATE_POLICE_SENT",
      "COMMENT_TEMPLATE_UNIT_EXTPOWER",
      "COMMENT_TEMPLATE_RESPONSE_IN_ACTION",
      "COMMENT_TEMPLATE_DUPLICATE",
      "COMMENT_TEMPLATE_OUTGOING_CALL_NO_AUDIO",
    ])
    .then(function (data) {

      angular.forEach(data, function (value, key) {

        $scope.commentTemplateList.push({
          "text": value
        })

      });

      $scope.commentTemplateList.sort(function (a, b) {

        if (a.text < b.text) {

          return -1;

        } else
        if (a.text > b.text) {

          return 1;

        }

        return 0;

      });


    })


  $scope.openDialog = "";
  $scope.openToggle = function (toggle) {
    $scope.openDialog = toggle;
  }

  $scope.closeToggle = function ($event) {
    var cl = $event.target.classList;
    if ($event.target.id != $scope.openDialog && !cl.contains("dropdownItem")) {
      $scope.openDialog = "";
    }
  };

  $scope.modes = {
    isDoubt: true
  }

  var codes = {
    customer: 0, // Customer, subject of the alarm
    qr: 1, // Quick Response
    ra: 4, // Response Area
    nqr: 3, // National Quick Response
    pc: 2, // Personal Contacts
    pd: 6, // Police Department
    bz: 5 // Backup zone
  };

  $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE", "XGUARD_TIMESTAMP_TODAY", "ALARM_MANAGER_NOTIFICATION_MESSAGE",
      "ALARM_MANAGER_NOTIFICATION_SUBJECT"
    ])
    .then(function (data) {
      $scope.translations = {
        hour: data['XGUARD_HOUR'],
        hours: data['XGUARD_HOURS'],
        minute: data['XGUARD_MINUTE'],
        minutes: data['XGUARD_MINUTES'],
        timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE'],
        today: data['XGUARD_TIMESTAMP_TODAY'],
        notificationMessage: data['ALARM_MANAGER_NOTIFICATION_MESSAGE'],
        notificationSubject: data['ALARM_MANAGER_NOTIFICATION_SUBJECT']
      };
    });



  var alarmID = $stateParams.id ? $stateParams.id : "67645959";
  var securityGuardID = "67566425";
  var employeeID = "67566364";



  var syntax = {
    ZMTag: "ACR_ZM",
    QRTag: "ACR_QR",
    NQRTag: "ACR_NQR",
    PDTag: "ACR_PD",
    BZTag: "ACR_BZ",
    RATag: "ACR_RA",
    CLTag: "ACR_CL",
    ContactTag: "ACR_CONTACT",
    email: "email",
    phone: "phone",
    sms: "sms",
    allowContact: "allowContact",
    allowContactNQR: "allowContactNQR",
    allowEmergencyContact: "allowEmergencyContact",
    allowNQR: "allowNQR",
    updateIntervalSeconds: "sixty"
  };


  $scope.$watch("timers.five", function () {
    if ($scope.alarm) {
      $scope.refreshEvents(0);
    }
  });

  $scope.timers = timerService.timers();
  $scope.$watch("timers.sixty", function () {
    if ($scope.alarm) {
      getTimeString();
    }
  });
  var killAlarmUpdater = $scope.$watch("timers." + syntax.updateIntervalSeconds, function () {
    if ($scope.alarm && ($scope.alarm.asset || $scope.alarm.zone)) {

      //var object = $scope.alarm.asset?'asset':'zone';
      downloadContacts($scope.alarm.asset ? $scope.alarm.asset : $scope.alarm.zone);

      smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id + "?select=meta+ackedBy", {
        onErrorDoNotRedirect: true
      }).then(function (response) {
        if (response.data.result != undefined) {
          var alarm = response.data.result[0];
          console.log("killAlarmUpdater > Succesfull")
        } else {
          //alert("Error: No response data available");
          console.log("killAlarmUpdater > FAILED");
        }

        if (alarm.meta && alarm.meta.actionStatus) {
          $scope.actionStatus = alarm.meta.actionStatus;
        }
        if (alarm.ackedBy)
          $scope.downloadAlarm();

      });

      $scope.refreshEvents(0);

    }
  });


  $scope.mapViewAltered = false;
  $scope.selectedMarker = '';
  $scope.selectedMarkerName = "";
  $scope.markers = {};
  $scope.mapSidebar = {
    'visible': false
  };
  $scope.indoorViewer = {
    location: null,
    markers: {},
    changeCounter: 0
  };
  mapService.basicMapDesign($scope, leafletData, "amMap");

  var updateBZVisibility = function () {
    var nbrOfContacts = 0;
    var allElseFailed = true;
    var totalNbrOfContacts = 0;
    for (var i in $scope.responseAreas) {
      var ra = $scope.responseAreas[i];
      if (ra.visible && ra.code != codes.bz && ra.code != codes.pd) {
        if (allElseFailed) {
          for (var i in ra.contacts) {
            var c = ra.contacts[i];
            var key = getActionStatusKey(c);
            if (!$scope.actionStatus.hasOwnProperty(key) || $scope.getActionStatus(c)) {
              allElseFailed = false;
            }
          }
        }
        if (ra.code != codes.pd && ra.code != codes.customer) {
          nbrOfContacts += ra.contacts.length;
        }
      }
    }

    updateRAPropertyForCode(codes.bz, "visible", nbrOfContacts == 0 || allElseFailed);
  }

  var clipboard = new Clipboard('.clipBtn');
  clipboard.on('success', function (e) {
    console.log(e);
  });
  clipboard.on('error', function (e) {
    console.log(e);
  });


  $scope.order = 0;
  $scope.actionStatus = {};
  $scope.setOrder = function (order) {
    $scope.responseAreas.sort(function (a, b) {
      if (order == 1 && b.code == codes.pc) return -1; // Exception for personal Contacts. They should not be reversed in order, but remain on the end. Maybe not the best solution. 
      if (a.code == b.code) {
        return a.priority - b.priority;
      }
      return (order == 0) ? a.code - b.code : b.code - a.code;
    });
    $scope.order = order;
  }

  $scope.isAlarmCenter = false;

  $scope.downloadAlarm = function () {

    return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/alarm/' + alarmID + '?select=@', {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (!response) return;
      $scope.alarm = response.data.result[0];
      $scope.isAlarmCenter = $scope.alarm.alarmCenter && $scope.alarm.alarmCenter.id == smarttrackerService.getCustomerId();
      if ($scope.alarm) {
        contentCacheService.put("alarm", $scope.alarm.id, $scope.alarm);
        currentAlarm();
      }
      console.log("downloading alarm ALARM ALARM !!", $scope.alarm);
      if (!$scope.alarm) return;

      if ($scope.alarm.meta.commentsMeta) {
        $scope.commentsMeta = $scope.alarm.meta.commentsMeta;
      }
      console.log("Lets check meta", $scope.alarm.meta);
      if ($scope.alarm.meta[notificationStatusKey]) {
        $scope.notificationStatus = $scope.alarm.meta[notificationStatusKey];
      }
      if ($scope.alarm.meta.order) {
        $scope.order = $scope.alarm.meta.order;
      }
      $scope.actionStatus = $scope.alarm.meta.actionStatus ? $scope.alarm.meta.actionStatus : {};
      getTimeString();

      if ($scope.alarm.ackedBy != null) { // Stop updating. Everything we need is persisted with the alarm on the meta JSON object. 
        var meta = $scope.alarm.meta;
        if (meta.responseAreas)
          $scope.responseAreas = meta.responseAreas;
        if (meta.comments) {
          $scope.events = meta.comments;
          for (var i in $scope.events) {
            var dd = moment.tz($scope.events[i].dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC");
            if (new Date() - dd.toDate() < 43200000)
              $scope.events[i].dateCreatedFormatted = $scope.translations.today + ", " + $filter("amDateFormat")($scope.events[i].dateCreated, 'HH:mm:ss');
            else
              $scope.events[i].dateCreatedFormatted = $filter("amDateFormat")($scope.events[i].dateCreated, 'YYYY-DD-MM, HH:mm:ss');
          }
        } else {
          $scope.events = [];
        }
        // update map
        if (meta.asset) {
          $scope.alarm.asset = meta.asset;
        } else if (meta.zone) {
          $scope.alarm.zone = meta.zone;
        }

        addCustomerMarker($scope.alarm.asset);
        addAlarmMarker($scope.alarm);
        renderLineBetween();

        if (typeof $scope.alarm.comment === 'string') {
          $scope.alarm.comment = $scope.alarm.comment.replace(/\*\*([\s\S]+?)\*\*/gm, '<strong>$1</strong>');
        }

        for (var i in $scope.responseAreas) {
          var ra = $scope.responseAreas[i];
          if (ra.code == codes.qr || ra.code == codes.nqr) {
            for (var x in ra.contacts) {
              var contact = ra.contacts[x];
              if (ra.code == codes.nqr) {
                addNQRMarker(contact);
              } else {
                addQRMarker(contact);
              }
            }
          }
        }

        $scope.chat = [];
        setupChat();

        if (killAlarmUpdater)
          killAlarmUpdater();

        $scope.initMap();
        $scope.ackedTS = utilService.getFormattedDateFromTimestamp($scope.alarm.lastUpdated);
        return;
      }

      var asset = $scope.alarm.asset;

      setupConferenceCalls($scope.alarm);

      $scope.chat = [];
      setupChat();

      if (asset /* && $scope.alarm.position /*&& asset.type && asset.type.id==employeeID*/ ) {

        addCustomerMarker($scope.alarm.asset);
        addAlarmMarker($scope.alarm);

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $scope.alarm.asset.id + '?select=@&crossAccount=true', {
          onErrorDoNotRedirect: true
        }).then(function (resp) {
          if (resp.data.result.length == 0) return;
          $scope.alarm.asset = resp.data.result[0];
          var asset = $scope.alarm.asset;
          var nqrEnabled = $scope.getPropertyValue(asset, syntax.allowNQR);

          getAssetContactList();

          $scope.contactInfo = {
            "id": asset.id,
            "name": asset.name,
            "image": asset.image,
            "phone": $scope.getPropertyValue(asset, syntax.phone),
            "phoneFormatted": $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone)),
            "sms": $scope.getPropertyValue(asset, syntax.sms),
            "email": $scope.getPropertyValue(asset, syntax.email),
            "allowEmergencyContact": $scope.getPropertyValue(asset, syntax.allowEmergencyContact),
            "nqrEnabled": nqrEnabled && nqrEnabled == "true"
          }

          addContactsForCode([$scope.contactInfo], codes.customer);
          getResponseAreaForCode(codes.nqr).visible = $scope.contactInfo.nqrEnabled;

          if ($scope.contactInfo.allowEmergencyContact == "false") {
            updateRAPropertyForCode(codes.customer, "visible", false);
          }
          downloadZones(asset.insideZones);
          downloadContacts(asset);
        })

        renderLineBetween();
        //$scope.updateMarkers(true);
        $timeout(function () {
          $scope.initMap();
        }, 300);
      } else if ($scope.alarm.zone) {
        var zone = $scope.alarm.zone;
        //addAlarmMarker($scope.alarm);
        // TODO Add marker to the center of the zone

        // Set Contact Info?
        addMarker(zone, "glyphicon glyphicon-map-marker", "#FF0000", "Current Position", true, codes.customer);

        for (var i in zone.labels) {
          var label = zone.labels[i];
          if (label.code == syntax.ZMTag) {
            try {
              var json = JSON.parse(label.value);
              $scope.contactInfo = {
                "nqrEnabled": (json.showNQR && json.showNQR == true)
              }
            } catch (e) {
              console.error(e);
            }
          }
        }


        $scope.contactInfo = {
          'name': $scope.alarm.zone.name
        };
        downloadZonesForZone(zone);
        downloadContacts(zone);
        $scope.initMap();

      } else {
        normalMode();
      }
      $scope.refreshEvents(0);

    }, function (response) {
      alert("Something went very wrong on this one, GEt alarm");
    });
  } // End Download Alarm

  $scope.contactStatus = 0;
  var mapInitiated = false;
  var maximumDistances = {
    'total': 0
  };

  function uniq_fast(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
      var item = a[i]
      if (seen[item.id] !== 1) {
        seen[item.id] = 1;
        out[j++] = item;
      }
    }
    return out;
  }

  var conferenceParseParticipants = function(alarm, rawParticipants) {

    // filter participants
    var participants = [];
    $scope.alarmAssetConnected = false;
    $scope.alarmAssetConnectedStartTime = null;
    $scope.conferenceOthersConnected = false;
    $scope.conferenceSelfConnected = false;
    $scope.mutedHintClicked = false;
    if(typeof rawParticipants !== 'undefined'){

      for (var i = 0; i < rawParticipants.length; i++) {

        var participant = rawParticipants[i];

        // parse away app_ prefix
        participant.client = participant.client.replace(/^app_/i, '');

        // check connected
        if(participant.status !== 'connected'){
          continue;
        }

        if(participant.client != alarm.asset.id){

          // check
          if(participant.userId == $scope.userResourceId) {

            participant.isSelf = true;
            $scope.conferenceSelfConnected = true;

          } else {

            $scope.conferenceOthersConnected = true;

          }

          participants.push(participant);

        } else {

          $scope.alarmAssetConnected = true;
          $scope.alarmAssetConnectedStartTime = participant.startTime;

        }

      }

      participants.sort(function(a, b) {

        if(a.isSelf === true) {

          return -1;

        }

        return 1;

      });

    }

    return participants;
  }

  var setupConferenceCalls = function(alarm) {

    if (alarm.ackedBy != null) {

      // log and done
      console.log('Tag: Conference', '- Not setting up conference calls, already acked so no call will come in')
      return;

    }

    // log
    console.log('Tag: Conference', '- Setting up websocket');
    $scope.dccPhoneNumber = stwoGlobal.dccPhoneNumber;
    $scope.conferenceEnded = false;
    $scope.alarmAssetConnected = false;
    $scope.conferenceSelfConnected = false;
    $scope.conferenceOthersConnected = false;
    $scope.conferenceParticipants = [];

    $scope.checkboxes = {
      dccJoinMuted: alarm.logLevel === 0,
    };

    $scope.$watch('checkboxes.dccJoinMuted', setJoinMuted);

    console.log('Tag: conference', 'Alarmdata', alarm)

    // $scope.conferenceCallCode = 444;
    // $timeout(function(){

    //   // filter participants
    //   var participants = [];
    //   var message = {
    //     participants: [
    //     {
    //       "client": "+31881261206",
    //       "status": "connected",
    //       "muted": false,
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     },
    //     {
    //       "client": "8232gfd44f0698",
    //       "status": "connected",
    //       "muted": false, 
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     },
    //     {
    //       "client": "+3188j1261207",
    //       "status": "connected",
    //       "muted": false,
    //       "hold": false,
    //       "endConferenceOnExit": true
    //     }]
    //   }
    //   for (var i = 0; i < message.participants.length; i++) {

    //     var participant = message.participants[i];
    //     if(participant.client != alarm.asset.id && participant.client.match(/[a-z]/gi) === null) {

    //       participants.push(participant);

    //     }

    //   }

    //   $scope.conferenceParticipants = participants;

    // }, 5000);

    // check if there is a call active now
    deploymentApiService.get('/v1/conference/find/'+alarm.asset.id+'?joinMuted='+$scope.checkboxes.dccJoinMuted).then(function(response){

      console.log('Tag: Conference', '- Set code to', response, response.data.code);
      if(response.status !== 200){
        return;
      }

      $scope.conferenceSid = response.data.conferenceSid;
      $scope.conferenceCallCode = response.data.code;

      if(typeof response.data.participants !== 'undefined'){

        $scope.conferenceParticipants = conferenceParseParticipants(alarm, response.data.participants);

      }

      // if-provider
      if($scope.isServiceProvider !== true) {

        $scope.registerEvent('(Waargenomen)\nTelefoongesprek aangeboden door gebruiker');

      }

    });

    // connect to socket
    socketioService.subscribe('asset/'+alarm.asset.id, function(message){

      console.log('Tag: Conference', '- Received message about asset', message);

      var participants = conferenceParseParticipants(alarm, message.participants);

      // new
      if(message.event === 'conference/create'){

        // set conference ended to not false
        $scope.conferenceEnded = false;
        $scope.conferenceCallCode = "...";

        $timeout(function() {

          // get the code
          getConferenceCallCode(alarm);

        }, 1000)

        // if-provider
        if($scope.isServiceProvider !== true) {

          $scope.registerEvent('(Waargenomen)\nTelefoongesprek aangeboden door gebruiker');

        }

      }else
      if(message.event === 'conference/event/conference-end'){

        if($scope.isServiceProvider !== true) {

          $scope.registerEvent('(Waargenomen)\nTelefoongesprek is opgehangen');

        }
        
        $scope.conferenceEnded = true;
        $scope.conferenceSelfConnected = false;
        $scope.alarmAssetConnected = false;

      }else
      if(message.event === 'conference/event/participant-join'){

        $scope.conferenceParticipants = participants;

      }else
      if(message.event === 'conference/event/participant-leave'){

        $scope.conferenceParticipants = participants;

      }else
      if(message.event === 'conference/event/participant-mute' || message.event === 'conference/event/participant-unmute'){

        // only update the muted variable
        angular.forEach($scope.conferenceParticipants, function(participant) {

          // loop and adjust
          for (var i = 0; i < participants.length; i++) {

            if(participants[i].callSid === participant.callSid) {

              participant.muted = participants[i].muted;
              break;

            }

          }

        });

      }


    })

  }

  $scope.setMuted = function(participant, muted) {

    console.log('Tag: Conference', '- setMuted', participant, muted);

    participant.muted = muted;

    // perform update on server
    deploymentApiService.post('/v1/conference/participant/mute', {
      callSid: participant.callSid,
      muted: muted,
    });

  }

  $scope.setMutedHintClicked = function() {

    $scope.mutedHintClicked = true;
    
  }

  function setJoinMuted(muted) {

    if(!$scope.conferenceSid) {
      return;
    }

    console.log('Tag: Conference', '- setJoinMuted', muted);

    // get the code
    deploymentApiService.post('/v1/conference/join-options/mute', {
      conferenceSid: $scope.conferenceSid,
      muted: muted,
    }).then(function(response){

      console.log('Tag: Conference', '- setJoinMuted - Result:', response);

    });

  }

  var getConferenceCallCode = function(alarm, attempts){

    // check
    if(typeof attempts === 'undefined' ) {

      attempts = 0;

    }

    // reset
    $scope.checkboxes.dccJoinMuted = (alarm.logLevel === 0);

    // get the code
    deploymentApiService.get('/v1/conference/find/'+alarm.asset.id+'?joinMuted='+$scope.checkboxes.dccJoinMuted).then(function(response){

      console.log('Tag: Conference', '- Set code to', response);
      $scope.conferenceSid = response.data.conferenceSid;
      $scope.conferenceCallCode = response.data.code;

    }, function(response) {

      if(attempts < 3) {

        return getConferenceCallCode(alarm, attempts + 1);

      }

    });

  }

  var downloadContacts = function (asset) {
    if (!asset || !$scope.access['type']['get'] || (!asset.position && !asset.lastValidPosition)) return;
    var position = asset.lastValidPosition ? asset.lastValidPosition : asset.position;

    var lessLat = position.latitude + 1; // 1 used to be 0.5
    var lessLon = position.longitude + 1;
    var greaterLat = position.latitude - 1;
    var greaterLon = position.longitude - 1;

    downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups+connectedTo&crossAccount=true&type.labels:contains=' + syntax.QRTag + '&owner:equals=' + asset.owner.id +
      '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat + '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.QRTag,
      function (list) {

        downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=ACR_QR_ALWAYS&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
          '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + '&max=50', 'ACR_QR_ALWAYS',
          function (list_2) {

            for (var a in list_2) {

              list_2[a].type_label = 'ACR_QR_ALWAYS';

              // loop properties
              list_2[a].propertiesFormatted = {}
              for (var p in list_2[a].properties) {

                list_2[a].propertiesFormatted[list_2[a].properties[p].code] = list_2[a].properties[p];

              }

            }

            // list = uniq_fast(list.concat(list_2))
            list = uniq_fast(list_2.concat(list))
            list.sort(function (a, b) {

              if (a.distance < b.distance) {

                return -1;

              } else
              if (a.distance > b.distance) {

                return 1;

              }

              return 0;

            })

            // get types meta
            var usedIDS = [];
            console.log('MERGED LIST 1', list);
            if (list && list.length > 0) {
              var typeIDS = list[0].type.id;
              var anyAvailablePush = false;
              for (var i = 0; i < list.length; i++) {
                var id = list[i].type.id;
                if (usedIDS.indexOf(id) < 0) {
                  usedIDS.push(id);
                  typeIDS += "%2B" + id;
                }
                if (list[i].connectedTo && list[i].connectedTo.length > 0) {
                  console.log("Check connection for " + list[i].name);
                  angular.forEach(list[i].connectedTo, function (obj) {
                    if (obj.to && obj.to.type == "user") {
                      list[i].user = obj.to;
                      list[i].notificationStatus = $scope.notificationStatus[obj.to.id] ? $scope.notificationStatus[obj.to.id].status : $scope.ns.available.status;
                      if (obj.to.id == $scope.userID) {
                        $scope.me = list[i];
                        updateFeedbackVariables();
                      }
                    }
                  });
                  anyAvailablePush = anyAvailablePush || list[i].notificationStatus == $scope.ns.available.status;
                } else {
                  // console.log("Skipping test for " + list[i].name + " because there is no connected objects", list[i].connectedTo);
                }
                if (!list[i].user) {
                  list[i].notificationStatus = $scope.ns.unavailable.status;
                }

              }

              console.log('MERGED LIST 2', list);

              $scope.anyAvailablePush = anyAvailablePush;
              if (!maximumDistances || !maximumDistances.qr) {
                getMaxDistancesForCode(list, codes.qr);
              }
              $scope.collegues = list;
              addContactsForCode(list, codes.qr, true);

              $scope.contactStatus++;
              updateBZVisibility();
              applyDistanceFilter(codes.qr);
              if (!mapInitiated) {
                $timeout(function () {
                  $scope.autoCenter();
                }, 300);
                mapInitiated = true;
              }
            }

          });

        // end
      });
    // 


    if (($scope.contactInfo.nqrEnabled || $scope.alarm.zone) && $scope.alarm && $scope.alarm.ackedBy == null) {
      downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.NQRTag + '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
        '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.NQRTag,
        function (list) {

          $scope.guards = list;

          if (!maximumDistances || !maximumDistances[codes.nqr]) {
            getMaxDistancesForCode(list, codes.nqr);
          }

          addContactsForCode($scope.guards, codes.nqr, true);

          $scope.contactStatus++;
          updateBZVisibility();
          applyDistanceFilter(codes.nqr);

        });

    }
    if ($scope.alarm && ($scope.alarm.asset || $scope.alarm.zone)) {
      var object = $scope.alarm.asset ? 'asset' : 'zone';

      smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/' + object + '/' + $scope.alarm[object].id + '?crossAccount=true', {
        onErrorDoNotRedirect: true
      }).then(function (response) {
        if (response && response.data && response.data.result && response.data.result.length > 0) {
          $scope.alarm[object] = response.data.result[0];

          // Add private contacts
          if (!getResponseAreaForCode(codes.pc) && $scope.alarm[object].labels) {
            var data = parseDataForZone($scope.alarm[object]);
            var contacts = data.contacts.sort(comparePriority);
            if (data.contacts) {
              $scope.responseAreas.push({
                "name": translations["XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS"],
                "color": "ra",
                "code": codes.pc,
                "contacts": contacts,
                "expanded": false,
                "visible": true
              });
              $scope.setOrder($scope.order);

            }
          }
          if ($scope.alarm.asset) {
            addCustomerMarker($scope.alarm.asset);
            downloadZones(asset.insideZones);
          }
        }
      }, function () {
        alert("Something went wrong with the " + object + " request");
      });
    }
  }

  var getLabelWithCode = function (objectWithLabel, code) {
    if (objectWithLabel.labels) {
      for (var i in objectWithLabel.labels) {
        if (objectWithLabel.labels[i].code == code) {
          return objectWithLabel.labels[i];
        }
      }
    }
  }

  var getAssetContactList = function () {
    if (!$scope.alarm ||  !$scope.alarm.asset || !$scope.access['alarm']['put']) return;
    var asset = $scope.alarm.asset;
    if ($scope.access['group']['get'] && asset.groups && asset.groups.length > 0) {
      var groupIDs = asset.groups[0].id;
      for (var i = 1; i < asset.groups.length; i++) {
        groupIDs += "%2B" + asset.groups[i].id;
      }
      smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/group/" + "?select=labels&id:equals=" + groupIDs + "&labels:contains=ACR_CL&crossAccount=true&owner:equals=" + $scope.alarm.asset.owner.id, {
          onErrorDoNotRedirect: true
        })
        .then(function (response) {
          if (response.data.result.length > 0) {
            var idFilters = "id:equals=";
            var usedIDs = [];
            angular.forEach(response.data.result, function (group) {
              var labels = group.labels;
              angular.forEach(labels, function (label, name) {
                if (label.code == syntax.CLTag) {
                  try {
                    var json = JSON.parse(label.value);
                    var id = json.id;
                    if (id && usedIDs.indexOf(id) < 0) {
                      usedIDs.push(id);
                      idFilters += id + "%2B";
                    }
                  } catch (e) {
                    console.log("Error parsing label ", label, e);
                  }
                }
              });
            });
            if (idFilters != "id:equals=") {
              idFilters = idFilters.substring(0, idFilters.lastIndexOf("%2B"));
              smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/contactList?select=@&" + idFilters + "&crossAccount=true", {
                onErrorDoNotRedirect: true
              }).then(function (response) {
                if (response.data.result.length > 0) {
                  $scope.contactLists = [];
                  angular.forEach(response.data.result, function (cl) {
                    $scope.contactLists.push(cl.id);
                  });
                }
                console.log("Contact Lists are set to: ", $scope.contactLists);
              });
            }
          }
        });
    }

  }


  var getMaxDistancesForCode = function (contacts, code) {
    if (contacts.length > 0) {
      var usedIDS = [];
      var typeIDS = contacts[0].type.id;
      for (var i = 1; i < contacts.length; i++) {
        var id = contacts[i].type.id;
        if (usedIDS.indexOf(id) === -1) {
          usedIDS.push(id);
          typeIDS += "%2B" + id;
        }
      }
      if (!maximumDistances || !maximumDistances.qr) {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/type/?select=labels&id:equals=" + typeIDS, {
            onErrorDoNotRedirect: true
          })
          .then(function (response) {

            var approvedContacts = [];
            maximumDistances[code] = new Date();
            for (var i in response.data.result) {
              var type = response.data.result[i];
              for (var x in type.labels) {
                var label = type.labels[x];

                if (label.code === 'ACR_QR_ALWAYS') {
                  continue;
                }

                if (label.value.indexOf("maxDistance") >= 0) {
                  try {
                    var value = JSON.parse(label.value);
                    maximumDistances[type.id + type.name] = value.maxDistance;
                    maximumDistances['total'] = maximumDistances['total'] + 1;

                    //alert('Set ' + type.id + type.name + ' to ' + value.maxDistance)

                  } catch (e) {
                    console.log(e);
                    maximumDistances[type.id + type.name] = 2000;
                    maximumDistances['total'] = maximumDistances['total'] + 1

                    //alert('Set ' + type.id + type.name + ' to default 2000')
                  }
                } else {
                  maximumDistances[type.id + type.name] = 2000;
                  maximumDistances['total'] = maximumDistances['total'] + 1

                  //alert('Set ' + type.id + type.name + ' to default 2000')

                }
              }
            }
            applyDistanceFilter(code);
          });
      }
    }
  }

  var applyDistanceFilter = function (code) {

    if (maximumDistances && maximumDistances.total > 0) {
      var ra = false;
      for (var i in $scope.responseAreas) {
        if ($scope.responseAreas[i].code == code) {
          ra = $scope.responseAreas[i];
        }
      }

      if (ra) {
        var list = [];
        for (var i in ra.contacts) {
          var contact = ra.contacts[i];

          console.log('distanceFilter', '['+code+']', contact.distance > maximumDistances[contact.type.id + contact.type.name] ? '🚫 FILTERED' : '🟢 ACCEPTED', contact.type.id, contact.type.name, '=', maximumDistances[contact.type.id + contact.type.name], 'vs', contact.distance, 'for', contact.name)

          if (!(contact.type && maximumDistances[contact.type.id + contact.type.name] &&
              contact.distance > maximumDistances[contact.type.id + contact.type.name])) {
            list.push(contact);
            if (code == codes.nqr) addNQRMarker(contact);
            else if (code == codes.qr) addQRMarker(contact);

          } else if ($scope.markers["marker" + contact.id]) {
            leafletData.getMap("amMap").then(function (map) {
              map.removeLayer($scope.markers["marker" + contact.id]);
              delete $scope.markers["marker" + contact.id];
            });
          }
        }
        addContactsForCode(list, code, true);

      }
    }
  }


  var downloadCloseAssets = function (url, context, repl) {
    var list = [];
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + url, {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (!response || !response.data) return;
      for (var i in response.data.result) {
        var asset = response.data.result[i];
        if (!asset.lastValidPosition || !isContactAllowed(asset, context))
          continue;

        if ($scope.alarm.asset && asset.id != $scope.alarm.asset.id || $scope.alarm.zone) {

          asset.invisibleResponder = $scope.getPropertyValue(asset, 'invisibleResponder') || 'false';
          asset.phone = $scope.getPropertyValue(asset, syntax.phone);
          asset.phoneFormatted = $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone));
          asset.sms = $scope.getPropertyValue(asset, syntax.sms);
          asset.email = $scope.getPropertyValue(asset, syntax.email);
          asset.distance = calculateDistance(asset.lastValidPosition, $scope.alarm.asset ? $scope.alarm.asset.lastValidPosition : $scope.alarm.zone.position);
          asset.distanceText = getDistanceText(asset.distance);
          //asset.allowConact = $scope.getPropertyValue(asset, syntax.allowConact);



          // only add when not invisible
          if(('' + asset.invisibleResponder) !== 'true') {

            list.push(asset);

          }

        }
      }
      list.sort(function (a, b) {
        return a.distance - b.distance;
      });

      repl(list);
    });
  }

  var downloadZonesForZone = function (zone) {
    var maxLat = zone.points[0].latitude;
    var minLat = zone.points[0].latitude;
    var maxLon = zone.points[0].longitude;
    var minLon = zone.points[0].longitude;

    for (var i in zone.points) {
      var lat = zone.points[i].latitude;
      var lon = zone.points[i].longitude;
      if (lat > maxLat) maxLat = lat;
      else if (lat < minLat) minLat = lat;
      if (lon > maxLon) maxLon = lon;
      else if (lon < minLon) minLon = lon;
    }
    // maxLat += 0.5;minLat -= 0.5;maxLon += 0.5;minLon -= 0.5;
    smarttrackerService.authGet(smarttrackerService.getCustomerId() +
      '/zone/?maxLatitude:greater=' + maxLat + '&minLatitude:less=' + minLat + '&maxLongitude:greater=' + maxLon + '&minLongitude:less=' + minLon + '&max=100&crossAccount=true&owner:equals=' + $scope.alarm.zone.owner.id + ($scope.alarm.alarmCenter ? '&owner:equals=' + $scope.alarm.alarmCenter.id : '', {
        onErrorDoNotRedirect: true
      })).then(function (response) {
      // compile list of ids. 
      var zones = response.data.result;

      if (zones.length > 1) {
        for (var i = 0; i < zones.length; i++) {
          if (zones[i].id == zone.id) {
            zones.splice(i, 1);
            break;
          }
        }
        downloadZones(zones);
      }
    });


  }

  var downloadZones = function (zones) {
    if (!zones || zones.length < 1) return;
    var zoneIDS = "" + zones[0].id;
    for (var i = 1; i < zones.length; i++) {
      zoneIDS += "%2B" + zones[i].id;
    }

    // remove zones that the asset is no longer inside


    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/zone/?id:equals=' + zoneIDS + "&select=type+labels+points&crossAccount=true", {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      var zs = response.data.result;
      // clear old zone contacts
      for (var i in $scope.responseAreas) {
        var ra = $scope.responseAreas[i];
        if (ra.code == codes.pd || ra.code == codes.bz || ra.code == codes.ra) {
          ra.contacts = [];
        }
      }

      for (var i in zs) {
        var z = zs[i];
        if (z.labels) {
          for (var l in z.labels) {
            var label = z.labels[l];
            switch (label.code) {
            case syntax.RATag:
              addResponseArea(z);
              break;
            case syntax.PDTag:
              if ($scope.isAlarmCenter || $scope.isServiceProvider)
                addContactsForCode(parseDataForZone(z).contacts, codes.pd);
              break;
            case syntax.BZTag:
              addContactsForCode(parseDataForZone(z).contacts, codes.bz);
              break;
            }
          }
        }
      }
      updateBZVisibility();
    });
  }

  var addResponseArea = function (z) {
    var data = parseDataForZone(z);
    var priority = data.priority ? data.priority : 20000;
    var contacts = data.contacts.sort(comparePriority);;
    getResponseAreaTextForZone(z).then(function (text) {
      var ra = {
        "name": text,
        "color": "ra",
        "code": codes.ra,
        "priority": priority,
        "contacts": contacts,
        "expanded": false,
        "visible": contacts.length > 0
      };
      if (data.messageData) ra.messageData = data.messageData;
      $scope.responseAreas.push(ra);
      $scope.setOrder($scope.order);
      var hp = ra.priority;
      var fp = false;
      for (var i in $scope.responseAreas) {
        var area = $scope.responseAreas[i];
        if (area.code == codes.ra && area.priority && area.priority < hp) {
          fp = true;
          break;
        }
      }
      if (!fp) {
        renderResponseArea(z);

      }
    });
  }

  $scope.setMode = function (mode) {

    $scope.modes.isDoubt = (mode === 'doubt');

  }

  $scope.centerOnAddress = function (data) {
    leafletData.getMap("amMap").then(function (map) {
      map.setView({
        'lat': data.point.lat,
        'lng': data.point.lng
      }, 16);
    });
  }

  var renderResponseArea = function (a) {
    leafletData.getMap("amMap").then(function (map) {
      var latlngs = [];
      try {
        angular.forEach(a.points, function (point) {
          latlngs.push({
            'lat': point['latitude'],
            'lng': point['longitude']
          });
        });
      } catch (e) {
        console.error(e);
      }
      addPath("ResponseArea", {
        type: "polygon",
        fillColor: 'darkgreen',
        color: 'darkgreen',
        latlngs: latlngs,
        clickable: false,
        weight: 2
      });
      if ($scope.polygon) {
        try {
          $scope.polygon.remove();
        } catch (e) {
          console.error(e);
        }
      }

      $scope.polygon = L.polygon(latlngs, {
        color: 'darkgreen',
        fillColor: 'darkgreen'
      });
      $scope.polygon.addTo(map);
      $scope.paths["responseArea"] = $scope.polygon;
    });
  }

  var getResponseAreaForCode = function (code, priority) {
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        var ra = $scope.responseAreas[i];
        if (priority && ra.priority != priority) {
          continue;
        }
        return ra;
      }
    }
    return false;
  }

  var updateRAPropertyForCode = function (code, property, value) {
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        $scope.responseAreas[i][property] = value;
        break;
      }
    }
  }

  var addContactsForCode = function (contacts, code, refresh) {
    var index = false;
    for (var i in $scope.responseAreas) {
      if ($scope.responseAreas[i].code == code) {
        index = i;
        break;
      }
    }
    if (index && index > -1) {
      if (refresh) {
        $scope.responseAreas[index].contacts = [];
      }
      for (var j in contacts) {
        $scope.responseAreas[i].contacts.push(contacts[j]);
      }

    }
    if (code == codes.nqr || code == codes.qr)
      $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts;
    else
      $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts.sort(comparePriority);
  }

  var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  var parseDataForZone = function (zone) {
    zone.contacts = [];
    var now = new Date();


    for (var i in zone.labels) {
      var label = zone.labels[i];
      if (label.code == "ACR_CONTACT") {
        try {
          var properties = JSON.parse(label.value);
          properties["name"] = i;
          // Check if the contact is available 
          if (properties.workhours && properties.workhours.length > 0) {
            properties.working = false;
            whcheck:
              for (var y in properties.workhours) {
                var wh = properties.workhours[y];
                for (var z in wh.weekday) {
                  if (days.indexOf(wh.weekday[z]) == now.getDay()) {

                    var startBound = new Date();
                    if (wh.hours) {
                      startBound.setHours(wh.hours.substring(0, 2));
                      startBound.setMinutes(wh.hours.substring(2, 4));
                      var endBound = new Date();
                      endBound.setHours(wh.hours.substring(5, 7));
                      endBound.setMinutes(wh.hours.substring(7, 9));
                      if (endBound == '0000') {
                        endBound.setDate(endBound.getDate() + 1);
                      }
                    }

                    if (now.getTime() > startBound.getTime() && now.getTime() < endBound.getTime() || !wh.hours) {
                      properties.working = true;
                      zone.contacts.push(properties);
                      break whcheck;
                    }
                  }
                }
              }

          } else {
            properties.working = true;
            zone.contacts.push(properties);
          }
        } catch (e) {
          console.log(e);
        }
      } else if (label.code == "ACR_RA") {

        try {
          var properties = JSON.parse(label.value);
          var kv = {
            showQR: "qr",
            showNQR: "nqr",
            showPD: "pd"
          };
          for (var k in kv) {
            if (properties.hasOwnProperty(k) && !properties[k]) {
              updateRAPropertyForCode(codes[kv[k]], "visible", false);
            }
          }
          zone.priority = properties.priority ? properties.priority : 20000;
          if (properties.messageData) {
            zone.messageData = properties.messageData;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }


    return zone;
  }


  $translate(["XGUARD_RESPONSE_AREAS_CUSTOMER", "XGUARD_RESPONSE_AREAS_QUICK_RESPONSE",
    "XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE", "XGUARD_RESPONSE_AREAS_POLICE_REGION", "XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS",
    "XGUARD_RESPONSE_AREAS_BACKUP"
  ]).then(function (data) {
    translations = data;

    $scope.responseAreas = [{
        "name": translations["XGUARD_RESPONSE_AREAS_CUSTOMER"],
        "color": "cu",
        "code": codes.customer,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_QUICK_RESPONSE"],
        "color": "qr",
        "code": codes.qr,
        "contacts": [],
        "expanded": false,
        "visible": true
      },
      //{"name":"Response Area", "color":"ra", "code":codes.ra, "contacts":[], "expanded":false, "visible":true},
      {
        "name": translations["XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE"],
        "color": "nqr",
        "code": codes.nqr,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_POLICE_REGION"],
        "color": "pd",
        "code": codes.pd,
        "contacts": [],
        "expanded": false,
        "visible": true
      }, {
        "name": translations["XGUARD_RESPONSE_AREAS_BACKUP"],
        "color": "pd",
        "code": codes.bz,
        "contacts": [],
        "expanded": false,
        "visible": false
      }
    ];
    smarttrackerService.isLoggedInDelayed().then(function () {
      leafletData.getMap("amMap").then(function (otherMap) {
        map = otherMap;
        $(window).width(function () {
          smallScreen();
          setMobileView();
          map.invalidateSize();
          $scope.autoCenter();
        });
        map.on('click', function (event) {
          $scope.selectedMarker = '';
          deselectSelectedMarker();
        });
        map.on('dragstart', function (event) {
          $scope.mapViewAltered = true;
        });
        notificationService.snooze();
        notificationService.ignore("alarm-" + alarmID);

        mapService.loadOverlays(map);
        $scope.userID = smarttrackerService.getUserData().user.id;
        $scope.userResourceId = smarttrackerService.getUserData().user.resourceId;
        $scope.isServiceProvider = smarttrackerService.getUserData().flags.isServiceProvider;
        $scope.downloadAlarm();
        $scope.customerID = smarttrackerService.getCustomerId();

      });
    });
  });
  //$scope.alarm = contentCacheService.get("alarm", 67523534);


  var isContactAllowed = function (asset, context) {
    var contactAllowed = true;
    var testValue = context == syntax.NQRTag ? syntax.allowContactNQR : syntax.allowContact;

    for (var i in asset.properties) {
      var prop = asset.properties[i];
      if (prop.code == testValue) {
        contactAllowed = prop.value != "false";
        break;
      }
    }
    return contactAllowed;
  }

  $scope.getPropertyValue = function (asset, code) {
    var value = false;
    if (asset && code) {
      for (var i in asset.properties) {
        var property = asset.properties[i];
        if (property.code == code) {
          value = property.value;
          break;
        }
      }
    }
    return value;
  }

  $scope.isNormalMode = false;
  var normalMode = function () {
    $scope.isNormalMode = true;

    if ($scope.alarm.asset && $scope.alarm.asset.lastValidPosition)
      addCustomerMarker($scope.alarm.asset);
    if ($scope.alarm && $scope.alarm.position)
      addAlarmMarker($scope.alarm);
    renderLineBetween();
    $scope.toggleMap();
    $timeout(function () {
      $scope.autoCenter();
    }, 1050);
  }

  makeNamedIcon = function (name, icon, color) {
    if (!color) {
      color = "#31708f";
    }
    if (!icon) {
      icon = "glyphicon glyphicon-map-marker";
    }
    var div_icon = {
      type: 'div',
      iconAnchor: [18, 36 - 8], //these numbers come from the fact that we use an icon 36x36 and the leaflet positions this with its top-felt corner. Thus I shift so the the nidle of the icon shows right point in map
      iconSize: [2000, 0],
      className: 'myleaflet-div-icon',
      //html: '<img src="images/Map-Marker-icon-' + color + '.png" align="top"><span class="name">' + name + '</span>',
      html: '<span class="pin" style="color:' + color + '"><span class="' + icon + '" style="color:' + color + '"></span></span><span class="name label" style="background-color:' + color + '">' + name + '</span>',
      popupAnchor: [0, 0]
    };


    return div_icon;
  }

  /* Map Commands*/
  var coreMarkers = [];
  $scope.securityGuardsVisible = false;

  var deselectSelectedMarker = function () {
    if (selectedMarker) {
      selectedMarker._icon.className = selectedMarker._icon.className.replace("selected", "");
    }
    selectedMarker = false;
  }
  var selectedMarker = false;
  var addSelectedMarker = function (marker) {
    /*$scope.markers[marker.id] = {
        id: marker.id,
        lat: marker.lat,
        lng: marker.lng,
        icon: makeNamedIcon(marker.item.name, "glyphicon glyphicon-map-marker", "DodgerBlue"),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
        //message : "message",
        focus: false, //just add them on the map. not in focus
        draggable: false,
        'item': marker.item,
        'code': marker.code
    };*/
    if (selectedMarker) {
      deselectSelectedMarker();
    }
    selectedMarker = marker;
    selectedMarker._icon.className += " selected";
  }
  var addAlarmMarker = function (alarm) {
    addMarker(alarm, "mdi mdi-bullseye", "#FF0000", "#e00000", "Alarm Position", true, null, 18, 18);
  }
  var addQRMarker = function (asset) {
    addMarker(asset, "mdi mdi-map-marker", "#22b573", "#1c925d", asset.name, true, codes.qr);
  }

  var addCustomerMarker = function (asset) {
    if (!asset.positionIsFixed) {
      addMarker(asset, "mdi mdi-map-marker", "#FF0000", "#e00000", "Current Position", true, codes.customer);
      renderLineBetween();
    }
  }

  var addNQRMarker = function (asset) {
    addMarker(asset, "mdi mdi-marker-check", "#0b788a", "#095e6d", asset.name, false, codes.nqr, 15, 29);
  }

  var oms = false;
  var addMarker = function (item, icon, color, colorDark, text, core, code, iconAnchorX, iconAnchorY) {
    if (!$scope.slInit) {
      oms = new OverlappingMarkerSpiderfier(map);
      oms.addListener("click", function (marker) {
        if (marker.code == codes.nqr || marker.code == codes.qr || marker.code == codes.customer) {

          var ra = getResponseAreaForCode(marker.code);
          if (ra.contacts.indexOf(marker.item) >= 2)
            ra.expanded = true;

          deselectSelectedMarker();
          addSelectedMarker(marker);

          $scope.selectedMarker = marker.item.id;
          $scope.selectedMarkerName = marker.id;
        }
      });
      $scope.slInit = true;
    }

    if (item && item.id && (item.lastValidPosition || item.position)) {
      var positionKey = item.position ? 'position' : 'lastValidPosition';
      /*$scope.markers["marker" + item.id] = {
          id: "marker" + item.id,
          lat: item[positionKey].latitude,
          lng: item[positionKey].longitude,
          icon: makeNamedIcon(text, icon, ("marker" + item.id == $scope.selectedMarkerName ? "DodgerBlue" : color)),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
          //message : "message",
          focus: false, //just add them on the map. not in focus
          draggable: false,
          'item': item,
          'code': code
      };*/
      if (oms) {
        L.Icon.Default.imagePath = 'css/images';

        if (!iconAnchorX || !iconAnchorY) {
          iconAnchorX = 18;
          iconAnchorY = 32;
        }

        var micon = L.divIcon({
          type: 'div',
          iconAnchor: [iconAnchorX, iconAnchorY],
          className: 'myleaflet-div-icon',
          html: '<div><div class="pin"><i class="' + icon + '" style="color:' + color + '"></i></div><div class="name label" style="background-color:' + color + '; border-color:' + colorDark + '"><span>' + text + '</span></div></div>',
          popupAnchor: [0, 0]
        });
        var markerId = "marker" + item.id;

        var marker = $scope.markers[markerId];
        var loc = new L.LatLng(item[positionKey].latitude, item[positionKey].longitude);
        if (marker)  {
          oms.unspiderfy();
          try {
            marker.setLatLng(loc);
          } catch (err) {
            console.log(err);
          }
        } else {
          marker = new L.Marker(loc, {
            icon: micon,
            riseOnHover: true
          });
          map.addLayer(marker);
          oms.addMarker(marker);
          marker.item = item;
          marker.code = code;
          marker.id = markerId;
          marker.iconCode = micon;
          // marker.on('mouseover', function (e){
          //     console.log(this);
          // });
          $scope.markers[markerId] = marker;
        }
      }

      if (core && coreMarkers.indexOf("marker" + item.id) < 0) {
        coreMarkers.push("marker" + item.id);
      }
    }

  }

  var clearMarkersForCode = function (code) {
    var markers = {};
    for (var i in $scope.markers) {
      if (i.indexOf(code) != 0) {
        markers[i] = $scope.markers[i];
      }
    }
    $scope.markers = markers;
  }

  var addPath = function (name, path) {
    var p = $scope.paths;
    $scope.paths = {};
    for (var i in p) {
      $scope.paths[i] = p[i];
    }
    $scope.paths[name] = path;
  }

  var renderLineBetween = function () {
    //if posisjon ulikif()
    if (!$scope.alarm || !$scope.alarm.position || !$scope.alarm.asset || !$scope.alarm.asset.lastValidPosition)
      return;
    var latlngs = [{
      'lat': $scope.alarm.position.latitude,
      'lng': $scope.alarm.position.longitude
    }, {
      'lat': $scope.alarm.asset.lastValidPosition.latitude,
      'lng': $scope.alarm.asset.lastValidPosition.longitude
    }];
    addPath("polyline", {
      type: "polyline",
      color: 'red',
      latlngs: latlngs,
      dashArray: "5,5",
      weight: 2
    });
  }

  $scope.initialCenterSet = false;

  $scope.setCenter = function (newCenter) {
    console.log("SetCenter", newCenter);
    map.setView($scope.mapData.center = new L.LatLng(newCenter.lat, newCenter.lng), newCenter.zoom);
    $scope.mapData.center.lat = newCenter.lat;
    $scope.mapData.center.lng = newCenter.lng;

    if (newCenter.zoom) {
      $scope.mapData.center.zoom = newCenter.zoom;
    }
  };

  $scope.centerOnItem = function (item) {
    console.log("center on item", item);
    if (item && item.position && item.position.location && item.position.location.locationId) {
      $scope.mapMode.indoor = true;
      $scope.indoorViewer.location = item.position.location.locationId;
    } else if (item && item.position && item.position.valid) {
      $scope.mapMode.indoor = false;
      var newcenter = {
        lat: item.position.latitude,
        lng: item.position.longitude
      };

      $scope.setCenter(newcenter);
    }
  };

  $scope.toggleMap = function () {
    $scope.mapVisible = !$scope.mapVisible;
    if ($scope.mapVisible) {
      if (!mapInitiated) {
        mapInitiated = true;
        $scope.autoCenter();
        $scope.mapViewAltered = false;
      }
      $timeout(function () {
        map.invalidateSize();
      }, 1050);
    }
  }

  $scope.zoomNQR = function () {
    $scope.securityGuardsVisible = true;
    $scope.autoCenter();
  }

  $scope.zoomCore = function () {

    $scope.securityGuardsVisible = false;
    $scope.autoCenter();
    $scope.mapViewAltered = false;
  }

  $scope.autoCenter = function () {
    var activeMarkersPoints = [];

    if ($scope.securityGuardsVisible) {
      for (var m in $scope.markers) {
        var item = $scope.markers[m];
        if (item && item.getLatLng()) {
          activeMarkersPoints.push(item.getLatLng());
        }
      }
    } else {
      for (var i in coreMarkers) {
        var item = $scope.markers[coreMarkers[i]];
        if (item && item.getLatLng()) {
          activeMarkersPoints.push(item.getLatLng());
        }
      }
    }

    var bounds = new L.latLngBounds(activeMarkersPoints);

    if (activeMarkersPoints.length > 0) {
      $timeout(function () {
        map.fitBounds(bounds, {
          padding: [50, 50]
        });
      }, 310);
    }
  };

  /*Map Commands*/

  var calculateDistance = function (pos1, pos2) {
    var lat1 = pos1.latitude;
    var lat2 = pos2.latitude;
    var lon1 = pos1.longitude;
    var lon2 = pos2.longitude;

    var R = 6371e3; // metres
    var φ1 = toRadians(lat1);
    var φ2 = toRadians(lat2);
    var Δφ = toRadians(lat2 - lat1);
    var Δλ = toRadians(lon2 - lon1);

    var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    var d = R * c;
    return d;
  }

  var toRadians = function (deg) {
    return deg * Math.PI / 180.0;
  }

  var getDistanceText = function (distance) {
    if (distance > 100) {
      return (Math.round(distance / 100) / 10) + " km";
    } else return (Math.round(distance * 10) / 10) + " m";
  }

  function comparePriority(a, b) {
    return a.priority == b.priority ? 0 : a.priority < b.priority ? -1 : 1;
  }

  $scope.commentsMeta = {};
  /** Registers a comment as an event, meta is expandable info in the comment. additionalInfo is labels on comment (*/
  $scope.registerEvent = function (eventText, meta, additionalInfo, editable) {

    if ($scope.alarm.ackedBy) return;

    socketioService.socket.emit('alarms/'+$scope.alarm.id+'/chat', {
      type: 'user',
      text: eventText,
      notification: {
        title: $scope.alarm.name +' '+$scope.alarm.asset.name,
      }
    });

  }

  $scope.expandedComment = false;
  $scope.expandComment = function (id) {
    if ($scope.expandedComment == id)
      $scope.expandedComment = false;
    else
      $scope.expandedComment = id;
  }

  var eventCommentDelim = "#$%#$%";



  $scope.addEditCommentEvent = function (comment, commentText) {

    if (typeof commentText === 'undefined') {
      commentText = false;
    }

    $translate(["XGUARD_COMMENT_DIALOG_ADD_TITLE", "XGUARD_COMMENT_DIALOG_EDIT_TITLE", "XGUARD_COMMENT_DIALOG_EDIT_CONTENT",
      "XGUARD_COMMENT_DIALOG_ADD_CONTENT", "XGUARD_COMMENT_DIALOG_EDIT_OK_BUTTON", "XGUARD_COMMENT_DIALOG_ADD_OK_BUTTON",
      "XGUARD_COMMENT_DIALOG_PLACEHOLDER"
    ]).then(function (data) {

      if (comment && comment.name != "editable") {
        return;
      }
      var promise = dialogService.prompt(
          comment ? data["XGUARD_COMMENT_DIALOG_EDIT_TITLE"] : data["XGUARD_COMMENT_DIALOG_ADD_TITLE"],
          comment ? data["XGUARD_COMMENT_DIALOG_EDIT_CONTENT"] : data["XGUARD_COMMENT_DIALOG_ADD_CONTENT"], {
            okButtonText: comment ? data["XGUARD_COMMENT_DIALOG_EDIT_OK_BUTTON"] : data["XGUARD_COMMENT_DIALOG_ADD_OK_BUTTON"],
            multiline: true,
            promptText: comment ? comment.text : '',
            placeHolder: data["XGUARD_COMMENT_DIALOG_PLACEHOLDER"]
          })
        .then(function (data) {
            var text = data.promptText;
            
            socketioService.socket.emit('alarms/'+$scope.alarm.id+'/chat', {
              type: 'user',
              text: text,
              notification: {
                title: $scope.alarm.name +' '+$scope.alarm.asset.name,
              }
            });

          },
          function (data) {
            //Cancelled
          });
    });
  }

  /** Helper functions*/
  $scope.isIndoor = function (item) {
    if (item.position) { // alarma
      return item.position.source && item.position.source.type == "beacon";
    } else {
      return item.lastValidPosition && item.lastValidPosition.source && item.lastValidPosition.source.type == "beacon";
    }
  }

  $scope.isInZone = function (item, zone) {

    if (zone && zone.id && (item.insideZones || (item.position && item.position.insideZones))) {
      var zones = item.insideZones ? item.insideZones : item.position.insideZones;
      for (var i in zones) {
        if (zones[i].id == zone.id)
          return true;
      }
    }
    return false;
  }

  $scope.isGuardsVisible = function () {
    var nqr = getResponseAreaForCode(codes.nqr);
    return $scope.alarm && $scope.alarm.asset && nqr.visible && nqr.contacts.length > 0;
  }

  // $scope.getIconColor = function(item){
  //    var clazz = 'badAccuracy';
  //    var accuracy = item.position?item.position.accuracy : item.lastValidPosition.accuracy;
  //     if($scope.isIndoor(item) || (accuracy>0&&accuracy<=15))
  //        clazz = 'goodAccuracy';
  //    else if(accuracy>15&&accuracy<=40)
  //        clazz = 'medAccuracy';
  //    return clazz;
  // }

  // $scope.getTimeColor = function(){
  //     var clazz = 'badAccuracy';
  //     if($scope.alarm){
  //         var alarmDate = new Date($scope.alarm.dateCreated)
  //         var now = new Date();
  //         var diff = now - alarmDate;
  //         if(diff < 901*1000){
  //             clazz = 'goodAccuracy';
  //         } else if(diff < 3900 * 1000) {
  //             clazz = 'medAccuracy';
  //         }
  //     }
  //     return clazz;
  // }

  $scope.timeString = "";
  var getTimeString = function () {

    if ($scope.alarm && $scope.translations) {

      var time = moment.tz($scope.alarm.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
      var diff = Math.floor((new Date() - time) / 1000);

      if (diff < 86400) {
        var hours = Math.floor(diff / 3600);
        diff = diff = Math.floor(diff % 3600);
        var minutes = Math.floor(diff / 60);

        $scope.timeString = $scope.translations.timeTemplate.toString().replace("<HOURS>", hours > 0 ? hours + (hours > 1 ? " " + $scope.translations.hours + " " : " " + $scope.translations.hour + " ") : "")
          .replace("<MINUTES>", minutes >= 0 ? (minutes + (minutes == 1 ? " " + $scope.translations.minute + " " : " " + $scope.translations.minutes + " ")) : "");

        $scope.timeStringDate = $scope.alarm.dateCreatedFormatted;

      } else {
        $scope.timeString = $scope.alarm.dateCreatedFormatted;
        $scope.timeStringDate = '';
      }

    }
  };

  var getResponseAreaTextForZone = function (zone) {
    return $translate("XGUARD_RESPONSE_AREAS_RESPONSE_AREA", {
      zoneName: zone.name
    });
  };

  /**End Helper functions*/

  $scope.$on('$locationChangeStart', function( event, next, current ) {

    if(current.match(new RegExp('alarm-manager-detail\/'+$scope.alarm.id+'$')) !== null) {

      socketioService.unsubscribe('alarms/'+$scope.alarm.id+'/chat');
      socketioService.unsubscribe('asset/'+alarm.asset.id);

    }

  });

  var setupChat = function(){

    $scope.getComments();

    // connect to socket
    socketioService.subscribe('alarms/'+$scope.alarm.id+'/chat', function(message){

      console.log('new chat message', message);

      parseMessage(message);

      $scope.chat = [].concat([message], $scope.chat);

    });

  }

  var parseMessage = function(message) {

    // fix timestamp
    var date = moment.tz(message.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
    message.dateCreated = new Date(date).toLocaleString('nl-NL');

  }

  $scope.getComments = function(offsetId) { 

    console.log('Getting chat messages with offsetId =', offsetId);

    var offset = '';
    if(typeof offsetId !== 'undefined') {

      offset = 'offsetId='+offsetId;

    }

    deploymentApiService.get('/v1/alarms/chat/'+$scope.alarm.id+'?limit=50&order=desc&'+offset).then(function(response) {

      // mutate
      for(var i = 0; i < response.data.result.length; i++) {

        var message = response.data.result[i];

        parseMessage(message);

      }

      // check if we need to fetch more
      if(response.data.result.length > 0) {

        // add earlier results
        $scope.chat = [].concat($scope.chat || [], response.data.result);

        // get more
        $scope.getComments(response.data.result[response.data.result.length - 1].id);

      } else {

        $scope.chat = [].concat($scope.chat || [], []);

      }

    });

  }

  $scope.refreshEvents = function (offset) {

    return;

    /*
    var limit = 50;

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/comment?filter:relatedToAlarm=' + $scope.alarm.id + '&sort=dateCreated&order=desc&max=' + limit + '&offset=' + offset + '&crossAccount=true&select=@', {
      onErrorDoNotRedirect: true
    }).then(function (response) {
      if (offset == 0) $scope.events = [];
      if ($scope.events && $scope.events.length > 0) {
        $scope.events = $scope.events.concat(
          response.data.result
        );
      } else if (response.data.result != undefined) {
        $scope.events = response.data.result;
        console.log("refreshEvents > Succesfull")
      } else {
        console.log("Error: No response data available");
        console.log("refreshEvents > FAILED");
      }
      if (response.data.result.length == 50) {
        $scope.refreshEvents(offset + limit)
      } else {
        $scope.events.sort(function (a, b) {
          return new Date(b.dateCreated) - new Date(a.dateCreated)
        });
        if ($scope.access['alarm']['put']) {
          checkNotificationStatusForComments();
        }
      }
    });
    */

    // console.log("SmartTracker Reequest" + 1202 + " Downloading comments");
  }

  /*$scope.googleMapsBackup = function (item) {
      $window.open('http://maps.google.com/maps?q=' + item.lastValidPosition.latitude + ',' + item.lastValidPosition.longitude);
  }*/

  $scope.googleMaps = function (item) {

    var lat = item.position.latitude;
    var lng = item.position.longitude;

    if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
      function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        }
      }

      var ver = iOSversion() || [0];

      if (ver[0] >= 6) {
        protocol = 'maps://';
      } else {
        protocol = 'http://';

      }
      window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
    } else {
      window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
    }
  };

  var getTableRow = function (col1, col2, addHeader, headerOnly) {

    var header = '';
    if(addHeader !== false) {

      header = '<h3 class="noticeTitle" style="margin-top:20px !important;display:block;background-color:#3581BE;padding-top:10px;padding-bottom:10px;padding-right:20px;padding-left:20px;color:white;margin-bottom:0;margin-right:20px;margin-left:20px;font-weight:400;">'+col1+'</h3>';

    }

    if(headerOnly === true) {

      return header + col2;

    }

    return header + '<div class="notice titled" style="margin-bottom: 0 !important; text-align: center; padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;margin-top:0;margin-right:20px;margin-left:20px;background-color:#efefef;color:black;font-size:14px;">'+col2+'</div>';
  }

  $scope.getTableRow = getTableRow;

  $scope.getGoogleMapsLink = function (lat, lon) {
    return "http://maps.google.com/maps?q=" + lat + "%2C" + lon;
  }

  $scope.getAddressHTML = function(position){

    var link = "http://maps.google.com/maps?q=" + position.latitude + "%2C" + position.longitude;
    var button = '<div class="heavyButton success previewHidden" target="_blank" deeplink="true" href="'+link+'" style="display:block;margin-bottom:1em; margin-top: 0 !important; padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;background-color:#378589;text-align:center;text-decoration:none;color:white;">Open via Google Maps</div>';
    var result = '<a class="boxedContent" href="'+link+'" target="_blank" style="text-decoration: none !important; display: block; margin-right:20px;margin-left:20px; margin-bottom: 0 !important; text-align: center; padding: 0 !important; background-color: #efefef;"><div class="boxedContent" style="display: inline-block;"><img width="100%" height="auto" src="https://maps.googleapis.com/maps/api/staticmap?center='+position.latitude+','+position.longitude+'&zoom=15&scale=1&size=600x200&maptype=roadmap&key=AIzaSyAswhMK5gur4laAFw7R9i5p5eU2ez_eurM&format=png&visual_refresh=true&markers=size:large|'+position.latitude+','+position.longitude+'" /><div style="padding: 20px; text-align: center;">'+position.address+'</div></div>'+button+'</a>';

    console.log('debugresult', result);

    return result;

  }

  $scope.acknowledgeText = "";
  $scope.acknowledgeAlarm = function (comment, surveyResult) {

    var acknowledge = {
      "comment": comment,
      "ackedBy": {
        "id": smarttrackerService.getUserData().user.id
      },
      "meta": {
        "responseAreas": $scope.responseAreas,
        "comments": $scope.events,
        "asset": $scope.alarm.asset,
        "zone": $scope.alarm.zone,
        "order": $scope.order,
        "actionStatus": $scope.actionStatus,
        "commentsMeta": $scope.commentsMeta,
        "notificationStatus": $scope.notificationStatus,
        "surveyResult": surveyResult,
      }
    };


    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, acknowledge).then(function (response) {
      var alarm = response.data.result[0];
      if (alarm) {
        $scope.alarm.ackedBy = alarm.ackedBy;
        $scope.alarm.comment = alarm.comment;

        if (typeof $scope.alarm.comment === 'string') {
          $scope.alarm.comment = $scope.alarm.comment.replace(/\*\*([\s\S]+?)\*\*/gm, '<strong>$1</strong>');
        }

        sendSurveyMail($scope.alarm.id, acknowledge, surveyResult, $scope.contactLists);

        getResponseAreaForCode(codes.nqr).visible = false;
        if (killAlarmUpdater){
          killAlarmUpdater();
        }

      }
    });

    $scope.downloadAlarm();
    
  }

  var sendSurveyMail = function (alarmId, acknowledgeData, surveyResult, contactLists) {

    $http.post('https://server1.microservices.x-guard.nl/survey/follow-up', {
      alarmId: alarmId,
      data: acknowledgeData,
      surveyResult: surveyResult,
      contactLists: contactLists,
    });

  }

  var getActionStatusKey = function (contact) {
    return contact.name + "" + contact.phone + contact.email;
  }

  $scope.getActionStatus = function (contact) {
    var name = getActionStatusKey(contact);
    return $scope.actionStatus[name];
  }

  $scope.updateActionStatus = function (contact, status) {
    var name = getActionStatusKey(contact);
    if ($scope.actionStatus.hasOwnProperty(name) && $scope.actionStatus[name] == status) {
      delete $scope.actionStatus[name];
    } else {
      $scope.actionStatus[name] = status;
    }

    var meta = $scope.alarm.meta;
    meta["actionStatus"] = $scope.actionStatus;

    //var labels = $scope.alarm.labels;
    //labels["ALARM_CENTER_ACTIONS"] = {"value":JSON.stringify($scope.actionStatus)};
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
      "meta": meta
    });
    updateBZVisibility();
    // put update
  }


  $scope.startSurvey = function () {

    var modalInstance = $modal.open({
      templateUrl: 'modules/alarm-screen-xguard/alarm-screen-xguard-survey.html',
      controller: function ($scope, $modalInstance, alarm, outerScope) {

        console.log('Survey scope alarm', alarm);


        // translation table
        var translations = {
          audioExpected: 'SURVEY_RESULT_AUDIO_EXPECTED',
          audioQualityOk: 'SURVEY_RESULT_AUDIO_QUALITY_OK',
          audioQualityNotOkReason: 'SURVEY_RESULT_AUDIO_QUALITY_NOT_OK_REASON',
          responseSettingsOk: 'SURVEY_RESULT_REPSONSE_SETTINGS_OK',
          responseSettingsComment: 'SURVEY_RESULT_REPSONSE_SETTINGS_NOT_OK_REASON',
          positionOk: 'SURVEY_RESULT_POSITION_OK',
          locationQualityNotOkReason: 'SURVEY_RESULT_POSITION_NOT_OK_REASON',
          customerHappy: 'SURVEY_RESULT_CUSTOMER_HAPPY',
          acknowledgementComment: 'SURVEY_RESULT_ACK_COMMENT'
        }

        // replacements
        var replacements = {
          'true': 'Yes',
          'false': 'No',
          '2': 'Unknown',
          '3': 'Not applicable',
          '0': 'No',
          '1': 'Yes',
          'undefined': 'Left blank',
        }

        var possibleConstants = ['true', 'false', '3', '2', '0', '1', 'undefined'];
        var logdataReplacements = {
          'true': 1,
          'false': 0,
          '3': -2,
          '2': -1,
          '0': 0,
          '1': 1,
          'undefined': -1,
        }

        var translateArray = ['SURVEY_BUTTON_YES', 'SURVEY_BUTTON_NO', 'SURVEY_BUTTON_NA', 'SURVEY_BUTTON_UNKNOWN', 'SURVEY_BUTTON_NO', 'SURVEY_BUTTON_YES', 'SURVEY_UNDEFINED'];
        for (var i in translations) {
          translateArray.push(translations[i]);
        }
        $translate(translateArray).then(function (transData) {

          console.log('survey', 'transdata', transData)

          // overwrite
          translations = {
            audioExpected: transData['SURVEY_RESULT_AUDIO_EXPECTED'],
            audioQualityOk: transData['SURVEY_RESULT_AUDIO_QUALITY_OK'],
            audioQualityNotOkReason: transData['SURVEY_RESULT_AUDIO_QUALITY_NOT_OK_REASON'],
            responseSettingsOk: transData['SURVEY_RESULT_REPSONSE_SETTINGS_OK'],
            responseSettingsComment: transData['SURVEY_RESULT_REPSONSE_SETTINGS_NOT_OK_REASON'],
            positionOk: transData['SURVEY_RESULT_POSITION_OK'],
            locationQualityNotOkReason: transData['SURVEY_RESULT_POSITION_NOT_OK_REASON'],
            customerHappy: transData['SURVEY_RESULT_CUSTOMER_HAPPY'],
            acknowledgementComment: transData['SURVEY_RESULT_ACK_COMMENT']
          }

          // replacements
          replacements = {
            'true': transData['SURVEY_BUTTON_YES'],
            'false': transData['SURVEY_BUTTON_NO'],
            '3': transData['SURVEY_BUTTON_NA'],
            '2': transData['SURVEY_BUTTON_UNKNOWN'],
            '0': transData['SURVEY_BUTTON_NO'],
            '1': transData['SURVEY_BUTTON_YES'],
            'undefined': transData['SURVEY_UNDEFINED'],
          }

        })

        // init
        $scope.surveyDone = false;
        $scope.step = 0;
        $scope.lastStep = 8;

        $scope.percentage = 0;
        $scope.progressStyle = {
          width: '0%'
        };

        // init local
        var result = {};

        // set step function
        $scope.setStep = function (step, stepResult) {

          // loop and push result
          for (var i in stepResult) {

            if (possibleConstants.indexOf(stepResult[i] + '') !== -1) {

              // save the result
              result[i] = '%' + stepResult[i] + '%';

            } else {

              // save the result
              result[i] = stepResult[i];

            }

          }

          console.log('SurveyResult', result);

          // check if last step
          if (step > $scope.lastStep) {

            // we
            // are
            // done
            $scope.ok();

          } else {

            // set
            $scope.step = step;

            // progress
            var percentage = (($scope.step / $scope.lastStep) * 100);
            $scope.progressStyle = {
              marginTop: 0,
              width: percentage + '%'
            };
            $scope.percentage = Math.round(percentage);

          }

        }

        var beforeTranslations = {};
        $scope.setTranslatedStep = function (step, key, value) {

          // translate
          $translate(['' + value]).then(function (data) {

            // set
            var object = {};
            object[key] = data[value];

            beforeTranslations[data[value]] = value;

            // proxy to setStep
            $scope.setStep(step, object);

          });

        }

        // ok
        $scope.ok = function () {

          // loop all results
          var message = "";
          var originalResult = angular.copy(result);
          for (var i in result) {

            // loop replacements
            for (var j in replacements) {

              result[i] = (result[i] + '').replace(new RegExp('%' + j + '%', 'gi'), replacements[j]);

            }

            message += "**" + translations[i] + "**\n" + result[i] + "\n\n";

          }

          // logdata
          for (var i in originalResult) {

            // loop replacements
            for (var j in logdataReplacements) {

              originalResult[i] = (originalResult[i] + '').replace(new RegExp(j, 'gi'), logdataReplacements[j]);

            }

            for (var k in beforeTranslations) {

              originalResult[i] = (originalResult[i] + '').replace(k, beforeTranslations[k]);

            }

          }

          originalResult.alarmId = alarmID;
          originalResult.customerId = smarttrackerService.getCustomerId();

          try {

            originalResult.LocationAccuracy = alarm.position ? alarm.position.accuracy : alarm.lastValidPosition.accuracy;

          }catch(e){

            originalResult.LocationAccuracy = -1;

          }

          originalResult.CreatedDate = alarm.dateCreated + 'Z';
          originalResult.AcknowledgeDate = new Date().toISOString();
          originalResult.AlarmSeverity = alarm.logLevelFormatted;
          originalResult.AlarmText = alarm.name;

          originalResult.IsAckedByAlarmCenter = outerScope.isAlarmCenter ? 1 : 0;

          originalResult.CommentCount = outerScope.events && outerScope.events.length || 0;
          originalResult.FirstCommentDate = outerScope.events && ((outerScope.events.length > 0) ? (outerScope.events[outerScope.events.length - 1].dateCreated + 'Z') : -1) || -1;
          originalResult.HasExternalId = alarm.asset && alarm.asset.externalId && 1 || 0;
          originalResult.PageOpenedDate = PageOpenedDate;

          // done
          $modalInstance.close({
            message: message,
            surveyResult: originalResult,
          });

          $http.post('https://server1.microservices.x-guard.nl/survey', originalResult);

        }

        // cancel
        $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
        };


      },
      size: "lg",
      resolve: {
        alarm: function () {
          return $scope.alarm;
        },
        outerScope: function () {
          return $scope;
        },
      }
    });

    modalInstance.result.then(function (data) {

      // be done with it
      $scope.acknowledgeAlarm(data.message, data.surveyResult);

    });


  }


  $scope.trimPhoneNumber = function (nbr) {
    return nbr ? nbr.replace(/\+/, "00").replace(/\s/g, "") : nbr;
  }

  $scope.sendEmail = function (name, mail) {

    var md_content = "";


    $translate(["XGUARD_SEND_SMS_DIALOG.EXTERNAL_ID", "XGUARD_SMS_SPLASH_TITLE", "XGUARD_SMS_SPLASH_CONTENT",
      "XGUARD_SMS_ALARM_POSITION", "XGUARD_SMS_GOOGLE_MAPS_LINK", "XGUARD_SMS_ALARM_POSITION_RECEIVED", "XGUARD_SMS_RULE",
      "XGUARD_SMS_ASSET", "XGUARD_SMS_NAME", "XGUARD_SMS_EXTERNAL_ID", "XGUARD_SMS_LATEST_POSITION_UPDATE",
      "XGUARD_SMS_CURRENT_POSITION", "XGUARD_SMS_INSIDE_ZONES", "XGUARD_SMS_TYPE",
      "XGUARD_SMS_PHONE", "XGUARD_SMS_SMS", "XGUARD_SMS_EMAIL", "XGUARD_SMS_SMS_EVENT_TEXT", "XGUARD_SMS_SMS_FAILED_EVENT_TEXT", "XGUARD_SEND_MAIL_DIALOG_CONTENT", "XGUARD_SEND_MAIL_SUBJECT",
      "XGUARD_SEND_MAIL_EVENT_TEXT", "XGUARD_SEND_MAIL_FAILED_TEXT", "XGUARD_USER_TITLE", "ALARM_MANAGER_FILTER_TRIGGERING_ASSET", "MESSAGE_SERVICE_EMAIL_ASSET_IMAGE"
    ], {
      externalId: $scope.alarm.asset ? $scope.alarm.asset.externalId : "",
      contact: name,
      name: name,
      email: mail
    }).then(function (langData) {
      var asset = $scope.alarm.asset;



      var properties = "";
      angular.forEach(asset.properties, function (prop) {
        properties += getTableRow()
      });
      var ra = getResponseAreaForCode(codes.ra);
      console.log("Message Data: ", ra.messageData);
      var md = ra.messageData;
      var messageComponents = {};
      if (!md || (md.includes('email_position') || md.includes('email_links') || md.includes('email_positionTime') || md.includes('email_rule'))) {
        messageComponents.asset = {};
        messageComponents.alarm = {};
        var components = {
          'email_position': {
            key: 'position',
            value: {
              text: getTableRow(langData['XGUARD_SMS_ALARM_POSITION'], $scope.getAddressHTML($scope.alarm.position), true, true),
              label: langData['XGUARD_SMS_ALARM_POSITION'],
              selected: true
            }
          },
          // 'email_links': {
          //   key: 'map_link',
          //   value: $scope.alarm.position ? {
          //     text: getTableRow("Google Maps ("+langData['XGUARD_SMS_ALARM_POSITION']+"):&nbsp;", $scope.getGoogleMapsEmailButton($scope.alarm.position.latitude, $scope.alarm.position.longitude)),
          //     selected: true
          //   } : false
          // },
          // 'email_positionTime': {
          //   key: 'received',
          //   value: $scope.alarm.position ? {
          //     text: getTableRow(langData["XGUARD_SMS_ALARM_POSITION_RECEIVED"] + ":", $scope.alarm.position.timestampFormatted),
          //     selected: true
          //   } : false
          // },
          // 'email_rule': {
          //   key: 'rule',
          //   value: $scope.alarm.rule ? {
          //     text: (getTableRow(langData["XGUARD_SMS_RULE"] + ":", $scope.alarm.rule.name)),
          //     selected: true
          //   } : false
          // },
        };
        angular.forEach(components, function (content, component) {
          if ((!md || md.includes(component) && content.value)) {
            messageComponents.alarm[content.key] = content.value
          }
        });
      }

      messageComponents.additional = {};
      if ($scope.alarm.zone) {
        messageComponents.additional = {
          zone: {
            text: ($scope.alarm.zone ? getTableRow(langData["XGUARD_SMS_NAME"], $scope.alarm.zone.name) : ""),
            selected: true
          }
        };
      }
      if (md && md.includes('email_links')) {
        messageComponents.additional['amlink'] = {
          text: getTableRow('More Info : ', '<a href="' + $state.href('secure.content.alarm-screen-xguard-detail', {}, {
            absolute: true
          }) + '">Click Here</a>'),
          selected: true
        }
      }



      var insideZones = "";
      if (asset) {
        if (asset.insideZones && asset.insideZones.length > 0) {
          insideZones += asset.insideZones[0].name;
          for (var i = 1; i < asset.insideZones.length; i++) {
            insideZones += ", " + asset.insideZones[i].name;
          }
        }
        var propertiesString = "<tr><td colspan='2'><h2>Properties</h2></td></tr>";
        if (asset.properties) {
          angular.forEach(asset.properties, function (property) {
            propertiesString += getTableRow(property.name + ": ", property.value);
          });
        }

        var image = '';
        if(asset.image) {
          image = '<a href="' + asset.image + '" target="_blank"><img src="' + asset.image + '" alt="Foto van '+asset.name+', laad externe afbeeldingen om deze te bekijken!" style="max-width:150px; max-height: 100px; display: block; margin: auto;" height="100" class="CToWUd a6T" tabindex="0" /><small class="previewHidden">Klik om te vergroten</small></a>';
        }

        var externalId = '';
        if(asset.externalId) {

          externalId = '<div style="color: #444; margin-bottom: 2em !important;"><small>referentie: '+asset.externalId+'</span></div>';

        }

        messageComponents.asset.name = {
          text: (!md || md.includes('email_name')) ? getTableRow(langData["XGUARD_USER_TITLE"], "<h4 class='assetName' style='font-size: 25px; font-weight: bolder; margin: 0; margin-top: 5px;'>"+ asset.name+"</h4>" + externalId + image) : false,
          label: langData["XGUARD_USER_TITLE"],
          selected: (!md || md.includes('email_name'))
        };

        // messageComponents.asset.position = {
        //   text: (asset.lastValidPosition && (!md || md.includes('email_positionTime'))) ? getTableRow(langData["XGUARD_SMS_LATEST_POSITION_UPDATE"] + ":", asset.lastValidPosition.timestampFormatted) : false,
        //   selected: (asset.lastValidPosition && (!md || md.includes('email_positionTime')))
        // };
        // messageComponents.asset.zones = {
        //   text: (asset.insideZones && (!md || md.includes('email_position'))) ? getTableRow(langData["XGUARD_SMS_INSIDE_ZONES"] + ":", insideZones) : false,
        //   selected: (asset.insideZones && (!md || md.includes('email_position')))
        // };
        // messageComponents.asset.type = {
        //   text: ((asset.type && (!md || md.includes('email_type'))) ? getTableRow(langData["XGUARD_SMS_TYPE"] + ":", asset.type.name) : false),
        //   selected: (asset.type && (!md || md.includes('email_type')))
        // };
        // messageComponents.asset.properties = {
        //   text: (asset.properties && (!md || md.includes('email_properties'))) ? propertiesString : false,
        //   selected: (asset.properties && (!md || md.includes('email_properties')))
        // };

        if(asset.lastValidPosition.latitude !== $scope.alarm.position.latitude || asset.lastValidPosition.longitude !== $scope.alarm.position.longitude){

          messageComponents.additional.address = {
            text: (asset.lastValidPosition && (!md || md.includes('email_position'))) ? getTableRow(langData["XGUARD_SMS_CURRENT_POSITION"], $scope.getAddressHTML(asset.lastValidPosition), true, true) : false,
            label: langData["XGUARD_SMS_CURRENT_POSITION"],
            selected: (asset.lastValidPosition && (!md || md.includes('email_position')))
          };

          // messageComponents.asset.map_link = {
          //   text: (asset.lastValidPosition && (!md || md.includes('email_position'))) ? getTableRow("Google Maps ("+langData['XGUARD_SMS_CURRENT_POSITION']+"):&nbsp;", $scope.getGoogleMapsEmailButton(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude)) : false,
          //   selected: (asset.lastValidPosition && (!md || md.includes('email_position')))
          // };

        }


      }


      var title = langData['XGUARD_SEND_MAIL_DIALOG_CONTENT'];
      var modalInstance = $modal.open({
        templateUrl: 'modules/alarm-screen-xguard/message-preview.html',
        controller: function ($scope, $modalInstance, messageComponents, title, alarmId, getTableRow) {
          $scope.messageComponents = messageComponents;
          $scope.customMessage = "";
          $scope.title = title;
          $scope.getTableRow = getTableRow;
          $scope.ok = function () {

            var message = '';

            // add custom message
            if($scope.customMessage.length > 0){

              message = getTableRow('Bericht van de centralist', $scope.customMessage);

            }

            message += '';
            angular.forEach($scope.messageComponents, function (value, key) {
              angular.forEach(value, function (value2, key2) {
                if (value2.selected) {
                  message += value2.text;
                }
              });
            });
            
            message += "<br /><div style='text-align: center;'><small>Alarm ID: "+alarmId+"</small></div><br />";

            $modalInstance.close({
              message: message
            });
          };
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        },
        size: "lg",
        resolve: {
          messageComponents: function () {
            return messageComponents;
          },
          title: function () {
            return title;
          },
          alarmId: function() {
            return $scope.alarm.id;
          },
          getTableRow: function(){
            return $scope.getTableRow;
          }
        }
      });

      modalInstance.result.then(function (data) {
        if (data.message) {
          var dialog = dialogService.wait("XGUARD_SEND_MAIL_SPLASH_TITLE", "XGUARD_SEND_MAIL_SPLASH_CONTENT", {});

          const templateData = '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"/><style>body{background-color: #F5F5F5; font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif; padding: 20px;}.main{margin: auto; width: 95%; max-width: 600px; background-color: white;}h1{font-size: 18px; margin: 0; display: block; background-color: #3581BE; color: white; margin: 0; padding: 5px; font-weight: 300; padding: 20px;}.logoXG{margin: 20px;}a.footer{color: black; font-size: x-small;}.question{padding: 20px; margin: 20px; background-color: #efefef; color: white; font-size: 14px;}.question h2{margin-top: 0; color: black; font-weight: 300; text-align: center; padding: 25px; padding-bottom: 0; margin-bottom: 10px;}.notice{padding: 20px; margin: 20px; background-color: #efefef; color: black; font-size: 14px;}.notice p{margin-top: 0; margin-bottom: 0;}.heavyButton{display: block; margin-bottom: 1em; padding: 10px; background-color: #d0382a; text-align: center; text-decoration: none; color: white;}.heavyButton.success{background-color: #378589;}</style><table border="0" cellpadding="0" cellspacing="0" class="main" style="width:95%;max-width:600px;margin-top:auto;margin-bottom:auto;margin-right:auto;margin-left:auto;border-width:0;border-collapse:collapse;background-color:white;" > <tr> <td style="border-width:0;" > <img class="logoXG" alt="X-Guard Logo" src="https://download.x-guard.nl/x-guard-header.png" width="300" style="width: 300px; margin-top:20px;margin-bottom:20px;margin-right:20px;margin-left:20px;" > </td></tr><tr> <td class="inside" style="border-width:0;" > <h1 style="font-size:18px;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;display:block;background-color:#3581BE;color:white;padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;font-weight:300;">Alarmmelding</h1> <div class="notice" style="padding-top:20px;padding-bottom:20px;padding-right:20px;padding-left:20px;margin-top:20px;margin-bottom:20px;margin-right:20px;margin-left:20px;background-color:#efefef;color:black;font-size:14px;" > <strong>U heeft een alarmmelding ontvangen</strong> <p>In de onderstaande e-mail staat informatie over de maker van een alarm. Deze informatie is u toegezonden door een centralist.</p><br /><p>U kunt deze informatie gebruiken bij de opvolging van het alarm.</p></div>%alarmBody%<br /></td></tr><tr> <td style="border-width:0;text-align:center;padding-top:10px;padding-bottom:10px;padding-right:10px;padding-left:10px;color:black;background-color:#F5F5F5;" > <small>Deze e-mail kan niet worden beantwoord.</small><br/> <small><a class="footer" href="https://x-guard.nl" target="_blank" style="color:black;font-size:x-small;" >x-guard.nl</a> / <a class="footer" href="tel:0031881261212" target="_blank" style="color:black;font-size:x-small;" >+31 88 126 12 12</a> / <a class="footer" href="mailto:info@x-guard.nl" target="_blank" style="color:black;font-size:x-small;" >info@x-guard.nl</a></small> </td></tr></table>';
          const mailBodyTemplated = templateData.replace('%alarmBody%', data.message);

          var mailBody = {
            "to": mail,
            "subject": langData['XGUARD_SEND_MAIL_SUBJECT'],
            "message": mailBodyTemplated
          };
          smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/mail/", mailBody).then(function () {
            $scope.registerEvent(langData['XGUARD_SEND_MAIL_EVENT_TEXT']);
            dialog.close();
          }, function (response) {
            $scope.registerEvent(langData['XGUARD_SEND_MAIL_FAILED_TEXT'], data.message);
            dialog.close();
          });
        }
      });

    });
  }

  $scope.contactCalled = function (name) {
    // $translate.use("nl");
    $translate("XGUARD_CONTACT_CALLED_EVENT_TEXT", {
      contact: name
    }).then(function (data) {
      $scope.registerEvent(data);
      //   $translate.use("en");
    })
  }

  $scope.showContact = function(contact) {

    contact.showNumber = true;
    $scope.contactCalled(contact.name);

  }

  $scope.linkClicked = function (link) {
    $location.path(link);
  };

  $scope.sendSMS = function (contact) {
    var formatNumber = false;
    var number = contact.sms;
    try {
      formatNumber = $scope.trimPhoneNumber(number);
    } catch (e) {}
    if (!formatNumber) {
      alert("The number: " + number + " is not a valid phone number " + formatNumber);
      return;
    }
    var name = contact.name;

    $translate(["XGUARD_SEND_SMS_DIALOG.EXTERNAL_ID", "XGUARD_SMS_SPLASH_TITLE", "XGUARD_SMS_SPLASH_CONTENT",
      "XGUARD_SMS_ALARM_POSITION", "XGUARD_SMS_GOOGLE_MAPS_LINK", "XGUARD_SMS_ALARM_POSITION_RECEIVED", "XGUARD_SMS_RULE",
      "XGUARD_SMS_ASSET", "XGUARD_SMS_NAME", "XGUARD_SMS_EXTERNAL_ID", "XGUARD_SMS_LATEST_POSITION_UPDATE",
      "XGUARD_SMS_CURRENT_POSITION", "XGUARD_SMS_INSIDE_ZONES", "XGUARD_SMS_TYPE",
      "XGUARD_SMS_PHONE", "XGUARD_SMS_SMS", "XGUARD_SMS_EMAIL", "XGUARD_SMS_SMS_EVENT_TEXT", "XGUARD_SMS_SMS_FAILED_EVENT_TEXT", "XGUARD_SEND_SMS_DIALOG_CONTENT"
    ], {
      externalId: $scope.alarm.asset ? $scope.alarm.asset.externalId : "",
      contact: name,
      name: name,
      number: number
    }).then(function (langData) {
      var asset = $scope.alarm.asset;
      var title = langData.XGUARD_SEND_SMS_DIALOG_CONTENT;
      var insideZones = "";
      if (asset && asset.insideZones && asset.insideZones.length > 0) {
        insideZones += asset.insideZones[0].name;
        for (var i = 1; i < asset.insideZones.length; i++) {
          insideZones += ", " + asset.insideZones[i].name;
        }
      }
      // $scope.assetTitle = (langData["XGUARD_SMS_ASSET"] + "\n");
      var messageComponents = {
        asset: {
          name: {
            text: "\n\n["+langData["XGUARD_SMS_NAME"] + "]\n" + asset.name,
            label: langData["XGUARD_SMS_NAME"],
            selected: true
          },
        },
        alarm: {
          position: {
            text: "\n\n["+langData["XGUARD_SMS_ALARM_POSITION"] + "]\n" + $scope.alarm.position.address,
            label: langData["XGUARD_SMS_ALARM_POSITION"],
            selected: true
          },
          // map_link: {
          //   text: langData["XGUARD_SMS_GOOGLE_MAPS_LINK"] + ": " + $scope.getGoogleMapsLink($scope.alarm.position.latitude, $scope.alarm.position.longitude) + "\n",
          //   selected: false
          // },
          // received: {
          //   text: langData["XGUARD_SMS_ALARM_POSITION_RECEIVED"] + ": " + $scope.alarm.position.timestampFormatted + "\n",
          //   selected: false
          // },
          // rule: {
          //   text: ($scope.alarm.rule ? langData["XGUARD_SMS_RULE"] + ": " + $scope.alarm.rule.name + "\n" : ""),
          //   selected: false
          // },
        },
        additional: {
          address: {
            text: "\n\n["+langData["XGUARD_SMS_CURRENT_POSITION"] + "]\n" + asset.lastValidPosition.address,
            label: langData["XGUARD_SMS_CURRENT_POSITION"],
            selected: true
          },
        }
        //   externalId: {
        //     text: langData["XGUARD_SMS_EXTERNAL_ID"] + ": " + asset.externalId + "\n",
        //     selected: false
        //   },
        //   position: {
        //     text: langData["XGUARD_SMS_LATEST_POSITION_UPDATE"] + ": " + asset.lastValidPosition.timestampFormatted + "\n",
        //     selected: false
        //   },
        //   zones: {
        //     text: langData["XGUARD_SMS_INSIDE_ZONES"] + ": " + insideZones + "\n",
        //     selected: false
        //   },
        //   type: {
        //     text: (asset.type ? langData["XGUARD_SMS_TYPE"] + ": " + asset.type.name + "\n" : ''),
        //     selected: false
        //   },
        //   phone: {
        //     text: (asset.phone ? langData["XGUARD_SMS_PHONE"] + ": " + asset.phone + "\n" : ""),
        //     selected: false
        //   },
        //   sms: {
        //     text: (asset.sms ? langData["XGUARD_SMS_SMS"] + ": " + asset.sms + "\n" : ""),
        //     selected: false
        //   },
        //   email: {
        //     text: (asset.email ? langData["XGUARD_SMS_EMAIL"] + ": " + asset.email + "\n" : ""),
        //     selected: false
        //   },
        //   map_link: {
        //     text: langData["XGUARD_SMS_GOOGLE_MAPS_LINK"] + ": " + $scope.getGoogleMapsLink(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude) + "\n",
        //     selected: false
        //   }
        // },
        // additional: {
        //   zone: {
        //     text: ($scope.alarm.zone ? langData["XGUARD_SMS_NAME"] + ": " + $scope.alarm.zone.name : ""),
        //     selected: false
        //   },
        //   amlink: {
        //     text: 'More Info : ' + $state.href('secure.content.alarm-screen-xguard-detail', {}, {
        //       absolute: true
        //     }),
        //     selected: false
        //   }
        // }

      };


      var modalInstance = $modal.open({
        templateUrl: 'modules/alarm-screen-xguard/message-preview.html',
        controller: function ($scope, $modalInstance, messageComponents, title) {
          $scope.messageComponents = messageComponents;
          $scope.customMessage = "";
          $scope.title = title;
          $scope.openToggle = function (toggle) {
            $scope.openDialog = toggle;
          }

          $scope.closeToggle = function ($event) {
            var cl = $event.target.classList;
            if ($event.target.id != $scope.openDialog && !cl.contains("dropdownItem")) {
              $scope.openDialog = "";
            }
          };

          $scope.setText = function(smsTemplateItem) {

            $scope.customMessage = smsTemplateItem.value;

          }

          $scope.smsTemplateList = [{
            label: 'Pand betreden veilig',
            value: 'Alles is veilig. U kunt het pand veilig betreden. Het alarm wordt voor u uitgeschakeld. Succes vandaag.',
          }, {
            label: 'Pand verlaten veilig',
            value: 'Er zijn geen bijzonderheden geconstateerd. U kunt de vestiging verlaten. Het alarm wordt aangezet en is binnen 2 minuten actief. Fijne avond.',
          }, {
            label: 'Bijzonderheden bij vestiging',
            value: 'Er zijn bijzonderheden rondom de vestiging. Er wordt nu contact met u opgenomen voor verdere instructies.',
          }, {
            label: '=================',
            value: '',
          }, {
            label: 'Opening - alarm al gedeactiveerd',
            value: 'Er is al een collega in de vestiging alarm is al gedeactiveerd.',
          }, {
            label: 'Opening - bijzonderheden',
            value: 'Er zijn bijzonderheden er wordt contact met u opgenomen voor instructies.',
          }, {
            label: 'Opening - geen bijzonderheden',
            value: 'De omgeving is gecontroleerd u kunt de vestiging betreden. Alarm is gedeactiveerd.',
          }, {
            label: '=================',
            value: '',
          }, {
            label: 'Sluiting - overbruggingen/storingen',
            value: 'Er zijn overbruggingen/storingen in de vestiging. Er wordt contact opgenomen of u krijgt een bericht voor instructies.',
          }, {
            label: 'Sluiting - brand- en sluitronde',
            value: 'Succes met brand- en sluitronde. Bij bijzonderheden druk op de rode knop om contact te maken met MCR.',
          }, {
            label: 'Sluiting - wacht op controle',
            value: 'U wilt de vestiging sluiten, wacht in de vestiging de omgeving wordt gecontroleerd.',
          }]


          $scope.ok = function () {
            var message = $scope.customMessage;
            // var assetTitle = {
            //   text: (langData["XGUARD_SMS_ASSET"] + "\n"),
            //   inserted: false
            // };
            angular.forEach($scope.messageComponents, function (value, key) {
              angular.forEach(value, function (value2, key2) {
                if (value2.selected) {
                  // if (key == 'asset' && !assetTitle.inserted) {
                  //   message += assetTitle.text;
                  //   assetTitle.inserted = true;
                  // }
                  message += value2.text;
                }
              });
            })

            // add line break in end
            message += "\n";

            // remove not needed line breaks
            message = message.replace(/^\n+/, '');

            console.log(message);
            $modalInstance.close({
              message: message
            });
          };
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        },
        size: "lg",
        resolve: {
          messageComponents: function () {
            return messageComponents;
          },
          title: function () {
            return title
          }
        }
      });

      modalInstance.result.then(function (data) {
        console.log("update alarm done", data);
        if (data.message) {
          var dialog = dialogService.wait("XGUARD_SMS_SPLASH_TITLE",
            "XGUARD_SMS_SPLASH_CONTENT", {});
          var smsBody = {
            "to": formatNumber,
            "message": data.message
          };

          smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/sms/", smsBody).then(function () {
            $scope.registerEvent(langData["XGUARD_SMS_SMS_EVENT_TEXT"], data.promptText);
            dialog.close();
          }, function (response) {
            $scope.registerEvent(langData["XGUARD_SMS_SMS_FAILED_EVENT_TEXT"], data.promptText);
            dialog.close();
          });
        }
      });
    });
  }


  $scope.mapData = {
    center: {
      lat: 52.386617,
      lng: 5.799990,
      zoom: 8
    },
    defaults: {
      dragging: true,
      maxZoom: 21
    },
    events: {
      map: {
        enable: ['dragstart', 'zoomstart', 'click'],
        logic: 'emit'
      }
    }
  };

  var smallScreen = function () {
    if ($(this).width() > 1199) {
      $scope.screenSmallitems = false;
    } else {
      $scope.screenSmallitems = true;
    }
  };

  $scope.getIconColor = function (item) {
    var clazz = 'text-danger';
    var accuracy = item.position ? item.position.accuracy : item.lastValidPosition.accuracy;
    if ($scope.isIndoor(item) || (accuracy >= 0 && accuracy <= 15))
      clazz = 'text-success';
    else if (accuracy > 15 && accuracy <= 40)
      clazz = 'text-warning';
    return clazz;
  }

  $scope.getTimeColor = function () {
    var clazz = 'text-danger';
    if ($scope.alarm) {
      var alarmDate = moment.tz($scope.alarm.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
      var now = new Date();
      var diff = now - alarmDate;
      if (diff < 901 * 1000) {
        clazz = 'text-success';
      } else if (diff < 3900 * 1000) {
        clazz = 'text-warning';
      }
    }
    return clazz;
  }

  var setMobileView = function () {
    if ($(this).width() < 768) {
      $scope.appFormat = true;
    } else {
      $scope.appFormat = false;
    }
  };

  $(window).width(function () {
    setMobileView();
    smallScreen();
  });

  $(window).resize(function () {
    setMobileView();
    smallScreen();
  });


  //$scope.currentTab = 1;

  //$scope.switchTabs = function (number) {
  //    $scope.currentTab = number;
  //};


  var currentAlarm = function () {
    if (localStorage["currentAlarm"] == $scope.alarm.id) {
      $scope.currentTab = localStorage["currentTab"];
      console.log('localStorage unchanged: ' + localStorage["currentAlarm"]);
    } else {
      $scope.currentTab = 1;
      localStorage["currentTab"] = 1;
      localStorage["currentAlarm"] = $scope.alarm.id;
      console.log('localStorage ID changed to: ' + localStorage["currentAlarm"]);
    }
  };

  $scope.switchTabs = function (number) {
    $scope.currentTab = number;
    localStorage["currentTab"] = number;
  };
  $scope.togglePinSidebarMap = function () {
    $scope.localPinSidebarMap = !$scope.localPinSidebarMap;
    localStorage["PinSidebarMap"] = $scope.localPinSidebarMap;
  };

  $scope.localAlarmScreenMap = (localStorage["AlarmScreenMapSmall"] === "true");
  $scope.toggleAlarmScreenMap = function () {
    $scope.localAlarmScreenMap = !$scope.localAlarmScreenMap;
    localStorage["AlarmScreenMapSmall"] = $scope.localAlarmScreenMap;
    setTimeout(function () {
      $scope.initMap();
    }, 310);
  };

  $scope.initMap = function () {
    map.invalidateSize();
    $scope.autoCenter();
  };

  $scope.initMapDelayed = function () {
    setTimeout(function () {
      $scope.initMap();
    }, 50);
  };

  // Bind a color to the alarm
  $scope.getAlarmColor = function (item) {
    var color = 'text-danger';

    if (item.logLevelFormatted == null) {
      color = 'text-danger'
    } else {
      if (item.logLevelFormatted == 'notification') {
        color = 'text-success'
      } else if (item.logLevelFormatted == 'red_alert') {
        color = 'text-danger'
      } else if (item.logLevelFormatted == 'warning') {
        color = 'text-warning'
      }
    }
    return color
  };

  $scope.ZoomIn = function () {
    map.zoomIn();
  };

  $scope.ZoomOut = function () {
    map.zoomOut();
  };

  /** Notification related*/

  $scope.ns = {
    available: {
      status: "available",
      order: 0,
      messageKey: '',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_AVAILABLE'
    },
    unavailable: {
      status: "unavailable",
      order: 0,
      messageKey: '',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_UNAVAILABLE'
    },
    pending: {
      status: "pending",
      order: 1,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_PENDING',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_PENDING'
    },
    responded: {
      status: "responded",
      order: 2,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_FEEDBACK',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_RESPONDED'
    },
    confirmed: {
      status: "confirmed",
      order: 3,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_CONFIRMED',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_CONFIRMED'
    },
    failed: {
      status: "failed",
      order: 5,
      messageKey: 'ALARM_MANAGER_NOTIFICATION_COMMENT_FAILED',
      titleKey: 'ALARM_MANAGER_NOTIFICATION_TITLE_FAILED'
    }
  };
  var nsLabelKeys = {
    event: 'notificationEvent',
    userID: 'notificationEventUserID',
    status: 'notificationEventState',
    contactID: 'notificationEventContactID'
  };

  $scope.notificationStatus = {};
  var notificationStatusKey = "notificationStatus";
  $scope.notificationStatus["ff4d8839-7e6c-4287-89be-760c073a2d7e"] = {
    'status': 'pending'
  };
  $scope.notificationStatus["2e137984-1f74-4cac-a835-45993881b09d"] = {
    'status': 'feedback'
  };

  $scope.sendNotifications = function () {
    if ($scope.anyAvailablePush) {
      var validAccess = $scope.access['sendNotification']['post'] && $scope.access['alarm']['put'];
      if (!validAccess) return;
      console.log("Trying to send push");
      var idString = "";
      var qrs = getResponseAreaForCode(codes.qr).contacts;
      angular.forEach(qrs, function (contact) {
        if (contact.user) {
          idString += contact.id + "%2B"
        }
      });
      idString = idString.replace(/%2B$/, "");
      var modalInstance = $modal.open({
        templateUrl: 'core/html/picker.html',
        controller: stwoCommonPickerModalController,
        size: "md",
        resolve: {
          pickerConfiguration: function () {
            return {
              title: "MANAGEMENT_ASSET_TYPE_TITLE",
              clazz: "type",
              fieldsToShow: ["name"],
              nullAllowed: false,
              multiple: true,
              nullButtonText: "MANAGEMENT_ASSET_REMOVE_TYPE",
              downloadUrl: '/asset?select=name+connectedTo&id:equals=' + idString + '&sort=name&order=asc'
            }
          }
        }
      });
      modalInstance.result.then(function (pickerResult) {

        var receivers = [];
        var receiverContacts = [];
        angular.forEach(pickerResult.selectedItems, function (contact) {
          for (var i = 0; i < qrs.length; i++) {
            if (qrs[i].id == contact.id) {
              //updateNotificationStatusForContact(qrs[i], $scope.ns.pending.status);
              receivers.push({
                'id': qrs[i].user.id
              });
              receiverContacts.push(qrs[i]);
              break;
            }
          }
        });

        var body = {
          "recipients": receivers,
          "subject": $scope.translations.notificationMessage,
          "message": $scope.translations.notificationSubject,
          "object": {
            "id": $scope.alarm.id,
            "type": "alarm"
          },
          "type": "push"
        };
        smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/sendNotification/", body).then(function (response) {
          console.log("response:", response);
          angular.forEach(receiverContacts, function (contact) {
            var found = false;
            angular.forEach(response.data.recipients, function (recipient) {
              if (recipient.id == contact.user.id) {
                found = true;
              }
            });
            updateNotificationStatusForContact(contact, found ? $scope.ns.pending.status : $scope.ns.failed.status);
          });
          saveNotificationStatus();
        });

        //saveNotificationStatus();
      }, function () { /** CANCEL */ });
    }
  };

  var updateNotificationStatusForContact = function (contact, newStatus) {
    if (contact.notificationStatus && ($scope.ns[contact.notificationStatus].order > $scope.ns[newStatus].order || contact.notificationStatus == newStatus)) {
      return false;
    }
    contact.notificationStatus = newStatus;
    $translate($scope.ns[newStatus].messageKey, {
      receiver: contact.name
    }).then(function (data) {
      console.log("translated", data);
      // var labels = {
      //         'notificationEvent':{code:'ACR_NE', value:contact.user.id}, 
      //         'notificationEventState':{code:'ACR_NES', value:newStatus}, 
      //         'notificationEventContactID':{code:'ACR_NECI', value:contact.id}
      // };
      $scope.registerEvent(data, "", createCommentLabel(newStatus, contact.user.id, contact.id));
    });

    $scope.notificationStatus[contact.user.id] = {
      'status': newStatus,
      updated: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
      contact: contact
    }
    return true;
  }

  var saveNotificationStatus = function () {
    var meta = $scope.alarm.meta;
    meta[notificationStatusKey] = $scope.notificationStatus;
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
      'meta': meta
    });
  }

  /** As the */
  var checkNotificationStatusForComments = function () {
    var elements = $filter('commentsWithLabelKey')($scope.events, 'notificationEvent');
    // angular.forEach($scope.events, function (comment) {
    //             if(comment.labels && comment.labels['notificationEvent']) {
    //                 console.log("Adding comment" + comment.text + " because labels is ", comment.labels);
    //                 elements.push(comment);
    //             } else {
    //                 console.log("Ignoring comment "  + comment.text + " because labels is ", comment.labels);
    //             }
    //         });
    console.log("elements:", elements);
    var qrs = getResponseAreaForCode(codes.qr).contacts;
    var changed = false;
    angular.forEach(elements, function (comment) {
      try {
        var data = JSON.parse(comment.labels[nsLabelKeys.event].value);
        var id = data[nsLabelKeys.userID];
        var contact = $filter('contactWithUserId', qrs, id);
        var state = data[nsLabelKeys.state];
        if ($scope.ns[state].order >= 2 && $scope.ns[state].order > $scope.ns[$scope.notificationStatus[id].status].order) { // Only responded and confirmed are updated by non centralist
          $scope.notificationStatus[id] = {
            'status': state,
            updated: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
            contact: contact
          };
          changed = true;
        }
        // var cid = comment.labels['notificationEventContactID'].value;
        // var currentState = $scope.notificationStatus.id;
        // if(currentState && $scope.ns[currentState.state].order < $scope.ns[state].order){

        //     var contact = false;
        //     for(var i = 0; i < qrs.length;i++) {
        //         if(qrs[i].id == cid) {
        //             contact = qrs[i];
        //             break;
        //         }
        //     }
        //     if(updateNotificationStatusForContact(contact, state)) {
        //         changed = true;
        //     }
        // }
      } catch (e) {
        console.error("Error when parsing comment data for " + comment.name + ": " + e);
      }
    });
    if (changed) {
      saveNotificationStatus();
    }
  }

  var createCommentLabel = function (eventID, userID, contactID) {
    var label = {};
    var o = {};
    o[nsLabelKeys.userID] = userID;
    o[nsLabelKeys.eventID] = eventID;
    o[nsLabelKeys.contactID] = contactID;
    var label = {};
    label[nsLabelKeys.event] = {
      code: 'ACR_NE',
      value: JSON.stringify(o)
    };
    return label;
  }

  $scope.sendNotificationFeedback = function () {
    var currentStatus = $scope.notificationStatus[$scope.userID];
    if (currentStatus && (currentStatus.status == $scope.ns.pending.status || (currentStatus.status == $scope.ns.responded.status && $scope.me && $scope.me.distance <= 40))) {
      var nextStatus = currentStatus.status == $scope.ns.pending.status ? $scope.ns.responded.status : ns.confirmed.status;
      updateNotificationStatusForContact($scope.me, nextStatus);
      updateFeedbackVariables();
    }
  }

  var updateFeedbackVariables = function () {
    var currentStatus = $scope.notificationStatus[$scope.userID];
    if (currentStatus) {
      $scope.showFeedbackButton = (currentStatus.status == $scope.ns.pending.status);
      $scope.showConfirmButton = (currentStatus.status == $scope.ns.responded.status);
    }
  }


  /** End notification related */


}); // End Module alarm-screen-xguard-detail

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardAssetController', function ($scope, $translate, $controller, $state, $stateParams, $modal, smarttrackerService, notificationService, $interval) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  var assetID = $stateParams.assetID;
  // if(!assetID) {
  //     $state.go('secure.content.alarm-screen-xguard');
  // }

  var syntax = {
    email: "email",
    phone: "phone",
    sms: "sms",
    allowContact: "allowContact",
    allowEmergencyContact: "allowEmergencyContact",
    allowNQR: "allowNQR",
    updateIntervalSeconds: 60
  };


  var translations = [];
  $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE"]).then(function (data) {
    translations = data;

  });

  $translate(["XGUARD_ASSET_LABEL_PHONE", "XGUARD_ASSET_LABEL_ALLOW_CONTACT", "XGUARD_ASSET_LABEL_SHOW_NQR",
      "XGUARD_ASSET_LABEL_EMAIL", "XGUARD_ASSET_LABEL_SMS", "XGUARD_ASSET_LABEL_ALLOW_EMERGENCY_CONTACT"
    ])
    .then(function (data) {
      $scope.translations = {
        allowNQR: data["XGUARD_ASSET_LABEL_SHOW_NQR"],
        allowEmergencyContact: data["XGUARD_ASSET_LABEL_ALLOW_EMERGENCY_CONTACT"],
        phone: data['XGUARD_ASSET_LABEL_PHONE'],
        email: data['XGUARD_ASSET_LABEL_EMAIL'],
        allowContact: data['XGUARD_ASSET_LABEL_ALLOW_CONTACT'],
        sms: data['XGUARD_ASSET_LABEL_SMS']
      };
    });

  smarttrackerService.isLoggedInDelayed().then(function () {

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/asset/" + assetID + "?select=@&crossAccount=true").then(function (response) {
      $scope.asset = response.data.result[0];

      // sort properties
      sortProperties();
    });
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm?select=@&crossAccount=true&asset.id:equals=" + assetID + "&ackedBy:equals=null")
      .then(function (response) {
        $scope.alarms = response.data.result;
        if ($scope.alarms.length == 0) {
          /*$state.go('secure.content.asset.detail', {'id': assetID})*/
          $scope.noAlarmAvailable = true;
        } else if ($scope.alarms.length == 1) {
          $scope.gotoAlarm($scope.alarms[0].id);
        }
      });
  });



  $scope.gotoAlarms = function () {
    $state.go('secure.content.alarm-screen-xguard');
  }
  $scope.enableProperty = function (index) {
    var properties = $scope.asset.properties;
    if (properties[index].value != "true") {
      toggleProperty(index, "true");
    }
  }
  $scope.disableProperty = function (index) {
    var properties = $scope.asset.properties;
    if (properties[index].value != "false") {
      toggleProperty(index, "false");
    }
  }
  var toggleProperty = function (index, action) {
    var property = copyProperty($scope.asset.properties[index]);
    property.value = action;
    var json = {
      "properties": [property]
    }

    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/asset/" + $scope.asset.id, json)
      .then(function (response) {
        $scope.asset.properties = response.data.result[0].properties;
        sortProperties();
      });
  }

  var sortProperties = function () {
    var correctOrder = ["email", "phone", "sms", "allowNQR", "allowEmergencyContact", "allowContact"];
    $scope.asset.properties.sort(function (a, b) {
      return correctOrder.indexOf(a.code) - correctOrder.indexOf(b.code);
    });
  }
  var copyProperty = function (property) {
    var copy = property.constructor();
    for (var attr in property) {
      if (property.hasOwnProperty(attr)) copy[attr] = property[attr];
    }
    return copy;
  }

  $scope.gotoAlarm = function (alarmID) {
    $state.go("secure.content.alarm-screen-xguard-detail", {
      id: alarmID
    });
  }
});

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardExternalIdController', function ($scope, $translate, $controller, $state, $stateParams, $modal, smarttrackerService, notificationService, $interval) {
  $controller('BaseListContentController', {
    $scope: $scope
  });

  smarttrackerService.isLoggedInDelayed().then(function () {

    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/alarm?select=asset.externalId%2BdateCreated&max=1&asset.externalId:equals=" + encodeURIComponent($stateParams.externalId) + "&sort=dateCreated&order=desc&crossAccount=true", {
      onErrorDoNotRedirect: true
    }).then(function (response) {

      // check result
      if (typeof response.data.result !== 'undefined' && response.data.result.length > 0) {

        // alarm is first item
        var alarm = response.data.result[0];

        // go to alarm
        $state.go("secure.content.alarm-screen-xguard-detail", {
          id: alarm.id,
        });

      } else {

        // go to alarm
        $state.go("secure.content.alarm-screen-xguard");

      }

    });

  });

  // // go to alarm
  // $state.go("secure.content.alarm-screen-xguard-detail", {
  //   id: alarmID
  // });

});

angular.module('stwo.alarm-screen-xguard').controller('AlarmScreenXGuardAlertController', function ($scope, $translate, $controller, $state, $stateParams, smarttrackerService) {
  $controller('BaseListContentController', {
    $scope: $scope
  });
  var assetID = $stateParams.assetID;
  $translate(["ALARM_CENTER_ALERT_ALARM_NAME", "ALARM_CENTER_ALERT_ALARM_ERROR",
    "ALARM_CENTER_ALERT_ALARM_PROVIDE_ASSET_ID"
  ]).then(function (data) {
    smarttrackerService.isLoggedInDelayed().then(function () {
      if (assetID) {
        smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/alarm/", {
          'name': data['ALARM_CENTER_ALERT_ALARM_NAME'],
          'ackNeeded': true,
          'asset': {
            'id': assetID
          }
        }).then(function (response) {
          $state.go("secure.content.alarm-screen-xguard-detail", {
            id: response.data.result[0].id
          });
        }, function (response) {
          $scope.errors = data['ALARM_CENTER_ALERT_ALARM_ERROR'] + response.data.message;
          console.error("Error response", response);
        });
      } else {
        $scope.errors = data['ALARM_CENTER_ALERT_ALARM_PROVIDE_ASSET_ID'];
      }
    });
  });
});
// module config
angular.module('stwo.cp', ["stwo.core"]).config(function ($stateProvider, moduleStoreProvider) {

    // init
    var lastCustomerIdOfPoll = -1;

    // poll function
    var pollSmarttrackerForCpEvents = function () {
        var sts = moduleStoreProvider.serviceRepository()["smarttrackerService"];
        var cps = moduleStoreProvider.serviceRepository()["cpService"];
        if (cps && sts && sts.getCustomerId() && sts.getAccessRights()["beacon"] && sts.getAccessRights()["beacon"]["put"]) {
            cps.pollForEvents(true); // always force for now because of complaints this does not work well. lastCustomerIdOfPoll !== sts.getCustomerId());
            lastCustomerIdOfPoll = sts.getCustomerId();
        }
    }

    // register module
    moduleStoreProvider.registerModule({
        name: "cp",
        links: [{
            name: "CP_NAVIGATION",
            category: "MANAGEMENT",
            sref: "secure.content.cp",
            access: ["beacon", "put"],
            icon: 'home',
            color: "danger",
            badge: "notificationCount",
            sort: 30,
            navigation: true,
            controllers: ['CpListController', 'CpEventController', 'CpCompleteController']
        }],
        notificationHandlers: {
            view: function (notification) {
                moduleStoreProvider.serviceRepository()["$state"].go("secure.content.cp");
            },
            push: function (data, util) {

                // check for push updates
                if (data.type === 'cp') {

                    // poll because of push
                    pollSmarttrackerForCpEvents();

                }

            },
            poll: function () {

                // poll
                pollSmarttrackerForCpEvents();

            },
            dismiss: function (notification, dismissFn) {
                dismissFn();
            }
        }
    });

    // state
    $stateProvider
        .state("secure.content.cp", {
            url: "/cp/",
            templateUrl: "modules/cp/cp.html",
            controller: "CpListController",
            titleName: 'CP_TITLE_EVENTS',
            titleIcon: "home"
        })
        .state("secure.content.cp.event", {
            url: "/cp-event/:id/:timestamp",
            templateUrl: "modules/cp/event.html",
            controller: "CpEventController",
            titleName: 'CP_TITLE_EVENTS',
            titleIcon: "home"
        })
        .state("secure.content.cpcomplete", {
            url: "/cp-complete",
            templateUrl: "modules/cp/complete.html",
            controller: "CpCompleteController",
            titleName: 'CP_TITLE_EVENTS',
            titleIcon: "home"
        })
});

// runtime code
angular.module('stwo.cp').run(function (cpService) {
    console.log("Force loading cp service")
});


// service definition
angular.module('stwo.cp').factory('cpService', function ($http, $q, smarttrackerService, notificationService, moduleStore) {

    // init
    var lastDownload = 0;
    var events = [];
    var zonesPerEvent = {};

    var i = {};

    var status = {
        downloading: false,
        defer: null
    };

    // update
    i.update = function (evs, zpes) {
        events = evs;
        zonesPerEvent = zpes;
    }

    // getters
    i.getEvents = function () {
        return events;
    }
    i.getStatus = function () {
        return status;
    }
    i.getZonesPerEvent = function () {
        return zonesPerEvent;
    }

    // poll funciton
    i.pollForEvents = function (forceDownload) {

        // check permissions
        if (smarttrackerService && smarttrackerService.getCustomerId() && smarttrackerService.getAccessRights()["beacon"] && smarttrackerService.getAccessRights()["beacon"]["put"]) {

            // download events first
            i.downloadEvents(forceDownload).then(function () {

                // get as object
                var potentialEvents = i.getEvents();

                // init loop
                var notificationIdsSeen = {};
                for (var n = 0; n < potentialEvents.length; n++) {

                    // save cp in array
                    notificationIdsSeen["cp-" + potentialEvents[n].uuid] = true;
                    notificationService.add({
                        id: "cp-" + potentialEvents[n].uuid,
                        time: potentialEvents[n].timestamp,
                        level: "success", //success, info, warning, danger
                        name: potentialEvents[n].message,
                        module: "cp",
                        dismissable: false,
                        dismissed: false,
                        access: ["beacon", "put"],
                        eventId: potentialEvents[n].uuid
                    });

                }

                // dismiss notifications for opened ids
                var nss = notificationService.list();

                //
                for (var nn = 0; nn < nss.length; nn++) {
                    if (nss[nn].module === "cp" && !notificationIdsSeen[nss[nn].id]) {

                        // silent dismissal
                        notificationService.silentDismiss(nss[nn].id);
                    }
                }
            });

        } else {

            console.log('CP Insufficient rights to add locations')

        }
    }

    // download all events
    i.downloadEvents = function (forceDownload) {

        // check force downloading or cache
        if (status.downloading || (!forceDownload && status.defer && (new Date().getTime() - lastDownload) < 120000)) {
            console.log('Stopping download of CP', status.downloading, forceDownload, status.defer, (new Date().getTime() - lastDownload) < 120000)
            return status.defer.promise;
        } else {
            status.downloading = true;
            status.defer = $q.defer();
            lastDownload = (new Date().getTime());
        }

        console.log('Downloading CPs started sequence')

        // prepare zones
        var zonesPerEventMap = {};
        for (var k in zonesPerEvent) {
            delete zonesPerEvent[k]
        }

        // prepare dates and times
        var nowInUtc = moment(new Date()).tz("UTC").format("YYYY-MM-DDTHH:mm:ss.SSS");
        var thenInUtc = moment(new Date((new Date()).getTime() - 24 * 3600 * 1000)).tz("UTC").format("YYYY-MM-DDTHH:mm:ss.SSS");
        var now = (new Date()).getTime();

        // localstorage updates
        // remove old localStorage entries not relevant anymore
        for (var k in localStorage) {
            if (k.indexOf("ignore-") === 0) {
                if (parseInt(localStorage[k]) < now) {
                    delete localStorage[k];
                }
            }
        }

        // get event history from time range define above
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/eventHistory?select=*&timestamp:greater=" + thenInUtc + "&timestamp:less=" + nowInUtc + "&max=1000")
            .then(function (responseHistory) {

                // check if we got data
                if (responseHistory && responseHistory.data && responseHistory.data.result) {

                    // init
                    events.splice(0, events.length)
                    var potentialEvents = [];
                    var potentialEventIds = [];
                    var zonesToDownload = {};

                    // loop events
                    for (var n = 0; n < responseHistory.data.result.length; n++) {

                        // init
                        var ev = responseHistory.data.result[n];

                        // online custom:cp events which are not ignored
                        if (ev.type === "custom" && ev.subEvent === "cp" && !localStorage["ignore-" + ev.uuid]) {

                            // save event
                            potentialEvents.push(ev);
                            potentialEventIds.push(ev.uuid);
                            zonesPerEventMap[ev.uuid] = {};
                            zonesPerEvent[ev.uuid] = [];

                            // zones bound to this event need to be downloaded
                            // save those in zonesToDownload
                            for (var k in ev.properties) {
                                if (k.indexOf("zone_") === 0) {
                                    zonesToDownload[k.split("_")[1]] = true;
                                    zonesPerEventMap[ev.uuid][k.split("_")[1]] = true;
                                }
                            }
                        }
                    }

                    // convert zonesToDownload to an array for easier handling
                    var zonesToDownloadArray = [];
                    for (var k in zonesToDownload) {
                        zonesToDownloadArray.push(k);
                    }

                    if (zonesToDownloadArray.length) {

                        var specificAddition = "&meta:contains=" + potentialEventIds.join("%2B");
                        if(specificAddition.length > 1800){

                            specificAddition = "";

                        }

                        // get beacons for all found CPs (line ~225)
                        //smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/beacon?max=1000&select=meta&meta:contains=" + potentialEventIds.join("%2B")) // %2B = +
                        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/beacon?max=10000&select=meta"+specificAddition) // %2B = +
                            .then(function (responseBeacons) {

                                if (responseBeacons && responseBeacons.data) {

                                    // loop found beacons
                                    for (var bidx = 0; bidx < responseBeacons.data.result.length; bidx++) {

                                        // init
                                        var beaconFromEvent = responseBeacons.data.result[bidx];

                                        // // check if potential
                                        // if(potentialEventIds.indexOf(beaconFromEvent.meta.sourceEvent))

                                        // loop all potential events
                                        for (var evidx = potentialEvents.length - 1; evidx >= 0; evidx--) {

                                            // remove potential events if the beacon source does not match
                                            if (beaconFromEvent.meta && beaconFromEvent.meta.sourceEvent === potentialEvents[evidx].uuid) {
                                                potentialEvents.splice(evidx, 1);
                                            }

                                        }

                                    }

                                }

                                // only proceed if we still have any CPs left
                                if (potentialEvents.length) {

                                    // download beacons close to zones
                                    // zones to download define at line ~228
                                    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/beacon?max=1000&select=positionProvider&positionedBy.id:equals=" + zonesToDownloadArray.join("%2B"))
                                        .then(function (responseBeacons2) {

                                            // check data
                                            var zonesWithBeacons = {};
                                            if (responseBeacons2 && responseBeacons2.data) {

                                                // zones with beacons are already confirmed
                                                // loop through the beacons bound to beacons
                                                // and make sure the CPs we found are 'unconfirmed'
                                                for (var b = 0; b < responseBeacons2.data.result.length; b++) {
                                                    var beacon = responseBeacons2.data.result[b];

                                                    if (beacon.positionProvider) {
                                                        zonesWithBeacons[beacon.positionProvider.id] = true;
                                                    }
                                                }

                                            }

                                            console.log('Starting CP get zones metdata')

                                            // get the zones to download metadata
                                            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/zone?max=1000&select=@&id:equals=" + zonesToDownloadArray.join("%2B"))
                                                .then(function (responseZones) {

                                                    // check
                                                    if (responseZones && responseZones.data) {

                                                        // loop through zones
                                                        for (var z = 0; z < responseZones.data.result.length; z++) {

                                                            // init
                                                            var zone = responseZones.data.result[z];

                                                            // zonesPerEventMap is defined at line ~228
                                                            // for every CP we saved what zones are associated
                                                            // these are downloaded now and should be associated with the zonesPerEvent 
                                                            for (var kz in zonesPerEventMap) {

                                                                // loop the zones defined for this kz (kz = the CP event in this case)
                                                                for (var kz2 in zonesPerEventMap[kz]) {

                                                                    // check if the zone does not have beacons
                                                                    // check if the zone exists and if the id matches
                                                                    if (!zonesWithBeacons[zone.id] && zonesPerEventMap[kz][kz2] && kz2 === String(zone.id)) {

                                                                        // save for the event
                                                                        zonesPerEvent[kz].push(zone);

                                                                    }
                                                                }
                                                            }
                                                        }

                                                        // // loop potential events again
                                                        // for (var cpn = 0; cpn < potentialEvents.length; cpn++) {

                                                        //     var insideZones = potentialEvents[cpn].position.insideZones;
                                                        //     for (var cpnInside = 0; cpnInside < insideZones.length; cpnInside++) {

                                                        //         if (zonesToDownloadArray.indexOf(insideZones[cpnInside].id) !== -1) {

                                                        //             potentialEvents[cpn].actuallyInside = true;
                                                        //             continue;

                                                        //         }

                                                        //     }

                                                        // }

                                                        // loop potential events again
                                                        for (var cpn = 0; cpn < potentialEvents.length; cpn++) {

                                                            // check if the CP has a zone and thus is an inside location
                                                            if (zonesPerEvent[potentialEvents[cpn].uuid] && zonesPerEvent[potentialEvents[cpn].uuid].length > 0) {

                                                                // if (potentialEvents[cpn].actuallyInside === true) {

                                                                // save
                                                                events.push(potentialEvents[cpn]);

                                                                // }

                                                            }
                                                        }

                                                        console.log('Found Events', events)
                                                        console.log('Found EventsZones', zonesPerEvent)
                                                        console.log('zonesToDownloadArray', zonesToDownloadArray)

                                                        // stop
                                                        status.defer.resolve();
                                                        status.downloading = false;

                                                    } else {

                                                        console.log('Stopped loading CPs', 'Something went wrong downloading the zones', responseZones)

                                                        // stop
                                                        status.defer.resolve();
                                                        status.downloading = false;

                                                    }

                                                }, function (response) {

                                                    console.log('Stopped loading CPs', response)

                                                    // stop
                                                    status.defer.reject();
                                                    status.downloading = false;

                                                })

                                        }, function (response) {

                                            console.log('Stopped loading CPs', response)

                                            // stop
                                            status.defer.reject();
                                            status.downloading = false;

                                        })

                                } else {

                                    console.log('Stopped loading CPs', 'no CPs left')

                                    // stop
                                    status.defer.resolve();
                                    status.downloading = false;

                                }

                            }, function (response) {

                                console.log('Stopped loading CPs', response)

                                // stop
                                status.defer.reject();
                                status.downloading = false;

                            })

                    } else {

                        console.log('Stopped loading CPs', 'no zonesToDownloadArray')

                        // stop
                        status.defer.reject();
                        status.downloading = false;

                    }
                } else {

                    console.log('Stopped loading CPs', 'no data', response)

                    // stop
                    status.defer.reject();
                    status.downloading = false;

                }

            }, function (response) {

                console.log('Stopped loading CPs', response)

                // stop
                status.defer.reject();
                status.downloading = false;

            })

        return status.defer.promise;
    }

    moduleStore.serviceRepository()["cpService"] = i;
    return i;
});

angular.module('stwo.cp').controller('CpListController', function ($scope, $stateParams, $state, $modal, $controller, smarttrackerService, cpService) {
    //https://www.smarttracker.no/web/api2/eventHistory?select=*&timestamp:greater=2015-05-27T06:31:00.320&timestamp:less=2015-08-10T10:22:00.320&max=100&order=desc&sort=timestamp
    $scope.cpEvents = cpService.getEvents();
    $scope.zonesPerEvent = cpService.getZonesPerEvent();
    $scope.status = cpService.getStatus();

    $scope.refresh = function () {
        console.log('Downloading CPs')
        smarttrackerService.isLoggedInDelayed().then(function () {
            console.log('Downloading CPs started')
            cpService.downloadEvents(true);
        });
    };

    smarttrackerService.isLoggedInDelayed().then(function () {
        console.log('Downloading CPs naturally')
        cpService.downloadEvents(true);
    });


    $scope.eventClicked = function (event) {

        console.log('==== eventClicked', event)

        $state.go("secure.content.cp.event", {
            id: event.uuid,
            zoneData: event.properties,
            timestamp: event.timestamp
        });
    }

    $scope.hideEvent = function (event) {
        var now = (new Date()).getTime();
        localStorage["ignore-" + event.uuid] = now + 24 * 3600 * 1000;
        for (var n = $scope.cpEvents.length - 1; n >= 0; n--) {
            if (event.uuid = $scope.cpEvents[n].uuid) {
                $scope.cpEvents.splice(n, 1);
                break;
            }
        }
        cpService.pollForEvents();
    }
});

angular.module('stwo.cp').controller('CpCompleteController', function ($scope, $state, $stateParams, smarttrackerService, cpService) {

    smarttrackerService.isLoggedInDelayed().then(function () {
        cpService.pollForEvents();
    });
});

angular.module('stwo.cp').controller('CpEventController', function ($scope, $state, $stateParams, $timeout, smarttrackerService, leafletData, mapService, cpService, $controller, IPSService) {
    $scope.CardCollapse = false;
    $scope.Card2Collapse = false;
    //$scope.markers = {};
    var markers = {};
    $scope.paths = {};
    $scope.events = {
        marker: {
            enable: ['click', 'drag'],
            logic: 'emit'
        },
        map: {
            enable: ['click', 'drag'],
            logic: 'emit'
        }
    };

    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 8
        },
        defaults: {
            maxZoom: 21
        }
    };

    mapService.basicMapDesign($scope, leafletData);


    $scope.event = null;
    $scope.zones = [];

    $scope.selectedZone = null;
    // $scope.selectZone = function (zone) {
    //     $scope.selectedZone = zone;
    //     $scope.recreateMarkers(true);
    // }

    $scope.step = "select-zone";
    $scope.stepProgress = -1;
    $scope.stepLength = -1;
    $scope.zoneModification = {
        data: {}
    };

    var createOrUpdateMarker = function (zone, lat, lon) {
        var loc = new L.latLng(lat, lon);
        var marker = markers["marker" + zone.id];
        if (!marker) {
            marker = new L.Marker(loc, {
                icon: mapService.makeNamedIcon(zone.name, "#22b573", "mdi mdi-map-marker", "#1c925d"),
                riseOnHover: true
            });
            marker.item = zone;
            marker.on("click", function () {
                $scope.selectZone(marker.item);
            });
            map.addLayer(marker);
            markers["marker" + zone.id] = marker;
        } else {
            marker.setLatLng(loc);
        }
    }

    $scope.recreateMarkers = function (dontRecheckBounds) {
        if ($scope.step === "select-zone") {
            // for (var k in markers) {
            //     markers[k].remove();
            //     delete markers[k];
            // }

            var activeMarkersPoints = [];
            for (var n = 0; n < $scope.zones.length; n++) {
                // $scope.markers["marker" + $scope.zones[n].id] = {
                //     id: "marker" + $scope.zones[n].id,
                //     lat: $scope.zones[n].position.latitude,
                //     lng: $scope.zones[n].position.longitude,
                //     icon: mapService.makeNamedIcon($scope.zones[n].name, ($scope.selectedZone && $scope.zones[n].id === $scope.selectedZone.id ? 'primary' : 'info')),
                //     focus: false,
                //     draggable: false,
                //     'item': $scope.zones[n]
                // };

                // var micon = L.divIcon({
                //     type: 'div',
                //     iconAnchor: [19, 32],
                //     className: 'myleaflet-div-icon',
                //     html: '<div><div class="pin"><i class="' + ($scope.selectedZone && $scope.zones[n].id === $scope.selectedZone.id ? 'primary' : 'info') + 
                //     '" style="color:#1972B9"></i></div><div class="name label" style="background-color:#1972B9; border-color:#005f9e"><span>' + $scope.zones[n].name + '</span></div></div>',
                //     popupAnchor:  [0, 0]
                // });



                // var marker = new L.Marker(loc, {icon:micon, riseOnHover:true});
                createOrUpdateMarker($scope.zones[n], $scope.zones[n].position.latitude, $scope.zones[n].position.longitude);
                activeMarkersPoints.push(new L.latLng($scope.zones[n].position.latitude, $scope.zones[n].position.longitude));
            }

            if (!dontRecheckBounds && activeMarkersPoints.length) {
                var bounds = new L.latLngBounds(activeMarkersPoints);

                $timeout(function () {
                    leafletData.getMap().then(function (map) {
                        map.fitBounds(bounds);
                        /*map.zoomOut(1);*/
                    });
                }, 100);
            }
        } else if ($scope.step === "modify-zone" || $scope.step === "create-zone") {
            // for (var k in $scope.markers) {
            //     delete $scope.markers[k];
            // }

            var activeMarkersPoints = [];

            // $scope.markers["marker" + $scope.selectedZone.id] = {
            //     id: "marker" + $scope.selectedZone.id,
            //     lat: $scope.zoneModification.data.latitude,
            //     lng: $scope.zoneModification.data.longitude,
            //     icon: mapService.makeNamedIcon($scope.selectedZone.name, 'primary'),
            //     focus: false,
            //     draggable: false,
            //     'item': $scope.selectedZone
            // };
            createOrUpdateMarker($scope.selectedZone, $scope.zoneModification.data.latitude, $scope.zoneModification.data.longitude);
            activeMarkersPoints.push(new L.latLng($scope.zoneModification.data.latitude, $scope.zoneModification.data.longitude));

            if (!dontRecheckBounds) {
                var bounds = new L.latLngBounds(activeMarkersPoints);

                $timeout(function () {
                    leafletData.getMap().then(function (map) {
                        map.fitBounds(bounds);
                        /*map.zoomOut(1);*/
                    });
                }, 100);
            }
        }
    }
    $scope.$on('leafletDirectiveMarker.click', function (event, attrs) {
        $scope.selectZone($scope.markers[attrs.markerName].item);
    });
    $scope.$on('leafletDirectiveMap.click', function (event, attrs) {
        console.log("leaflet click", event, attrs)

        if ($scope.access['zone']['put'] && ($scope.step === "create-zone" || $scope.step === "modify-zone")) {
            $scope.zoneModification.data.latitude = attrs.leafletEvent.latlng.lat;
            $scope.zoneModification.data.longitude = attrs.leafletEvent.latlng.lng;
            $scope.recreateMarkers(true);
        }
    });
    $scope.stepToSelectZone = function () {
        $scope.step = "select-zone";
        $scope.recreateMarkers();
    }
    $scope.resetZoneModifications = function () {
        $scope.zoneModification.data.name = $scope.selectedZone.name;
        $scope.zoneModification.data.address = $scope.selectedZone.address;
        $scope.zoneModification.data.latitude = $scope.selectedZone.position.latitude;
        $scope.zoneModification.data.longitude = $scope.selectedZone.position.longitude;
        $scope.recreateMarkers();
    }

    $scope.stepToCreateZone = function () {
        $scope.selectedZone = {
            name: $scope.event.position.address,
            address: "",
            position: {
                latitude: $scope.event.position.latitude,
                longitude: $scope.event.position.longitude
            }
        };
        $scope.zoneModification.data = {
            name: $scope.selectedZone.name,
            address: $scope.selectedZone.address,
            latitude: $scope.selectedZone.position.latitude,
            longitude: $scope.selectedZone.position.longitude
        };
        $scope.step = "create-zone";
        $scope.recreateMarkers();
    }

    $scope.stepToModifyZone = function () {
        if ($scope.step === "select-zone") {
            $scope.zoneModification.data = {
                name: $scope.selectedZone.name,
                address: $scope.selectedZone.address,
                latitude: $scope.selectedZone.position.latitude,
                longitude: $scope.selectedZone.position.longitude
            };
        }
        $scope.step = "modify-zone";
        $scope.recreateMarkers(true);
    }

    $scope.createBeacons = function () {
        if ($scope.beaconsToCreate.length) {
            for (var n = 0; n < $scope.beaconsToCreate.length; n++) {
                var beacon = $scope.beaconsToCreate[n];
                $scope.beaconsToCreate.splice(n, 1);

                var newBeacon = {
                    "name": "CP-" + $scope.selectedZone.name + "-" + beacon.beaconCode,
                    "beaconCode": beacon.beaconCode,
                    "meta": {
                        "sourceEvent": $scope.event.uuid
                    },
                    "signalStrengthAddend": beacon.signalStrengthAddend,
                    "positionProvider": {
                        "id": $scope.selectedZone.id
                    },
                    "disabled": false
                };

                smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/beacon", newBeacon)
                    .then(function (response) {
                        $scope.stepProgress++;
                        $scope.createBeacons();
                    })

                break;
            }
        } else {
            $state.go("secure.content.cpcomplete");
        }
    }

    $scope.finalizeZoneAndCreateBeacons = function () {
        $scope.step = "finalizing-zones";

        $scope.stepProgress = -1;

        if (!$scope.access['zone']['put'] || ($scope.selectedZone.id && $scope.selectedZone.name === $scope.zoneModification.data.name &&
                $scope.selectedZone.address === $scope.zoneModification.data.address &&
                $scope.selectedZone.position.latitude === $scope.zoneModification.data.latitude &&
                $scope.selectedZone.position.longitude === $scope.zoneModification.data.longitude)) {

            $scope.findCpInHistoryAndCreateBeacons();

        } else {

            // check if this is a navigational zone (secure navigation)
            if($scope.zones){

                if($scope.zones.length === 1){

                    var zone = $scope.zones[0];
                    if(zone.description === "IPS_SecureNavigation"){

                        leafletData.getMap().then(function(map) {

                            IPSService.changeArcSize(zone.resourceId, map).then(function(){

                                console.log('1 Starting findCpInHistoryAndCreateBeacons')
                                $scope.findCpInHistoryAndCreateBeacons();

                            });

                        });

                    }else{

                        var zoneUpdate = {
                            "id": $scope.selectedZone.id,
                            "name": $scope.zoneModification.data.name,
                            "address": $scope.zoneModification.data.address,
                            "points": []
                        };
                        var radius = 5 / 111000;
                        for (var v = 0; v < (2 * Math.PI); v += (Math.PI * 0.2)) {
                            zoneUpdate.points.push({
                                latitude: $scope.zoneModification.data.latitude + radius * Math.sin(v) * Math.cos(Math.PI * ($scope.zoneModification.data.latitude / 180)),
                                longitude: $scope.zoneModification.data.longitude + radius * Math.cos(v)
                            });
                        }
                        zoneUpdate.points.push(zoneUpdate.points[0])

                        if (zoneUpdate.id) {
                            smarttrackerService.authPut($scope.selectedZone.owner.id + "/zone/" + $scope.selectedZone.id, zoneUpdate)
                                .then(function (response) {
                                    $scope.findCpInHistoryAndCreateBeacons();
                                })
                        } else {
                            delete zoneUpdate["id"];
                            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/zone/", zoneUpdate)
                                .then(function (response) {
                                    $scope.selectedZone = response.data.result[0];
                                    $scope.findCpInHistoryAndCreateBeacons();
                                })
                        }

                    }

                }

            }else{

                 console.log('3 Starting findCpInHistoryAndCreateBeacons')
                 $scope.findCpInHistoryAndCreateBeacons();

            }

        }
        return;

        // if (!$scope.access['zone']['put'] || ($scope.selectedZone.id && $scope.selectedZone.name === $scope.zoneModification.data.name &&
        //         $scope.selectedZone.address === $scope.zoneModification.data.address &&
        //         $scope.selectedZone.position.latitude === $scope.zoneModification.data.latitude &&
        //         $scope.selectedZone.position.longitude === $scope.zoneModification.data.longitude)) {
        //     $scope.findCpInHistoryAndCreateBeacons();
        // } else {
        // 
        //     var zoneUpdate = {
        //         "id": $scope.selectedZone.id,
        //         "name": $scope.zoneModification.data.name,
        //         "address": $scope.zoneModification.data.address,
        //         "points": []
        //     };
        //     var radius = 5 / 111000;
        //     for (var v = 0; v < (2 * Math.PI); v += (Math.PI * 0.2)) {
        //         zoneUpdate.points.push({
        //             latitude: $scope.zoneModification.data.latitude + radius * Math.sin(v) * Math.cos(Math.PI * ($scope.zoneModification.data.latitude / 180)),
        //             longitude: $scope.zoneModification.data.longitude + radius * Math.cos(v)
        //         });
        //     }
        //     zoneUpdate.points.push(zoneUpdate.points[0])

        //     if (zoneUpdate.id) {
        //         smarttrackerService.authPut($scope.selectedZone.owner.id + "/zone/" + $scope.selectedZone.id, zoneUpdate)
        //             .then(function (response) {
        //                 $scope.findCpInHistoryAndCreateBeacons();
        //             })
        //     } else {
        //         delete zoneUpdate["id"];
        //         smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/zone/", zoneUpdate)
        //             .then(function (response) {
        //                 $scope.selectedZone = response.data.result[0];
        //                 $scope.findCpInHistoryAndCreateBeacons();
        //             })
        //     }
        // }
    }

    $scope.findCpInHistoryAndCreateBeacons = function () {
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/history?select=*&asset:equals=" + $scope.event.object.info.id + "&timestamp:greater=2010-01-01T00:00:00.0&timestamp:less=" + $scope.event.timestamp + "&max=100&order=desc&sort=timestamp")
            .then(function (response) {

                var rxCpFound = false;
                var locrFound = false;
                $scope.beaconsToCreate = [];

                for (var n = 0; n < response.data.result.length; n++) {
                    console.log("Observation id", response.data.result[n].event.id)
                    if (response.data.result[n].event.id === "device_observation") {
                        var h = response.data.result[n];

                        console.log("h.data.length", h.data.length)
                        for (var m = 0; m < h.data.length; m++) {
                            console.log("Data type", h.data[m].type)
                            if (h.data[m].type === "observation") {
                                var odata = h.data[m].info;

                                console.log("rxEvent", odata.properties.rxEvent)
                                if (odata.properties.rxEvent === "CP") {
                                    rxCpFound = true;
                                }

                                if (rxCpFound && odata.properties.rxEvent === "LOCR") {
                                    locrFound = true;

                                    for (var mm = 1; mm < 99; mm++) {
                                        if (!odata.properties["tag.rssi-" + mm]) {
                                            console.log("!odata.properties[\"tag.rssi-\" + mm]", mm)
                                            break;
                                        }
                                        if (!odata.properties["tag.rssi.calc-" + mm] || odata.properties["tag.rssi.calc-" + mm] !== "?") {
                                            console.log("!odata.properties[\"tag.rssi.calc-\" + mm] || odata.properties[\"tag.rssi.calc-\" + mm] !== \"?\"", mm)
                                            continue;
                                        }
                                        var rssiValue = parseFloat(odata.properties["tag.rssi-" + mm]);
                                        var rssiCutoff = -70;

                                        if ($scope.selectedZone.type) {
                                            if ($scope.selectedZone.type.name === "Closer" || $scope.selectedZone.type.name === "Close") {
                                                rssiCutoff = -55;
                                            } else if ($scope.selectedZone.type.name === "Farther") {
                                                rssiCutoff = -70;
                                            } else if ($scope.selectedZone.type.name.indexOf("-")) {
                                                var splitName = $scope.selectedZone.type.name.split("-");
                                                rssiCutoff = -parseFloat(splitName[splitName.length - 1]);
                                            }
                                        }

                                        var bbbb = {
                                            beaconCode: odata.properties["tag.id-" + mm],
                                            signalStrengthAddend: -rssiCutoff
                                        };
                                        console.log('bbbb', bbbb);
                                        $scope.beaconsToCreate.push(bbbb);
                                    }

                                    if (locrFound) {
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    if (locrFound) {
                        break;
                    }
                }

                $scope.stepProgress = 0;
                $scope.stepLength = $scope.beaconsToCreate.length;
                $scope.createBeacons();
            });


    }
    var map = false;
    smarttrackerService.isLoggedInDelayed().then(function () {
        var preEvent = ($stateParams.timestamp.split(".")[0]) + ".0";
        var postEvent = ($stateParams.timestamp.split(".")[0]) + ".9999";

        leafletData.getMap().then(function (otherMap) {
            map = otherMap;
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/eventHistory?select=*&timestamp:greater=" + preEvent + "&timestamp:less=" + postEvent + "&max=100")
                .then(function (response) {
                    for (var n = 0; n < response.data.result.length; n++) {
                        if (response.data.result[n].uuid === $stateParams.id) {
                            $scope.event = response.data.result[n];

                            $scope.zones = cpService.getZonesPerEvent()[$scope.event.uuid];

                            if (!$scope.zones) {
                                $scope.zones = [];
                            }

                            $scope.stepToSelectZone();
                            break;
                        }
                    }
                });
        });
    });

    $scope.popupExpand = true;

    $scope.togglePopup = function () {
        if ($scope.popupExpand) {
            TweenLite.to("#cpPopup", 0.5, {
                height: "10px",
                ease: "Quart.easeInOut"
            });
            $scope.popupExpand = false
        } else {
            TweenLite.set("#cpPopup", {
                height: "auto"
            });
            TweenLite.from("#cpPopup", 0.5, {
                height: "10px",
                ease: "Quart.easeInOut"
            });
            $scope.popupExpand = true;
        }
    };

    $scope.selectZone = function (zone) {
        $scope.selectedZone = zone;
        $scope.recreateMarkers(true);
        $scope.stepToModifyZone();
    };

    $scope.ZoomIn = function () {
        leafletData.getMap().then(function (map) {
            map.zoomIn();
        });
    };

    $scope.ZoomOut = function () {
        leafletData.getMap().then(function (map) {
            map.zoomOut();
        });
    };

});
// module config
angular.module('stwo.navigate', ["stwo.core"]).config(function ($stateProvider, moduleStoreProvider) {


    // register module
    moduleStoreProvider.registerModule({
        name: "navigate",
        links: [{
            name: "NAVIGATE",
            category: "",
            sref: "secure.content.navigate",
            icon: 'navigation',
            color: "danger",
            sort: 30,
            navigation: true,
            controllers: ['NavigationController']
        }]
    });

    // state
    $stateProvider
        .state("secure.content.navigate", {
            url: "/navigate/",
            templateUrl: "modules/navigate/navigate.html",
            controller: "NavigationController",
            titleName: 'XGUARD_APP_NAVIGATE',
            titleIcon: "navigation"
        })
});

// runtime code
angular.module('stwo.navigate').run(function (navigateService) {
    console.log("Force loading cp service")
});


// service definition
angular.module('stwo.navigate').factory('navigateService', function ($http, $q, moduleStore, smarttrackerService) {

    var i = {};

    moduleStore.serviceRepository()["navigateService"] = i;
    return i;

});



angular.module('stwo.navigate').controller('NavigationController', function ($scope, $stateParams, $timeout, $state, $modal, $controller, leafletData, mapService, googlemapsService, smarttrackerService, IPSService) {

    $scope.currentAddressData = {}
    $scope.loadingNavigation = {
        toggle: false,
        foundStreetNumber: null,
        knownLocation: false
    };

    var map = false;
    leafletData.getMap("mapMap").then(function (otherMap) {
        console.log('Got map', otherMap)
        map = otherMap;
        //mapService.loadOverlays(map);
    });

    smarttrackerService.isLoggedInDelayed().then(function () {
        console.log('Loading mapdata')
        $scope.alarmCenter = smarttrackerService.isAlarmCenter();
        $scope.CID = smarttrackerService.getCustomerId();
    });

    function initAutocomplete() {

        // check ready
        if (typeof google === 'undefined') {

            return $timeout(function () {

                initAutocomplete();

            }, 100)

        }

        // var map = new google.maps.Map(document.getElementById('fakeMap'), {
        //     zoom: 13,
        //     mapTypeId: 'roadmap'
        // });

        // Create the search box and link it to the UI element.
        var input = document.getElementById('googlePlacesSearch');
        //var searchBox = new google.maps.places.SearchBox(input);
        var searchBox = new google.maps.places.Autocomplete(input);

         searchBox.addListener('place_changed', function() {

            var place = searchBox.getPlace();

            // check if the address has a street number
            var foundStreetNumber = false;
            for(var i in place.address_components){

                if(place.address_components[i].types.indexOf('street_number') !== -1){

                    foundStreetNumber = true;

                }

            }

            console.log('Place', place)

            $scope.loadingNavigation.foundStreetNumber = foundStreetNumber;

            $scope.currentAddressData.raw = place;
            $scope.currentAddressData.placeName = place.name;
            $scope.currentAddressData.address = place.formatted_address;
            $scope.currentAddressData.name = input.value;
            $scope.currentAddressData.point = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };

            // check if zone exists
            IPSService.checkAddressZoneExists($scope.currentAddressData).then(function(exists){

                $scope.loadingNavigation.knownLocation = exists;

            })


         })

        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        // searchBox.addListener('places_changed', function () {
        //     var places = searchBox.getPlaces();

        //     if (places.length == 0) {
        //         return;
        //     }

        //     console.log('saving address')

        //     $scope.currentAddressData.address = places[0].formatted_address;
        //     $scope.currentAddressData.name = input.value;
        //     $scope.currentAddressData.point = {
        //         lat: places[0].geometry.location.lat(),
        //         lng: places[0].geometry.location.lng()
        //     };

        // });

    }

    function saveRecent(item) {

        // get
        var recents = getRecents()

        // add
        recents.unshift(item)

        // check max items
        recents = recents.splice(0, 5)

        // save
        localStorage.setItem('NAVIGATE_SEARCH_RECENTS', JSON.stringify(recents));

        // done
        return recents;

    }

    function getRecents() {

        // get recents
        var recents = [];
        try {

            recents = JSON.parse(localStorage.getItem('NAVIGATE_SEARCH_RECENTS'));

        } catch (e) {}

        return recents || [];

    }
    $scope.recents = getRecents();

    $timeout(function () {

        initAutocomplete();

    })

    $scope.selectRecent = function (index) {

        console.log('selected', $scope.recents[index])

        $scope.currentAddressData.raw = $scope.recents[index].raw;
        $scope.currentAddressData.name = $scope.recents[index].name;
        $scope.currentAddressData.placeName = $scope.recents[index].placeName;
        $scope.currentAddressData.address = $scope.recents[index].address;
        $scope.currentAddressData.point = $scope.recents[index].point;

        $scope.startNavigation(true);

    }

    $scope.startNavigation = function (skipRecent) {

        // check if we have a map
        if (map === false) {

            return $timeout(function () {

                console.log('Waiting for map', map)
                $scope.startNavigation(skipRecent);

            }, 500)

        }


        // check if address string is there
        if (typeof $scope.currentAddressData.address !== 'undefined') {

            $scope.loadingNavigation.toggle = true;

            if (skipRecent !== true) {

                // save recent
                $scope.recents = saveRecent($scope.currentAddressData)

            }

            console.log('starting navigation')

            // create new IPS point
            IPSService.newIPSPoint($scope.currentAddressData, map, 0).then(function (response) {

                // set toggle
                $scope.loadingNavigation.knownLocation = (typeof response.resourceId !== 'undefined');

                // open maps
                console.log('Start maps');


                var delay = 0;
                if($scope.loadingNavigation.knownLocation === true){

                    delay = 1750;

                }

                // wait
                $timeout(function () {

                    // go
                    googlemapsService.googleMaps(null, null, $scope.currentAddressData.address)

                    // reset position at next tick
                    $timeout(function () {

                        $scope.currentAddressData = {};

                    })

                }, delay);


            }, function (rejection) {

                console.log('rejection creating ips point', rejection)

            });

            // }

        }

    }

});
angular.module('stwo.zone', ["stwo.core", "dndLists"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider, $translateProvider) {

    moduleStoreProvider.registerModule({
        name: "zone",
        links: [{
            name: "ZONE_TITLE",
            category: "MANAGEMENT",
            icon: "selection",
            access: ["zone", "get"],
            sref: "secure.content.zone",
            sort: 5,
            color: "info",
            controllers: ["ZoneListController"]
        }]
    });

    $stateProvider.state("secure.content.zone", {
        url: "/zone:filter",
        templateUrl: "modules/zone/zone.html",
        controller: "ZoneListController",
        titleName: 'ZONE_TITLE',
        titleIcon: "selection"
    });

    moduleStoreProvider.addPossibleFilter("zone", {
        id: "name",
        label: "ZONE_FILTER_NAME",
        type: "string",
        field: "name",
        comparator: "contains"
    });

});
angular.module('stwo.zone').controller('ZoneListController', function ($scope, $state, $controller, smarttrackerService, moduleStore, mapService, leafletData, $timeout, $modal, utilService, dialogService, $translate) {
    $controller('BaseListContentController', {$scope: $scope});


    $scope.filter = {
        type: {'IPS_ZONES': '&type.name:contains=RSSI',
        'RA_ZONES': '&labels:contains=ACR_RA',
        'BZ_ZONES': '&labels:contains=ACR_BZ',
        'MM_ZONES': '&type.name:equals=My-Maps',
        'ALL_ZONES': '',
        'selected': 'ALL_ZONES'}
    }

    $scope.$watch("filter.type.selected", function () {
        if($scope.filter&&$scope.filter.bundles&&$scope.filter.type) {
            $scope.filterUrlString = $scope.filter.type[$scope.filter.type.selected] + $scope.filter.bundles[$scope.filter.bundles.selected] + ($scope.textInput.nameSearchValue && $scope.textInput.nameSearchValue != '' ? '&name:contains=' + $scope.textInput.nameSearchValue : '');
            localStorage.setItem(zfKey, JSON.stringify({'bundles':$scope.filter.bundles.selected, 'type':$scope.filter.type.selected}));
        }
    });

    $scope.$watch("filter.bundles.selected", function () {
        if($scope.filter&&$scope.filter.bundles&&$scope.filter.type){
            $scope.filterUrlString = $scope.filter.type[$scope.filter.type.selected] + $scope.filter.bundles[$scope.filter.bundles.selected] + ($scope.textInput.nameSearchValue && $scope.textInput.nameSearchValue != '' ? '&name:contains=' + $scope.textInput.nameSearchValue : '');
            localStorage.setItem(zfKey, JSON.stringify({'bundles':$scope.filter.bundles.selected, 'type':$scope.filter.type.selected}));
        }
    });

    $scope.textInput = {nameSearchValue: ''};
    $scope.applyNameFilter = function ($event) {
        if (!$scope.textInput.nameSearchValue || $scope.textInput.nameSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            $scope.filterValues = {"name": $scope.textInput.nameSearchValue};
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue + $scope.filter.type[$scope.filter.type.selected] + $scope.filter.bundles[$scope.filter.bundles.selected];
            $scope.textInput = {nameSearchValue: "", externalIdSearchValue: "", assetIdSearchValue: ""};
        }
    }

    $scope.downloadAll = function () {
        var max = $scope.pagination.max;
        $scope.pagination.max = $scope.pagination.total;
        $scope.downloadMore();
        $scope.pagination.max = max;
    }


    $scope.messageDataValues = [
        "email_name",
        "email_tags",
        "email_insideZones",
        "email_properties",
        "email_links",
        "email_type",
        "email_position",
        "email_rule",
        "email_messageTime",
        "email_positionTime"
    ];


    $scope.zoneRoles = {
        'NONE': 'MANAGEMENT_ZONE_ROLE_NONE',
        'ACR_RA': 'MANAGEMENT_ZONE_ROLE_RESPONSE_AREA',
        'ACR_BZ': 'MANAGEMENT_ZONE_ROLE_BACKUP'
    };

    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 16
        },
        defaults: {
            dragging: false,
            maxZoom: 21,
            doubleClickZoom: false,
            scrollWheelZoom: false
        },
        events: {
            map: {
                enable: ['dragstart', 'zoomstart', 'click'],
                logic: 'emit'
            }
        }
    };

    $scope.editMapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 16
        },
        defaults: {
            dragging: true,
            maxZoom: 21
        },
        events: {
            map: {
                enable: ['dragstart', 'zoomstart', 'click'],
                logic: 'emit'
            }
        }
    };

    $scope.$watch("itemsChanged", function () {
        // if($scope.items && $scope.items.length > 0 && !$scope.currentZone) {
        //     $timeout(function(){$scope.zoneClicked($scope.items[0])}, 500);
        // }
    });


    $scope.syntax = {
        circle: 'ACR_ZCIRCLE',
        dmPolygon: 'POLYGON',
        dmCircle: 'CIRCLE',
        dmSquare: 'SQUARE'
    }


    $scope.zoneClicked = function (zone) {
        if (!zone || $scope.newZone)return;

        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }

        $scope.currentZoneID = zone.id;
        $scope.currentZone = zone;
        $scope.currentZone.isOwner = zone.owner.id == $scope.customerID;
        $scope.currentZone.floor = $scope.currentZone.floor?$scope.currentZone.floor:0;

        zone.originals = {name: zone.name, description: zone.description};
        zone.working = {};
        zone.errors = {};
        angular.forEach($scope.currentZone.labels, function (va, k) {
            var v = JSON.parse(va.value);
            v.code = va.code;
            console.log("Done parsing");
            switch (v.code) {
                // case 'ACR_CONTACT':
                //     v.name = k;
                //     zone.contacts.push(v);
                //     break;
                case 'ACR_RA':
                case 'ACR_BZ':
                case 'ACR_PD':
                    v.role = v.code;
                    zone.meta = v;
                    break;
            }
        });
        if (!zone.meta) {
            zone.meta = {role: 'NONE'};
        }
        if (zone.meta.role == 'ACR_RA') {
            zone.meta.md = {};
            angular.forEach($scope.messageDataValues, function (value) {
                console.log(value + " " + zone.meta.messageData + "||" + !zone.meta.messageData);
                zone.meta.md[value] = !zone.meta.messageData || zone.meta.messageData.indexOf(value) >= 0;
            });
            zone.meta.originalMD = utilService.clone(zone.meta.md);
        }
        $scope.mdExpanded = false;


        $scope.autoCenter();
        $scope.drawCurrentZone();
    };

    $scope.toggleMd = function() {
        if ($scope.mdExpanded){
            $scope.mdExpanded = false;
            TweenLite.to("#metabox", 0.5, {height: "0px", opacity: 0, ease: "Quart.easeInOut"});
        } else {
            $scope.mdExpanded = true;
            TweenLite.set("#metabox", {height: "auto", opacity: 1});
            TweenLite.from("#metabox", 0.5, {height: "0px", opacity: 0, ease: "Quart.easeInOut"});
        }
    };

    $scope.currentZoneID = false;

    $scope.setCenter = function (newCenter) {
        $scope.mapData.center.lat = newCenter.lat;
        $scope.mapData.center.lng = newCenter.lng;
        if (newCenter.zoom) {
            $scope.mapData.center.zoom = newCenter.zoom;
        }
    };

    $scope.drawCurrentZone = function () {
        if (!$scope.currentZone) return; // No zone to draw

        var latlngs = [];
        angular.forEach($scope.currentZone.points, function (point) {
            latlngs.push({'lat': point.latitude, 'lng': point.longitude});
        });
        $scope.paths = {};
        $scope.paths["current"] = {
            type: "polygon",
            fillColor: 'darkgreen',
            color: 'darkgreen',
            latlngs: latlngs,
            clickable: false,
            weight: 2,
            editing: true
        };
        if ($scope.polygon) {
            $scope.polygon.remove();
        }
        $scope.polygon = L.polygon(latlngs, {color: 'darkgreen', fillColor: 'darkgreen'});

        $timeout(function () {
            $scope.polygon.addTo(map);



        }, 310);
    }


    var emptyRestricted = ['name'];
    var map = false;
    var editMap = false;
    var editZone = false;
    $scope.editing = false;
    var newLayer = false;

    var zfKey = "ZoneFilter";

    smarttrackerService.isLoggedInDelayed().then(function () {
        mapService.basicMapDesign($scope, leafletData, "zoneMap");

        $scope.isServiceProvider = smarttrackerService.getUserData().flags.isServiceProvider;
        if($scope.isServiceProvider) {
            $scope.zoneRoles = {
                'NONE': 'MANAGEMENT_ZONE_ROLE_NONE',
                'ACR_RA': 'MANAGEMENT_ZONE_ROLE_RESPONSE_AREA',
                'ACR_PD': 'MANAGEMENT_ZONE_ROLE_POLICE_DISTRICT',
                'ACR_BZ': 'MANAGEMENT_ZONE_ROLE_BACKUP'
            };
        }

        leafletData.getMap('editMap').then(function (otherMap) {
            editMap = otherMap;
            $scope.filter["bundles"] = {
                'BUNDLED':'&bundles:empty=false',
                'OWNED':'&owner:equals=' + smarttrackerService.getCustomerId(),
                'ALL':'',
                'selected':'OWNED'
            };
            if(localStorage[zfKey]) {
                try{
                    var selections = JSON.parse(localStorage[zfKey]);
                    $scope.filter.bundles.selected = selections.bundles;
                    $scope.filter.type.selected = selections.type;
                    $scope.filterUrlString = $scope.filter.type[$scope.filter.type.selected] + $scope.filter.bundles[$scope.filter.bundles.selected] + ($scope.textInput.nameSearchValue && $scope.textInput.nameSearchValue != '' ? '&name:contains=' + $scope.textInput.nameSearchValue : '');
            
                } catch(e) {
                    console.error("Failed to parse stored filter", e);
                    localStorage.removeItem(zfKey);
                }
            } else {
                $scope.filterUrlString = $scope.filter.bundles[$scope.filter.bundles.selected];
            }

            
            $scope.super({
                clazz: 'zone',
                downloadUrl: '/zone?select=@&order=asc'
            });
            $scope.isServiceProvider = smarttrackerService.getUserData().flags.isServiceProvider;
            var drawnItems = new L.FeatureGroup();
            angular.extend($scope, {
                controls: {
                    draw: {
                        polygon: {
                            allowIntersection: false
                        },
                        marker: false
                    },
                    edit: {
                        featureGroup: drawnItems
                    }
                }
            });
            $scope.editTool = new L.EditToolbar.Edit(editMap, {featureGroup: drawnItems});
            editMap.on('draw:created', function (e) {

                console.log("draw:created called");
                var layer = e.layer;

                /* commented out
                 //var points = layer.getLatLngs();
                 */
                layer.editing.enable();
                if (editZone) {
                    editZone = layer;
                } else if ($scope.newZone) {
                    newLayer = layer;
                }
                $scope.drawing = false;

                console.log("Layer: ", layer);

                drawnItems.addLayer(layer);
                $scope.editTool.enable();

            }); // End draw:created

            editMap.on("draw:drawvertex", function (e) {
                if ($scope.drawMode == $scope.syntax.dmPolygon) {
                    $scope.pointsInPolygon++;
                }
            });

            editMap.on("draw:editvertex", function (e) {
                $scope.pointsInPolygon = e.poly.getLatLngs()[0].length;
            });
        });

        leafletData.getMap('zoneMap').then(function (otherMap) {
            map = otherMap;

        })
        $scope.customerID = smarttrackerService.getCustomerId();
    });
    $scope.pointsInPolygon = 0;


    $scope.changeZoneType = function () {
        var z = $scope.currentZone;
        var disabledIDs = z.type ? [z.type.id] : [];

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-type.html',
            controller: stwoCommonPickerModalController,
            size: "md",
            resolve: {
                pickerConfiguration: function () {
                    return {
                        title: "MANAGEMENT_ZONE_TYPE_SELECT_TITLE",
                        clazz: "zoneType",
                        data: z, fieldsToShow: ["name", "description"],
                        nullAllowed: true,
                        disabledIDs: disabledIDs,
                        nullButtonText: "MANAGEMENT_ZONE_REMOVE_TYPE",
                        downloadUrl: '/zoneType?select=name+description&sort=name&order=asc'
                    }
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            console.log(pickerResult);
            var zt = pickerResult.selectedItems[0];
            var body = {
                "type": zt == null ? null : {'id': zt.id}
            };
            z.working['type'] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, body).then(function (response) {
                z.type = response.data.result[0].type;
                z.working['type'] = false;
            });
        });
    }

    
    $scope.centerOnAddress = function(data) {
        editMap.setView({
            'lat': data.point.lat,
            'lng': data.point.lng
        }, 16);
    }

    $scope.changeZoneRole = function (role) {
        //{"showQR":true,"showNQR":true,"showPD":true,"priority":1,"messageData":["name","type"]}
        console.log("Will change the role to ", role);
        var z = $scope.currentZone;
        if (role != z.meta.role) {
            var labels = utilService.clone(z.labels);
            console.log(z.labels);
            var re = /ACR_RA|ACR_BZ|ACR_PD/;
            angular.forEach(labels, function (value, key) {
                if (re.test(value.code)) {
                    delete labels[key];
                }
            });
            switch (role) {
                case 'NONE':
                    break;
                case 'ACR_PD':
                case 'ACR_BZ':
                    labels['meta'] = {code: role, value: '{}'};
                    break;
                case 'ACR_RA':
                    labels['meta'] = {
                        code: role,
                        value: JSON.stringify({showQR: true, showNQR: true, showPD: true, priority: 1})
                    };
                    break;
            }
            z.working['role'] = true;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/zone/' + z.id, {'labels': labels}).then(function (response) {
                z.labels = response.data.result[0].labels;
                z.working['role'] = false;
                if ($scope.currentZone.id == z.id) {
                    z.meta = false;
                    $scope.zoneClicked(z);
                }
            });
        }

    }

    var levelUpdater = false;
     $scope.changeZoneFloor = function(amount) {
        var newLevel = $scope.currentZone.floor + amount
        //if(newLevel >= $scope.levelOptions[0].value && newLevel <= $scope.levelOptions[$scope.levelOptions.length-1].value) {
            $scope.currentZone.working = $scope.currentZone.working?$scope.currentZone.working:{};
            if(levelUpdater) {
                $timeout.cancel(levelUpdater);
            }
            $scope.currentZone.floor = newLevel;
            levelUpdater = $timeout(function(){
                $scope.currentZone.working['floor'] = true;
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + $scope.currentZone.id, {'floor':$scope.currentZone.floor}).then(function (response){
                    $scope.currentZone.working['floor'] = false;
                });
            }, 800);
        //}
    }

    $scope.changeZoneProperty = function (prop) {
        var z = $scope.currentZone;
        var pValue = z[prop];
        if (emptyRestricted.indexOf(prop) >= 0 && pValue == '') {
            z.errors[prop] = "MANAGEMENT_ZONE_" + prop.toUpperCase() + "_ERROR_EMPTY";
            return;
        }
        if (z.errors[prop]) {
            delete z.errors[prop];
        }
        var pOrigValue = z.originals[prop];
        if (pValue != pOrigValue) {
            z.working[prop] = true;
            var body = {};
            body[prop] = pValue;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, body).then(function (response) {
                z.working[prop] = false;
                z.originals[prop] = pValue;
            });
        }
    }

    $scope.updateMD = function () {
        var z = $scope.currentZone;
        var changed = JSON.stringify(z.meta.md) != JSON.stringify(z.meta.originalMD);
        console.log(JSON.stringify(z.meta.md) + "==" + JSON.stringify(z.meta.originalMD));
        if (changed) {
            var md = [];
            z.working['ACR_RA'] = true;
            angular.forEach($scope.messageDataValues, function (value) {
                if (z.meta.md[value]) {
                    md.push(value);
                }
            });
            if (md.length == 0) {
                // Error should be displayed. They cannot all be disabled.
                z.meta.mdError = "MANAGEMENT_ZONE_MESSAGE_DATA_ERROR";
                return;
            }
            z.meta.mdError = false;
            var labels = utilService.clone(z.labels);
            var index = -1;
            angular.forEach(labels, function (value, key) {
                if (value.code == 'ACR_RA') {
                    index = key;
                }
            });
            try {
                var json = JSON.parse(labels[index].value);
                if (md.length == $scope.messageDataValues.length && json.messageData) {
                    delete json.messageData;
                } else if (md.length < $scope.messageDataValues.length) {
                    json.messageData = md;
                }
                labels[index].value = JSON.stringify(json);
            } catch (e) {
                console.error("Failed to parse meta data for " + z.name + ": ", e);
            }
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, {"labels": labels}).then(function (response) {
                z.meta.mdDirty = z.working['ACR_RA'] = false;
                z.labels[index] = response.data.result[0].labels[index];
                // $scope.zoneClicked(z);
                // $scope.mdExpanded = true;
            });
            $scope.toggleMd();
        } else {
            console.log("No changes");
            z.meta.mdDirty = false;
            $scope.toggleMd();
        }
    };

    $scope.changeACRZonePriority = function () {
        var z = $scope.currentZone;
        var labels = utilService.clone(z.labels);
        var index = getIndexForCode('ACR_RA');
        try {
            var json = JSON.parse(labels[index].value);
            console.log(json.priority + " == " + z.meta.priority);
            if (json.priority == z.meta.priority) {
                //No changes
                console.log("No changes");
                return;
            }
            json.priority = z.meta.priority;
            labels[index].value = JSON.stringify(json);
        } catch (e) {
            console.error("Failed to parse meta data for " + z.name + ": ", e);
        }
        z.working['ACR_RA'] = z.working['priority'] = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, {'labels': labels}).then(function (response) {
            z.labels[index] = response.data.result[0].labels[index];
            z.working['ACR_RA'] = z.working['priority'] = false;
        });
    }

    var getIndexForCode = function (code) {
        var index = -1;
        angular.forEach($scope.currentZone.labels, function (value, key) {
            if (value.code == code) {
                index = key;
            }
        })
        return index;
    }

    var validateNewZone = function () {
        $scope.newZone.errors = {'name': false, 'drawing': false};
        if ($scope.newZone.name == '') {
            $scope.newZone.errors.name = "MANAGEMENT_ZONE_NAME_ERROR_EMPTY";
        }
        if ($scope.newZone.drawing) {
            $scope.newZone.errors.drawing = "MANAGEMENT_ZONE_ERROR_INCONCLUSIVE";
        }
        console.log("In validation: " + ($scope.newZone.errors.name != false || $scope.newZone.errors.name != false));
        return ($scope.newZone.errors.name == false || $scope.newZone.errors.name == false);
    }
    $scope.saveZone = function () {
        console.log("Will validate zone");
        if (editZone || validateNewZone()) {


            var layer = editZone ? editZone : newLayer;
            var points = [];
            var labels = false;
            if (layer instanceof L.Circle) {
                var circ = L.circle([layer.getLatLng().lat, layer.getLatLng().lng], {radius: layer.getRadius()});
                circ.addTo(editMap);
                var theta = 0;  // angle that will be increased each loop
                var h = layer.getLatLng().lat;      // x coordinate of circle center
                var k = layer.getLatLng().lng;      // y coordinate of circle center
                var step = 360 / 20;//15  // amount to add to theta each time (degrees)
                var rx = circ.getBounds().getNorthEast().lat - layer.getLatLng().lat;
                var ry = circ.getBounds().getNorthEast().lng - layer.getLatLng().lng;
                circ.remove();

                var p1 = {
                    'latitude': h + rx * Math.cos(toRadians(theta)),
                    'longitude': k - ry * Math.sin(toRadians(theta))
                };
                while (theta < 360) {
                    var lat = h + rx * Math.cos(toRadians(theta));
                    var lng = k - ry * Math.sin(toRadians(theta))
                    points.push({'latitude': lat, 'longitude': lng});
                    theta += step;
                }
                points.push(p1);
                labels = {};
                labels['shapeMeta'] = {
                    code: 'ACR_ZCIRCLE',
                    value: JSON.stringify({
                        'lat': layer.getLatLng().lat,
                        'lng': layer.getLatLng().lng,
                        'radius': layer.getRadius()
                    })
                };

            } else {
                angular.forEach(layer.getLatLngs()[0], function (val) {
                    points.push({'latitude': val.lat.toFixed(6), 'longitude': val.lng.toFixed(6)});
                });
            }


            if (editZone) {
                var z = $scope.currentZone;
                var labelsCopy = utilService.clone(z.labels);
                if (labels) {
                    labelsCopy['shapeMeta'] = labels['shapeMeta'];
                } else {
                    angular.forEach(labelsCopy, function (label, key) {
                        if (label.code == $scope.syntax.circle) {
                            delete labelsCopy[key];
                        }
                    })
                }
                var zBody = {
                    'points': points,
                    'labels': labelsCopy
                }
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, zBody).then(function (response) {
                    editZone = false;
                    cancelEditMode();
                    angular.forEach($scope.items, function (zone) {
                        if (zone.id == z.id) {
                            zone.points = response.data.result[0].points;
                            zone.labels = response.data.result[0].labels;
                            $scope.zoneClicked(zone);
                        }
                    });
                });
            } else if ($scope.newZone) {
                var nz = $scope.newZone;

                var zBody = {
                    'name': nz.name,
                    'points': points
                }

                smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/zone/", zBody).then(function (response) {
                    $scope.zoneClicked(response.data.result[0]);
                    $scope.refresh();
                    $scope.newZone = false;
                    cancelEditMode();
                    $scope.zoneClicked(response.data.result[0]);

                    if (labels) {
                        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + response.data.result[0].id, {'labels': labels}).then(function (response2) {
                            console.log("success");
                            angular.forEach($scope.items, function (value) {
                                if (value.id == response2.data.result[0].id) {
                                    value.labels = response2.data.result[0].labels;
                                }
                            });
                        });
                    }

                });
            } // end if newZone
            $scope.editing = false;
            $scope.sidebarLocked = false;
            TweenLite.to("#zoneEditMap", 0.5, {height: "0px", ease: "Quart.easeInOut"});
            TweenLite.to("#zoneTools", 0.5, {height: "0", marginTop: "0", opacity: "0", ease: "Quart.easeInOut"});
        }


    }

    $scope.undoClose = function() {
        var layer = editZone ? editZone : newLayer;
        editMap.removeLayer(layer);
        var points = [];


        angular.forEach(layer.getLatLngs()[0], function (val) {
            points.push({'latitude': val.lat.toFixed(6), 'longitude': val.lng.toFixed(6)});
        });
        points.splice(points.length-1, 1);
        $scope.polygonDrawer = new L.Draw.Polygon(editMap);

        $scope.polygonDrawer.enable();
        $scope.drawing = true;

        angular.forEach(layer.getLatLngs()[0], function (latLng){
            $scope.polygonDrawer.addVertex(latLng);
        })
        
    }

    var cancelEditMode = function () {
        try {
            $scope.clearOtherZones();
            if ($scope.polygonDrawer) {
                $scope.polygonDrawer.disable();
            }

            $scope.drawing = false;
            $scope.editTool.disable();
            var drawnItems = $scope.controls.edit.featureGroup;
            angular.forEach(drawnItems.getLayers(), function (l) {
                drawnItems.removeLayer(l);
            });
        } catch (e) {
            console.error(e);
        }

    }

    $scope.deleteZone = function () {
        var z = $scope.currentZone;
        var promise = dialogService.prompt("MANAGEMENT_ZONE_CONFIRM_DELETE_ZONE_TITLE", "MANAGEMENT_ZONE_CONFIRM_DELETE_ZONE_CONTENT", {
            promptText: "",
            disablePromptText: true,
            deleteButton: true
        });

        promise.then(function (data) {
            smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/zone/" + z.id).then(function (response) {
                // Zone is no more. Deselect everything
                $scope.currentZone = false;
                $scope.currentZoneID = false;
                if ($scope.polygon) {
                    $scope.polygon.remove();
                }
                $scope.refresh();
                $scope.sidebarLocked = false;
            });
        })
    }

    function toRadians(angle) {
        return angle * (Math.PI / 180);
    }

    $scope.createZone = function () {
        TweenLite.to("#zoneEditMap", 0.5, {height: "700px", ease: "Quart.easeInOut"});
        TweenLite.set("#zoneTools", {height: "auto", marginTop: "0", opacity: "1"});
        TweenLite.from("#zoneTools", 0.5, {height: "0", marginTop: "0", opacity: "0", ease: "Quart.easeInOut"});

        $scope.editing = true;
        $scope.Sidebar = false;
        $scope.sidebarLocked = true;

        $scope.newZone = {'name': '', elayer: {}, errors: {'name': false, 'drawing': false}};
        $scope.paths = {};
        $scope.setDrawMode($scope.syntax.dmPolygon);
        if($scope.currentZone) {
            $scope.autoCenter();
        } else {
            var customerMapData = smarttrackerService.getUserData().customer.map.center;
            editMap.setView({
                'lat': customerMapData.latitude,
                'lng': customerMapData.longitude
            }, customerMapData.zoom);
        }
        $timeout(function () {
            editMap.invalidateSize();
        }, 510);
    }

    $scope.showOtherZones = false;
    var activeEditMapPaths = [];
    $scope.clearOtherZones = function () {
        $scope.showOtherZones = false;
        angular.forEach(activeEditMapPaths, function (path) {
            editMap.removeLayer(path);
        });
        activeEditMapPaths = [];
    }
    $scope.activateOtherZones = function () {
        angular.forEach($scope.items, function (zone, index) {
            var latlngs = [];
            angular.forEach(zone.points, function (point) {
                latlngs.push({'lat': point.latitude, 'lng': point.longitude});
            });
            var polygon = L.polygon(latlngs, {color: 'darkgreen', fillColor: 'darkgreen', interactive: false});
            activeEditMapPaths.push(polygon);
            polygon.addTo(editMap);
        });
        $scope.showOtherZones = true;
    }

    $scope.editZonePoints = function () {

        TweenLite.to("#zoneEditMap", 0.5, {height: "700px", ease: "Quart.easeInOut"});
        TweenLite.set("#zoneTools", {height: "auto", marginTop: "0", opacity: "1"});
        TweenLite.from("#zoneTools", 0.5, {height: "0", marginTop: "0", opacity: "0", ease: "Quart.easeInOut"});

        $scope.editing = true;
        $scope.Sidebar = false;
        $scope.sidebarLocked = true;

        var z = $scope.currentZone;
        var circleMeta = false;
        angular.forEach(z.labels, function (label, key) {
            if (label.code == $scope.syntax.circle) {
                circleMeta = JSON.parse(label.value);
            }
        });

        var drawnItems = $scope.controls.edit.featureGroup;
        drawnItems.addTo(editMap);
          

        if (circleMeta) {
            var circ = L.circle([circleMeta.lat, circleMeta.lng], {radius: circleMeta.radius});
            drawnItems.addLayer(circ);
            editZone = circ;
            $scope.drawMode = $scope.syntax.dmCircle;
        } else {
            $scope.pointsInPolygon = z.points.length;
            var latlngs = [];
            angular.forEach(z.points, function (point) {
                latlngs.push(L.latLng(point.latitude, point.longitude));
            });
            var polygon = L.polygon(latlngs);
            editZone = polygon;
            $scope.drawMode = $scope.syntax.dmPolygon;
            drawnItems.addLayer(polygon);

        }
        $timeout(function () {
            editMap.invalidateSize();
            $scope.autoCenter();
            $scope.editTool.enable();
        }, 550);
    }


    $scope.setDrawMode = function (drawMode) {
        cancelEditMode();
        if ($scope.newZone) {
            $scope.paths = {};
        }
        $scope.drawing = true;
        var drawnItems = $scope.controls.edit.featureGroup;
        drawnItems.addTo(editMap);
        if ($scope.polygonDrawer) {
            $scope.polygonDrawer.disable();
        }
        $scope.drawMode = drawMode;
        $scope.pointsInPolygon = 0;
        if ($scope.polygon) {
            $scope.polygon.remove();
        }
        switch (drawMode) {
            case 'POLYGON':
                (function () {
                    var originalOnTouch = L.Draw.Polyline.prototype._onTouch;
                    L.Draw.Polyline.prototype._onTouch = function (e) {
                        if (e.originalEvent.pointerType != 'mouse') {
                            return originalOnTouch.call(this, e);
                        }
                    }
                })();
                $scope.polygonDrawer = new L.Draw.Polygon(editMap);
                $scope.polygonDrawer.enable();
                break;
            case 'CIRCLE':
                $scope.polygonDrawer = new L.Draw.Circle(editMap);
                $scope.polygonDrawer.enable();
                break;
            case 'SQUARE':
                $scope.polygonDrawer = new L.Draw.Rectangle(editMap);
                $scope.polygonDrawer.enable();
                break;
        }

    }

    $scope.cancelZone = function () {

        TweenLite.to("#zoneEditMap", 0.5, {height: "0px", ease: "Quart.easeInOut"});
        TweenLite.to("#zoneTools", 0.5, {height: "0", marginTop: "0", opacity: "0", ease: "Quart.easeInOut"});

        $scope.newZone = false;
        editZone = false;
        $scope.editing = false;
        $scope.sidebarLocked = false;

        cancelEditMode();
        $scope.zoneClicked($scope.currentZone);
    }

    $scope.deleteLast = function () {
        console.log("Should it delete now? ");
        if ($scope.polygonDrawer) {
            console.log("Yes, we should");
            $scope.polygonDrawer.deleteLastVertex();
            $scope.pointsLeft++;
        }
    }

    $scope.toggleACRZoneProperty = function (name) {
        var z = $scope.currentZone;
        console.log("Toggle: ", name);
        var newValue = !z.meta[name];
        var labels = utilService.clone(z.labels);
        var index = -1;
        angular.forEach(labels, function (value, key) {
            if (value.code == 'ACR_RA') {
                index = key;
            }
        });
        try {
            var json = JSON.parse(labels[index].value);
            json[name] = newValue;
            labels[index].value = JSON.stringify(json);
        } catch (e) {
            console.error("Failed to parse meta data for Response Area: ", e);
            return;
        }
        z.working[name] = z.working['ACR_RA'] = true;

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/" + z.id, {'labels': labels}).then(function (response) {
            z.labels[index].value = response.data.result[0].labels[index].value;
            z.meta[name] = newValue;
            z.working[name] = z.working['ACR_RA'] = false;
        });
    }

    var findLabelIndexByCode = function (code) {
        for (var i in $scope.currentZone.labels) {
            if ($scope.currentZone.labels[i].code == code) {
                return i;
            }
        }
    }

    $scope.autoCenter = function () {
        if (!$scope.currentZone)return; // Nothing to center
        var activeMarkersPoints = [];
        angular.forEach($scope.currentZone.points, function (point) {
            activeMarkersPoints.push(new L.latLng(point.latitude, point.longitude));
        });
        var bounds = new L.latLngBounds(activeMarkersPoints);

        if (activeMarkersPoints.length > 0) {
            $timeout(function () {
                map.fitBounds(bounds, {padding: [50, 50]});
                editMap.fitBounds(bounds, {padding: [50, 50]});
            }, 310);
        }
    };

    $scope.Screensize = function () {
        if (($(window).width() > 991) && !$scope.sidebarLocked) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.lockedPopup = function(){
        dialogService.prompt("SIDEBAR_LOCKED_TITLE", "SIDEBAR_LOCKED_WARNING",
            {
                disablePromptText: true,
                cancelButton: false,
                deleteButton: false
            }
        );
    };

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        if ($scope.sidebarLocked){
            $scope.lockedPopup();
        } else {
            $scope.Sidebar = !$scope.Sidebar;
        }
    };

    $scope.sidebarOptions = (localStorage["sidebarOptions"] === "true");

    $scope.toggleSidebarOptions = function () {
        if ($scope.sidebarOptions) {
            $scope.sidebarOptions = false;
            localStorage["sidebarOptions"] = $scope.sidebarOptions;
            TweenLite.to("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});

        } else {
            $scope.sidebarOptions = true;
            localStorage["sidebarOptions"] = $scope.sidebarOptions;
            TweenLite.set("#sidebarOptions", {height: "auto"});
            TweenLite.from("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});
        }
    };

    $scope.localFavorites = (localStorage["Favorites"] === "true");

    if ($scope.localFavorites){
        $scope.showFavorites();
    }

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    $scope.localCollapseZone = (localStorage["CollapseZone"] === "true");
    $scope.toggleCollapseZone = function () {
        $scope.localCollapseZone = !$scope.localCollapseZone;
        localStorage["CollapseZone"] = $scope.localCollapseZone;
    };

    $scope.ZoomIn = function () {
        map.zoomIn();
    };

    $scope.ZoomOut = function () {
        map.zoomOut();
    };

    $scope.searchOnMap = function () {
        $scope.searchOverlay = !$scope.searchOverlay;
    };

});


angular.module("stwo.response-check", ["stwo.core"]).config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
        name: "response-check",
        links: [{
            name: "XGUARD_ASSET_SITUATION_TITLE",
            category: "ASSETS",
            icon: "verified",
            sref: "secure.content.response-check",
            categoryDependency: "ALARMS",
            sort: 5,
            color: "info",
            controllers: ["AssetSituationListController"]
        }]
    });

    $stateProvider.state("secure.content.response-check", {
        url: "/response-check/:id",
        templateUrl: "modules/response-check/response-check.html",
        controller: "AssetSituationListController",
        titleName: 'ASSET_SITUATION_LIST_TITLE',
        titleIcon: "verified"
    }).state("secure.content.response-check-detail", {
        url: "/response-check-detail/:id",
        templateUrl: "modules/response-check/detail.html",
        controller: "AssetSituationDetailController",
        titleName: 'XGUARD_ASSET_SITUATION_TITLE',
        titleIcon: "verified"
    });

    console.log("modulestoreprovider", moduleStoreProvider);

    moduleStoreProvider.addPossibleFilter("asset", {
        id: "name",
        label: "MANAGEMENT_ASSET_EXTERNAL_ID_FILTER",
        type: "string",
        field: "name",
        comparator: "contains"
    });

}); // End Module definition

angular.module('stwo.response-check').controller('AssetSituationListController', function ($scope, $controller, $stateParams, $translate, $timeout, $state, timerService, $modal, smarttrackerService, mapService, leafletData, notificationService, contentCacheService, $location, dialogService, $filter, messageService) {
    $controller('BaseListContentController', {
        $scope: $scope
    });

    $scope.addPredefinedFilter("unacknowledged", [{
        filterId: "ack_needed",
        label: "ALARMS_FILTER_ACK_NEEDED",
        value: "true"
    }, {
        filterId: "acked_by",
        label: "ALARMS_FILTER_ACKED",
        value: "true"
    }], "&ackNeeded:equals=true&ackedBy:null=true");

    $scope.super({
        clazz: 'alarm',
        pagination: {
            max: 100
        },
        downloadUrl: '/asset?select=name+image+lastValidPosition&sort=name&order=asc'
    });



    $scope.downloadAll = function () {
        var total = $scope.pagination.total;
        //$scope.clearItems();

        $scope.super({
            pagination: {
                max: total
            },
            clazz: 'asset',
            downloadUrl: '/asset?select=name+image+lastValidPosition&sort=name&order=asc'
        });
        $scope.downloadMore();
        $scope.downloadProgress.active = true;
    };

    $scope.textInput = {
        nameSearchValue: "",
        externalIdSearchValue: "",
        assetIdSearchValue: ""
    };
    $scope.applyNameSearch = function ($event) {
        if (!$scope.textInput.nameSearchValue || $scope.textInput.nameSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            $scope.filterValues = {
                "name": $scope.textInput.nameSearchValue
            };
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue + ($scope.isAlarmCenter ? "&crossAccount=true" : "");
            $scope.textInput = {
                nameSearchValue: "",
                externalIdSearchValue: "",
                assetIdSearchValue: ""
            };
        }
    }

    $scope.downloadInProgress = true;

    $scope.$watch("itemsChanged", function () {
        console.log("Changed", $scope.items);
        if ($scope.itemsChanged > 0) {
            $scope.downloadInProgress = false;
        }
    });

    $scope.assetClicked = function (asset) {
        $scope.currentAssetID = asset.id;
        $scope.downloadAsset();
        $scope.initMapDelayed();

        if ($(window).width() < 1400) {
            $scope.Sidebar = false;
        }
    };


    $scope.closeAsset = function () {
        $scope.currentAssetID = 0;
        $scope.Sidebar = true;
    };

    $scope.localSidebarSituation = (localStorage["SidebarSituation"] === "true");
    $scope.toggleSidebarSituation = function () {
        $scope.localSidebarSituation = !$scope.localSidebarSituation;
        localStorage["SidebarSituation"] = $scope.localSidebarSituation;
        $scope.initMapDelayed();
    };

    $scope.initMap = function () {
        map.invalidateSize();
        $scope.autoCenter();
    };

    $scope.initMapDelayed = function () {
        setTimeout(function () {
            $scope.initMap();
        }, 20);
    };


    var debugMode = true;

    var translations = [];
    $scope.responseAreas = [];

    // var codes = {
    //     customer: 0,
    //     qr: 1,
    //     ra: 3,
    //     nqr: 2,
    //     pc: 4,
    //     pd: 6,
    //     bz: 5
    // };

    var codes = {
        customer: 0, // Customer, subject of the alarm
        qr: 1, // Quick Response
        ra: 4, // Response Area
        nqr: 3, // National Quick Response
        pc: 2, // Personal Contacts
        pd: 6, // Police Department
        bz: 5 // Backup zone
    };

    $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE", "XGUARD_TIMESTAMP_TODAY"])
        .then(function (data) {
            $scope.translations = {
                hour: data['XGUARD_HOUR'],
                hours: data['XGUARD_HOURS'],
                minute: data['XGUARD_MINUTE'],
                minutes: data['XGUARD_MINUTES'],
                timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE'],
                today: data['XGUARD_TIMESTAMP_TODAY']
            };
        });


    var syntax = {
        ZMTag: "ACR_ZM",
        QRTag: "ACR_QR",
        NQRTag: "ACR_NQR",
        PDTag: "ACR_PD",
        BZTag: "ACR_BZ",
        RATag: "ACR_RA",
        CLTag: "ACR_CL",
        ContactTag: "ACR_CONTACT",
        email: "email",
        phone: "phone",
        sms: "sms",
        allowContact: "allowContact",
        allowContactNQR: "allowContactNQR",
        allowEmergencyContact: "allowEmergencyContact",
        allowNQR: "allowNQR",
        updateIntervalSeconds: "sixty"
    };


    // $scope.timers = timerService.timers();
    // $scope.$watch("timers.sixty", function () {
    //     if ($scope.alarm) {

    //     }
    // });
    var killAlarmUpdater = $scope.$watch("timers." + syntax.updateIntervalSeconds, function () {
        if ($scope.asset) {
            downloadContacts($scope.asset);
        }
        getTimeString();
    });

    $scope.mapViewAltered = false;
    $scope.$on('leafletDirectiveMap.dragstart', function (event) {
        $scope.mapViewAltered = true;
    });

    $scope.$on('leafletDirectiveMap.click', function (event) {
        $scope.selectedMarker = '';
        deselectSelectedMarker();
    });
    $scope.selectedMarker = '';
    $scope.selectedMarkerName = "";

    $scope.markers = {};


    $scope.mapSidebar = {
        'visible': false
    };
    $scope.markers = {};
    $scope.paths = {
        popupPath: {
            color: '#FF0000',
            weight: 4,
            latlngs: [],
        }
    };

    $scope.indoorViewer = {
        location: null,
        markers: {},
        changeCounter: 0
    };
    mapService.basicMapDesign($scope, leafletData);

    var updateBZVisibility = function () {
        var nbrOfContacts = 0;
        var allElseFailed = true;
        var totalNbrOfContacts = 0;
        for (var i in $scope.responseAreas) {
            var ra = $scope.responseAreas[i];
            if (ra.visible && ra.code != codes.bz && ra.code != codes.pd) {
                if (allElseFailed) {
                    for (var i in ra.contacts) {
                        var c = ra.contacts[i];
                        var key = getActionStatusKey(c);
                        if (!$scope.actionStatus.hasOwnProperty(key) || $scope.getActionStatus(c)) {
                            allElseFailed = false;
                        }
                    }
                }
                if (ra.code != codes.pd && ra.code != codes.customer) {
                    nbrOfContacts += ra.contacts.length;
                }
            }
        }

        updateRAPropertyForCode(codes.bz, "visible", nbrOfContacts == 0 || allElseFailed);
    }

    var clipboard = new Clipboard('.clipBtn');
    clipboard.on('success', function (e) {
        console.log(e);
    });
    clipboard.on('error', function (e) {
        console.log(e);
    });


    $scope.order = 0;
    $scope.actionStatus = {};
    $scope.setOrder = function (order) {
        $scope.responseAreas.sort(function (a, b) {
            if (a.code == b.code) {
                return a.priority - b.priority;
            }
            return (order == 0) ? a.code - b.code : b.code - a.code;
        });
        $scope.order = order;
    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $scope.customerID = smarttrackerService.getCustomerId();
        if ($stateParams.id) {
            $scope.filterUrlString = "&id:equals=" + $stateParams.id;
            $scope.filterMessage = "SELECTED_ITEMS";
            $scope.filterMessage2 = "";
            $scope.assetClicked({
                id: $stateParams.id
            });

            $scope.singleAsset = true;
            $scope.Sidebar = false;

        };
    });

    $scope.isAlarmCenter = false;
    $scope.downloadStatus = {
        'NQR': true,
        'QR': true,
        'RA': true
    };
    $scope.downloadAsset = function () {
        leafletData.getMap("rcmap").then(function (map) {

            map.eachLayer(function (layer) {
                if (layer.hasOwnProperty("item")) {
                    layer.remove();
                }
            });
            $scope.markers = {};
            coreMarkers = [];
            $scope.paths = {};



            var assetID = $scope.currentAssetID;
            if (!assetID) {
                $scope.errorMessage = "Please provide an Asset ID TRANSLATE THIS MESSAGE";
                return;
            }
            return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + assetID + '?select=@&crossAccount=true', {
                onErrorDoNotRedirect: true
            }).then(function (response) {
                if (!response) return;
                $scope.asset = response.data.result[0];

                if ($scope.asset) {
                    contentCacheService.put("asset", assetID, $scope.asset);
                }

                if (!$scope.asset) return;

                getTimeString();


                var asset = $scope.asset;

                if (asset && $scope.asset.lastValidPosition) {



                    addCustomerMarker($scope.asset);

                    if (response.data.result.length == 0) return;
                    var asset = $scope.asset;
                    var nqrEnabled = $scope.getPropertyValue(asset, syntax.allowNQR);

                    $scope.contactInfo = {
                        "id": asset.id,
                        "name": asset.name,
                        "image": asset.image,
                        "phone": $scope.getPropertyValue(asset, syntax.phone),
                        "phoneFormatted": $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone)),
                        "sms": $scope.getPropertyValue(asset, syntax.sms),
                        "email": $scope.getPropertyValue(asset, syntax.email),
                        "allowEmergencyContact": $scope.getPropertyValue(asset, syntax.allowEmergencyContact),
                        "nqrEnabled": nqrEnabled && nqrEnabled == "true"
                    }

                    addContactsForCode([$scope.contactInfo], codes.customer, true);
                    getResponseAreaForCode(codes.nqr).visible = $scope.contactInfo.nqrEnabled;

                    if ($scope.contactInfo.allowEmergencyContact == "false") {
                        updateRAPropertyForCode(codes.customer, "visible", false);
                    }
                    downloadZones(asset.insideZones);
                    downloadContacts(asset);
                    $timeout(function () {
                        $scope.initMap();
                    }, 300);
                }
            }); // ENd download asset request
        });
    }


    $scope.contactStatus = 0;
    var mapInitiated = false;
    var maximumDistances = {
        'total': 0
    };
    var downloadContacts = function (asset) {
        if (!asset || !$scope.access['type']['get'] || (!asset.position && !asset.lastValidPosition)) return;
        var position = asset.lastValidPosition ? asset.lastValidPosition : asset.position;
        var lessLat = position.latitude + 1;
        var lessLon = position.longitude + 1;
        var greaterLat = position.latitude - 1;
        var greaterLon = position.longitude - 1;

        downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.QRTag + '&owner:equals=' + asset.owner.id +
            '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat + '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.QRTag,
            function (list) {
                // get types meta
                var usedIDS = [];
                if (list && list.length > 0) {
                    var typeIDS = list[0].type.id;

                    for (var i = 1; i < list.length; i++) {
                        var id = list[i].type.id;
                        if (usedIDS.indexOf(id) < 0) {
                            usedIDS.push(id);
                            typeIDS += "%2B" + id;
                        }
                    }
                    if (!maximumDistances || !maximumDistances.qr) {
                        getMaxDistancesForCode(list, codes.qr);
                    }
                    $scope.collegues = list;
                    addContactsForCode(list, codes.qr, true);

                    $scope.contactStatus++;
                    updateBZVisibility();
                    applyDistanceFilter(codes.qr);
                    if (!mapInitiated) {
                        $timeout(function () {
                            $scope.autoCenter();
                        }, 300);
                        mapInitiated = true;
                    }
                }
                $scope.downloadStatus['QR'] = false;

            });
        if ($scope.contactInfo.nqrEnabled) {
            downloadCloseAssets('/asset?select=properties+lastValidPosition+lastPosition+type+groups&crossAccount=true&type.labels:contains=' + syntax.NQRTag + '&latitude:less=' + lessLat + '&latitude:greater=' + greaterLat +
                '&longitude:less=' + lessLon + '&longitude:greater=' + greaterLon + (debugMode ? '' : '&embeddedTimestamp:younger=3900000') + '&max=50', syntax.NQRTag,
                function (list) {

                    $scope.guards = list;
                    if (!maximumDistances || !maximumDistances[codes.nqr]) {
                        getMaxDistancesForCode(list, codes.nqr);
                    }

                    addContactsForCode($scope.guards, codes.nqr, true);
                    $scope.contactStatus++;
                    updateBZVisibility();
                    applyDistanceFilter(codes.nqr);
                    $scope.downloadStatus['NQR'] = false;
                });

        } else {
            $scope.downloadStatus['NQR'] = false;
        }
        if ($scope.asset) {

            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $scope.asset.id + '?crossAccount=true', {
                onErrorDoNotRedirect: true
            }).then(function (response) {
                if (response && response.data && response.data.result && response.data.result.length > 0) {
                    $scope.asset = response.data.result[0];

                    // Add private contacts
                    if (!getResponseAreaForCode(codes.pc) && $scope.asset.labels) {
                        var data = parseDataForZone($scope.asset);
                        var contacts = data.contacts.sort(comparePriority);
                        if (data.contacts) {
                            $scope.responseAreas.push({
                                "name": translations["XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS"],
                                "color": "ra",
                                "code": codes.pc,
                                "contacts": contacts,
                                "expanded": false,
                                "visible": true
                            });
                            $scope.setOrder($scope.order);
                        }
                    }
                    if ($scope.asset) {
                        addCustomerMarker($scope.asset);
                        downloadZones(asset.insideZones);
                    }
                }
            });
        }
    }

    var getLabelWithCode = function (objectWithLabel, code) {
        if (objectWithLabel.labels) {
            for (var i in objectWithLabel.labels) {
                if (objectWithLabel.labels[i].code == code) {
                    return objectWithLabel.labels[i];
                }
            }
        }
    }

    var getMaxDistancesForCode = function (contacts, code) {
        if (contacts.length > 0) {
            var usedIDS = [];
            var typeIDS = contacts[0].type.id;
            for (var i = 1; i < contacts.length; i++) {
                var id = contacts[i].type.id;
                if (usedIDS.indexOf(id) < 0) {
                    usedIDS.push(id);
                    typeIDS += "%2B" + id;
                }
            }
            if (!maximumDistances || !maximumDistances.qr) {
                smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/type/?select=labels&id:equals=" + typeIDS, {
                        onErrorDoNotRedirect: true
                    })
                    .then(function (response) {

                        var approvedContacts = [];
                

                        for (var i in response.data.result) {
                            var type = response.data.result[i];
                            for (var x in type.labels) {
                                var label = type.labels[x];
                                if (label.value.indexOf("maxDistance") >= 0) {
                                    try {
                                        var value = JSON.parse(label.value);
                                        maximumDistances[type.id + type.name] = value.maxDistance;
                                        maximumDistances['total'] = maximumDistances['total'] + 1;
                                    } catch (e) {
                                        console.log(e);
                                        maximumDistances[type.id + type.name] = 2000;
                                        maximumDistances['total'] = maximumDistances['total'] + 1
                                    }
                                } else {
                                    maximumDistances[type.id + type.name] = 2000;
                                    maximumDistances['total'] = maximumDistances['total'] + 1
                                }
                            }
                        }
                        applyDistanceFilter(code);
                    });
            }
        }
    }

    var applyDistanceFilter = function (code) {
        if (maximumDistances && maximumDistances.total > 0) {
            var ra = false;
            for (var i in $scope.responseAreas) {
                if ($scope.responseAreas[i].code == code) {
                    ra = $scope.responseAreas[i];
                }
            }
            if (ra) {
                var list = [];
                for (var i in ra.contacts) {
                    var contact = ra.contacts[i];
                    if (!(contact.type && maximumDistances[contact.type.id + contact.type.name] &&
                            contact.distance > maximumDistances[contact.type.id + contact.type.name])) {
                        list.push(contact);
                        if (code == codes.nqr) addNQRMarker(contact);
                        else if (code == codes.qr) addQRMarker(contact);

                    } else if ($scope.markers["marker" + contact.id]) {
                        leafletData.getMap("rcmap").then(function (map) {
                            map.removeLayer($scope.markers["marker" + contact.id]);
                            delete $scope.markers["marker" + contact.id];
                        });
                    }
                }
                addContactsForCode(list, code, true);

            }
        }
    }




    var downloadCloseAssets = function (url, context, repl) {
        var list = [];
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + url, {
            onErrorDoNotRedirect: true
        }).then(function (response) {
            if (!response || !response.data) return;
            for (var i in response.data.result) {
                var asset = response.data.result[i];

                if (!asset.lastValidPosition || !isContactAllowed(asset, context)) {
                    console.log('Stopped showing asset in response-check', {
                        lastValidPosition: asset.lastValidPosition
                    }, {
                        isContactAllowed: isContactAllowed(asset, context)
                    })
                    continue;
                }

                if ($scope.asset && asset.id != $scope.asset.id) {

                    asset.phone = $scope.getPropertyValue(asset, syntax.phone);
                    asset.phoneFormatted = $scope.trimPhoneNumber($scope.getPropertyValue(asset, syntax.phone));
                    asset.sms = $scope.getPropertyValue(asset, syntax.sms);
                    asset.email = $scope.getPropertyValue(asset, syntax.email);
                    asset.distance = calculateDistance(asset.lastValidPosition, $scope.asset.lastValidPosition);
                    asset.distanceText = getDistanceText(asset.distance);
                    //asset.allowConact = $scope.getPropertyValue(asset, syntax.allowConact);


                    list.push(asset);

                }else{

                    console.log('Stopped showing asset in response-check', 'missing data');

                }
            }
            list.sort(function (a, b) {
                return a.distance - b.distance;
            });

            repl(list);
        });
    }

    var downloadZones = function (zones) {
        if (!zones || zones.length < 1) {
            $scope.downloadStatus['RA'] = false;
            return;
        }
        var zoneIDS = "" + zones[0].id;
        for (var i = 1; i < zones.length; i++) {
            zoneIDS += "%2B" + zones[i].id;
        }

        console.log("IS GOING TO DOWNLOAD ZONES: " + zones);
        // remove zones that the asset is no longer inside


        smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/zone/?id:equals=' + zoneIDS + "&select=type+labels+points&crossAccount=true", {
            onErrorDoNotRedirect: true
        }).then(function (response) {
            var zs = response.data.result;
            // clear old zone contacts
            for (var i in $scope.responseAreas) {
                var ra = $scope.responseAreas[i];
                if (ra.code == codes.pd || ra.code == codes.bz || ra.code == codes.ra) {
                    ra.contacts = [];
                }
            }

            for (var i in zs) {
                var z = zs[i];
                if (z.labels) {
                    for (var l in z.labels) {
                        var label = z.labels[l];
                        switch (label.code) {
                        case syntax.RATag:
                            addResponseArea(z);
                            break;
                        case syntax.PDTag:
                            if ($scope.isAlarmCenter)
                                addContactsForCode(parseDataForZone(z).contacts, codes.pd);
                            break;
                        case syntax.BZTag:
                            addContactsForCode(parseDataForZone(z).contacts, codes.bz);
                            break;
                        }
                    }
                }
            }
            updateBZVisibility();
            $scope.downloadStatus['RA'] = false;
        });
    }

    var addResponseArea = function (z) {
        var data = parseDataForZone(z);
        var priority = data.priority ? data.priority : 20000;
        var contacts = data.contacts.sort(comparePriority);;
        getResponseAreaTextForZone(z).then(function (text) {
            var ra = {
                "name": text,
                "color": "ra",
                "code": codes.ra,
                "priority": priority,
                "contacts": contacts,
                "expanded": false,
                "visible": contacts.length > 0
            };
            if (data.messageData) ra.messageData = data.messageData;
            $scope.responseAreas.push(ra);
            $scope.setOrder($scope.order);
            var hp = ra.priority;
            var fp = false;
            for (var i in $scope.responseAreas) {
                var area = $scope.responseAreas[i];
                if (area.code == codes.ra && area.priority && area.priority < hp) {
                    fp = true;
                    break;
                }
            }
            if (!fp) {
                renderResponseArea(z);

            }
        });
    }

    var renderResponseArea = function (a) {
        var latlngs = [];
        for (var i in a.points) {
            var point = a.points[i];
            latlngs.push({
                'lat': point['latitude'],
                'lng': point['longitude']
            });
        }

        addPath("ResponseArea", {
            type: "polygon",
            fillColor: 'darkgreen',
            color: 'darkgreen',
            latlngs: latlngs,
            clickable: false,
            weight: 2
        });
    }

    var getResponseAreaForCode = function (code, priority) {
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                var ra = $scope.responseAreas[i];
                if (priority && ra.priority != priority) {
                    continue;
                }
                return ra;
            }
        }
        return false;
    }

    var updateRAPropertyForCode = function (code, property, value) {
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                $scope.responseAreas[i][property] = value;
                break;
            }
        }
    }

    var addContactsForCode = function (contacts, code, refresh) {
        var index = false;
        for (var i in $scope.responseAreas) {
            if ($scope.responseAreas[i].code == code) {
                index = i;
                break;
            }
        }
        if (index && index > -1) {
            if (refresh) {
                $scope.responseAreas[index].contacts = [];
            }
            for (var j in contacts) {
                $scope.responseAreas[i].contacts.push(contacts[j]);
            }

        }
        if (code == codes.nqr || code == codes.qr)
            $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts;
        else
            $scope.responseAreas[i].contacts = $scope.responseAreas[i].contacts.sort(comparePriority);
    }

    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    var parseDataForZone = function (zone) {
        zone.contacts = [];
        var now = new Date();


        for (var i in zone.labels) {
            var label = zone.labels[i];
            if (label.code == "ACR_CONTACT") {
                try {
                    var properties = JSON.parse(label.value);
                    properties["name"] = i;

                    console.log('CONTACT NAME', properties["name"])

                    // Check if the contact is available 
                    if (properties.workhours.length > 0) {
                        properties.working = false;
                        whcheck:
                            for (var y in properties.workhours) {
                                var wh = properties.workhours[y];
                                for (var z in wh.weekday) {
                                    if (days.indexOf(wh.weekday[z]) == now.getDay()) {

                                        var startBound = new Date();
                                        startBound.setHours(wh.hours.substring(0, 2));
                                        startBound.setMinutes(wh.hours.substring(2, 4));
                                        var endBound = new Date();
                                        endBound.setHours(wh.hours.substring(5, 7));
                                        endBound.setMinutes(wh.hours.substring(7, 9));

                                        if (now.getTime() > startBound.getTime() && now.getTime() < endBound.getTime()) {
                                            properties.working = true;
                                            zone.contacts.push(properties);
                                            break whcheck;
                                        }
                                    }
                                }
                            }

                    } else {
                        properties.working = true;
                        zone.contacts.push(properties);
                    }
                } catch (e) {
                    console.log('error parsing workhours', e);
                }
            } else if (label.code == "ACR_RA") {

                try {
                    var properties = JSON.parse(label.value);
                    var kv = {
                        showQR: "qr",
                        showNQR: "nqr",
                        showPD: "pd"
                    };
                    for (var k in kv) {
                        if (properties.hasOwnProperty(k) && !properties[k]) {
                            updateRAPropertyForCode(codes[kv[k]], "visible", false);
                        }
                    }
                    zone.priority = properties.priority ? properties.priority : 20000;
                    if (properties.messageData) {
                        zone.messageData = properties.messageData;
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }


        return zone;
    }


    $translate(["XGUARD_RESPONSE_AREAS_CUSTOMER", "XGUARD_RESPONSE_AREAS_QUICK_RESPONSE",
        "XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE", "XGUARD_RESPONSE_AREAS_POLICE_REGION", "XGUARD_RESPONSE_AREAS_PRIVATE_CONTACTS",
        "XGUARD_RESPONSE_AREAS_BACKUP"
    ]).then(function (data) {
        translations = data;

        $scope.responseAreas = [{
                "name": translations["XGUARD_RESPONSE_AREAS_CUSTOMER"],
                "color": "cu",
                "code": codes.customer,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_QUICK_RESPONSE"],
                "color": "qr",
                "code": codes.qr,
                "contacts": [],
                "expanded": false,
                "visible": true
            },
            //{"name":"Response Area", "color":"ra", "code":codes.ra, "contacts":[], "expanded":false, "visible":true},
            {
                "name": translations["XGUARD_RESPONSE_AREAS_NATIONAL_QUICK_RESPONSE"],
                "color": "nqr",
                "code": codes.nqr,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_POLICE_REGION"],
                "color": "pd",
                "code": codes.pd,
                "contacts": [],
                "expanded": false,
                "visible": true
            }, {
                "name": translations["XGUARD_RESPONSE_AREAS_BACKUP"],
                "color": "pd",
                "code": codes.bz,
                "contacts": [],
                "expanded": false,
                "visible": false
            }
        ];

    });



    var isContactAllowed = function (asset, context) {
        var contactAllowed = true;
        var testValue = context == syntax.NQRTag ? syntax.allowContactNQR : syntax.allowContact;

        console.log('Testvalue', asset, testValue)

        for (var i in asset.properties) {
            var prop = asset.properties[i];
            if (prop.code == testValue) {
                contactAllowed = prop.value != "false";
                break;
            }
        }
        return contactAllowed;
    }

    $scope.getPropertyValue = function (asset, code) {
        var value = false;
        if (asset && code) {
            for (var i in asset.properties) {
                var property = asset.properties[i];
                if (property.code == code) {
                    value = property.value;
                    break;
                }
            }
        }
        return value;
    }



    var makeNamedIcon = function (name, icon, color) {
        if (!color) {
            color = "#31708f";
        }
        if (!icon) {
            icon = "glyphicon glyphicon-map-marker";
        }
        var div_icon = {
            type: 'div',
            iconAnchor: [18, 36 - 8], //these numbers come from the fact that we use an icon 36x36 and the leaflet positions this with its top-felt corner. Thus I shift so the the nidle of the icon shows right point in map
            iconSize: [2000, 0],
            className: 'myleaflet-div-icon',
            //html: '<img src="images/Map-Marker-icon-' + color + '.png" align="top"><span class="name">' + name + '</span>',
            html: '<span class="pin" style="color:' + color + '"><span class="' + icon + '" style="color:' + color + '"></span></span><span class="name label" style="background-color:' + color + '">' + name + '</span>',
            popupAnchor: [0, 0]
        };


        return div_icon;
    }

    /* Map Commands*/
    var coreMarkers = [];
    $scope.securityGuardsVisible = false;

    var deselectSelectedMarker = function () {
        if (selectedMarker) {
            selectedMarker._icon.className = selectedMarker._icon.className.replace("selected", "");
        }
        selectedMarker = false;
    }
    var selectedMarker = false;
    var addSelectedMarker = function (marker) {
        /*$scope.markers[marker.id] = {
            id: marker.id,
            lat: marker.lat,
            lng: marker.lng,
            icon: makeNamedIcon(marker.item.name, "glyphicon glyphicon-map-marker", "DodgerBlue"),//(item.logLevelFormatted === 'notification' ? 'success' : (item.logLevelFormatted === 'warning' ? 'warning' : 'danger' ) )),
            //message : "message",
            focus: false, //just add them on the map. not in focus
            draggable: false,
            'item': marker.item,
            'code': marker.code
        };*/
        if (selectedMarker) {
            deselectSelectedMarker();
        }
        selectedMarker = marker;
        selectedMarker._icon.className += " selected";
    }
    var addAlarmMarker = function (alarm) {
        addMarker(alarm, "mdi mdi-bullseye", "#FF0000", "#e00000", "Alarm Position", true, null, 18, 18);
    }
    var addQRMarker = function (asset) {
        addMarker(asset, "mdi mdi-map-marker", "#22b573", "#1c925d", asset.name, true, codes.qr);
    }
    var addCustomerMarker = function (asset) {
        addMarker(asset, "mdi mdi-map-marker", "#FF0000", "#e00000", "Current Position", true, codes.customer);
        //renderLineBetween();
    }
    var addNQRMarker = function (asset) {
        addMarker(asset, "mdi mdi-marker-check", "#0b788a", "#095e6d", asset.name, false, codes.nqr, 15, 29);
    }

    var oms = false;
    var addMarker = function (item, icon, color, colorDark, text, core, code, iconAnchorX, iconAnchorY) {
        leafletData.getMap("rcmap").then(function (map) {

            if (!$scope.slInit) {
                oms = new OverlappingMarkerSpiderfier(map);
                oms.addListener("click", function (marker) {
                    if (marker.code == codes.nqr || marker.code == codes.qr || marker.code == codes.customer) {

                        var ra = getResponseAreaForCode(marker.code);
                        if (ra.contacts.indexOf(marker.item) >= 2)
                            ra.expanded = true;

                        deselectSelectedMarker();
                        addSelectedMarker(marker);

                        $scope.selectedMarker = marker.item.id;
                        $scope.selectedMarkerName = marker.id;
                    }
                });
                $scope.slInit = true;
            }

            if (item && item.id && (item.lastValidPosition || item.position)) {
                var positionKey = item.position ? 'position' : 'lastValidPosition';

                if (oms) {
                    L.Icon.Default.imagePath = 'css/images';

                    if (!iconAnchorX || !iconAnchorY) {
                        iconAnchorX = 18;
                        iconAnchorY = 32;
                    }

                    var micon = L.divIcon({
                        type: 'div',
                        iconAnchor: [iconAnchorX, iconAnchorY],
                        className: 'myleaflet-div-icon',
                        html: '<div><div class="pin"><i class="' + icon + '" style="color:' + color + '"></i></div><div class="name label" style="background-color:' + color + '; border-color:' + colorDark + '"><span>' + text + '</span></div></div>',
                        popupAnchor: [0, 0]
                    });
                    var markerId = "marker" + item.id;

                    var marker = $scope.markers[markerId];
                    var loc = new L.LatLng(item[positionKey].latitude, item[positionKey].longitude);
                    if (marker)  {
                        oms.unspiderfy();
                        try {
                            marker.setLatLng(loc);
                        } catch (err) {
                            console.log(err);
                        }
                    } else {
                        marker = new L.Marker(loc, {
                            icon: micon,
                            riseOnHover: true
                        });
                        map.addLayer(marker);
                        oms.addMarker(marker);
                        marker.item = item;
                        marker.code = code;
                        marker.id = markerId;
                        marker.iconCode = micon;
                        // marker.on('mouseover', function (e){
                        //     console.log(this);
                        // });
                        $scope.markers[markerId] = marker;
                    }
                }

                if (core && coreMarkers.indexOf("marker" + item.id) < 0) {
                    coreMarkers.push("marker" + item.id);
                }
            }
        });

    }

    var clearMarkersForCode = function (code) {
        var markers = {};
        for (var i in $scope.markers) {
            if (i.indexOf(code) != 0) {
                markers[i] = $scope.markers[i];
            }
        }
        $scope.markers = markers;
    }

    var addPath = function (name, path) {
        var p = $scope.paths;
        $scope.paths = {};
        for (var i in p) {
            $scope.paths[i] = p[i];
        }
        $scope.paths[name] = path;
    }


    $scope.initialCenterSet = false;

    $scope.setCenter = function (newCenter) {
        console.log("SetCenter", newCenter);
        leafletData.getMap("rcmap").then(function (map) {
            map.setView($scope.mapData.center = new L.LatLng(newCenter.lat, newCenter.lng), newCenter.zoom);
        });
        $scope.mapData.center.lat = newCenter.lat;
        $scope.mapData.center.lng = newCenter.lng;

        if (newCenter.zoom) {
            $scope.mapData.center.zoom = newCenter.zoom;
        }
    };

    $scope.centerOnItem = function (item) {
        console.log("center on item", item);
        if (item && item.position && item.position.location && item.position.location.locationId) {
            $scope.mapMode.indoor = true;
            $scope.indoorViewer.location = item.position.location.locationId;
        } else if (item && item.position && item.position.valid) {
            $scope.mapMode.indoor = false;
            var newcenter = {
                lat: item.position.latitude,
                lng: item.position.longitude
            };

            $scope.setCenter(newcenter);
        }
    };

    $scope.toggleMap = function () {
        $scope.mapVisible = !$scope.mapVisible;
        if ($scope.mapVisible) {
            if (!mapInitiated) {
                mapInitiated = true;
                $scope.autoCenter();
                $scope.mapViewAltered = false;
            }
            $timeout(function () {
                leafletData.getMap("rcmap").then(function (map) {
                    map.invalidateSize();
                });
            }, 1050);
        }
    }

    $scope.zoomNQR = function () {
        $scope.securityGuardsVisible = true;
        $scope.autoCenter();
    }

    $scope.zoomCore = function () {

        $scope.securityGuardsVisible = false;
        $scope.autoCenter();
        $scope.mapViewAltered = false;
    }

    $scope.autoCenter = function () {
        var activeMarkersPoints = [];

        if ($scope.securityGuardsVisible) {
            for (var m in $scope.markers) {
                var item = $scope.markers[m];
                if (item && item.getLatLng()) {
                    activeMarkersPoints.push(item.getLatLng());
                }
            }
        } else {
            for (var i in coreMarkers) {
                var item = $scope.markers[coreMarkers[i]];
                if (item && item.getLatLng()) {
                    activeMarkersPoints.push(item.getLatLng());
                }
            }
        }

        var bounds = new L.latLngBounds(activeMarkersPoints);

        if (activeMarkersPoints.length > 0 && bounds.isValid()) {
            $timeout(function () {
                leafletData.getMap("rcmap").then(function (map) {
                    var f = bounds.isValid();
                    map.fitBounds(bounds, {
                        padding: [50, 50]
                    });
                    // map.zoomOut(1);
                });
            }, 310);
        }
    };

    /*Map Commands*/

    var calculateDistance = function (pos1, pos2) {
        var lat1 = pos1.latitude;
        var lat2 = pos2.latitude;
        var lon1 = pos1.longitude;
        var lon2 = pos2.longitude;

        var R = 6371e3; // metres
        var φ1 = toRadians(lat1);
        var φ2 = toRadians(lat2);
        var Δφ = toRadians(lat2 - lat1);
        var Δλ = toRadians(lon2 - lon1);

        var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        var d = R * c;
        return d;
    }

    var toRadians = function (deg) {
        return deg * Math.PI / 180.0;
    }

    var getDistanceText = function (distance) {
        if (distance > 100) {
            return (Math.round(distance / 100) / 10) + " km";
        } else return (Math.round(distance * 10) / 10) + " m";
    }

    function comparePriority(a, b) {
        return a.priority == b.priority ? 0 : a.priority < b.priority ? -1 : 1;
    }


    /** Helper functions*/
    $scope.isIndoor = function (item) {
        if (item.position) { // alarma
            return item.position.source && item.position.source.type == "beacon";
        } else {
            return item.lastValidPosition && item.lastValidPosition.source && item.lastValidPosition.source.type == "beacon";
        }
    }

    $scope.isInZone = function (item, zone) {

        if (zone && zone.id && (item.insideZones || (item.position && item.position.insideZones))) {
            var zones = item.insideZones ? item.insideZones : item.position.insideZones;
            for (var i in zones) {
                if (zones[i].id == zone.id)
                    return true;
            }
        }
        return false;
    }

    $scope.isGuardsVisible = function () {
        var nqr = getResponseAreaForCode(codes.nqr);
        return $scope.asset && nqr.visible && nqr.contacts.length > 0;
    }

    $scope.timeString = "";
    var getTimeString = function () {

        if ($scope.asset && $scope.asset.lastValidPosition && $scope.translations) {
            var time = moment.tz($scope.asset.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
            var diff = Math.floor((new Date() - time) / 1000);
            if (diff < 86400) {
                var hours = Math.floor(diff / 3600);
                diff = diff = Math.floor(diff % 3600);
                var minutes = Math.floor(diff / 60);

                $scope.timeString = $scope.translations.timeTemplate.toString().replace("<HOURS>", hours > 0 ? hours + (hours > 1 ? " " + $scope.translations.hours + " " : " " + $scope.translations.hour + " ") : "")
                    .replace("<MINUTES>", minutes >= 0 ? (minutes + (minutes == 1 ? " " + $scope.translations.minute + " " : " " + $scope.translations.minutes + " ")) : "");
            } else {
                $scope.timeString = $scope.asset.lastValidPosition.timestampFormatted;
            }
        }
    };

    var getResponseAreaTextForZone = function (zone) {
        return $translate("XGUARD_RESPONSE_AREAS_RESPONSE_AREA", {
            zoneName: zone.name
        });
    };

    /**End Helper functions*/

    /*$scope.googleMapsBackup = function (item) {
        $window.open('http://maps.google.com/maps?q=' + item.lastValidPosition.latitude + ',' + item.lastValidPosition.longitude);
    }*/

    $scope.googleMaps = function (item) {

        var lat = item.position.latitude;
        var lng = item.position.longitude;

        if ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1)) {
            function iOSversion() {
                if (/iP(hone|od|ad)/.test(navigator.platform)) {
                    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                }
            }

            var ver = iOSversion() || [0];

            if (ver[0] >= 6) {
                protocol = 'maps://';
            } else {
                protocol = 'http://';

            }
            window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
        } else {
            window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
        }
    };

    var getTableRow = function (col1, col2) {
        return "<tr><td><b>" + col1 + "</b></td><td>" + col2 + "</td></tr>";
    }

    $scope.getGoogleMapsLink = function (lat, lon) {
        return "http://maps.google.com/maps?q=" + lat + "%2C" + lon;
    }

    var sendMailsSynchronized = function (list, index, endFN) {
        if (index < list.length) {
            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/mail/", list[index++]).then(function (response) {
                sendMailsSynchronized(list, index, endFN);
            }, function (response) {
                sendMailsSynchronized(list, index, endFN);
            });
        } else {
            endFN();
        }
    }

    var getActionStatusKey = function (contact) {
        return contact.name + "" + contact.phone + contact.email;
    }

    $scope.getActionStatus = function (contact) {
        var name = getActionStatusKey(contact);
        return $scope.actionStatus[name];
    }

    $scope.updateActionStatus = function (contact, status) {
        var name = getActionStatusKey(contact);
        if ($scope.actionStatus.hasOwnProperty(name) && $scope.actionStatus[name] == status) {
            delete $scope.actionStatus[name];
        } else {
            $scope.actionStatus[name] = status;
        }

        var meta = $scope.alarm.meta;
        meta["actionStatus"] = $scope.actionStatus;

        //var labels = $scope.alarm.labels;
        //labels["ALARM_CENTER_ACTIONS"] = {"value":JSON.stringify($scope.actionStatus)};
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/alarm/" + $scope.alarm.id, {
            "meta": meta
        });
        updateBZVisibility();
        // put update
    }

    $scope.trimPhoneNumber = function (nbr) {
        return nbr ? nbr.replace(/\+/, "00").replace(/\s/g, "") : nbr;
    }

    $scope.sendEmail = function (name, mail) {

        var md_content = "";
        var va = $translate(["ASSET_SITUATION_SEND_MAIL_DIALOG_CONTENT", "ASSET_SITUATION_SEND_MAIL_FAILED_TEXT", "ASSET_SITUATION_SEND_MAIL_DIALOG_TITLE", "ASSET_SITUATION_SEND_MAIL_DIALOG_BUTTONS_OK",
            "ASSET_SITUATION_SEND_MAIL_DIALOG_PLACEHOLDER", "ASSET_SITUATION_SEND_MAIL_SPLASH_TITLE", "ASSET_SITUATION_SEND_MAIL_SPLASH_CONTENT"
        ], {
            assetName: $scope.asset.name,
            "contactMail": mail
        }).then(function (lan) {



            md_content = lan['ASSET_SITUATION_SEND_MAIL_DIALOG_CONTENT'];



            dialogService.prompt("ASSET_SITUATION_SEND_MAIL_DIALOG_TITLE",
                md_content, {
                    okButtonText: "ASSET_SITUATION_SEND_MAIL_DIALOG_BUTTONS_OK",
                    multiline: true,
                    placeHolder: "ASSET_SITUATION_SEND_MAIL_DIALOG_PLACEHOLDER"
                }).then(function (data) {

                var dialog = dialogService.wait("ASSET_SITUATION_SEND_MAIL_SPLASH_TITLE",
                    "ASSET_SITUATION_SEND_MAIL_SPLASH_CONTENT", {});

                messageService.sendAssetByMail(data.promptText, $scope.asset, mail, getResponseAreaForCode(codes.ra).messageData).then(function (response) {
                    //$scope.registerEvent(lan['XGUARD_SEND_MAIL_EVENT_TEXT'], data.promptText);
                    dialog.close();
                }, function (response) {
                    //$scope.registerEvent(lan['XGUARD_SEND_MAIL_FAILED_TEXT'], data.promptText);
                    dialog.close();
                });
            }, function () { /* Cancelled */ });


        });
    }

    $scope.contactCalled = function (name) {
        // $translate.use("nl");
        $translate("XGUARD_CONTACT_CALLED_EVENT_TEXT", {
            contact: name
        }).then(function (data) {
            $scope.registerEvent(data);
            //   $translate.use("en");
        })
    }

    $scope.linkClicked = function (link) {
        $location.path(link);
    };

    $scope.sendSMS = function (contact) {
        var formatNumber = false;
        var number = contact.sms;
        try {
            formatNumber = $scope.trimPhoneNumber(number);
        } catch (e) {}
        if (!formatNumber) {
            alert("The number: " + number + " is not a valid phone number " + formatNumber);
            return;
        }
        var name = contact.name;
        var va = $translate("ASSET_SITUATION_SMS_DIALOG_CONTENT", {
            assetName: $scope.asset.name,
            contact: name,
            number: number
        }).then(function (data) {


            dialogService.prompt("ASSET_SITUATION_SEND_SMS_DIALOG_TITLE",
                data, {
                    okButtonText: "ASSET_SITUATION_SEND_SMS_DIALOG_BUTTONS_OK",
                    multiline: true,
                    placeHolder: "ASSET_SITUATION_SEND_SMS_DIALOG_PLACEHOLDER"
                }).then(function (data) {


                var dialog = dialogService.wait("ASSET_SITUATION_SMS_SPLASH_TITLE",
                    "ASSET_SITUATION_SMS_SPLASH_CONTENT", {});

                messageService.sendAssetBySMS(data.promptText, $scope.asset, contact.sms).then(function () {
                    dialog.close();
                }, function (response) {
                    dialog.close();
                });
            }, function (data) { /** Cancelled*/ });

        });

    }




    //ALL THE CODE BELOW CUSTOM MADE BY X-GUARD




    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 8
        },
        defaults: {
            'dragging': true
        },
        events: {
            map: {
                enable: ['dragstart', 'zoomstart', 'click'],
                logic: 'emit'
            }
        }
    };

    var smallScreen = function () {
        if ($(this).width() > 1199) {
            $scope.screenSmallitems = false
        } else {
            $scope.screenSmallitems = true
        }
    };

    $scope.getIconColor = function (item) {
        var clazz = 'text-danger';
        var accuracy = item.position ? item.position.accuracy : item.lastValidPosition.accuracy;
        if ($scope.isIndoor(item) || (accuracy > 0 && accuracy <= 15))
            clazz = 'text-success';
        else if (accuracy > 15 && accuracy <= 40)
            clazz = 'text-warning';
        return clazz;
    }

    $scope.getTimeColor = function () {
        var clazz = 'text-danger';
        if ($scope.asset && $scope.asset.lastValidPosition) {
            var assetPositionDate = moment.tz($scope.asset.lastValidPosition.timestamp, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC").toDate();
            var now = new Date();
            var diff = now - assetPositionDate;
            if (diff < 901 * 1000) {
                clazz = 'text-success';
            } else if (diff < 3900 * 1000) {
                clazz = 'text-warning';
            }
        }
        return clazz;
    }

    var setMobileView = function () {
        if ($(this).width() < 992) {
            $scope.appFormat = true
        } else {
            $scope.appFormat = false
        }
    };

    $(window).width(function () {
        smallScreen();
        setMobileView();
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    });

    $(window).resize(function () {
        smallScreen();
        setMobileView();
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    });

    $scope.centerOnAddress = function (data) {
        leafletData.getMap("rcmap").then(function (map) {
            map.setView({
                'lat': data.point.lat,
                'lng': data.point.lng
            }, 16);
        });
    }


    // MOBILE FORMAT

    $scope.currentTab = 1;

    $scope.switchTabs = function (number) {
        $scope.currentTab = number;
    };

    $scope.localAlarmScreenMap = false;
    $scope.toggleAlarmScreenMap = function () {
        $scope.localAlarmScreenMap = !$scope.localAlarmScreenMap;
        localStorage["AlarmScreenMapSmall"] = $scope.localAlarmScreenMap;
        setTimeout(function () {
            $scope.initMap();
        }, 310);
    };

    $scope.initMap = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.invalidateSize();
        });
        $scope.autoCenter();
    };

    $scope.initMapDelayed = function () {
        setTimeout(function () {
            $scope.initMap();
        }, 50);
    };

    // Bind a color to the alarm
    $scope.getAlarmColor = function (item) {
        var color = 'text-danger';

        if (item.logLevelFormatted == null) {
            color = 'text-danger'
        } else {
            if (item.logLevelFormatted == 'notification') {
                color = 'text-success'
            } else if (item.logLevelFormatted == 'red_alert') {
                color = 'text-danger'
            } else if (item.logLevelFormatted == 'warning') {
                color = 'text-warning'
            }
        }
        return color
    };

    $scope.ZoomIn = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.zoomIn();
        });
    };

    $scope.ZoomOut = function () {
        leafletData.getMap("rcmap").then(function (map) {
            map.zoomOut();
        });
    };

    $scope.Screensize = function () {
        if ($(window).width() > 1400) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        $scope.Sidebar = !$scope.Sidebar;
        $scope.popupExpand = false;
        setTimeout(function () {
            $scope.initMap();
        }, 350);
    };

    $scope.localCollapseResponse = (localStorage["CollapseResponse"] === "true");
    $scope.toggleCollapseResponse = function () {
        $scope.localCollapseResponse = !$scope.localCollapseResponse;
        localStorage["CollapseResponse"] = $scope.localCollapseResponse;
    };

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

}); // End Module alarm-screen-xguard-detail
angular.module('stwo.management-user', ["stwo.management"])
    .config(function ($stateProvider, moduleStoreProvider) {

        moduleStoreProvider.registerModule({
            name: "user-management", links: [
                {
                    name: "MANAGEMENT_USER_TITLE",
                    category: "MANAGEMENT",
                    sref: "secure.content.management.user",
                    icon: 'account-multiple',
                    access: ["customerUser", "put"],
                    navigation: true,
                    sort: 23,
                    controllers: ['UserManagementListController']
                }
            ]
        });

        moduleStoreProvider.addPossibleFilter("customerUser", {
            id: "firstName",
            label: "MANAGEMENT_USER_FIRST_NAME_FILTER",
            type: "string",
            field: "firstName",
            comparator: "contains"
        });

        $stateProvider.state("secure.content.management.user", {
            url: "/user/:id",
            templateUrl: "modules/management-user/user-management.html",
            controller: "UserManagementListController",
            titleName: 'MANAGEMENT_USER_TITLE',
            titleIcon: "account-multiple"
        });
    });


angular.module('stwo.management-user').controller('UserManagementListController', function ($scope, $controller, $state, $modal, smarttrackerService, utilService, $translate, dialogService, $timeout) {
    $controller('BaseListContentController', {$scope: $scope});
    $scope.super({
        clazz: 'customerUser',
        pagination: {max: 50},
        downloadUrl: '/customerUser?select=role+user.restriction'
    });

    $scope.downloadAll = function () {
        var max = $scope.pagination.max;
        $scope.pagination.max = $scope.pagination.total;
        $scope.downloadMore();
        $scope.pagination.max = max;
    }

    smarttrackerService.isLoggedInDelayed().then(function () {
        $translate(['MANAGEMENT_USER_LANGUAGE_NETHERLANDS', 'MANAGEMENT_USER_LANGUAGE_ENGLISH', 'MANAGEMENT_USER_LANGUAGE_NORWEGIAN', 'MANAGEMENT_USER_LANGUAGE_SWEDISH',
            'MANAGEMENT_USER_LANGUAGE_GERMAN', 'MANAGEMENT_USER_LANGUAGE_CHINESE']).then(function (data) {
            $scope.languageOptions = {};
            var keys = ["nl", "en"];
            var i = 0;
            angular.forEach(data, function (value, key) {
                $scope.languageOptions[keys[i++]] = value;
            });
        });
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/role/").then(function (response) {
            if (utilService.isResponseValid(response)) {
                $scope.availableRoles = response.data.result;
            }
        });
        $translate(['MANAGEMENT_USER_TYPE_NORMAL', 'MANAGEMENT_USER_TYPE_API']).then(function (data){
            $scope.userTypeMap = {api: data.MANAGEMENT_USER_TYPE_API, normal:data.MANAGEMENT_USER_TYPE_NORMAL};
        });
        

        reloadInvitations();

    });

    /** Invitation related code*/
    $scope.invitations = [];
    $scope.toggleShowInvitations = function () {
        $scope.showInvitationList = !$scope.showInvitationList;
    }

    $scope.deleteInvitation = function (i) {
        smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/customerInvitation/" + i.id).then(function (response) {
            $scope.feedbackInfo = "Invitation for " + i.user.name + " has been revoked";
            reloadInvitations();
        });
    }

    var reloadInvitations = function (offset) {
        offset = offset ? offset : 0;

        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/customerInvitation?select=user&user:null=false&offset=" + offset).then(function (response) {
            if (offset == 0) $scope.invitations = [];

            $scope.invitations = $scope.invitations.concat(response.data.result);
            if ($scope.invitations.length < response.data.total && response.data.result.length > 0) {
                reloadInvitations($scope.invitations.length);
            }
        });
    }

    // Remove feedback after 10 seconds
    var feedbackHider = false;
    $scope.$watch('feedbackInfo', function (newVal) {
        if (newVal && newVal != '') {
            if (feedbackHider) {
                $timeout.cancel(feedbackHider);
            }
            feedbackHider = $timeout(function () {
                $scope.feedbackInfo = '';
            }, 10 * 1000);
        }
    });

    /** END invitation related*/

    $scope.selectedRoleFilter = "ALL";
    var selectedFilterRole = false;
    $scope.changeRoleFilter = function (role) {
        if (role == selectedFilterRole)return;
        if (role) {
            $scope.selectedRoleFilter = role.name;
        } else {
            $scope.selectedRoleFilter = "ALL";
        }
        selectedFilterRole = role;
        applyFilter();
    }

    $scope.textInput = {nameSearchValue:""};
    var nameFilter = false;
    $scope.applyNameFilter = function ($event ){
        if (!$scope.textInput.nameSearchValue || $scope.textInput.nameSearchValue == '')
            return;
        var keyCode = $event.which || $event.keyCode;
        if (keyCode === 13) {
            $scope.filterValues = {"firstName": $scope.textInput.nameSearchValue};
            $scope.filterUrlString = "&firstName:contains=" + $scope.textInput.nameSearchValue;
            applyFilter();
            $scope.textInput.nameSearchValue = "";
        }
    }

    $scope.$watch("itemsChanged", function () {
        $scope.items.sort(function (a, b) {
            return a.user.name > b.user.name?1:-1;
        });

        angular.forEach($scope.items, function (user) {
            user.originalUser = utilService.clone(user.user);
        });
        if ($scope.items.length > 0 && $scope.filterUrlString.indexOf("id:equals=") >= 0) {
            $scope.userClicked($scope.items[0]);
        }
    });

    $scope.localCollapseUser = (localStorage["CollapseUser"] === "true");
    $scope.toggleCollapseUser = function () {
        $scope.localCollapseUser = !$scope.localCollapseUser;
        localStorage["CollapseUser"] = $scope.localCollapseUser;
    };

    var applyFilter = function () {
        $scope.filterUrlString = ($scope.textInput.nameSearchValue ? '&user.firstName:contains=' + $scope.textInput.nameSearchValue : '') + (selectedFilterRole ? '&role.id:equals=' + selectedFilterRole.id : '');
    };

    $scope.userClicked = function (user) {
        $scope.currentUser = user;
        $scope.currentUser.originalUser = utilService.clone(user.user);
        prepareUserRestricitons();

        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }
    };

    $scope.createUser = function () {
        $scope.newUser = {
            role: {},
            user: {
                "language": "nl",
                "username": "",
                "email": "",
                "firstName": "",
                "lastName": "",
                "timeZone": "Europe/Oslo",
                "password": "",
                "repassword": "",
                "temporaryPW": true,
                "approvedIp": [],
                "restriction": {
                    "direct": {"assets": [], "groups": []},
                    "merged": {"assets": [], "groups": []}
                }
            }
        };
        $scope.Sidebar = false;
        $scope.sidebarLocked = true;
    };

    $scope.cancelNewUser = function () {
        $scope.newUser = false;
        $scope.Sidebar = true;
        $scope.sidebarLocked = false;
    };

    $scope.saveNewUser = function () {
        // validate new user
        $scope.newUser.errors = {};
        if (!$scope.newUser.role.id) {
            $scope.newUser.errors["role"] = "MANAGEMENT_USER_CREATE_USER_ERROR_NO_ROLE";
        }
        if ($scope.newUser.user.password != $scope.newUser.user.repassword) {
            $scope.newUser.errors["password"] = "MANAGEMENT_USER_CREATE_USER_ERROR_PASSWORD_MISMATCH";
            $scope.newUser.user.password = $scope.newUser.user.repassword = "";
        }

        // var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // if(!re.test($scope.newUser.user.email)) {
        // 	$scope.newUser.errors["email"] = "MANAGEMENT_USER_CREATE_USER_ERROR_INVALID_EMAIL";
        // }// Not supported yet
        $scope.newUser.user.type = "api";
        if (Object.keys($scope.newUser.errors).length == 0) {
            if ($scope.newUser.user.temporaryPW) {
                $scope.newUser.user.temporaryPassword = $scope.newUser.user.password;
            }
            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/customerUser?select=user.permission+role", $scope.newUser).then(function (response) {
                var user = response.data.result[0];
                if (user.status && user.status == "pending") {
                    $translate(["MANAGEMENT_USER_USER_INVITED"], {
                        username: user.user.username,
                        name: user.user.name
                    }).then(function (data) {
                        $scope.feedbackInfo = data.MANAGEMENT_USER_USER_INVITED
                    });
                    reloadInvitations();
                    $scope.newUser = false;
                } else {
                    $scope.filterUrlString = "&id:equals=" + user.id;
                    $scope.filterMessage = "NEW_ASSET";
                    $scope.filterMessage2 = "";
                    $scope.selectedRoleFilter = "ALL";
                    //$scope.userClicked(response.data.result[0]);
                    $scope.newUser = false;
                }
            }, function (errorResponse) {
                console.log(errorResponse);
                if (errorResponse && errorResponse.data) {
                    if (errorResponse.data.message == "user already added") {
                        $scope.newUser.errors["username"] = "MANAGEMENT_USER_CREATE_USER_ERROR_USERNAME_TAKEN";
                    } else if (errorResponse && errorResponse.data && errorResponse.data.message == "User already invited") {
                        $scope.newUser.errors["alreadyInvited"] = "MANAGEMENT_USER_CREATE_USER_ERROR_ALREADY_INVITED";
                    } else if (errorResponse.data.message == "must have a user password") {
                        $scope.newUser.errors["password"] = "MANAGEMENT_USER_CREATE_USER_ERROR_MUST_HAVE_PASSWORD";
                    }
                } else {
                    $scope.newUser.errors["unknown"] = "MANAGEMENT_USER_CREATE_USER_ERROR_UNKNOWN_ERROR";
                }
            })
            $scope.sidebarLocked = false;
            $scope.Sidebar = true;
        }

    }

    $scope.changeRole = function () {
        var u = $scope.currentUser;
        var disabledIDs = $scope.newUser ? [] : [$scope.currentUser.role.id];

        var modalInstance = $modal.open({
            templateUrl: 'core/html/pickers/picker-role.html',
            controller: stwoCommonPickerModalController,
            size: "lg",
            resolve: {
                pickerConfiguration: function () {
                    return {
                        title: "MANAGEMENT_USER_ROLE_PICKER_TITLE",
                        clazz: "role",
                        fieldsToShow: ["name"],
                        multiple: false,
                        nullAllowed: false,
                        disabledIDs: disabledIDs,
                        downloadUrl: '/role?select=name&sort=name&order=asc'
                    }
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            if (pickerResult.selectedItems.length > 0) {
                if ($scope.newUser) {
                    $scope.newUser.role = pickerResult.selectedItems[0];
                    return;
                }
                var body = {"role": {"id": pickerResult.selectedItems[0].id}};
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + u.id, body).then(function (response) {
                    if (utilService.isResponseValid(response, true)) {
                        u.role = response.data.result[0].role;
                    }
                });
            }
        })

    }

    var prepareUserRestricitons = function () {
        angular.forEach($scope.currentUser.user.restriction.merged.assets, function (mr) {
            mr.direct = false;
            angular.forEach($scope.currentUser.user.restriction.direct.assets, function (dr) {
                if (mr.id == dr.id) {
                    mr.direct = true;
                }
            })
        });
        angular.forEach($scope.currentUser.user.restriction.merged.groups, function (mr) {
            mr.direct = false;
            angular.forEach($scope.currentUser.user.restriction.direct.groups, function (dr) {
                if (mr.id == dr.id) {
                    mr.direct = true;
                }
            })
        });
    }

    $scope.removeRestriction = function (type, restriction) {
        if ($scope.newUser) {
            var r = $scope.newUser.user.restriction.direct[type];
            for (var i = 0; i < r.length; i++) {
                if (r[i].id == restriction.id) {
                    r.splice(i, 1);
                    break;
                }
            }
            return;
        }
        var u = $scope.currentUser;
        var restrictions = utilService.clone(u.user.restriction);
        for (var i = 0; i < restrictions.direct[type].length; i++) {
            if (restrictions.direct[type][i].id == restriction.id) {
                restrictions.direct[type].splice(i, 1);
                break;
            }
        }
        var body = {user: {restriction: restrictions}};
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + u.id + "?select=user.restriction+role", body).then(function (response) {
            // smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/customerUser/" + u.id + "?select=user.restriction").then(function (response2){
            u.user.restriction = response.data.result[0].user.restriction;
            prepareUserRestricitons();
            // });
        });
    }

    $scope.addRestrictionsToUser = function (type) {
        var disabledIDs = [];
        var u = $scope.newUser ? $scope.newUser : $scope.currentUser;

        angular.forEach(u.user.restriction.direct[type + "s"], function (restriction) {
            disabledIDs.push(restriction.id);
        });

        var modalInstance = $modal.open({
            templateUrl: type == 'asset' ? 'core/html/pickers/picker-asset-to-group.html' : 'core/html/pickers/picker-group.html',
            controller: stwoCommonPickerModalController,
            size: "lg",
            resolve: {
                pickerConfiguration: function () {
                    return {
                        title: "MANAGEMENT_USER_" + type.toUpperCase() + "S_RESTRICTION_PICKER_TITLE",
                        clazz: type,
                        fieldsToShow: ["name"],
                        multiple: true,
                        nullAllowed: false,
                        disabledIDs: disabledIDs,
                        downloadUrl: (type == 'asset' ? '/asset' : '/group') + '?select=name&sort=name&order=asc'
                    }
                }
            }
        });

        modalInstance.result.then(function (pickerResult) {
            console.log(pickerResult.selectedItems);
            if ($scope.newUser) {
                angular.forEach(pickerResult.selectedItems, function (value, key) {
                    $scope.newUser.user.restriction.direct[type + "s"].push(value);
                });
                return;
            }
            var ar = utilService.clone(u.user.restriction.direct[type + "s"]);
            var mar = utilService.clone(u.user.restriction.merged[type + "s"]);

            angular.forEach(pickerResult.selectedItems, function (item) {
                console.log(item);
                ar.push({id: item.id, name: item.name});
                mar.push({id: item.id, name: item.name});
            });
            console.log(mar);
            var body = {user: {restriction: {direct: {}}}};
            body.user.restriction.direct[type + "s"] = ar;

            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + u.id + "?select=user.restriction+role", body).then(function (response) {
                console.log(response);
                if (response && response.data && response.data.result) {
                    u.user.restriction = response.data.result[0].user.restriction;
                    console.log(u);
                    prepareUserRestricitons();
                }
            });
        });
    };

    $scope.deleteUser = function () {
        $translate(["MANAGEMENT_USER_DELETE_WARNING"], {username: $scope.currentUser.user.name}).then(function (data) {
            var promise = dialogService.prompt("MANAGEMENT_USER_DELETE_TITLE", data['MANAGEMENT_USER_DELETE_WARNING'],
                {
                    warningButtonText: "MANAGEMENT_USER_DELETE_OK",
                    promptText: "",
                    disablePromptText: true,
                    deleteButton: true
                });
            promise.then(function (data) {
                smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/customerUser/" + $scope.currentUser.id).then(function (response) {
                    var index = $scope.items.indexOf($scope.currentUser);
                    $scope.items.splice(index, 1);

                    $scope.currentUser = false;
                });
            });
        });
    };

    $scope.changeUserProperty = function (property) {
        if ($scope.currentUser.originalUser[property] != $scope.currentUser.user[property]) {
            if (!$scope.currentUser.working) {
                $scope.currentUser.working = {};
            }
            $scope.currentUser.working[property] = true;
            var body = {'user': {}};
            body.user[property] = $scope.currentUser.user[property];
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + $scope.currentUser.id + "?select=user.restriction+role", body).then(function (response) {
                $scope.currentUser.working[property] = false;
                $scope.currentUser.user = response.data.result[0].user;
                $scope.currentUser.originalUser = utilService.clone($scope.currentUser.user);
                prepareUserRestricitons();
            });
        }
    };


    $scope.Screensize = function () {
        if (($(window).width() > 991) && !$scope.sidebarLocked) {
            $scope.Sidebar = true;
        }
    };


    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.lockedPopup = function(){
        dialogService.prompt("SIDEBAR_LOCKED_TITLE", "SIDEBAR_LOCKED_WARNING",
            {
                disablePromptText: true,
                cancelButton: false,
                deleteButton: false
            }
        );
    };

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        if ($scope.sidebarLocked){
            $scope.lockedPopup();
        } else {
            $scope.Sidebar = !$scope.Sidebar;
        }
    };

    $scope.sidebarOptions = (localStorage["sidebarOptions"] === "true");

    $scope.toggleSidebarOptions = function () {
        if ($scope.sidebarOptions) {
            $scope.sidebarOptions = false;
            localStorage["sidebarOptions"] = $scope.sidebarOptions;
            TweenLite.to("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});

        } else {
            $scope.sidebarOptions = true;
            localStorage["sidebarOptions"] = $scope.sidebarOptions;
            TweenLite.set("#sidebarOptions", {height: "auto"});
            TweenLite.from("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});
        }
    };

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };



    /**
    IP-related
    */
    
    $scope.$watch("editIP.value", function (newVal){
        if($scope.editIP){
            var re = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
            $scope.editIP.valid = re.test(newVal);
            console.log($scope.editIP);
        }
    });
    $scope.removeIp = function(index) {
        $scope.currentUser.user.approvedIp.splice(index, 1);
        var ips = $scope.currentUser.user.approvedIp.length == 0?[""]:$scope.currentUser.user.approvedIp;// bug
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + $scope.currentUser.id, {user:{'approvedIp':ips}}).then(function (response){

            });
    }
    $scope.addIP = function() {
        if($scope.editIP.valid){
            $scope.currentUser.user.approvedIp.push($scope.editIP.value);
            $scope.editIP = false;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + $scope.currentUser.id, {user:{'approvedIp':$scope.currentUser.user.approvedIp}}).then(function (response){

            });
        }
    }
    $scope.openIPDialog = function(open) {
        $scope.editIP = open?{value:"", valid:false}:false;
    }
    /**
    End IP related 
    */

    $scope.changeUserType = function(newType) {
        $scope.currentUser.working = $scope.currentUser.working? $scope.currentUser.working: {};
        if($scope.currentUser.user.type != newType && !$scope.currentUser.working['type']) {
            $scope.currentUser.working['type'] = true;
            $scope.currentUser.user.type = newType; 
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/customerUser/" + $scope.currentUser.id, {'user':{'type':newType}}).then(function (responser){
                $scope.currentUser.working['type'] = false;
            });
        } 
    }


}); 
angular.module('stwo.management-overlay', ["stwo.management"]).config(function($stateProvider, moduleStoreProvider) {

    moduleStoreProvider.registerModule({
        name : "overlay-management",
        links : [{
            name : "MANAGEMENT_OVERLAYS_LINK",
            category : "MANAGEMENT",
            sref : "secure.content.management-overlay",
            access : ["document", "put"],
            sort : 10,
            icon : "image-area",
            color: "info",
            controllers: ['OverlayManagementListController']
        }]
    });


    $stateProvider.state("secure.content.management-overlay", {
        url : "/asset-overlay/",
        templateUrl : "modules/management-overlay/overlay.html",
        controller : "OverlayManagementListController",
        titleName: 'MANAGEMENT_OVERLAY_TITLE',
        titleIcon: "image-area"
    });
});


angular.module('stwo.management-overlay').controller('OverlayManagementListController', function ($scope, $translate, $timeout, $q, $stateParams, $state, $modal, $controller, smarttrackerService, dialogService, contentCacheService, mapService, leafletData) {


    $scope.items = [];
    $scope.currentOverlay = null;
    $controller('BaseListContentController', {$scope: $scope});
    $scope.toggleSidebar = true;
    var map = false;
    var syntax = {'overlayKey':"ACR_OVERLAY"};

    $scope.super({
        clazz: 'document',
        //downloadUrl: '/document/?select=@&labels:contains='+syntax.overlayKey+'&sort=name&order=asc'
        downloadUrl: '/document/?select=@&type:equals='+syntax.overlayKey+'&sort=name&order=asc'
    });

    $scope.mapData = {
        center: {
            lat: 52.386617,
            lng: 5.799990,
            zoom: 8
        },
        defaults: {
            dragging: true,
            maxZoom: 21,
            pan: true
        },
        events: {
            map: {
                enable: ['dragstart', 'zoomstart', 'click'],
                logic: 'emit'
            }
        }
    };

    $scope.editOverlay = null;
    $scope.levelOptions = [];
    for(var i = -10; i <= 100; i++) {
        $scope.levelOptions.push({id:i, label: i + "", value:i});
    }

    smarttrackerService.isLoggedInDelayed().then(function() {

        mapService.basicMapDesign($scope, leafletData, "map");
        leafletData.getMap('map').then(function (otherMap) {
            map = otherMap;
            map.on("click", function (e){
                if($scope.editOverlay && $scope.editOverlay.setPosition) {
                    if($scope.editOverlay.overlay) {
                        repositionEditableLayer(e.latlng);
                    } else {
                        addEditOverlayToMap(e.latlng);
                    }
                    $scope.editOverlay.setPosition = false;
                }
            });
        });
    });

    $scope.$watch("editOverlay.imageURL", function(){
        if($scope.editOverlay){
            validateImage($scope.editOverlay.imageURL).then(function (valid) {
                $scope.editOverlay.imageValid = valid;
                if(valid) {
                    var image = new Image();
                    image.src = $scope.editOverlay.imageURL;
                    const height = 100;
                    const width = image.width / (image.height/100);
                    $scope.editOverlay.helpers = {height:height, width:width}
                }
                if($scope.editOverlay.overlay){
                    if(!valid) {
                        removeNewOverlay();
                    } else {
                        $scope.editOverlay.overlay.setUrl($scope.editOverlay.imageURL);
                        rotate($scope.editOverlay.pd.srHandle.getLatLng()); // Dimensions may have changed, use scale and roate to calculate new coordinates. 
                    }
                }
                $scope.editOverlay.setPosition = $scope.editOverlay.setPosition&&$scope.editOverlay.imageValid;
            });
        }
    });


    var layers = {};
    $scope.$watch("itemsChanged", function(){
        if($scope.items){
            angular.forEach($scope.items, function (overlay){
                var o = overlay.meta;
                if(!layers[overlay.resourceId]) {
                    layers[overlay.resourceId] = L.imageOverlay.rotated(o.imageURL, o.points.nw, o.points.ne, o.points.sw, {opacity:1.0, interactive:false}).addTo(map);
                }
                overlay.originalName = overlay.name;
                overlay.working = {};
                validateImage(overlay.meta.imageURL).then(function (valid){
                    overlay.imageValid = valid;
                });
            });
        }
    });


    // Utility methods

    /** Checks whether the provided imageURL for the new or edited overlay is a valid image */
    var validateImage = function(url) {
        var deferred = $q.defer();
        var image = new Image();
        image.onerror = function() {
            deferred.resolve(false);
        };
        image.onload = function() {
            deferred.resolve(true);
        };
        image.src = url;

        return deferred.promise;
    }

    /** Calculates the center and handle positions and ratio for a new overlay or repositions the editLayer if present*/
    var addEditOverlayToMap = function (ll) {
        if(!$scope.editOverlay.imageURL) return;
        

        if(!$scope.editOverlay.pd){
            const width = $scope.editOverlay.helpers.width;
            const height = $scope.editOverlay.helpers.height;
            // POsition Data 
            $scope.editOverlay.pd = {};
            var centerPX = map.latLngToLayerPoint(ll);
            $scope.editOverlay.pd['tl'] = map.layerPointToLatLng(L.point(centerPX.x - width/2, centerPX.y - height/2));// top left
            $scope.editOverlay.pd['tr'] = map.layerPointToLatLng(L.point(centerPX.x + width/2, centerPX.y - height/2));// top right
            $scope.editOverlay.pd['bl'] = map.layerPointToLatLng(L.point(centerPX.x - width/2, centerPX.y + height/2));// bottom left
        } 

        $

        // Size and Rotation handle
        $scope.editOverlay.pd.srHandle = L.marker($scope.editOverlay.pd.tr, {draggable: true} ).setIcon(
            L.icon({
                iconUrl:'customization/images/scale_rotate.png',
                iconSize: [40, 40],
                iconAnchor:[20, 20],
                className:'overlay-transformation-handle'
            })
        ).addTo(map);
            // Position Handle
            $scope.editOverlay.pd.posHandle = L.marker($scope.editOverlay.pd.bl, {draggable: true} ).setIcon(
                L.icon({
                    iconUrl:'customization/images/translate.png',
                    iconSize: [40, 40],
                    iconAnchor:[20, 20],
                    className:'overlay-transformation-handle'
                })
                ).addTo(map);
            // Keep track of the Size and Rotation handle previous position, to calculate difference.  
            $scope.editOverlay.pd.srHandlePP = $scope.editOverlay.pd.srHandle.getLatLng();
            $scope.editOverlay.pd.posHandlePP = $scope.editOverlay.pd.posHandle.getLatLng();

            $scope.editOverlay.overlay = L.imageOverlay.rotated($scope.editOverlay.imageURL, $scope.editOverlay.pd.tl, $scope.editOverlay.pd.tr, $scope.editOverlay.pd.bl, {
            opacity: 0.7,
            interactive: true
        }).addTo(map);

        $scope.editOverlay.pd.srHandle.on('drag dragend', function (e){
            rotate(e.target.getLatLng());

        });



        $scope.editOverlay.pd.posHandle.on('drag dragend', function (e){
            repositionEditableLayer(e.target.getLatLng());
        });

    }

    /** Debug method, convert radians to degrees*/
    var tat = function(a) {
        return a*180/Math.PI;
    }

    /** Transformation Util */
    /** Rotates a given point p a radians around center c*/

    var rotate = function(newPosition) { // Scale and rotate
        var blPX = map.latLngToLayerPoint($scope.editOverlay.pd.posHandle.getLatLng());  // Bottom left corner
        var troPX = L.point(blPX.x + $scope.editOverlay.helpers.width, blPX.y - $scope.editOverlay.helpers.height); // Original topright corner for reference
        var trnPX = map.latLngToLayerPoint(newPosition); // New topright corner
            
        $scope.editOverlay.pd.tr = newPosition;
            
        var d2 = trnPX.distanceTo(blPX);  // New diameter
        var od = Math.sqrt(Math.pow($scope.editOverlay.helpers.height, 2) + Math.pow($scope.editOverlay.helpers.width, 2)); // Original Diameter
        var scale = d2/od;
        var hs = scale*$scope.editOverlay.helpers.height;

        var rotationAngle = Math.atan2(trnPX.y - blPX.y, trnPX.x - blPX.x);
        var r2 = Math.atan2(troPX.y - blPX.y, troPX.x - blPX.x);
        var adiff = r2 - rotationAngle;
        $scope.editOverlay.pd.tl = map.layerPointToLatLng(
            convertPoint(L.point(blPX.x, blPX.y + hs), blPX, (Math.PI - adiff))
        );
        $scope.editOverlay.overlay.reposition($scope.editOverlay.pd.tl, $scope.editOverlay.pd.tr, $scope.editOverlay.pd.bl);
    }

    var repositionEditableLayer = function(newPosition) {
        $scope.editOverlay.pd.posHandle.setLatLng(newPosition); // In case buttons were used
        // Calculate diff, and move all points necessary accordingly
        var bloPX = map.latLngToLayerPoint($scope.editOverlay.pd.bl); // Previous Bottom left Corner
        var blnPX = map.latLngToLayerPoint(newPosition);      // New Bottom Left Corner
        var dx = bloPX.x - blnPX.x; 
        var dy = bloPX.y - blnPX.y;
        var entries = ['tl', 'tr', 'bl'];
        // Reposition all points and both handles. 
        angular.forEach(entries, function (key){
            pxp = map.latLngToLayerPoint($scope.editOverlay.pd[key]);
            $scope.editOverlay.pd[key] = map.layerPointToLatLng(L.point(pxp.x - dx, pxp.y - dy));
        });
        
        var rhPX = map.latLngToLayerPoint($scope.editOverlay.pd.srHandle.getLatLng());
        $scope.editOverlay.pd.srHandle.setLatLng(map.layerPointToLatLng(L.point(rhPX.x - dx, rhPX.y - dy)));
        $scope.editOverlay.overlay.reposition($scope.editOverlay.pd.tl, $scope.editOverlay.pd.tr, $scope.editOverlay.pd.bl);
    }

    /** Transformation by button hooks */
    $scope.scaleDirection = function(direction) {
        $scope.cancelTransformation();
        var srPX = map.latLngToLayerPoint($scope.editOverlay.pd.srHandle.getLatLng());
        var phPX = map.latLngToLayerPoint($scope.editOverlay.pd.posHandle.getLatLng());

        var ydiff = (srPX.y > phPX.y ? 1 : -1)*direction;
        var xdiff = (srPX.x > phPX.x ? 1 : -1)*direction;

        srPX = L.point(srPX.x + xdiff, srPX.y + ydiff);
        var srp = map.layerPointToLatLng(srPX);
        $scope.editOverlay.pd.srHandle.setLatLng(srp);
        rotate(srp);
        transformerTimer = $timeout( function(){$scope.scaleDirection(direction)}, 100);
    }

    $scope.repositionDirection = function(xdiff, ydiff) {
        $scope.cancelTransformation();
        var phPX = map.latLngToLayerPoint($scope.editOverlay.pd.posHandle.getLatLng());
        phPX = L.point(phPX.x + xdiff, phPX.y + ydiff);
        var ph = map.layerPointToLatLng(phPX);
        $scope.editOverlay.pd.posHandle.setLatLng(ph);
        repositionEditableLayer(ph);
        transformerTimer = $timeout( function(){$scope.repositionDirection(xdiff, ydiff)}, 100);
    }

    const RADIAN = Math.PI/180;
    $scope.rotateDirection = function (direction) {
        $scope.cancelTransformation();
        var srPX = map.latLngToLayerPoint($scope.editOverlay.pd.srHandle.getLatLng());
        var cPX  = map.latLngToLayerPoint($scope.editOverlay.pd.posHandle.getLatLng());
        var currentAngle = Math.atan2(cPX.y - srPX.y, cPX.x - srPX.x);
        var npPX = convertPoint(srPX, cPX,  direction*RADIAN);
        var np = map.layerPointToLatLng(npPX);
        $scope.editOverlay.pd.srHandle.setLatLng(np);
        rotate(np);
        transformerTimer = $timeout( function(){$scope.rotateDirection(direction)}, 100);
    }

    $scope.cancelTransformation = function() {
        if(transformerTimer) {
            $timeout.cancel(transformerTimer);
        }
    } 
    var transformerTimer = false;
    var ttActive = false;
    //$timeout.cancel(levelUpdater);
    /** End Transformation by buttons hooks*/


    // Rotates point p a angles around c
    var convertPoint = function (p, c,  a){
        // Move to origo, then rotate, then move back
        p =p.subtract(c);
        p = L.point((p.x * Math.cos(a) - p.y * Math.sin(a)), (p.y * Math.cos(a) + p.x * Math.sin(a)));
        return p.add(c);
    }

    /** END Transformation Util*/

    /** Removes The editable overlay from the map*/
    var removeNewOverlay = function() {
        if($scope.editOverlay && $scope.editOverlay.overlay) {
            try{
                $scope.editOverlay.pd.srHandle.remove();
                $scope.editOverlay.pd.posHandle.remove();
                $scope.editOverlay.overlay.remove();
            } catch (e) {
                console.error("Something went wrong when removing editable overlay: " + e);
            }
        }
    };
    // End Utility Methods

    // hook methods

    /**  Triggered from the web when a user clicks an overlay in the list. Selects the overlay, and pans to its location. */
    $scope.overlayClicked = function(overlay) {
        $scope.currentOverlay = overlay;
        var o = layers[overlay.resourceId];
        o.remove().addTo(map); // Bring to front
        /** @FIXME hack.*/
        if(!boundsInit) {
            map.fitBounds(o.getBounds());
            boundsInit = true; // why? Need to fit bounds twice first time
        }
        /** End FIXME*/
        map.fitBounds(o.getBounds());
        

        if ($(window).width() < 992) {
            $scope.Sidebar = false;
        }
    };
    var boundsInit = false;

    /** Triggered from the web when a user clicks delete button on an overlay in the list */
    $scope.deleteOverlay = function() {
        var promise = dialogService.prompt("MANAGEMENT_OVERLAY_DELETE_TITLE", "MANAGEMENT_OVERLAY_DELETE_WARNING",
            {
                warningButtonText: "MANAGEMENT_OVERLAY_DELETE_OK",
                promptText: "",
                disablePromptText: true,
                deleteButton: true
            });
        promise.then(function (data) {
            layers[$scope.currentOverlay.resourceId].remove();
            delete layers[$scope.currentOverlay.resourceId];
            smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/document/" + $scope.currentOverlay.id).then(function (response){
                $scope.refresh();
                $scope.currentOverlay = false;
                $scope.sidebarLocked = false;
            });
        });
    };


    /** Triggered from the web, when the user clicks new Overlay */
    $scope.createNewOverlay = function() {
        $scope.currentOverlay = false;
        $scope.Sidebar = false;
        $scope.sidebarLocked = true;
        $scope.editOverlay = {
            name:"",
            imageURL: "", //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTksP1nspUKip55NWGfKorHJVnb-vXdUcWMbZsiUxQ36cfxesRi5g",//"https://images.unsplash.com/photo-1445217143695-467124038776?dpr=1&auto=format&fit=crop&w=376&h=226&q=60&cs=tinysrgb",
            imageValid:false,
            level:"0"
        };
    };

    /** Methods to edit overlay properties*/
    $scope.updateOverlayName = function(overlay) {
        if(overlay.name === overlay.originalName) {
            return;
        }
        overlay.working['name'] = true;
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/document/" + overlay.id, {"name":overlay.name}).then(function (response) {
            overlay.originalName = overlay.name;
            overlay.working['name'] = false;
        });
    }

    var levelUpdater = false;
    $scope.changeOverlayLevel = function(amount) {
        var newLevel = false;
        if($scope.editOverlay&&!$scope.editOverlay.resourceId) {
            newLevel = parseInt($scope.editOverlay.level) + amount
        } else {
            newLevel = parseInt($scope.currentOverlay.meta.level) + amount
        }

        if(newLevel >= $scope.levelOptions[0].value && newLevel <= $scope.levelOptions[$scope.levelOptions.length-1].value) {
            if($scope.editOverlay&&!$scope.editOverlay.resourceId) {
                $scope.editOverlay.level = newLevel;
            } else {
                if(levelUpdater) {
                    $timeout.cancel(levelUpdater);
                }
                $scope.currentOverlay.meta.level = newLevel + "";
                levelUpdater = $timeout(function(){
                    $scope.currentOverlay.working['level'] = true;
                    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/document/" + $scope.currentOverlay.id, {'meta':$scope.currentOverlay.meta}).then(function (response){
                        $scope.currentOverlay.working['level'] = false;
                    });
                }, 800);
            }
        }
    }
    /** End Methods to edit overlay properties*/


    $scope.editSelectedOverlay = function() {
        var overlay = $scope.currentOverlay;
        $scope.editOverlay = {
            name: overlay.name,
            imageURL: overlay.meta.imageURL,
            resourceId: overlay.resourceId,
            showPrevious: false,
            level:overlay.meta.level,
            pd:{
                tr:overlay.meta.points.ne,
                tl:overlay.meta.points.nw,
                bl:overlay.meta.points.sw
            }
        };
        validateImage($scope.editOverlay.imageURL).then(function (valid){
            $scope.editOverlay.imageValid = valid;
            if(valid) addEditOverlayToMap();
        });
        if(layers[overlay.resourceId]) {
            layers[overlay.resourceId].setOpacity(0.0);
            map.fitBounds(layers[overlay.resourceId].getBounds());
        }
        $scope.Sidebar = false;
        $scope.sidebarLocked = true;
    };

    /** Triggered from the web to select whether or not the old image overlay should be drawn in the map */
    $scope.togglePrevious = function() {
        var o = $scope.editOverlay;
        layers[o.resourceId].setOpacity(o.showPrevious?0.0:0.5);
        o.showPrevious = !o.showPrevious;
    };

    /** Triggered from the web when a user clicks save on an overlay that is in edit mode */
    $scope.saveOverlay = function() {
        var o = $scope.editOverlay;

        removeNewOverlay();

        if(o.resourceId){
            var body = {
                meta:$scope.currentOverlay.meta
            };
            body.meta.imageURL = o.imageURL;
            body.meta.points = {nw:o.pd.tl, ne:o.pd.tr, sw:o.pd.bl};

            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/document/" + o.resourceId, body).then(function (response){
                var o = response.data.result[0];
                layers[o.resourceId].remove();

                layers[o.resourceId] = L.imageOverlay.rotated(o.meta.imageURL, o.meta.points.nw, o.meta.points.ne, o.meta.points.sw, {opacity:1.0, interactive:false}).addTo(map);
                var index = -1;
                for(var i = 0; i < $scope.items.length;i++) {
                    if($scope.items[i].resourceId == o.resourceId) {
                        index = i;
                        break;
                    }
                }
                if(index>-1) {
                    o.originalName = o.name;
                    validateImage(o.meta.imageURL).then(function (valid){o.imageValid = valid});
                    o.working = {};
                    $scope.items[index] = o;
                    $scope.overlayClicked($scope.items[index]);
                }
            });
        } else {
            var body = {
                name:o.name,
                meta:{
                    imageURL: o.imageURL,
                    points: {nw:o.pd.tl, ne:o.pd.tr, sw:o.pd.bl},
                    level:o.level
                },
                type:syntax.overlayKey
            };
            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/document/", body).then(function (response) {
                var o = response.data.result[0];
                layers[o.resourceId] = L.imageOverlay.rotated(o.meta.imageURL, o.meta.points.nw, o.meta.points.ne, o.meta.points.sw, {opacity:1.0, interactive:false}).addTo(map);
                $scope.overlayClicked(response.data.result[0]);
                $scope.refresh();
            });
        }
        $scope.editOverlay = false;
        $scope.Sidebar = true;
        $scope.sidebarLocked = false;
    }


    /** Will cancel edit mode of existing or new layer. */
    $scope.cancelEditOverlay = function() {
        if($scope.editOverlay.overlay) {
            removeNewOverlay();
        }
        if($scope.editOverlay.resourceId && layers[$scope.editOverlay.resourceId]) {
            //layers[$scope.editOverlay.resourceId].addTo(map);
            layers[$scope.editOverlay.resourceId].setOpacity(1.0);
        }
        $scope.editOverlay = false;
        $scope.Sidebar = true;
        $scope.sidebarLocked = false;
    }

    /** Triggered from web to indicate that the next click in the map should position or reposition the editable layer. Will not trigger if the imageURL is not a valid image*/
    $scope.setPosition = function() {
        if($scope.editOverlay.imageValid) {
            $scope.editOverlay.setPosition = true;
        }
    }

    /** Centers the map on the provided address data. */
    $scope.centerOnAddress = function(data) {
        map.setView({
            'lat': data.point.lat,
            'lng': data.point.lng
        }, 16);
    }


    // End hook methods

    /** CSS and appearance control*/
    $scope.sidebarOptions = true;

    $scope.toggleSidebarOptions = function () {
        if ($scope.sidebarOptions){
            $scope.sidebarOptions = false;
            TweenLite.to("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});

        } else {
            $scope.sidebarOptions = true;
            TweenLite.set("#sidebarOptions", {height: "auto"});
            TweenLite.from("#sidebarOptions", 0.5, {height: "0", ease: "Quart.easeInOut"});
        }
    };


    $scope.initMap = function () {
        map.invalidateSize();
        /*$scope.centerOnOverlay();*/
    };

    $scope.initMapDelayed = function () {
        setTimeout(function () {
            $scope.initMap();
        }, 20);
    };

    $scope.ZoomIn = function () {
        map.zoomIn();
    };

    $scope.ZoomOut = function () {
        map.zoomOut();
    };


    $scope.centerOnOverlay = function() {
        overlay = $scope.currentOverlay;
        var o = layers[overlay.resourceId];
        
        map.fitBounds(o.getBounds());
    };

    $scope.Screensize = function () {
        if (($(window).width() > 991) && !$scope.sidebarLocked) {
            $scope.Sidebar = true;
        }
    };

    $(window).width(function () {
        $scope.Screensize()
    });
    $(window).resize(function () {
        $scope.Screensize()
    });

    $scope.lockedPopup = function(){
        dialogService.prompt("SIDEBAR_LOCKED_TITLE", "SIDEBAR_LOCKED_WARNING",
            {
                disablePromptText: true,
                cancelButton: false,
                deleteButton: false
            }
        );
    };

    $scope.Sidebar = true;
    $scope.toggleSidebar = function () {
        if ($scope.sidebarLocked){
            $scope.lockedPopup();
        } else {
            $scope.Sidebar = !$scope.Sidebar;
        }
    };

    $scope.toggleFavorites = function (value) {
        if (value) {
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else if ($scope.localFavorites){
            $scope.clearFilter();
            $scope.localFavorites = false;
            localStorage["Favorites"] = $scope.localFavorites;
        } else {
            $scope.showFavorites();
            $scope.localFavorites = true;
            localStorage["Favorites"] = $scope.localFavorites;
        }
    };

    /** End CSS and appearance control*/

});
//# sourceMappingURL=stwo_x-guard-modules.js.map